import React, { useState, useEffect, useRef } from 'react';
import {
  Truck, Users, Package, DollarSign, Plus, Eye, Edit, X, Trash2, CheckCircle,
  MapPin, Clock, Star, Phone, FileText, Send, AlertCircle, TrendingUp,
  Calendar, ChevronRight, Award, Navigation, Bell, Settings, LogOut, Search,
  Filter, MoreVertical, UserPlus, Key, Mail, XCircle, RotateCcw, Map, Lock,
  FileCheck, Download, Printer, QrCode, Scale, Clipboard, Shield, Hash, Building, Copy, ChevronDown, MessageCircle,
  User, Edit2, Save, Upload, Camera, CreditCard, Banknote, ArrowDownCircle, CheckSquare, Menu,
  Wrench, Fuel
} from 'lucide-react';
import { useStore, getStore, cerrarConversacionAdmin, reabrirConversacionAdmin, expirarSolicitudesVencidas, enviarCotizacion as storeEnviarCotizacion, asignarViajeAChofer, getNotificacionesPendientes, marcarNotificacionesLeidas, limpiarNotificaciones, deduplicarNotifsPorTipo, crearAccesoChofer, choferTieneAcceso, actualizarUnidadFlota, toggleActivoChofer, agregarChoferPlantilla, actualizarChoferPlantilla, asignarChoferAUnidad, calificarServicio, CATALOGO_INSIGNIAS, CATALOGO_INSIGNIAS_CLIENTE, subirDocumentoEmpresa as storeSubirDocumento, actualizarFileUrlDocumento as storeActualizarFileUrl, DOCUMENTOS_REQUERIDOS, getDocumentosRequeridos, actualizarLogoEmpresa, actualizarPerfilEmpresa, publicarRetornoVacio, responderOfertaRetorno, cerrarRetornoManual, cancelarRetornoVacio, notificarChoferRetorno, pagarSuscripcionPro as storePagarPro, calcCiudadesEnRuta } from '../store';
import { useApiStore } from '../hooks/useApiStore';
import { apiEnviarCotizacion, apiAsignarChofer, apiReasignarChofer, apiPublicarRetorno, apiResponderOferta, apiCalificar, apiMarcarLeidas, apiEliminarTodasNotificaciones, apiEliminarNotificacion, apiAgregarChofer, apiActualizarChofer, apiEliminarChofer, apiAgregarUnidad, apiActualizarUnidad, apiEliminarUnidad, apiCrearAccesoChofer, apiToggleActivoChofer, apiSuscribirPro, apiCrearPreferenciaPro, apiUnirseListaEsperaPro, apiGetEstadisticasPro, apiActualizarEmpresa, apiTransportistaSubirDocumento, apiReenviarSolicitud, apiGetMisCobros, apiGetDatosBancarios, apiActualizarDatosBancarios, apiCancelarViaje, apiResendVerification, apiGetMisFacturas, apiActualizarDatosFiscales, apiGetFacturaArchivos, apiGetMiEmpresa, apiCancelarRetorno, apiCerrarRetorno, apiSubirFacturaTransportista, apiGetDownloadUrl, apiGetCalificacionesUsuario, apiGetMantenimiento, apiAgregarMantenimiento, apiEliminarMantenimiento, apiGetDiesel, apiAgregarDiesel, apiEliminarDiesel, apiReclamarContraEntrega } from '../api';
import ChatModal from '../components/ChatModal';
import FeedbackButton from '../components/FeedbackButton';
import { solicitarPermisoNotif, fireNotifBrowser, playNotifSound } from '../notifHelper';
import { phCapture } from '../posthog';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

// Fix Leaflet default icon broken by webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// ========== CIUDADES BAJA CALIFORNIA ==========
const CIUDADES_BC = [
  // Baja California (BC) — Zona Tijuana/Rosarito
  'Tijuana, BC', 'Rosarito, BC', 'Playas de Rosarito, BC', 'La Misión, BC',
  'El Descanso, BC', 'Primo Tapia, BC', 'Popotla, BC', 'Puerto Nuevo, BC',
  // BC — Ensenada y costa noroeste
  'Ensenada, BC', 'Maneadero, BC', 'El Sauzal, BC', 'Punta Banda, BC',
  'Santo Tomás, BC', 'Eréndira, BC', 'San Quintín, BC', 'Camalu, BC',
  'Colonet, BC', 'San Vicente, BC', 'El Rosario, BC', 'Vicente Guerrero, BC',
  'Valle de Guadalupe, BC',
  // BC — Tecate y sierra
  'Tecate, BC', 'El Hongo, BC', 'La Rumorosa, BC', 'Valle de las Palmas, BC',
  'Ojos Negros, BC',
  // BC — Mexicali y valle
  'Mexicali, BC', 'Algodones, BC', 'San Felipe, BC', 'Guadalupe Victoria, BC',
  'Ejido Nuevo León, BC', 'Ejido Sonora, BC', 'Ciudad Morelos, BC',
  // BC — Bahía de los Ángeles / costa del golfo
  'Bahía de los Ángeles, BC', 'El Mármol, BC', 'Punta Prieta, BC',
  // Baja California Sur (BCS) — Frontera norte BCS
  'Guerrero Negro, BCS', 'Bahía Asunción, BCS', 'Punta Abreojos, BCS',
  'San Ignacio, BCS', 'Vizcaíno, BCS', 'Villa Alberto Andrés Alvarado, BCS',
  // BCS — Santa Rosalía / Mulegé
  'Santa Rosalía, BCS', 'Mulegé, BCS', 'San Carlos, BCS',
  'Bahía Concepción, BCS', 'Loreto, BCS', 'Puerto Escondido, BCS',
  // BCS — La Paz y alrededores
  'La Paz, BCS', 'El Centenario, BCS', 'La Ventana, BCS', 'Los Planes, BCS',
  'Todos Santos, BCS', 'El Pescadero, BCS', 'Ciudad Constitución, BCS',
  'Ciudad Insurgentes, BCS', 'Comondú, BCS',
  // BCS — Los Cabos y Corredor
  'Cabo San Lucas, BCS', 'San José del Cabo, BCS', 'Los Barriles, BCS',
  'Buena Vista, BCS', 'La Ribera, BCS', 'Miraflores, BCS', 'Santiago, BCS',
  'El Triunfo, BCS', 'San Antonio, BCS',
];

function CiudadComboboxT({ placeholder, value, onChange }) {
  const [abierto, setAbierto] = React.useState(false);
  const [cursor, setCursor] = React.useState(-1);
  const listaRef = React.useRef(null);
  const opciones = value
    ? CIUDADES_BC.filter(c => c.toLowerCase().includes(value.toLowerCase()))
    : CIUDADES_BC;

  const seleccionar = (ciudad) => { onChange(ciudad); setAbierto(false); setCursor(-1); };

  const handleKeyDown = (e) => {
    if (!abierto) { setAbierto(true); return; }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setCursor(prev => {
        const next = prev < opciones.length - 1 ? prev + 1 : 0;
        setTimeout(() => listaRef.current?.children[next]?.scrollIntoView({ block: 'nearest' }), 0);
        return next;
      });
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setCursor(prev => {
        const next = prev > 0 ? prev - 1 : opciones.length - 1;
        setTimeout(() => listaRef.current?.children[next]?.scrollIntoView({ block: 'nearest' }), 0);
        return next;
      });
    } else if (e.key === 'Enter') {
      if (cursor >= 0 && opciones[cursor]) { e.preventDefault(); seleccionar(opciones[cursor]); }
    } else if (e.key === 'Escape') {
      setAbierto(false); setCursor(-1);
    }
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={e => { onChange(e.target.value); setAbierto(true); setCursor(-1); }}
        onFocus={() => setAbierto(true)}
        onBlur={() => setTimeout(() => {
          setAbierto(false); setCursor(-1);
          if (value && !CIUDADES_BC.includes(value)) onChange('');
        }, 150)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        autoComplete="off"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
      />
      {abierto && (
        <ul ref={listaRef} className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-52 overflow-y-auto">
          {opciones.map((ciudad, i) => (
            <li key={ciudad} onMouseDown={() => seleccionar(ciudad)}
              className={`px-4 py-2 cursor-pointer text-sm ${i === cursor ? 'bg-green-100 text-green-700 font-semibold' : 'text-gray-700 hover:bg-green-50'}`}>
              {ciudad}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function MiniMapView({ origenCoords, destinoCoords }) {
  const mapDivRef = React.useRef(null);
  const mapInstanceRef = React.useRef(null);

  React.useEffect(() => {
    if (!mapDivRef.current || mapInstanceRef.current) return;
    const puntos = [origenCoords, destinoCoords].filter(Boolean);
    if (puntos.length === 0) return;

    const centro = puntos.length === 2
      ? [(puntos[0].lat + puntos[1].lat) / 2, (puntos[0].lng + puntos[1].lng) / 2]
      : [puntos[0].lat, puntos[0].lng];
    const zoom = puntos.length === 2 ? 9 : 13;

    const map = L.map(mapDivRef.current, {
      zoomControl: false, dragging: false,
      scrollWheelZoom: false, doubleClickZoom: false
    }).setView(centro, zoom);
    mapInstanceRef.current = map;

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap'
    }).addTo(map);

    if (origenCoords) L.marker([origenCoords.lat, origenCoords.lng]).addTo(map);
    if (destinoCoords) L.marker([destinoCoords.lat, destinoCoords.lng]).addTo(map);
    if (origenCoords && destinoCoords) {
      L.polyline([[origenCoords.lat, origenCoords.lng], [destinoCoords.lat, destinoCoords.lng]], {
        color: '#2563eb', dashArray: '6 6', weight: 2
      }).addTo(map);
    }

    return () => { try { map.remove(); } catch (_) {} mapInstanceRef.current = null; };
  }, []);

  return <div ref={mapDivRef} style={{ height: '200px', width: '100%', isolation: 'isolate' }} />;
}

// ========== MAPA DE VIAJE CON GPS DEL CHOFER ==========
function ViajeMapView({ origenCoords, destinoCoords, progreso = 0, choferCoords = null }) {
  const mapDivRef = React.useRef(null);
  const mapInstanceRef = React.useRef(null);
  const choferMarkerRef = React.useRef(null);

  React.useEffect(() => {
    if (!mapDivRef.current || mapInstanceRef.current) return;

    const puntos = [origenCoords, destinoCoords].filter(Boolean);
    const centroInicial = choferCoords
      ? [choferCoords.lat, choferCoords.lng]
      : puntos.length === 2
        ? [(puntos[0].lat + puntos[1].lat) / 2, (puntos[0].lng + puntos[1].lng) / 2]
        : puntos.length === 1
          ? [puntos[0].lat, puntos[0].lng]
          : null;
    if (!centroInicial) return;

    const centro = centroInicial;
    const zoom = puntos.length === 2 ? 8 : 12;

    const map = L.map(mapDivRef.current, {
      zoomControl: true, dragging: true,
      scrollWheelZoom: false, doubleClickZoom: false
    }).setView(centro, zoom);
    mapInstanceRef.current = map;

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap'
    }).addTo(map);

    // Marker origen (verde)
    if (origenCoords) {
      L.marker([origenCoords.lat, origenCoords.lng], {
        icon: L.divIcon({ className: '', html: '<div style="background:#16a34a;color:white;border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:14px;border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4)">📦</div>', iconSize: [28, 28], iconAnchor: [14, 14] })
      }).addTo(map).bindPopup('Origen de recogida');
    }

    // Marker destino (rojo)
    if (destinoCoords) {
      L.marker([destinoCoords.lat, destinoCoords.lng], {
        icon: L.divIcon({ className: '', html: '<div style="background:#dc2626;color:white;border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:14px;border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4)">🏁</div>', iconSize: [28, 28], iconAnchor: [14, 14] })
      }).addTo(map).bindPopup('Punto de entrega');
    }

    // Ruta entre puntos
    if (origenCoords && destinoCoords) {
      L.polyline([[origenCoords.lat, origenCoords.lng], [destinoCoords.lat, destinoCoords.lng]], {
        color: '#2563eb', weight: 3, dashArray: '8 6'
      }).addTo(map);
    }

    // Posición inicial del chofer
    const iconGps = L.divIcon({ className: '', html: '<div style="background:#7c3aed;color:white;border-radius:50%;width:38px;height:38px;display:flex;align-items:center;justify-content:center;font-size:20px;border:3px solid white;box-shadow:0 2px 10px rgba(124,58,237,0.6)">🚛</div>', iconSize: [38, 38], iconAnchor: [19, 19] });
    const iconEstimado = L.divIcon({ className: '', html: '<div style="background:#f97316;color:white;border-radius:50%;width:34px;height:34px;display:flex;align-items:center;justify-content:center;font-size:18px;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.5)">🚛</div>', iconSize: [34, 34], iconAnchor: [17, 17] });

    if (choferCoords) {
      choferMarkerRef.current = L.marker([choferCoords.lat, choferCoords.lng], { icon: iconGps })
        .addTo(map).bindPopup('📡 Ubicación GPS real del chofer');
      map.setView([choferCoords.lat, choferCoords.lng], Math.max(zoom, 12));
    } else if (origenCoords && destinoCoords) {
      const p = Math.min(Math.max(progreso, 0), 100) / 100;
      const choferLat = origenCoords.lat + (destinoCoords.lat - origenCoords.lat) * p;
      const choferLng = origenCoords.lng + (destinoCoords.lng - origenCoords.lng) * p;
      choferMarkerRef.current = L.marker([choferLat, choferLng], { icon: iconEstimado })
        .addTo(map).bindPopup(`Posición estimada — progreso ${progreso}%`);
    }

    return () => { try { map.remove(); } catch (_) {} mapInstanceRef.current = null; choferMarkerRef.current = null; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Actualizar marcador del chofer cuando llega GPS en tiempo real
  React.useEffect(() => {
    if (!choferCoords || !mapInstanceRef.current) return;
    const iconGps = L.divIcon({ className: '', html: '<div style="background:#7c3aed;color:white;border-radius:50%;width:38px;height:38px;display:flex;align-items:center;justify-content:center;font-size:20px;border:3px solid white;box-shadow:0 2px 10px rgba(124,58,237,0.6)">🚛</div>', iconSize: [38, 38], iconAnchor: [19, 19] });
    if (choferMarkerRef.current) {
      choferMarkerRef.current.setLatLng([choferCoords.lat, choferCoords.lng]);
      choferMarkerRef.current.setIcon(iconGps);
    } else {
      choferMarkerRef.current = L.marker([choferCoords.lat, choferCoords.lng], { icon: iconGps })
        .addTo(mapInstanceRef.current).bindPopup('📡 Ubicación GPS real del chofer');
    }
    mapInstanceRef.current.panTo([choferCoords.lat, choferCoords.lng]);
  }, [choferCoords]);

  return <div ref={mapDivRef} style={{ height: '260px', width: '100%', isolation: 'isolate' }} />;
}

// ========== MODAL: DAR ACCESO AL MÓDULO CHOFER ==========
function ModalAccesoChofer({ chofer, onClose, onCrear, accesoCreado, yaExiste }) {
  const tel = (chofer.telefono || '').replace(/\D/g, '').slice(-10);
  const emailChofer = tel.length === 10 ? `tel_${tel}@chofer.choyero` : (chofer.email || '');
  const [password, setPassword] = React.useState('');
  const [copiado, setCopiado] = React.useState('');

  const generarPassword = () => {
    const chars = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
    let pwd = '';
    for (let i = 0; i < 8; i++) pwd += chars[Math.floor(Math.random() * chars.length)];
    setPassword(pwd);
  };

  const copiar = (texto, campo) => {
    const _copy = (t) => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(t).catch(() => { const ta = document.createElement('textarea'); ta.value = t; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (_) {} document.body.removeChild(ta); });
      } else {
        const ta = document.createElement('textarea'); ta.value = t; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (_) {} document.body.removeChild(ta);
      }
    };
    _copy(texto);
    setCopiado(campo);
    setTimeout(() => setCopiado(''), 2000);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-6 border-b flex justify-between items-center">
          <div>
            <h3 className="text-xl font-bold text-gray-800">Acceso al Módulo Chofer</h3>
            <p className="text-sm text-gray-500 mt-0.5">{chofer.nombre}</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X size={20} /></button>
        </div>

        <div className="p-6">
          {accesoCreado ? (
            /* ── Vista de credenciales generadas ── */
            <div>
              <div className="flex items-center space-x-3 mb-5">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <CheckCircle size={26} className="text-green-600" />
                </div>
                <div>
                  <p className="font-bold text-green-700">¡Acceso creado exitosamente!</p>
                  <p className="text-sm text-gray-500">Comparte estas credenciales con el chofer</p>
                </div>
              </div>

              <div className="space-y-3 mb-6">
                <div className="bg-gray-50 rounded-xl p-4 flex justify-between items-center">
                  <div>
                    <p className="text-xs text-gray-500 mb-0.5">Número de teléfono (usuario)</p>
                    <p className="font-mono font-semibold text-gray-800">{accesoCreado.telefono || chofer.telefono}</p>
                  </div>
                  <button onClick={() => copiar(accesoCreado.telefono || chofer.telefono, 'tel')} className="p-2 hover:bg-gray-200 rounded-lg">
                    {copiado === 'tel' ? <CheckCircle size={18} className="text-green-600" /> : <Copy size={18} className="text-gray-500" />}
                  </button>
                </div>
                <div className="bg-gray-50 rounded-xl p-4 flex justify-between items-center">
                  <div>
                    <p className="text-xs text-gray-500 mb-0.5">Contraseña</p>
                    <p className="font-mono font-semibold text-gray-800 text-xl tracking-widest">{accesoCreado.password}</p>
                  </div>
                  <button onClick={() => copiar(accesoCreado.password, 'pwd')} className="p-2 hover:bg-gray-200 rounded-lg">
                    {copiado === 'pwd' ? <CheckCircle size={18} className="text-green-600" /> : <Copy size={18} className="text-gray-500" />}
                  </button>
                </div>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 mb-4 text-sm text-blue-700">
                <p><span className="font-semibold">URL de acceso:</span> Módulo Chofer → portal-unificado</p>
                <p className="mt-1">El chofer debe ingresar estas credenciales en la pantalla de login.</p>
              </div>

              <button onClick={onClose} className="w-full py-3 bg-green-600 text-white rounded-xl font-semibold hover:bg-green-700">
                Listo
              </button>
            </div>
          ) : yaExiste ? (
            /* ── Ya tiene acceso ── */
            <div>
              <div className="flex items-center space-x-3 mb-5">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <CheckCircle size={26} className="text-green-600" />
                </div>
                <div>
                  <p className="font-bold text-green-700">Este chofer ya tiene acceso</p>
                  <p className="text-sm text-gray-500">{chofer.telefono}</p>
                </div>
              </div>
              <p className="text-sm text-gray-600 mb-4">Si necesitas restablecer la contraseña, puedes crear nuevas credenciales con un correo diferente o contactar al administrador.</p>
              <button onClick={onClose} className="w-full py-3 border border-gray-300 rounded-xl font-medium hover:bg-gray-50">Cerrar</button>
            </div>
          ) : (
            /* ── Formulario para crear acceso ── */
            <div className="space-y-4">
              <p className="text-sm text-gray-600">Define la contraseña con la que <span className="font-semibold">{chofer.nombre}</span> entrará al módulo del chofer.</p>

              <div className="bg-gray-50 rounded-xl p-3 flex items-center gap-3">
                <Phone size={16} className="text-gray-400 flex-shrink-0" />
                <div>
                  <p className="text-xs text-gray-500">Número de teléfono (usuario)</p>
                  <p className="font-mono font-semibold text-gray-800">{chofer.telefono}</p>
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Contraseña</label>
                <div className="flex space-x-2">
                  <input
                    type="text"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    className="flex-1 px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent font-mono tracking-widest"
                    placeholder="Contraseña"
                  />
                  <button
                    type="button"
                    onClick={generarPassword}
                    className="px-4 py-3 bg-gray-100 hover:bg-gray-200 rounded-xl text-sm font-medium text-gray-700 whitespace-nowrap"
                  >
                    Generar
                  </button>
                </div>
                <p className="text-xs text-gray-400 mt-1">Mínimo 6 caracteres. Puedes escribir una o usar "Generar".</p>
              </div>

              <div className="flex space-x-3 pt-2">
                <button onClick={onClose} className="flex-1 py-3 border border-gray-300 rounded-xl font-medium hover:bg-gray-50">
                  Cancelar
                </button>
                <button
                  onClick={() => password.length >= 6 && onCrear(emailChofer, password)}
                  disabled={password.length < 6}
                  className="flex-1 py-3 bg-green-600 text-white rounded-xl font-semibold hover:bg-green-700 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                >
                  <Key size={18} />
                  <span>Crear Acceso</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ModalCalificarCliente({ viaje, onClose, onSubmit }) {
  const [estrellas, setEstrellas] = React.useState(0);
  const [comentario, setComentario] = React.useState('');
  const [hover, setHover] = React.useState(0);

  const labels = ['', '😞 Muy malo', '😕 Malo', '😐 Regular', '🙂 Bueno', '😍 ¡Excelente!'];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        <div className="p-6 border-b flex justify-between items-center">
          <h3 className="text-xl font-bold text-gray-800">Calificar al Cliente</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <div className="p-6">
          <div className="bg-gray-50 rounded-xl p-4 mb-6">
            <p className="text-sm text-gray-500">Viaje {viaje.id}</p>
            <p className="font-semibold">{viaje.cliente || viaje.clienteId}</p>
          </div>

          <div className="text-center mb-6">
            <p className="text-sm font-semibold text-gray-700 mb-3">¿Cómo fue la experiencia con este cliente?</p>
            <div className="flex justify-center space-x-2">
              {[1,2,3,4,5].map(star => (
                <button
                  key={star}
                  onClick={() => setEstrellas(star)}
                  onMouseEnter={() => setHover(star)}
                  onMouseLeave={() => setHover(0)}
                  className="transition-transform hover:scale-110"
                >
                  <Star
                    size={40}
                    className={(hover || estrellas) >= star ? 'text-yellow-400' : 'text-gray-300'}
                    fill={(hover || estrellas) >= star ? 'currentColor' : 'none'}
                  />
                </button>
              ))}
            </div>
            <p className="text-sm text-gray-500 mt-2">{labels[hover || estrellas] || 'Selecciona una calificación'}</p>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-semibold text-gray-700 mb-2">Comentario (opcional)</label>
            <textarea
              value={comentario}
              onChange={e => setComentario(e.target.value)}
              placeholder="¿Cómo fue la comunicación y el trato del cliente?"
              rows="3"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="mb-6">
            <p className="text-xs text-gray-500 mb-2">Sugerencias:</p>
            <div className="flex flex-wrap gap-2">
              {['Puntual en pagos', 'Buena comunicación', 'Carga bien preparada', 'Instrucciones claras', 'Recomendado'].map(tag => (
                <button
                  key={tag}
                  onClick={() => setComentario(prev => prev ? `${prev}, ${tag}` : tag)}
                  className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm hover:bg-blue-100"
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>

          <button
            onClick={() => {
              if (estrellas === 0) return;
              onSubmit(estrellas, comentario);
            }}
            disabled={estrellas === 0}
            className="w-full px-6 py-3 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 font-semibold flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Send size={20} />
            <span>Enviar Calificación</span>
          </button>
        </div>
      </div>
    </div>
  );
}

/** Mapa Leaflet con ruta real por carretera (OSRM) entre origen y destino */
function MapaGpsOfertaView({ origenCoords, destinoCoords, onInfoRuta }) {
  const mapRef = React.useRef(null);
  const instanceRef = React.useRef(null);

  React.useEffect(() => {
    if (!mapRef.current || instanceRef.current) return;
    const puntos = [origenCoords, destinoCoords].filter(Boolean);
    if (puntos.length === 0) return;

    const center = puntos.length === 2
      ? [(puntos[0].lat + puntos[1].lat) / 2, (puntos[0].lng + puntos[1].lng) / 2]
      : [puntos[0].lat, puntos[0].lng];

    const map = L.map(mapRef.current, { zoomControl: true, dragging: true, scrollWheelZoom: true }).setView(center, 8);
    instanceRef.current = map;
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
    }).addTo(map);

    const makeIcon = (color, emoji) => L.divIcon({
      className: '',
      html: `<div style="background:${color};color:white;border-radius:50%;width:32px;height:32px;display:flex;align-items:center;justify-content:center;font-size:16px;border:3px solid white;box-shadow:0 3px 8px rgba(0,0,0,.5)">${emoji}</div>`,
      iconSize: [32, 32], iconAnchor: [16, 16]
    });

    if (origenCoords) {
      L.marker([origenCoords.lat, origenCoords.lng], { icon: makeIcon('#16a34a', '📦') })
        .addTo(map)
        .bindPopup(`<b>📦 Recogida</b>${origenCoords.direccion ? '<br><span style="font-size:12px">' + origenCoords.direccion + '</span>' : ''}`);
    }
    if (destinoCoords) {
      L.marker([destinoCoords.lat, destinoCoords.lng], { icon: makeIcon('#dc2626', '🏁') })
        .addTo(map)
        .bindPopup(`<b>🏁 Entrega</b>${destinoCoords.direccion ? '<br><span style="font-size:12px">' + destinoCoords.direccion + '</span>' : ''}`);
    }

    if (puntos.length === 2) {
      map.fitBounds([[origenCoords.lat, origenCoords.lng], [destinoCoords.lat, destinoCoords.lng]], { padding: [50, 50] });

      // Ruta real por carretera via OSRM
      const osrmUrl = `https://router.project-osrm.org/route/v1/driving/${origenCoords.lng},${origenCoords.lat};${destinoCoords.lng},${destinoCoords.lat}?overview=full&geometries=geojson`;
      const osrmController = new AbortController();
      const osrmTimeout = setTimeout(() => osrmController.abort(), 5000);
      fetch(osrmUrl, { signal: osrmController.signal })
        .then(r => r.json())
        .then(data => {
          clearTimeout(osrmTimeout);
          if (!instanceRef.current) return;
          if (data.routes && data.routes.length > 0) {
            const ruta = data.routes[0];
            const coordsRuta = ruta.geometry.coordinates.map(([lng, lat]) => [lat, lng]);
            const linea = L.polyline(coordsRuta, { color: '#4f46e5', weight: 5, opacity: 0.85, lineJoin: 'round', lineCap: 'round' }).addTo(instanceRef.current);
            instanceRef.current.fitBounds(linea.getBounds(), { padding: [50, 50] });

            // Info de distancia y tiempo en esquina del mapa
            const km = (ruta.distance / 1000).toFixed(0);
            const hrs = Math.floor(ruta.duration / 3600);
            const mins = Math.floor((ruta.duration % 3600) / 60);
            const tiempoStr = hrs > 0 ? `${hrs}h ${mins}min` : `${mins} min`;
            if (onInfoRuta) onInfoRuta({ km, tiempo: tiempoStr });

            const InfoCtrl = L.Control.extend({
              onAdd: () => {
                const div = L.DomUtil.create('div');
                div.style.cssText = 'background:white;padding:6px 10px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,.25);font-size:13px;font-weight:700;color:#1e293b;line-height:1.5;pointer-events:none';
                div.textContent = `🚛 ${km} km  |  ⏱ ${tiempoStr}`;
                return div;
              }
            });
            new InfoCtrl({ position: 'topright' }).addTo(instanceRef.current);
          } else {
            // Fallback línea recta
            L.polyline([[origenCoords.lat, origenCoords.lng], [destinoCoords.lat, destinoCoords.lng]], { color: '#4f46e5', weight: 3, dashArray: '10 6' }).addTo(instanceRef.current);
          }
        })
        .catch(() => {
          clearTimeout(osrmTimeout);
          if (!instanceRef.current) return;
          L.polyline([[origenCoords.lat, origenCoords.lng], [destinoCoords.lat, destinoCoords.lng]], { color: '#4f46e5', weight: 3, dashArray: '10 6' }).addTo(instanceRef.current);
        });
    }

    map.invalidateSize();
    return () => { try { map.remove(); } catch (_) {} instanceRef.current = null; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div ref={mapRef} style={{ height: '100%', minHeight: '340px', width: '100%', borderRadius: '0 0 16px 16px', overflow: 'hidden' }} />;
}

// ─── Constante y componente fuera de AppTransportista para respetar reglas de hooks ───

const COORDS_CIUDADES = {
  'Tijuana, BC': [32.5149, -117.0382], 'Rosarito, BC': [32.3656, -117.0640],
  'Mexicali, BC': [32.6245, -115.4523], 'Tecate, BC': [32.5736, -116.6258],
  'Ensenada, BC': [31.8667, -116.6000], 'El Sauzal, BC': [31.9167, -116.6833],
  'Maneadero, BC': [31.7167, -116.6000], 'Valle de Guadalupe, BC': [32.0167, -116.5333],
  'San Felipe, BC': [31.0249, -114.8390], 'Algodones, BC': [32.7167, -114.7167],
  'La Rumorosa, BC': [32.5333, -116.0667], 'Ojos Negros, BC': [31.8667, -116.2500],
  'San Vicente, BC': [31.3333, -116.2667], 'San Quintín, BC': [30.5491, -115.9839],
  'Vicente Guerrero, BC': [29.7167, -115.8833], 'El Rosario, BC': [29.7833, -115.7167],
  'Colonet, BC': [30.9667, -116.0833], 'Camalu, BC': [30.8500, -116.0500],
  'Punta Banda, BC': [31.7000, -116.7000], 'Valle de las Palmas, BC': [32.3167, -116.5167],
  'El Hongo, BC': [32.5000, -116.2667], 'Guerrero Negro, BCS': [27.9667, -114.0000],
  'Santa Rosalía, BCS': [27.3333, -112.2667], 'Loreto, BCS': [26.0122, -111.3464],
  'La Paz, BCS': [24.1426, -110.3128], 'Los Cabos, BCS': [23.0545, -109.7022],
  'Mulegé, BCS': [26.8833, -111.9833], 'Comondú, BCS': [26.0500, -111.8167],
  'Ciudad Constitución, BCS': [25.0414, -111.6586], 'Todos Santos, BCS': [23.4500, -110.2167],
};

const COLOR_STATUS_MAPA = { disponible: '#3b82f6', en_viaje: '#8b5cf6', descanso: '#9ca3af', activa: '#22c55e', mantenimiento: '#f59e0b' };
const LABEL_STATUS_MAPA = { disponible: 'Disponible', en_viaje: 'En viaje', descanso: 'En descanso' };

function MapaUnidades({ unidades, plantillaChoferes, empresaActiva }) {
  const ciudadEmpresa = empresaActiva?.ciudad || 'Tijuana, BC';
  const coordsFallback = COORDS_CIUDADES[ciudadEmpresa] || [32.5149, -117.0382];

  const choferes = (plantillaChoferes || [])
    .filter(c => c.empresaId === empresaActiva?.id)
    .map(c => ({
      ...c,
      lat: c.lat ?? (coordsFallback[0] + (Math.random() - 0.5) * 0.04),
      lng: c.lng ?? (coordsFallback[1] + (Math.random() - 0.5) * 0.04),
      rutaActual: c.rutaActual ?? null,
    }));

  const choferById = {};
  choferes.forEach(c => { choferById[c.id] = c; });

  const unidadesConChofer = unidades.filter(u => u.choferAsignado && choferById[u.choferAsignado]);
  const unidadesSinChofer = unidades.filter(u => !u.choferAsignado || !choferById[u.choferAsignado]);

  const idChoferesCombinados = new Set(unidadesConChofer.map(u => u.choferAsignado));
  const choferesSinUnidad = choferes.filter(c => !idChoferesCombinados.has(c.id));

  const unidadesSinChoferPorCiudad = {};
  unidadesSinChofer.forEach(u => {
    const ciudad = u.ubicacion?.ciudad;
    if (ciudad && COORDS_CIUDADES[ciudad]) {
      if (!unidadesSinChoferPorCiudad[ciudad]) unidadesSinChoferPorCiudad[ciudad] = [];
      unidadesSinChoferPorCiudad[ciudad].push(u);
    }
  });

  const [posChoferes, setPosChoferes] = useState(() => {
    const pos = {};
    choferes.forEach(c => { pos[c.id] = { lat: c.lat, lng: c.lng, ts: null }; });
    return pos;
  });

  useEffect(() => {
    const enViaje = choferes.filter(c => c.status === 'en_viaje' && c.rutaActual?.destLat != null);
    if (enViaje.length === 0) return;
    const interval = setInterval(() => {
      setPosChoferes(prev => {
        const next = { ...prev };
        enViaje.forEach(c => {
          const cur = next[c.id];
          if (!cur) return;
          const dlat = (c.rutaActual.destLat - cur.lat) * 0.03;
          const dlng = (c.rutaActual.destLng - cur.lng) * 0.03;
          if (Math.abs(dlat) < 0.0003 && Math.abs(dlng) < 0.0003) return;
          next[c.id] = { lat: cur.lat + dlat, lng: cur.lng + dlng };
        });
        return next;
      });
    }, 1500);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // GPS en tiempo real — actualizar posición cuando llega evento del socket
  useEffect(() => {
    const handle = (e) => {
      const { choferNombre, lat, lng } = e.detail || {};
      if (!choferNombre || !lat || !lng) return;
      const chofer = choferes.find(c => c.nombre === choferNombre || c.nombre?.toLowerCase() === choferNombre?.toLowerCase());
      if (!chofer) return;
      setPosChoferes(prev => ({ ...prev, [chofer.id]: { lat, lng, ts: Date.now() } }));
    };
    window.addEventListener('choyero_gps_update', handle);
    return () => window.removeEventListener('choyero_gps_update', handle);
  }, [choferes]); // eslint-disable-line react-hooks/exhaustive-deps

  const hayDatos = unidades.length > 0 || choferes.length > 0;

  const iconCamion = (us) => {
    const activa = us.some(u => u.status === 'activa');
    const color = activa ? '#22c55e' : '#f59e0b';
    return L.divIcon({
      html: `<div style="position:relative;display:inline-block;">
        <div style="background:white;border:2.5px solid ${color};border-radius:50%;width:42px;height:42px;display:flex;align-items:center;justify-content:center;box-shadow:0 3px 10px rgba(0,0,0,0.22);">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
          </svg>
        </div>
        ${us.length > 1 ? `<div style="position:absolute;top:-5px;right:-5px;background:#ef4444;color:white;font-size:10px;font-weight:bold;border-radius:50%;width:18px;height:18px;display:flex;align-items:center;justify-content:center;border:1.5px solid white;">${us.length}</div>` : ''}
      </div>`,
      iconSize: [42, 42], iconAnchor: [21, 21], popupAnchor: [0, -26], className: '',
    });
  };

  const iconChofer = (status, sinSenal) => {
    const color = sinSenal ? '#9ca3af' : (COLOR_STATUS_MAPA[status] || '#6b7280');
    const pulso = !sinSenal && status === 'en_viaje'
      ? `<div style="position:absolute;inset:-5px;border-radius:50%;border:2px solid ${color};opacity:0.4;animation:chofer-ping 1.6s ease-out infinite;"></div>`
      : '';
    const badgeSinSenal = sinSenal
      ? `<div title="Sin señal GPS" style="position:absolute;top:-4px;right:-4px;background:#ef4444;border-radius:50%;width:13px;height:13px;border:2px solid white;"></div>`
      : '';
    return L.divIcon({
      html: `<div style="position:relative;width:38px;height:38px;">
        ${pulso}
        <div style="position:absolute;inset:0;background:white;border:2.5px solid ${color};border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 3px 10px rgba(0,0,0,0.22);opacity:${sinSenal ? 0.6 : 1};">
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        ${badgeSinSenal}
      </div>`,
      iconSize: [38, 38], iconAnchor: [19, 19], popupAnchor: [0, -24], className: '',
    });
  };

  const iconCombinado = (status, sinSenal) => {
    const color = sinSenal ? '#9ca3af' : (COLOR_STATUS_MAPA[status] || '#6b7280');
    const pulso = !sinSenal && status === 'en_viaje'
      ? `<div style="position:absolute;inset:-5px;border-radius:10px;border:2px solid ${color};opacity:0.4;animation:chofer-ping 1.6s ease-out infinite;"></div>`
      : '';
    const badgeSinSenal = sinSenal
      ? `<div title="Sin señal GPS" style="position:absolute;top:-4px;right:-4px;background:#ef4444;border-radius:50%;width:13px;height:13px;border:2px solid white;"></div>`
      : '';
    return L.divIcon({
      html: `<div style="position:relative;width:50px;height:44px;">
        ${pulso}
        <div style="position:absolute;inset:0;background:white;border:2.5px solid ${color};border-radius:10px;display:flex;align-items:center;justify-content:center;gap:3px;box-shadow:0 3px 10px rgba(0,0,0,0.22);padding:0 4px;opacity:${sinSenal ? 0.6 : 1};">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
          </svg>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="opacity:0.85;">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        ${badgeSinSenal}
      </div>`,
      iconSize: [50, 44], iconAnchor: [25, 22], popupAnchor: [0, -26], className: '',
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h3 className="text-xl font-bold text-gray-800">Distribución de Flota</h3>
        <div className="flex flex-wrap items-center gap-3 text-xs text-gray-500">
          <span className="flex items-center gap-1.5"><span style={{ width:10,height:10,borderRadius:'50%',background:'#22c55e',display:'inline-block' }}></span> Unidad activa</span>
          <span className="flex items-center gap-1.5"><span style={{ width:10,height:10,borderRadius:'50%',background:'#f59e0b',display:'inline-block' }}></span> Unidad inactiva</span>
          <span className="flex items-center gap-1.5"><span style={{ width:10,height:10,borderRadius:'50%',background:'#3b82f6',display:'inline-block' }}></span> Chofer disponible</span>
          <span className="flex items-center gap-1.5"><span style={{ width:10,height:10,borderRadius:'50%',background:'#8b5cf6',display:'inline-block' }}></span> En viaje</span>
          <span className="flex items-center gap-1.5"><span style={{ width:10,height:10,borderRadius:'50%',background:'#9ca3af',display:'inline-block' }}></span> En descanso</span>
          <span className="flex items-center gap-1.5"><span style={{ width:10,height:10,borderRadius:'50%',background:'#ef4444',display:'inline-block' }}></span> Sin señal GPS</span>
        </div>
      </div>
      <div className="rounded-xl overflow-hidden border border-gray-200" style={{ height: '500px', position: 'relative', zIndex: 0 }}>
        <MapContainer center={[28.0, -113.5]} zoom={6} style={{ height: '100%', width: '100%' }} scrollWheelZoom={true}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {Object.entries(unidadesSinChoferPorCiudad).map(([ciudad, us]) => (
            <Marker key={`uc-${ciudad}`} position={COORDS_CIUDADES[ciudad]} icon={iconCamion(us)}>
              <Popup>
                <div style={{ minWidth: '180px' }}>
                  <p style={{ fontWeight: '700', fontSize: '13px', marginBottom: '6px', color: '#1f2937' }}>🚛 {ciudad}</p>
                  {us.map(u => (
                    <div key={u.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 0', borderTop: '1px solid #f3f4f6' }}>
                      <div>
                        <span style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>{u.placas}</span>
                        <span style={{ fontSize: '11px', color: '#9ca3af', display: 'block' }}>{u.tipo} · Sin chofer asignado</span>
                      </div>
                      <span style={{ width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0, background: u.status === 'activa' ? '#22c55e' : '#f59e0b', display: 'inline-block' }}></span>
                    </div>
                  ))}
                </div>
              </Popup>
            </Marker>
          ))}
          {unidadesConChofer.map(u => {
            const c = choferById[u.choferAsignado];
            const pos = posChoferes[c.id];
            if (!pos) return null;
            const sinSenal = !pos.ts || (Date.now() - pos.ts) > 120000;
            const color = sinSenal ? '#9ca3af' : (COLOR_STATUS_MAPA[c.status] || '#6b7280');
            return (
              <Marker key={`par-${u.id}`} position={[pos.lat, pos.lng]} icon={iconCombinado(c.status, sinSenal)}>
                <Popup>
                  <div style={{ minWidth: '185px' }}>
                    <p style={{ fontWeight: '700', fontSize: '13px', color: '#1f2937', marginBottom: '2px' }}>🚛 {u.placas} · {u.tipo}</p>
                    <p style={{ fontSize: '11px', color: '#9ca3af', marginBottom: '8px' }}>{u.marca} {u.modelo} · {u.capacidad}</p>
                    <div style={{ borderTop: '1px solid #f3f4f6', paddingTop: '7px' }}>
                      <p style={{ fontWeight: '700', fontSize: '12px', color: '#1f2937', marginBottom: '2px' }}>👤 {c.nombre}</p>
                      <p style={{ fontSize: '11px', color, fontWeight: '600', marginBottom: '5px' }}>{LABEL_STATUS_MAPA[c.status] || c.status}</p>
                      {sinSenal && <p style={{ fontSize: '11px', color: '#ef4444', fontWeight: '600', marginBottom: '4px' }}>⚠️ Sin señal GPS</p>}
                      <div style={{ fontSize: '11px', color: '#6b7280', lineHeight: '1.7' }}>
                        <p>📞 {c.telefono}</p>
                        <p>{c.viajes > 0 && c.calificacion ? `⭐ ${c.calificacion} · ` : ''}{c.viajes} viajes</p>
                        {c.rutaActual && <p style={{ color: '#8b5cf6', fontWeight: '600', marginTop: '4px' }}>📍 {c.rutaActual.origen} → {c.rutaActual.destino}</p>}
                      </div>
                    </div>
                  </div>
                </Popup>
              </Marker>
            );
          })}
          {choferesSinUnidad.map(c => {
            const pos = posChoferes[c.id];
            if (!pos) return null;
            const sinSenal = !pos.ts || (Date.now() - pos.ts) > 120000;
            const color = sinSenal ? '#9ca3af' : (COLOR_STATUS_MAPA[c.status] || '#6b7280');
            return (
              <Marker key={`cs-${c.id}`} position={[pos.lat, pos.lng]} icon={iconChofer(c.status, sinSenal)}>
                <Popup>
                  <div style={{ minWidth: '170px' }}>
                    <p style={{ fontWeight: '700', fontSize: '13px', color: '#1f2937', marginBottom: '2px' }}>👤 {c.nombre}</p>
                    <p style={{ fontSize: '11px', color, fontWeight: '600', marginBottom: '6px' }}>{LABEL_STATUS_MAPA[c.status] || c.status} · Sin unidad asignada</p>
                    {sinSenal && <p style={{ fontSize: '11px', color: '#ef4444', fontWeight: '600', marginBottom: '4px' }}>⚠️ Sin señal GPS</p>}
                    <div style={{ fontSize: '11px', color: '#6b7280', lineHeight: '1.7' }}>
                      <p>📞 {c.telefono}</p>
                      <p>🪪 {c.licencia}</p>
                      <p>⭐ {c.calificacion} · {c.viajes} viajes</p>
                    </div>
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
      {!hayDatos && (
        <p className="text-center text-gray-400 text-sm mt-4">Agrega unidades o choferes para verlos en el mapa.</p>
      )}
    </div>
  );
}

// Constantes fiscales reutilizadas en SeccionMisFacturas y modal auto al cargar
const REGIMENES_FISCALES = [
  { value: '601', label: '601 – General de Ley Personas Morales' },
  { value: '612', label: '612 – Personas Físicas con Actividades Empresariales' },
  { value: '626', label: '626 – Régimen Simplificado de Confianza (RESICO)' },
];
const USOS_CFDI = [
  { value: 'G03', label: 'G03 – Gastos en general' },
  { value: 'P01', label: 'P01 – Por definir' },
];

// ─── Sección: Mis Facturas ──────────────────────────────────────────────────
function SeccionMisFacturas({ empresaId, autoAbrirModal }) {
  const [facturas, setFacturas] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [datosFiscalesModal, setDatosFiscalesModal] = React.useState(false);
  const [form, setForm] = React.useState({ rfc: '', razonSocial: '', regimenFiscal: '', cpFiscal: '', usoCfdi: 'G03' });
  const [guardando, setGuardando] = React.useState(false);
  const [msg, setMsg] = React.useState(null);
  const [descargando, setDescargando] = React.useState({}); // { [facturaId_tipo]: true }

  React.useEffect(() => {
    if (!autoAbrirModal) return;
    apiGetMiEmpresa().then(emp => {
      const esFisica = (emp?.rfc?.length === 13);
      const razonSocialDefault = emp?.razonSocial || (esFisica ? emp?.representante : emp?.nombre) || '';
      setForm({ rfc: emp?.rfc || '', razonSocial: razonSocialDefault, regimenFiscal: emp?.regimenFiscal || '', cpFiscal: emp?.cpFiscal || '', usoCfdi: emp?.usoCfdi || 'G03' });
      setDatosFiscalesModal(true);
    }).catch(() => setDatosFiscalesModal(true));
  }, [autoAbrirModal]);

  const cargar = React.useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiGetMisFacturas();
      setFacturas(data || []);
    } catch (e) {
      console.error('[Facturas] Error cargando:', e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => { cargar(); }, [cargar]);

  const statusColor = (s) => ({
    timbrada:  'bg-green-100 text-green-700',
    pendiente: 'bg-yellow-100 text-yellow-700',
    cancelada: 'bg-red-100 text-red-600',
    error:     'bg-red-50 text-red-400',
  }[s] || 'bg-gray-100 text-gray-600');

  const descargar = (dataUrl, nombre) => {
    if (!dataUrl) return;
    // Usar Blob + ObjectURL para evitar límites de data URLs en el navegador
    if (dataUrl.startsWith('data:')) {
      try {
        const [header, b64] = dataUrl.split(',');
        const mime = header.match(/data:([^;]+)/)?.[1] || 'application/octet-stream';
        const bytes = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
        const blob = new Blob([bytes], { type: mime });
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = nombre;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
        return;
      } catch (e) {
        console.error('[Descarga] Error convirtiendo base64:', e);
      }
    }
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = nombre;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const [reciboModal, setReciboModal] = React.useState(null);

  const imprimirRecibo = (fd) => {
    const w = window.open('', '_blank');
    w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Factura ${fd.serie}-${fd.folio}</title>
    <style>body{font-family:Arial,sans-serif;padding:40px;max-width:700px;margin:auto}h2{color:#1a5276}table{width:100%;border-collapse:collapse;margin-top:16px}td,th{padding:8px 12px;border:1px solid #ddd;font-size:13px}th{background:#f2f2f2}.total{font-weight:bold;font-size:15px}.uuid{font-family:monospace;font-size:11px;color:#666;word-break:break-all}</style>
    </head><body>
    <h2>CFDI — Comisión por servicio de intermediación</h2>
    <p><b>Folio:</b> ${fd.serie}-${fd.folio} &nbsp;&nbsp; <b>Fecha:</b> ${fd.fecha ? new Date(fd.fecha).toLocaleDateString('es-MX') : ''}</p>
    ${fd.uuid ? `<p class="uuid"><b>UUID:</b> ${fd.uuid}</p>` : ''}
    <table><tr><th colspan="2">Emisor</th></tr>
    <tr><td>RFC</td><td>${fd.emisor?.rfc || ''}</td></tr>
    <tr><td>Nombre</td><td>${fd.emisor?.nombre || ''}</td></tr></table>
    <table style="margin-top:12px"><tr><th colspan="2">Receptor</th></tr>
    <tr><td>RFC</td><td>${fd.receptor?.rfc || ''}</td></tr>
    <tr><td>Nombre</td><td>${fd.receptor?.nombre || ''}</td></tr>
    <tr><td>Régimen</td><td>${fd.receptor?.regimen || ''}</td></tr>
    <tr><td>CP Fiscal</td><td>${fd.receptor?.cp || ''}</td></tr></table>
    <table style="margin-top:12px"><tr><th>Concepto</th><th>Importe</th></tr>
    <tr><td>Comisión intermediación logística — ${fd.origen || ''} → ${fd.destino || ''}</td><td>$${(fd.subtotal||0).toLocaleString('es-MX')}</td></tr>
    <tr><td>IVA (16%)</td><td>$${(fd.iva||0).toLocaleString('es-MX')}</td></tr>
    <tr class="total"><td><b>TOTAL</b></td><td><b>$${(fd.total||0).toLocaleString('es-MX')} MXN</b></td></tr></table>
    <p style="margin-top:24px;font-size:11px;color:#999">Este documento es un resumen informativo. El CFDI oficial fue timbrado ante el SAT por Facturama.</p>
    <script>window.onload=()=>window.print()</script></body></html>`);
    w.document.close();
  };

  const descargarFactura = async (factura, tipo) => {
    const key = `${factura.id}_${tipo}`;
    const url = tipo === 'xml' ? factura.xmlUrl : factura.pdfUrl;
    if (url) { descargar(url, `factura-${factura.folio || factura.id}.${tipo}`); return; }
    // Necesita re-descarga desde Facturama
    setDescargando(p => ({ ...p, [key]: true }));
    try {
      const res = await apiGetFacturaArchivos(factura.id, true);
      const nuevoUrl = tipo === 'xml' ? res.xmlUrl : res.pdfUrl;
      if (nuevoUrl) {
        setFacturas(prev => prev.map(f => f.id === factura.id ? { ...f, xmlUrl: res.xmlUrl, pdfUrl: res.pdfUrl } : f));
        descargar(nuevoUrl, `factura-${factura.folio || factura.id}.${tipo}`);
      } else if (res.facturaData) {
        // Facturama no pudo entregar el archivo — mostrar recibo imprimible
        setReciboModal(res.facturaData);
      } else {
        alert('No se pudo obtener el archivo de Facturama. Intenta de nuevo en unos momentos.');
      }
    } catch (e) {
      console.error('[Facturas] Error re-descarga:', e.message);
      alert(`Error al descargar: ${e.message}`);
    } finally {
      setDescargando(p => ({ ...p, [key]: false }));
    }
  };

  const guardarDatosFiscales = async () => {
    setGuardando(true); setMsg(null);
    try {
      await apiActualizarDatosFiscales(form);
      setMsg({ tipo: 'ok', texto: 'Datos fiscales guardados correctamente.' });
      setTimeout(() => setDatosFiscalesModal(false), 1200);
    } catch (e) {
      setMsg({ tipo: 'error', texto: e.message || 'Error al guardar' });
    } finally {
      setGuardando(false);
    }
  };

  const REGIMENES = REGIMENES_FISCALES;
  const USO_CFDI = USOS_CFDI;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
          <FileText size={26} className="text-blue-600" /> Mis Facturas
        </h2>
        <div className="flex gap-2">
          <button onClick={async () => {
            try {
              const emp = await apiGetMiEmpresa();
              const esFisica = (emp?.rfc?.length === 13);
              const razonSocialDefault = emp?.razonSocial || (esFisica ? emp?.representante : emp?.nombre) || '';
              setForm({
                rfc:           emp?.rfc            || '',
                razonSocial:   razonSocialDefault,
                regimenFiscal: emp?.regimenFiscal  || '',
                cpFiscal:      emp?.cpFiscal       || '',
                usoCfdi:       emp?.usoCfdi        || 'G03',
              });
            } catch { /* usa valores vacíos si falla */ }
            setDatosFiscalesModal(true);
          }} className="flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-600 transition">
            <Settings size={14} /> Datos fiscales
          </button>
          <button onClick={cargar} disabled={loading} className="flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-600 disabled:opacity-50 transition">
            <RotateCcw size={14} className={loading ? 'animate-spin' : ''} /> Actualizar
          </button>
        </div>
      </div>

      {/* Modal recibo imprimible — fallback cuando Facturama no entrega archivos */}
      {reciboModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl p-6 max-w-md w-full">
            <h3 className="text-lg font-bold text-gray-800 mb-2">Archivos no disponibles en Facturama</h3>
            <p className="text-sm text-gray-500 mb-4">
              El servidor de Facturama no pudo entregar el PDF/XML en este momento (puede ocurrir en modo sandbox).
              Puedes imprimir o guardar este resumen oficial del CFDI.
            </p>
            <div className="bg-gray-50 rounded-xl p-4 text-sm space-y-1 mb-4">
              <p><b>Folio:</b> {reciboModal.serie}-{reciboModal.folio}</p>
              {reciboModal.uuid && <p className="font-mono text-xs text-gray-500 break-all"><b>UUID:</b> {reciboModal.uuid}</p>}
              <p><b>Receptor:</b> {reciboModal.receptor?.nombre} ({reciboModal.receptor?.rfc})</p>
              <p><b>Subtotal:</b> ${(reciboModal.subtotal||0).toLocaleString('es-MX')}</p>
              <p><b>IVA:</b> ${(reciboModal.iva||0).toLocaleString('es-MX')}</p>
              <p className="font-bold"><b>Total:</b> ${(reciboModal.total||0).toLocaleString('es-MX')} MXN</p>
            </div>
            <div className="flex gap-3">
              <button onClick={() => imprimirRecibo(reciboModal)} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-xl font-semibold text-sm hover:bg-blue-700">
                🖨 Imprimir / Guardar PDF
              </button>
              <button onClick={() => setReciboModal(null)} className="px-4 py-2 border border-gray-300 rounded-xl text-sm hover:bg-gray-50">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6 text-sm text-blue-700">
        <p className="font-semibold mb-1">¿Qué son estas facturas?</p>
        <p>Choyero te emite un CFDI por su comisión de servicio cada vez que completas un flete. Descarga el XML y PDF para tu contabilidad.</p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-400">Cargando facturas...</div>
      ) : facturas.length === 0 ? (
        <div className="text-center py-12 text-gray-400">
          <FileText size={40} className="mx-auto mb-3 opacity-30" />
          <p>No tienes facturas aún</p>
          <p className="text-xs mt-1">Se generan automáticamente al completar fletes</p>
        </div>
      ) : (
        <div className="space-y-3">
          {facturas.map(f => (
            <div key={f.id} className="bg-white border border-gray-200 rounded-xl p-4 flex items-center justify-between gap-4 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${statusColor(f.status)}`}>
                    {f.status === 'timbrada' ? 'Timbrada' : f.status === 'pendiente' ? 'Pendiente' : f.status === 'cancelada' ? 'Cancelada' : 'Error'}
                  </span>
                  {f.serie && f.folio && (
                    <span className="text-xs text-gray-500 font-mono">{f.serie}-{f.folio}</span>
                  )}
                </div>
                <p className="text-sm font-semibold text-gray-800 truncate">
                  {f.viaje ? `${f.viaje.origen} → ${f.viaje.destino}` : 'Sin viaje'}
                </p>
                {f.uuid && <p className="text-xs text-gray-400 font-mono truncate">UUID: {f.uuid}</p>}
                <p className="text-xs text-gray-400 mt-0.5">
                  {new Date(f.creadoEn).toLocaleDateString('es-MX')} · Subtotal ${(f.subtotal||0).toLocaleString('es-MX')} + IVA ${(f.iva||0).toLocaleString('es-MX')} = <strong>${(f.total||0).toLocaleString('es-MX')} MXN</strong>
                </p>
                {f.errorMsg && <p className="text-xs text-red-500 mt-1">Error: {f.errorMsg}</p>}
              </div>
              {f.status === 'timbrada' && (
                <div className="flex gap-2 flex-shrink-0">
                  <button
                    onClick={() => descargarFactura(f, 'xml')}
                    disabled={descargando[`${f.id}_xml`]}
                    className="flex items-center gap-1 px-3 py-1.5 text-xs border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-600 disabled:opacity-50 transition"
                  >
                    {descargando[`${f.id}_xml`] ? <RotateCcw size={13} className="animate-spin" /> : <Download size={13} />} XML
                  </button>
                  <button
                    onClick={() => descargarFactura(f, 'pdf')}
                    disabled={descargando[`${f.id}_pdf`]}
                    className="flex items-center gap-1 px-3 py-1.5 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition"
                  >
                    {descargando[`${f.id}_pdf`] ? <RotateCcw size={13} className="animate-spin" /> : <Download size={13} />} PDF
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Modal datos fiscales */}
      {datosFiscalesModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-gray-800">Datos Fiscales</h3>
              <button onClick={() => setDatosFiscalesModal(false)} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
            </div>
            <p className="text-xs text-gray-500 mb-4">Estos datos aparecerán como receptor en las facturas que emite Choyero.</p>
            <div className="space-y-3">
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">RFC (solo lectura)</label>
                <div className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-gray-50 text-gray-500 font-mono flex items-center justify-between">
                  <span>{form.rfc || <span className="italic text-gray-400">Sin RFC registrado</span>}</span>
                  {!form.rfc && <span className="text-xs text-orange-500 font-sans font-semibold">⚠ Sube tu CSF para registrarlo</span>}
                </div>
                <p className="text-xs text-gray-400 mt-0.5">El RFC se extrae automáticamente de tu Constancia de Situación Fiscal. Contacta a soporte si necesitas corregirlo.</p>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Razón Social *</label>
                <input value={form.razonSocial} onChange={e => setForm(p => ({ ...p, razonSocial: e.target.value }))} placeholder="Ej: Transportes Ejemplo SA de CV" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Régimen Fiscal *</label>
                <select value={form.regimenFiscal} onChange={e => setForm(p => ({ ...p, regimenFiscal: e.target.value }))} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none">
                  <option value="">Selecciona...</option>
                  {REGIMENES_FISCALES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Código Postal Fiscal *</label>
                <input value={form.cpFiscal} onChange={e => setForm(p => ({ ...p, cpFiscal: e.target.value }))} placeholder="Ej: 06600" maxLength={5} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Uso del CFDI</label>
                <select value={form.usoCfdi} onChange={e => setForm(p => ({ ...p, usoCfdi: e.target.value }))} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none">
                  {USOS_CFDI.map(u => <option key={u.value} value={u.value}>{u.label}</option>)}
                </select>
              </div>
            </div>
            {msg && <p className={`text-xs mt-3 ${msg.tipo === 'ok' ? 'text-green-600' : 'text-red-500'}`}>{msg.texto}</p>}
            <div className="flex gap-3 mt-5">
              <button onClick={() => setDatosFiscalesModal(false)} className="flex-1 px-4 py-2 border border-gray-300 rounded-xl text-gray-600 text-sm hover:bg-gray-50 transition">Cancelar</button>
              <button onClick={guardarDatosFiscales} disabled={guardando} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700 disabled:opacity-50 transition">
                {guardando ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Sección: Costos Operativos ──────────────────────────────────────────────
function SeccionCostos({ unidades }) {
  const [tab, setTab] = React.useState('mantenimiento');
  const [registros, setRegistros] = React.useState([]);
  const [diesel, setDiesel] = React.useState([]);
  const [cargando, setCargando] = React.useState(true);
  const [form, setForm] = React.useState({ unidadId: '', tipo: '', descripcion: '', costo: '', fecha: new Date().toISOString().slice(0,10) });
  const [formD, setFormD] = React.useState({ unidadId: '', litros: '', precioPorLitro: '', fecha: new Date().toISOString().slice(0,10), notas: '' });
  const [guardando, setGuardando] = React.useState(false);
  const [msg, setMsg] = React.useState(null);

  const cargar = React.useCallback(async () => {
    setCargando(true);
    try {
      const [m, d] = await Promise.all([apiGetMantenimiento(), apiGetDiesel()]);
      setRegistros(m || []);
      setDiesel(d || []);
    } catch {} finally { setCargando(false); }
  }, []);

  React.useEffect(() => { cargar(); }, [cargar]);

  const ahora = new Date();
  const inicioMes = new Date(ahora.getFullYear(), ahora.getMonth(), 1);
  const gastoMantMes = registros.filter(r => new Date(r.fecha) >= inicioMes).reduce((s,r) => s + (r.costo||0), 0);
  const gastoDieselMes = diesel.filter(r => new Date(r.fecha) >= inicioMes).reduce((s,r) => s + (r.totalCosto||0), 0);
  const gastoTotalMes = gastoMantMes + gastoDieselMes;

  const tiposMantenimiento = ['aceite', 'neumáticos', 'frenos', 'eléctrico', 'preventivo', 'correctivo', 'otro'];

  const etiquetaUnidad = (u) => `${u.tipo} ${u.marca||''} ${u.modelo||''} ${u.anio||''} ${u.placas ? `· ${u.placas}` : ''}`.trim();

  const handleGuardarMant = async (e) => {
    e.preventDefault();
    if (!form.unidadId || !form.tipo || !form.fecha) return;
    setGuardando(true);
    try {
      const r = await apiAgregarMantenimiento(form);
      setRegistros(prev => [r, ...prev]);
      setForm({ unidadId: '', tipo: '', descripcion: '', costo: '', fecha: new Date().toISOString().slice(0,10) });
      setMsg({ ok: true, text: 'Mantenimiento registrado' });
    } catch { setMsg({ ok: false, text: 'Error al guardar' }); }
    finally { setGuardando(false); setTimeout(() => setMsg(null), 3000); }
  };

  const handleGuardarDiesel = async (e) => {
    e.preventDefault();
    if (!formD.unidadId || !formD.litros || !formD.precioPorLitro || !formD.fecha) return;
    setGuardando(true);
    try {
      const r = await apiAgregarDiesel(formD);
      setDiesel(prev => [r, ...prev]);
      setFormD({ unidadId: '', litros: '', precioPorLitro: '', fecha: new Date().toISOString().slice(0,10), notas: '' });
      setMsg({ ok: true, text: 'Carga registrada' });
    } catch { setMsg({ ok: false, text: 'Error al guardar' }); }
    finally { setGuardando(false); setTimeout(() => setMsg(null), 3000); }
  };

  const eliminarMant = async (id) => {
    await apiEliminarMantenimiento(id).catch(()=>{});
    setRegistros(prev => prev.filter(r => r.id !== id));
  };
  const eliminarDiesel = async (id) => {
    await apiEliminarDiesel(id).catch(()=>{});
    setDiesel(prev => prev.filter(r => r.id !== id));
  };

  const inputCls = 'w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-400 focus:outline-none';

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
        <Wrench size={24} className="text-gray-600" /> Costos Operativos
      </h2>

      {/* Cards resumen del mes */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        {[
          { label: 'Mantenimiento este mes', value: gastoMantMes, wrap: 'bg-blue-50 border border-blue-100', lbl: 'text-blue-600', val: 'text-blue-800' },
          { label: 'Diesel este mes', value: gastoDieselMes, wrap: 'bg-orange-50 border border-orange-100', lbl: 'text-orange-600', val: 'text-orange-800' },
          { label: 'Total costos mes', value: gastoTotalMes, wrap: 'bg-red-50 border border-red-100', lbl: 'text-red-600', val: 'text-red-800' },
        ].map(({ label, value, wrap, lbl, val }) => (
          <div key={label} className={`${wrap} rounded-xl p-4`}>
            <p className={`text-xs font-semibold ${lbl} uppercase mb-1`}>{label}</p>
            <p className={`text-2xl font-black ${val}`}>${value.toLocaleString('es-MX', { minimumFractionDigits: 0 })} MXN</p>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="flex gap-1 bg-gray-100 rounded-lg p-1 mb-6 w-fit">
        {[{ id: 'mantenimiento', label: '🔧 Mantenimiento' }, { id: 'diesel', label: '⛽ Diesel' }].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            className={`px-4 py-2 rounded-md text-sm font-semibold transition ${tab === t.id ? 'bg-white shadow text-gray-800' : 'text-gray-500 hover:text-gray-700'}`}>
            {t.label}
          </button>
        ))}
      </div>

      {msg && <div className={`mb-4 p-3 rounded-xl text-sm font-medium ${msg.ok ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>{msg.text}</div>}

      {/* ── Tab Mantenimiento ── */}
      {tab === 'mantenimiento' && (
        <div className="space-y-6">
          <form onSubmit={handleGuardarMant} className="bg-white border border-gray-200 rounded-xl p-5">
            <h3 className="font-bold text-gray-800 mb-4">Registrar mantenimiento</h3>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Unidad *</label>
                <select required value={form.unidadId} onChange={e => setForm({...form, unidadId: e.target.value})} className={inputCls}>
                  <option value="">Seleccionar...</option>
                  {unidades.map(u => <option key={u.id} value={u.id}>{etiquetaUnidad(u)}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Tipo *</label>
                <select required value={form.tipo} onChange={e => setForm({...form, tipo: e.target.value})} className={inputCls}>
                  <option value="">Seleccionar...</option>
                  {tiposMantenimiento.map(t => <option key={t} value={t}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Fecha *</label>
                <input type="date" required value={form.fecha} onChange={e => setForm({...form, fecha: e.target.value})} className={inputCls} />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Costo (MXN)</label>
                <input type="number" min="0" step="0.01" value={form.costo} onChange={e => setForm({...form, costo: e.target.value})} onWheel={e=>e.target.blur()} placeholder="0.00" className={inputCls} />
              </div>
              <div className="col-span-2">
                <label className="block text-xs font-semibold text-gray-600 mb-1">Descripción</label>
                <input type="text" value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})} placeholder="Ej. Cambio de aceite 5W-30" className={inputCls} />
              </div>
            </div>
            <button type="submit" disabled={guardando} className="mt-4 px-5 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-semibold rounded-xl transition disabled:opacity-50">
              {guardando ? 'Guardando...' : '+ Registrar'}
            </button>
          </form>

          <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
            <div className="px-5 py-3 border-b border-gray-100 font-bold text-gray-700 text-sm">Historial de mantenimientos</div>
            {cargando ? <p className="p-5 text-gray-400 text-sm">Cargando...</p>
              : registros.length === 0 ? <p className="p-5 text-gray-400 text-sm">Sin registros aún.</p>
              : <div className="divide-y divide-gray-100">
                {registros.map(r => (
                  <div key={r.id} className="flex items-center justify-between px-5 py-3">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-xs font-bold bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full capitalize">{r.tipo}</span>
                        <span className="text-sm font-semibold text-gray-800">{r.unidad ? etiquetaUnidad(r.unidad) : ''}</span>
                      </div>
                      {r.descripcion && <p className="text-xs text-gray-500 mt-0.5">{r.descripcion}</p>}
                      <p className="text-xs text-gray-400 mt-0.5">{new Date(r.fecha).toLocaleDateString('es-MX', { day:'2-digit', month:'short', year:'numeric' })}</p>
                    </div>
                    <div className="flex items-center gap-3 ml-4 flex-shrink-0">
                      {r.costo > 0 && <span className="text-sm font-bold text-gray-800">${r.costo.toLocaleString('es-MX')} MXN</span>}
                      <button onClick={() => eliminarMant(r.id)} className="text-red-400 hover:text-red-600"><X size={16}/></button>
                    </div>
                  </div>
                ))}
              </div>
            }
          </div>
        </div>
      )}

      {/* ── Tab Diesel ── */}
      {tab === 'diesel' && (
        <div className="space-y-6">
          <form onSubmit={handleGuardarDiesel} className="bg-white border border-gray-200 rounded-xl p-5">
            <h3 className="font-bold text-gray-800 mb-4">Registrar carga de diesel</h3>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Unidad *</label>
                <select required value={formD.unidadId} onChange={e => setFormD({...formD, unidadId: e.target.value})} className={inputCls}>
                  <option value="">Seleccionar...</option>
                  {unidades.map(u => <option key={u.id} value={u.id}>{etiquetaUnidad(u)}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Fecha *</label>
                <input type="date" required value={formD.fecha} onChange={e => setFormD({...formD, fecha: e.target.value})} className={inputCls} />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Litros *</label>
                <input type="number" min="0" step="0.1" required value={formD.litros} onChange={e => setFormD({...formD, litros: e.target.value})} onWheel={e=>e.target.blur()} placeholder="150.5" className={inputCls} />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Precio por litro (MXN) *</label>
                <input type="number" min="0" step="0.01" required value={formD.precioPorLitro} onChange={e => setFormD({...formD, precioPorLitro: e.target.value})} onWheel={e=>e.target.blur()} placeholder="23.50" className={inputCls} />
              </div>
              {formD.litros && formD.precioPorLitro && (
                <div className="col-span-2 bg-green-50 rounded-lg px-4 py-2 text-sm font-semibold text-green-700">
                  Total: ${(parseFloat(formD.litros||0) * parseFloat(formD.precioPorLitro||0)).toFixed(2)} MXN
                </div>
              )}
              <div className="col-span-2">
                <label className="block text-xs font-semibold text-gray-600 mb-1">Notas</label>
                <input type="text" value={formD.notas} onChange={e => setFormD({...formD, notas: e.target.value})} placeholder="Ej. Gasolinera en km 45 carr. La Paz" className={inputCls} />
              </div>
            </div>
            <button type="submit" disabled={guardando} className="mt-4 px-5 py-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold rounded-xl transition disabled:opacity-50">
              {guardando ? 'Guardando...' : '+ Registrar'}
            </button>
          </form>

          <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
            <div className="px-5 py-3 border-b border-gray-100 font-bold text-gray-700 text-sm">Historial de cargas</div>
            {cargando ? <p className="p-5 text-gray-400 text-sm">Cargando...</p>
              : diesel.length === 0 ? <p className="p-5 text-gray-400 text-sm">Sin registros aún.</p>
              : <div className="divide-y divide-gray-100">
                {diesel.map(r => (
                  <div key={r.id} className="flex items-center justify-between px-5 py-3">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <Fuel size={14} className="text-orange-500 flex-shrink-0" />
                        <span className="text-sm font-semibold text-gray-800">{r.unidad ? etiquetaUnidad(r.unidad) : ''}</span>
                        <span className="text-xs text-gray-500">{r.litros}L · ${r.precioPorLitro}/L</span>
                      </div>
                      {r.notas && <p className="text-xs text-gray-500 mt-0.5">{r.notas}</p>}
                      <p className="text-xs text-gray-400 mt-0.5">{new Date(r.fecha).toLocaleDateString('es-MX', { day:'2-digit', month:'short', year:'numeric' })}</p>
                    </div>
                    <div className="flex items-center gap-3 ml-4 flex-shrink-0">
                      <span className="text-sm font-bold text-orange-700">${r.totalCosto.toLocaleString('es-MX')} MXN</span>
                      <button onClick={() => eliminarDiesel(r.id)} className="text-red-400 hover:text-red-600"><X size={16}/></button>
                    </div>
                  </div>
                ))}
              </div>
            }
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Sección: Estadísticas PRO ──────────────────────────────────────────────
function SeccionEstadisticasPro() {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [periodo, setPeriodo] = React.useState('mes');

  const cargar = React.useCallback(async (p) => {
    setLoading(true);
    try { const r = await apiGetEstadisticasPro(p); if (r.ok) setData(r); }
    catch { /* silencioso */ } finally { setLoading(false); }
  }, []);

  React.useEffect(() => { cargar(periodo); }, [cargar, periodo]);

  const periodos = [{ id: 'mes', label: 'Este mes' }, { id: 'trimestre', label: 'Trimestre' }, { id: 'anio', label: 'Este año' }, { id: 'todo', label: 'Todo' }];

  const maxIngreso = data ? Math.max(...data.tendencia.map(t => t.ingresos), 1) : 1;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
          📊 Estadísticas
        </h2>
        <div className="flex gap-1 bg-gray-100 rounded-lg p-1">
          {periodos.map(p => (
            <button key={p.id} onClick={() => setPeriodo(p.id)}
              className={`px-3 py-1.5 rounded-md text-xs font-semibold transition ${periodo === p.id ? 'bg-white shadow text-gray-800' : 'text-gray-500 hover:text-gray-700'}`}>
              {p.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center h-48 text-gray-400">Cargando estadísticas...</div>
      ) : !data ? (
        <div className="text-center text-gray-400 py-16">No se pudieron cargar las estadísticas.</div>
      ) : (
        <>
          {/* Tarjetas resumen */}
          {(() => {
            const CARD_STYLES = {
              green:  { wrap: 'bg-green-50 border border-green-100',   lbl: 'text-green-600',  val: 'text-green-800',  sub: 'text-green-500' },
              yellow: { wrap: 'bg-yellow-50 border border-yellow-100', lbl: 'text-yellow-600', val: 'text-yellow-800', sub: 'text-yellow-500' },
              blue:   { wrap: 'bg-blue-50 border border-blue-100',     lbl: 'text-blue-600',   val: 'text-blue-800',   sub: 'text-blue-500' },
              purple: { wrap: 'bg-purple-50 border border-purple-100', lbl: 'text-purple-600', val: 'text-purple-800', sub: 'text-purple-500' },
            };
            const tarjetas = [
              { label: 'Ingresos netos', valor: `$${Math.round(data.resumen.ingresosTotal).toLocaleString()}`, sub: 'MXN liberados', color: 'green' },
              { label: 'En garantía', valor: `$${Math.round(data.resumen.ingresosEspera).toLocaleString()}`, sub: 'pendiente de liberar', color: 'yellow' },
              { label: 'Viajes completados', valor: data.resumen.viajesCompletados, sub: `${data.resumen.viajesCancelados} cancelados`, color: 'blue' },
              { label: 'Tasa de cierre', valor: `${data.resumen.tasaCierre}%`, sub: `${data.resumen.cotizAceptadas} / ${data.resumen.cotizTotal} cotizaciones`, color: 'purple' },
            ];
            return (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                {tarjetas.map(({ label, valor, sub, color }) => {
                  const s = CARD_STYLES[color];
                  return (
                    <div key={label} className={`${s.wrap} rounded-xl p-4`}>
                      <p className={`text-xs font-semibold ${s.lbl} uppercase mb-1`}>{label}</p>
                      <p className={`text-2xl font-black ${s.val}`}>{valor}</p>
                      <p className={`text-xs ${s.sub} mt-0.5`}>{sub}</p>
                    </div>
                  );
                })}
              </div>
            );
          })()}

          {/* Tendencia mensual */}
          <div className="bg-white border border-gray-200 rounded-xl p-5 mb-6">
            <h3 className="text-sm font-bold text-gray-700 mb-4">Ingresos netos — últimos 6 meses</h3>
            <div className="flex items-end gap-2 h-32">
              {data.tendencia.map((t, i) => {
                const pct = maxIngreso > 0 ? (t.ingresos / maxIngreso) * 100 : 0;
                return (
                  <div key={i} className="flex-1 flex flex-col items-center gap-1">
                    <p className="text-xs text-gray-500 font-semibold">{t.ingresos > 0 ? `$${Math.round(t.ingresos / 1000)}k` : ''}</p>
                    <div className="w-full rounded-t-md bg-orange-400 transition-all" style={{ height: `${Math.max(pct, 2)}%` }} title={`$${t.ingresos.toLocaleString()} · ${t.viajes} viajes`} />
                    <p className="text-xs text-gray-400">{t.label}</p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Rutas más rentables */}
          <div className="bg-white border border-gray-200 rounded-xl p-5 mb-6">
            <h3 className="text-sm font-bold text-gray-700 mb-3">🗺 Rutas más rentables</h3>
            {data.rutasRentables.length === 0 ? (
              <p className="text-sm text-gray-400 text-center py-4">Sin datos de rutas en este período.</p>
            ) : (
              <div className="space-y-2">
                {data.rutasRentables.map((r, i) => {
                  const pct = data.rutasRentables[0].ingresos > 0 ? (r.ingresos / data.rutasRentables[0].ingresos) * 100 : 0;
                  return (
                    <div key={i} className="flex items-center gap-3">
                      <span className="text-xs text-gray-400 w-4 shrink-0">#{i + 1}</span>
                      <div className="flex-1">
                        <div className="flex justify-between items-center mb-0.5">
                          <span className="text-xs font-semibold text-gray-700">{r.ruta}</span>
                          <span className="text-xs text-gray-500">{r.viajes} viaje{r.viajes !== 1 ? 's' : ''} · <span className="font-bold text-green-700">${Math.round(r.ingresos).toLocaleString()}</span></span>
                        </div>
                        <div className="h-1.5 bg-gray-100 rounded-full"><div className="h-full bg-orange-400 rounded-full" style={{ width: `${pct}%` }} /></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Cotizaciones */}
          <div className="bg-white border border-gray-200 rounded-xl p-5">
            <h3 className="text-sm font-bold text-gray-700 mb-3">📋 Cotizaciones enviadas</h3>
            <div className="flex items-center gap-4">
              {[
                { label: 'Enviadas', val: data.resumen.cotizTotal, color: 'bg-gray-200' },
                { label: 'Aceptadas', val: data.resumen.cotizAceptadas, color: 'bg-green-400' },
                { label: 'No seleccionadas', val: data.resumen.cotizTotal - data.resumen.cotizAceptadas, color: 'bg-red-300' },
              ].map(({ label, val, color }) => (
                <div key={label} className="text-center flex-1">
                  <div className={`w-12 h-12 ${color} rounded-full flex items-center justify-center mx-auto mb-1`}>
                    <span className="text-sm font-black text-white">{val}</span>
                  </div>
                  <p className="text-xs text-gray-500">{label}</p>
                </div>
              ))}
              <div className="flex-1 text-center">
                <div className="w-12 h-12 bg-orange-400 rounded-full flex items-center justify-center mx-auto mb-1">
                  <span className="text-sm font-black text-white">{data.resumen.tasaCierre}%</span>
                </div>
                <p className="text-xs text-gray-500">Tasa de cierre</p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

// ─── Sección: Mis Cobros ────────────────────────────────────────────────────
function SeccionMisCobros() {
  const [cobros, setCobros] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const cargar = React.useCallback(() => {
    setLoading(true);
    apiGetMisCobros().then(p => setCobros(p || [])).catch(e => { console.warn('[Transportista] Error cargando cobros:', e.message); setCobros([]); }).finally(() => setLoading(false));
  }, []);

  React.useEffect(() => {
    cargar();
    const interval = setInterval(cargar, 30000);
    return () => clearInterval(interval);
  }, [cargar]);

  const totalRetenido = cobros.filter(p => p.status === 'retenido').reduce((s, p) => s + p.montoTransportista, 0);
  const totalLiberado = cobros.filter(p => ['liberado', 'pagado'].includes(p.status)).reduce((s, p) => s + p.montoTransportista, 0);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
          <Banknote size={26} className="text-green-600" /> Mis Cobros
        </h2>
        <button onClick={cargar} disabled={loading} className="flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-600 disabled:opacity-50 transition">
          <RotateCcw size={14} className={loading ? 'animate-spin' : ''} /> Actualizar
        </button>
      </div>

      {/* Resumen */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
          <p className="text-xs text-yellow-700 font-semibold uppercase mb-1">En garantía (por liberar)</p>
          <p className="text-2xl font-bold text-yellow-800">${totalRetenido.toLocaleString()} <span className="text-sm font-normal">MXN</span></p>
        </div>
        <div className="bg-green-50 border border-green-200 rounded-xl p-4">
          <p className="text-xs text-green-700 font-semibold uppercase mb-1">Liberado / disponible</p>
          <p className="text-2xl font-bold text-green-800">${totalLiberado.toLocaleString()} <span className="text-sm font-normal">MXN</span></p>
        </div>
      </div>

      {/* Tabla */}
      {loading ? (
        <div className="text-center py-12 text-gray-400">Cargando cobros...</div>
      ) : cobros.length === 0 ? (
        <div className="text-center py-12 text-gray-400">
          <Banknote size={40} className="mx-auto mb-3 opacity-30" />
          <p>Aún no tienes cobros registrados</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Ruta</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Método</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">Tu cobro</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">Comisión plataforma</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase">Estado</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Fecha</th>
              </tr>
            </thead>
            <tbody>
              {cobros.map(p => (
                <tr key={p.id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="px-4 py-3">
                    <p className="font-medium text-gray-800 truncate max-w-[180px]">{p.viaje?.origen?.split(',')[0]} → {p.viaje?.destino?.split(',')[0]}</p>
                    {p.viaje?.retornoId && <span className="text-xs bg-teal-100 text-teal-700 px-1.5 py-0.5 rounded font-semibold">Retorno</span>}
                  </td>
                  <td className="px-4 py-3 text-gray-500 capitalize">
                    {p.esPromo && <span className="inline-block mb-0.5 text-xs bg-green-100 text-green-700 font-semibold px-1.5 py-0.5 rounded">🎁 Promo</span>}
                    {!p.esPromo && (p.metodoPago || '—')}
                  </td>
                  <td className="px-4 py-3 text-right font-bold text-green-700">${(p.montoTransportista||0).toLocaleString()}</td>
                  <td className="px-4 py-3 text-right text-gray-500">${(p.montoComision||0).toLocaleString()}</td>
                  <td className="px-4 py-3 text-center">
                    {p.status === 'pagado' && !p.transferId?.startsWith('manual-') ? (
                      <span className="bg-purple-100 text-purple-700 text-xs font-semibold px-2 py-1 rounded-full">💳 Pagado</span>
                    ) : p.status === 'pagado' ? (
                      <span className="bg-orange-100 text-orange-700 text-xs font-semibold px-2 py-1 rounded-full">⏳ SPEI en proceso</span>
                    ) : p.status === 'liberado' ? (
                      <span className="bg-blue-100 text-blue-700 text-xs font-semibold px-2 py-1 rounded-full">🏦 Por cobrar</span>
                    ) : p.status === 'retenido' ? (
                      <span className="bg-yellow-100 text-yellow-700 text-xs font-semibold px-2 py-1 rounded-full">🔒 En garantía</span>
                    ) : p.status === 'pendiente' ? (
                      <span className="bg-gray-100 text-gray-600 text-xs font-semibold px-2 py-1 rounded-full">⏳ Pendiente</span>
                    ) : (
                      <span className="bg-red-100 text-red-700 text-xs font-semibold px-2 py-1 rounded-full">Cancelado</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-gray-500 text-xs">{new Date(p.creadoEn).toLocaleDateString('es-MX')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ─── Sección: Datos Bancarios ────────────────────────────────────────────────
function SeccionDatosBancarios({ empresaId, onCLABERegistrada }) {
  const [datos, setDatos] = React.useState({ clabe: '', nombreBanco: '' });
  const [editando, setEditando] = React.useState(false);
  const [guardando, setGuardando] = React.useState(false);
  const [msg, setMsg] = React.useState(null);

  React.useEffect(() => {
    apiGetDatosBancarios().then(d => { if (d) setDatos({ clabe: d.clabe || '', nombreBanco: d.nombreBanco || '' }); }).catch(e => console.warn('[Transportista] Error cargando datos bancarios:', e.message));
  }, []);

  const guardar = async () => {
    setGuardando(true); setMsg(null);
    try {
      await apiActualizarDatosBancarios(datos);
      setMsg({ ok: true, text: 'Datos bancarios guardados correctamente' });
      setEditando(false);
      if (datos.clabe && onCLABERegistrada) onCLABERegistrada();
    } catch (e) { setMsg({ ok: false, text: 'Error al guardar' }); }
    setGuardando(false);
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
        <CreditCard size={26} className="text-green-600" /> Datos Bancarios
      </h2>
      <p className="text-gray-500 text-sm mb-6">Aquí depositamos tus cobros cuando el cliente confirma la entrega. La CLABE debe ser la cuenta donde recibirás los pagos.</p>

      {msg && (
        <div className={`mb-4 px-4 py-3 rounded-lg text-sm font-medium ${msg.ok ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
          {msg.text}
        </div>
      )}

      <div className="bg-white border border-gray-200 rounded-xl p-6 space-y-5">
        {/* CLABE */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">CLABE Interbancaria <span className="text-red-500">*</span></label>
          {editando ? (
            <input
              type="text"
              maxLength={18}
              value={datos.clabe}
              onChange={e => setDatos(p => ({ ...p, clabe: e.target.value.replace(/\D/g, '').slice(0, 18) }))}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 font-mono tracking-widest"
              placeholder="18 dígitos"
            />
          ) : (
            <div className="flex items-center gap-3">
              <p className="font-mono text-lg tracking-widest text-gray-800">
                {datos.clabe ? datos.clabe.replace(/(\d{4})(?=\d)/g, '$1 ') : <span className="text-gray-400 text-sm font-sans">Sin CLABE registrada</span>}
              </p>
              {datos.clabe && <span className="bg-green-100 text-green-700 text-xs font-semibold px-2 py-0.5 rounded-full">✓ Registrada</span>}
            </div>
          )}
          <p className="text-xs text-gray-400 mt-1">La CLABE tiene 18 dígitos y la proporciona tu banco.</p>
        </div>

        {/* Banco */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Nombre del banco</label>
          {editando ? (
            <input
              type="text"
              value={datos.nombreBanco}
              onChange={e => setDatos(p => ({ ...p, nombreBanco: e.target.value }))}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Ej: BBVA, Banorte, HSBC..."
            />
          ) : (
            <p className="text-gray-800">{datos.nombreBanco || <span className="text-gray-400 text-sm">Sin banco registrado</span>}</p>
          )}
        </div>

        {/* Botones */}
        <div className="flex gap-3 pt-2">
          {editando ? (
            <>
              <button onClick={guardar} disabled={guardando} className="flex-1 bg-green-600 text-white font-semibold py-2 rounded-lg hover:bg-green-700 transition text-sm disabled:opacity-50">
                {guardando ? 'Guardando...' : '💾 Guardar datos'}
              </button>
              <button onClick={() => setEditando(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">Cancelar</button>
            </>
          ) : (
            <button onClick={() => setEditando(true)} className="flex items-center gap-2 px-5 py-2 border border-green-600 text-green-700 font-semibold rounded-lg hover:bg-green-50 transition text-sm">
              <Edit size={14} /> {datos.clabe ? 'Editar datos' : 'Agregar CLABE'}
            </button>
          )}
        </div>
      </div>

      {/* Info escrow */}
      <div className="mt-4 bg-blue-50 border border-blue-200 rounded-xl p-4 text-sm text-blue-700">
        <p className="font-semibold mb-1">¿Cómo funciona el pago?</p>
        <ol className="list-decimal list-inside space-y-1 text-blue-600">
          <li>El cliente paga al aceptar tu cotización (queda en garantía)</li>
          <li>Completas el viaje y el cliente confirma la entrega</li>
          <li>El sistema deposita automáticamente a tu CLABE</li>
        </ol>
      </div>
    </div>
  );
}

function ProCountdown({ fecha }) {
  const [t, setT] = React.useState({ d: 0, h: 0, m: 0, s: 0 });
  React.useEffect(() => {
    const calc = () => {
      const diff = fecha - new Date();
      if (diff <= 0) return setT({ d: 0, h: 0, m: 0, s: 0 });
      setT({ d: Math.floor(diff / 86400000), h: Math.floor((diff % 86400000) / 3600000), m: Math.floor((diff % 3600000) / 60000), s: Math.floor((diff % 60000) / 1000) });
    };
    calc();
    const id = setInterval(calc, 1000);
    return () => clearInterval(id);
  }, [fecha]);
  return (
    <div className="flex justify-center gap-2 my-3">
      {[['d', 'días'], ['h', 'hrs'], ['m', 'min'], ['s', 'seg']].map(([k, lbl]) => (
        <div key={k} className="text-center">
          <div className="bg-gray-900 text-white text-base font-black rounded-lg w-11 h-11 flex items-center justify-center">{String(t[k]).padStart(2, '0')}</div>
          <p className="text-xs text-gray-400 mt-0.5">{lbl}</p>
        </div>
      ))}
    </div>
  );
}

function AppTransportista({ usuario, onLogout }) {
  const { store, dispatch, recargar, cargandoApi, pausarPolling, reanudarPolling } = useApiStore('transportista');
  // ========== ESTADOS DE LA APLICACIÓN ==========
  const [tickMinuto, setTickMinuto] = useState(0);
  const [seccion, setSeccion] = useState('dashboard');
  const [sidebarAbierto, setSidebarAbierto] = useState(false);
  const [mostrarFormUnidad, setMostrarFormUnidad] = useState(false);
  const [mostrarFormChofer, setMostrarFormChofer] = useState(false);
  const [mostrarCotizacion, setMostrarCotizacion] = useState(null);
  const [fotoAmpliada, setFotoAmpliada] = useState(null);
  // Estado del formulario de cotización — elevado al padre para evitar reset en re-renders
  const [cotizLocalPrecio, setCotizLocalPrecio] = useState('');

  const descargarCartaPortePDF = (viaje) => {
    const cp = viaje.cartaPorte;
    const mercancias = Array.isArray(cp.mercancias) ? cp.mercancias : [cp.mercancias];
    const dir = (d) => [d?.calle, d?.numero].filter(Boolean).join(' ') + (d?.colonia ? `, Col. ${d.colonia}` : '') + (d?.municipio ? `, ${d.municipio}` : '') + (d?.estado ? `, ${d.estado}` : '') + (d?.cp ? ` C.P. ${d.cp}` : '');
    const fmt = (n) => n ? `$${Number(n).toLocaleString('es-MX')} MXN` : '—';
    const fecha = new Date().toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' });
    const mercRows = mercancias.map((m, i) => `
      <tr style="background:${i % 2 === 0 ? '#f8f9ff' : '#fff'}">
        <td style="padding:8px 10px;border:1px solid #dde3f0">${m?.descripcion || '—'}</td>
        <td style="padding:8px 10px;border:1px solid #dde3f0;text-align:center">${m?.claveSAT || '—'}</td>
        <td style="padding:8px 10px;border:1px solid #dde3f0;text-align:center">${m?.cantidad || '—'}</td>
        <td style="padding:8px 10px;border:1px solid #dde3f0;text-align:center">${m?.unidadMedida || '—'}</td>
        <td style="padding:8px 10px;border:1px solid #dde3f0;text-align:center">${m?.pesoKg ? `${m.pesoKg} kg` : '—'}</td>
        <td style="padding:8px 10px;border:1px solid #dde3f0;text-align:center">${m?.tipoEmbalaje || '—'}</td>
        <td style="padding:8px 10px;border:1px solid #dde3f0;text-align:right">${fmt(m?.valorDeclarado)}</td>
      </tr>`).join('');
    const html = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8">
    <title>Carta Porte — ${viaje.origen} → ${viaje.destino}</title>
    <style>
      * { margin:0; padding:0; box-sizing:border-box; }
      body { font-family: Arial, sans-serif; font-size: 12px; color: #1a1a2e; background: #fff; padding: 30px; }
      .header { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:3px solid #4f46e5; padding-bottom:16px; margin-bottom:20px; }
      .logo { font-size:22px; font-weight:900; color:#4f46e5; letter-spacing:-0.5px; }
      .logo span { color:#1a1a2e; }
      .doc-title { text-align:right; }
      .doc-title h1 { font-size:16px; font-weight:800; color:#1a1a2e; text-transform:uppercase; letter-spacing:1px; }
      .doc-title p { font-size:11px; color:#666; margin-top:4px; }
      .badge { display:inline-block; background:#4f46e5; color:#fff; font-size:10px; font-weight:700; padding:3px 10px; border-radius:20px; margin-top:6px; }
      .ruta { background:#f0f4ff; border:1px solid #c7d2fe; border-radius:8px; padding:12px 16px; margin-bottom:20px; display:flex; align-items:center; gap:12px; }
      .ruta-text { font-size:13px; font-weight:700; color:#3730a3; }
      .section { margin-bottom:20px; }
      .section-title { font-size:11px; font-weight:800; text-transform:uppercase; letter-spacing:1px; color:#4f46e5; border-left:3px solid #4f46e5; padding-left:8px; margin-bottom:10px; }
      .grid2 { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
      .card { border:1px solid #dde3f0; border-radius:6px; padding:12px; background:#fafbff; }
      .card p { margin-bottom:4px; color:#333; line-height:1.5; }
      .card .label { color:#888; font-size:10px; }
      .card .value { font-weight:600; }
      table { width:100%; border-collapse:collapse; font-size:11px; }
      th { background:#4f46e5; color:#fff; padding:8px 10px; text-align:left; font-weight:700; font-size:10px; text-transform:uppercase; letter-spacing:0.5px; }
      th:not(:first-child) { text-align:center; }
      th:last-child { text-align:right; }
      .footer { margin-top:30px; border-top:1px solid #dde3f0; padding-top:16px; display:flex; justify-content:space-between; color:#999; font-size:10px; }
      .folio { font-size:10px; color:#888; }
      @media print { body { padding:20px; } button { display:none !important; } }
    </style></head><body>
    <div class="header">
      <div>
        <div class="logo">Choye<span>ro</span></div>
        <div class="folio" style="margin-top:6px">Folio: ${viaje.folio || viaje.id.slice(-8).toUpperCase()}</div>
      </div>
      <div class="doc-title">
        <h1>Carta Porte</h1>
        <p>Fecha de emisión: ${fecha}</p>
        <span class="badge">Complemento de Transporte</span>
      </div>
    </div>
    <div class="ruta">
      <div>
        <div style="font-size:10px;color:#6366f1;font-weight:700;text-transform:uppercase">Ruta</div>
        <div class="ruta-text">${viaje.origen} → ${viaje.destino}</div>
      </div>
      <div style="margin-left:auto;text-align:right">
        <div style="font-size:10px;color:#6366f1;font-weight:700;text-transform:uppercase">Transportista</div>
        <div style="font-weight:700">${viaje.transportista || '—'}</div>
      </div>
    </div>
    <div class="section">
      <div class="section-title">Mercancías transportadas</div>
      <table>
        <thead><tr>
          <th>Descripción</th><th style="text-align:center">Clave SAT</th><th style="text-align:center">Cantidad</th>
          <th style="text-align:center">Unidad</th><th style="text-align:center">Peso</th>
          <th style="text-align:center">Embalaje</th><th style="text-align:right">Valor declarado</th>
        </tr></thead>
        <tbody>${mercRows}</tbody>
      </table>
    </div>
    <div class="section grid2">
      <div>
        <div class="section-title">Remitente (quien envía)</div>
        <div class="card">
          <p class="value" style="font-size:13px;margin-bottom:6px">${cp.remitente?.nombre || '—'}</p>
          <p><span class="label">RFC: </span><span class="value">${cp.remitente?.rfc || '—'}</span></p>
          <p style="margin-top:6px;color:#555">${dir(cp.remitente) || '—'}</p>
        </div>
      </div>
      <div>
        <div class="section-title">Destinatario (quien recibe)</div>
        <div class="card">
          <p class="value" style="font-size:13px;margin-bottom:6px">${cp.destinatario?.nombre || '—'}</p>
          <p><span class="label">RFC: </span><span class="value">${cp.destinatario?.rfc || '—'}</span></p>
          <p style="margin-top:6px;color:#555">${dir(cp.destinatario) || '—'}</p>
        </div>
      </div>
    </div>
    ${(cp.operador?.nombre || cp.vehiculo?.placas) ? `
    <div class="section grid2" style="margin-top:8px">
      ${cp.operador?.nombre ? `<div>
        <div class="section-title">Operador</div>
        <div class="card">
          <p class="value" style="font-size:13px;margin-bottom:6px">${cp.operador.nombre}</p>
          ${cp.operador.licencia ? `<p><span class="label">Licencia federal: </span><span class="value">${cp.operador.licencia}</span></p>` : ''}
          ${cp.operador.curp ? `<p><span class="label">CURP: </span><span class="value">${cp.operador.curp}</span></p>` : ''}
        </div>
      </div>` : '<div></div>'}
      ${cp.vehiculo?.placas ? `<div>
        <div class="section-title">Vehículo</div>
        <div class="card">
          ${cp.vehiculo.descripcion ? `<p class="value" style="font-size:13px;margin-bottom:6px">${cp.vehiculo.descripcion}</p>` : ''}
          <p><span class="label">Placas: </span><span class="value">${cp.vehiculo.placas}</span></p>
          ${cp.vehiculo.configuracion ? `<p><span class="label">Configuración: </span><span class="value">${cp.vehiculo.configuracion}</span></p>` : ''}
          ${cp.vehiculo.numeroRemolque ? `<p><span class="label">Remolque: </span><span class="value">${cp.vehiculo.numeroRemolque}</span></p>` : ''}
        </div>
      </div>` : '<div></div>'}
    </div>` : ''}
    <div class="footer">
      <span>Generado por Choyero — Marketplace Logístico</span>
      <span>Documento informativo. Para efectos fiscales genere el CFDI correspondiente.</span>
    </div>
    <div style="margin-top:20px;text-align:center">
      <button onclick="window.print()" style="background:#4f46e5;color:#fff;border:none;padding:10px 28px;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer">
        ⬇ Guardar como PDF
      </button>
    </div>
    </body></html>`;
    const win = window.open('', '_blank', 'width=900,height=700');
    win.document.write(html);
    win.document.close();
    setTimeout(() => win.print(), 600);
  };
  const [cotizLocalTiempoEntrega, setCotizLocalTiempoEntrega] = useState('');
  const [cotizLocalUnidadId, setCotizLocalUnidadId] = useState('');
  const [cotizLocalComentario, setCotizLocalComentario] = useState('');
  const [cotizLocalSeguro, setCotizLocalSeguro] = useState(false);
  const [cotizLocalRastreoGPS, setCotizLocalRastreoGPS] = useState(true);
  const [cotizLocalCargaDescarga, setCotizLocalCargaDescarga] = useState(false);
  const [cotizLocalAniosExp, setCotizLocalAniosExp] = useState('');
  const [cotizEnviando, setCotizEnviando] = useState(false);

  // Pausar polling mientras haya un modal de formulario abierto para evitar que se borre lo escrito
  useEffect(() => {
    const hayModal = !!mostrarCotizacion || mostrarFormUnidad || mostrarFormChofer;
    if (hayModal) pausarPolling();
    else reanudarPolling();
  }, [mostrarCotizacion, mostrarFormUnidad, mostrarFormChofer]); // eslint-disable-line

  const abrirModalCotizacion = (sol) => {
    const sinUnidad = unidades.length === 0;
    const sinChofer = choferes.length === 0;
    if (sinUnidad || sinChofer) {
      setModalSinFlota({ sinUnidad, sinChofer });
      return;
    }
    setCotizLocalPrecio('');
    setCotizLocalTiempoEntrega('');
    setCotizLocalUnidadId('');
    setCotizLocalComentario('');
    setCotizLocalSeguro(false);
    setCotizLocalRastreoGPS(true);
    setCotizLocalCargaDescarga(false);
    setCotizLocalAniosExp('');
    setMostrarCotizacion(sol);
  };

  const [verMapaViajeId, setVerMapaViajeId] = useState(null);
  const [verMapaRetornoId, setVerMapaRetornoId] = useState(null);
  const [expandedViaje, setExpandedViaje] = useState(null);
  const [mostrarDetalleViaje, setMostrarDetalleViaje] = useState(null);
  const [mostrarAsignarViaje, setMostrarAsignarViaje] = useState(null);
  const [mostrarCalificarCliente, setMostrarCalificarCliente] = useState(null);
  const [cancelarViajeModal, setCancelarViajeModal] = useState(null); // { id, origen, destino }
  const [cancelarMotivo, setCancelarMotivo] = useState('');
  const [cancelandoViaje, setCancelandoViaje] = useState(false);
  const [reenvioVerifLoading, setReenvioVerifLoading] = useState(false);
  const [reenvioVerifOk, setReenvioVerifOk] = useState(false);
  const [mostrarCredenciales, setMostrarCredenciales] = useState(null);
  const [mostrarAccesoChofer, setMostrarAccesoChofer] = useState(null); // chofer al que dar acceso
  const [accesoCreado, setAccesoCreado] = useState(null); // credenciales generadas para mostrar
  const [mostrarFormRetorno, setMostrarFormRetorno] = useState(false);
  const [notificacion, setNotificacion] = useState(null);
  const [editando, setEditando] = useState(null);
  const [filtroSolicitudes, setFiltroSolicitudes] = useState('todas');
  const [busquedaSolicitudes, setBusquedaSolicitudes] = useState('');
  const [filtroTipoUnidad, setFiltroTipoUnidad] = useState('');
  const [filtroPrioridad, setFiltroPrioridad] = useState('');
  const [expandedSolicitud, setExpandedSolicitud] = useState(null);
  const [califClienteCache, setCalifClienteCache] = useState({});
  const [opinionesExpandidas, setOpinionesExpandidas] = useState({});
  const [filtroRetornos, setFiltroRetornos] = useState('mis_ofertas');
  const [mostrarNotificaciones, setMostrarNotificaciones] = useState(false);
  const [toastNotif, setToastNotif] = useState([]);
  const [toastPausado, setToastPausado] = useState(false);
  const toastTimer = useRef(null);
  const [chatModal, setChatModal] = useState(null);
  const _chatSeenKey = `choyero_chat_seen_${usuario?.id || 'guest'}`;
  const [lastSeenMessages, setLastSeenMessages] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem(_chatSeenKey) || '{}'); } catch { return {}; }
  });
  const [unreadByChatKey, setUnreadByChatKey] = useState({});

  // GPS en tiempo real — actualiza cuando el chofer envía su posición
  const [choferGpsLive, setChoferGpsLive] = useState({});
  useEffect(() => {
    const handle = (e) => {
      const { viajeId, ordenId, lat, lng } = e.detail || {};
      if (!lat || !lng) return;
      setChoferGpsLive(prev => {
        const next = { ...prev };
        if (viajeId) next[viajeId] = { lat, lng };
        if (ordenId) next[ordenId] = { lat, lng };
        return next;
      });
    };
    window.addEventListener('choyero_gps_update', handle);
    return () => window.removeEventListener('choyero_gps_update', handle);
  }, []);
  const chatModalRef = useRef(null);
  const prevMensajesCount = useRef((store.mensajes || []).length);
  useEffect(() => { solicitarPermisoNotif(); }, []);
  useEffect(() => {
    apiGetDatosBancarios()
      .then(d => setTieneCLABE(!!(d && d.clabe)))
      .catch(() => setTieneCLABE(true)); // en caso de error, no bloquear
  }, []);
  // Mostrar modal de bienvenida solo la primera vez que el transportista accede con empresa activa
  useEffect(() => {
    if (!usuario?.id || !store.miEmpresa) return;
    if (store.miEmpresa.status !== 'activa') return;
    const key = `choyero_bienvenida_transportista_${usuario.id}`;
    if (localStorage.getItem(key)) return;
    // Solo mostrar si no tienen ningún paso del onboarding completado aún
    // tieneCLABE no se incluye porque empieza en true por defecto hasta que carga la API
    const emp = empresaActiva || store.miEmpresa;
    const tieneAlgo = !!(emp?.telefono || emp?.logo || emp?.rfc || (unidades.length > 0) || (choferes.length > 0));
    if (!tieneAlgo) {
      localStorage.setItem(key, '1');
      setModalBienvenida(true);
    }
  }, [usuario?.id, store.miEmpresa?.status]);
  // Detectar retorno de MercadoPago tras pago PRO
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pagoPro = params.get('pago_pro');
    if (!pagoPro) return;
    window.history.replaceState({}, '', window.location.pathname);
    if (pagoPro === 'exitoso') {
      mostrarNotificacion('¡Pago recibido! Activando tu plan PRO...', 'success');
      recargar();
    } else if (pagoPro === 'pendiente') {
      mostrarNotificacion('Tu pago SPEI está pendiente. Activaremos PRO al confirmarse.', 'warning');
    } else if (pagoPro === 'fallido') {
      mostrarNotificacion('El pago no se pudo completar. Intenta de nuevo.', 'error');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Datos fiscales integrados en el checklist de onboarding — modal automático eliminado
  // Al iniciar sesión, si hay múltiples notificaciones de estado de empresa acumuladas (porque el usuario
  // no estaba logueado cuando se produjeron), dejar solo la más reciente sin leer para evitar spam.
  const adminLoginToastShown = useRef(false);
  // También notificar si hay mensajes pendientes del canal admin que el usuario no ha visto esta sesión.
  useEffect(() => {
    if (!usuario?.id || adminLoginToastShown.current) return;
    adminLoginToastShown.current = true;

    deduplicarNotifsPorTipo(usuario.id, ['empresa_suspendida', 'empresa_reactivada']);

    // Revisar si hay mensajes del admin en el canal directo que no se han visto esta sesión
    const adminCanalId = `admin-empresa-${empresaId}`;
    const seenKey = `${adminCanalId}_admin`;
    const ultimoVistoTs = lastSeenMessages[seenKey] || null;
    const mensajesAdmin = (getStore().mensajes || []).filter(
      m => m.viajeId === adminCanalId && m.emisorId !== usuario.id &&
           (!ultimoVistoTs || new Date(m.fecha) > new Date(ultimoVistoTs))
    );
    if (mensajesAdmin.length > 0) {
      const ultimo = mensajesAdmin[mensajesAdmin.length - 1];
      const preview = ultimo.texto.length > 40 ? ultimo.texto.slice(0, 40) + '…' : ultimo.texto;
      setToastNotif(q => [...q, {
        tipo: 'chat_mensaje',
        titulo: `💬 Mensaje de ${ultimo.emisorNombre || 'Administración'}`,
        mensaje: `${mensajesAdmin.length > 1 ? `${mensajesAdmin.length} mensajes nuevos: ` : ''}${preview}`,
        datos: { viajeId: adminCanalId }
      }]);
      playNotifSound();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario?.id]);
  const prevFaseVisibleIds = useRef(null); // para polling de fases geográficas
  const notifiedSolicitudIds = useRef(new Set()); // evitar toasts duplicados
  const getSolicitudFaseRef = useRef(null); // ref para evitar stale closure en el intervalo
  const guardarDatosFiscalesAuto = async () => {
    if (!formDFAuto.razonSocial.trim() || !formDFAuto.regimenFiscal || !formDFAuto.cpFiscal.trim()) {
      setMsgDFAuto({ tipo: 'error', texto: 'Razón social, régimen fiscal y CP son obligatorios.' });
      return;
    }
    setGuardandoDFAuto(true); setMsgDFAuto(null);
    try {
      await apiActualizarDatosFiscales({ ...formDFAuto, usoCfdi: 'G03' });
      await recargar();
      setMsgDFAuto({ tipo: 'ok', texto: '¡Datos fiscales guardados!' });
      setTimeout(() => setModalDatosFiscalesAuto(false), 1000);
    } catch (e) {
      setMsgDFAuto({ tipo: 'error', texto: e.message || 'Error al guardar' });
    } finally {
      setGuardandoDFAuto(false);
    }
  };

  const logoInputRef = useRef(null); // ref para abrir file picker de logo desde onboarding
  const handleLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (ev) => {
      const logo = ev.target.result;
      actualizarLogoEmpresa(empresaId, logo); // feedback inmediato
      try {
        await apiActualizarEmpresa({ logo });
        await recargar();
      } catch { /* ya se actualizó localmente */ }
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  };
  const [editandoPerfil, setEditandoPerfil] = useState(false);
  const [formPerfil, setFormPerfil] = useState({});
  const [perfilGuardado, setPerfilGuardado] = useState(false);
  const [modalPagarPro, setModalPagarPro] = useState(false);
  const [formPago, setFormPago] = useState({ numero: '', nombre: '', expira: '', cvv: '' });
  const [pagoProcesando, setPagoProcesando] = useState(false);
  const [pagoExitoso, setPagoExitoso] = useState(false);
  const [periodoPro, setPeriodoPro] = useState('mensual');
  const [tieneCLABE, setTieneCLABE] = useState(true); // asumir true hasta verificar
  const [bannerFlotaCerrado, setBannerFlotaCerrado] = useState(
    () => typeof window !== 'undefined' && !!sessionStorage.getItem(`choyero_banner_flota_${JSON.parse(localStorage.getItem('choyero_usuario') || 'null')?.id}`)
  );
  const [modalSinFlota, setModalSinFlota] = useState(null); // { sinUnidad, sinChofer }
  const [modalBienvenida, setModalBienvenida] = useState(false);
  const [modalDatosFiscalesAuto, setModalDatosFiscalesAuto] = useState(false);
  const [formDFAuto, setFormDFAuto] = useState({ razonSocial: '', regimenFiscal: '', cpFiscal: '' });
  const [abrirDFModal, setAbrirDFModal] = useState(false);
  const [guardandoDFAuto, setGuardandoDFAuto] = useState(false);
  const [msgDFAuto, setMsgDFAuto] = useState(null);

  // ========== NOTIFICACIONES DEL STORE ==========
  const [panelNotifAbierto, setPanelNotifAbierto] = useState(false);
  const notifsPendientesRaw = getNotificacionesPendientes(store, usuario?.id, 'transportista');
  // Cuando el panel está abierto el badge se oculta de inmediato (no esperar sync del store)
  const notifsPendientes = panelNotifAbierto ? [] : notifsPendientesRaw;

  // Detectar notificaciones nuevas y mostrar popup automático
  // Toasts: solo desde evento centralizado de useApiStore (nunca desde polling directo)
  useEffect(() => {
    const handle = (e) => {
      const nuevas = e.detail?.notificaciones || [];
      if (nuevas.length === 0) return;
      setToastNotif(q => [...q, ...nuevas]);
      playNotifSound();
      fireNotifBrowser(nuevas[0].titulo || 'Choyero', nuevas[0].mensaje || '');
      // Marcar como leídas al mostrarse en pantalla — evita que reaparezcan en la siguiente sesión
      marcarNotificacionesLeidas(usuario?.id, 'transportista');
      apiMarcarLeidas().catch(() => {});
    };
    window.addEventListener('choyero_notif_nueva', handle);
    return () => window.removeEventListener('choyero_notif_nueva', handle);
  }, [usuario?.id]); // eslint-disable-line

  // Detectar nuevos mensajes de chat vía evento de socket y mostrar toast + badge
  const mensajesYaToastados = useRef(new Set());
  useEffect(() => {
    const handle = (e) => {
      if (e.detail?.evento !== 'nuevo_mensaje') return;
      const m = e.detail?.data?.mensaje;
      if (!m || m.emisorId === usuario?.id) return;
      // Deduplicar: el backend emite a múltiples rooms y el evento puede llegar varias veces
      if (mensajesYaToastados.current.has(m.id)) return;
      mensajesYaToastados.current.add(m.id);
      const myEmpresaId = usuario?.empresaId;
      const myViajeIds = new Set((getStore().viajes || [])
        .filter(v => v.empresaId === myEmpresaId || v.transportistaId === usuario?.id)
        .map(v => v.id));
      const adminCanalId = `admin-empresa-${myEmpresaId}`;
      if (!myViajeIds.has(m.viajeId) && m.viajeId !== adminCanalId) return;
      // Determinar la clave del canal (misma que se usa al abrir el chat)
      const chatKey = `${m.viajeId}_${m.emisorRol}`;
      // Solo incrementar badge si el chat de ese canal no está abierto ahora mismo
      const modalActual = chatModalRef.current;
      const chatAbierto = modalActual && modalActual.viajeId === m.viajeId;
      if (!chatAbierto) {
        setUnreadByChatKey(prev => ({ ...prev, [chatKey]: (prev[chatKey] || 0) + 1 }));
        const preview = m.texto.length > 40 ? m.texto.slice(0, 40) + '…' : m.texto;
        setToastNotif(q => [...q, { tipo: 'chat_mensaje', titulo: `💬 Mensaje de ${m.emisorNombre}`, mensaje: preview, datos: { viajeId: m.viajeId }, contraparte: { id: m.emisorId, nombre: m.emisorNombre, rol: m.emisorRol } }]);
        playNotifSound();
        fireNotifBrowser(`💬 Mensaje de ${m.emisorNombre}`, preview);
      }
    };
    window.addEventListener('choyero_realtime', handle);
    return () => window.removeEventListener('choyero_realtime', handle);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario?.id]);

  const cerrarToast = () => {
    setToastNotif(q => {
      if (q[0]?.id) {
        marcarNotificacionesLeidas(usuario?.id, 'transportista');
        apiMarcarLeidas().catch(() => {});
      }
      return q.slice(1);
    });
    setToastPausado(true);
  };

  // Mostrar siguiente notificación cuando el modal de acción se cierra
  useEffect(() => {
    if (toastPausado && !mostrarCotizacion && !mostrarAsignarViaje) {
      setToastPausado(false);
    }
  }, [mostrarCotizacion, mostrarAsignarViaje, toastPausado]);

  const abrirNotificaciones = () => {
    setMostrarNotificaciones(true);
    setPanelNotifAbierto(true);
    marcarNotificacionesLeidas(usuario?.id, 'transportista');
    // Marcar como leídas en la BD para que persista al recargar/reiniciar sesión
    apiMarcarLeidas().catch(() => {});
    // Actualizar store local inmediatamente
    dispatch(s => ({
      ...s,
      notificaciones: (s.notificaciones || []).map(n =>
        (n.destinatarioId === usuario?.id) ? { ...n, leida: true } : n
      )
    }));
  };

  const cerrarNotificaciones = () => {
    setMostrarNotificaciones(false);
    setPanelNotifAbierto(false);
  };

  // ========== CONFIGURACIÓN DE LÍMITES ==========
  const MAX_COTIZACIONES_POR_SOLICITUD = 10;

  // ========== CATÁLOGO DE MARCAS POR TIPO DE UNIDAD ==========
  const MARCAS_POR_TIPO = {
    'Camioneta':           ['Ford', 'Chevrolet', 'Toyota', 'Ram', 'Nissan', 'Volkswagen', 'Honda'],
    'Rabon':               ['International', 'Kenworth', 'Freightliner', 'Mercedes-Benz', 'Hino', 'Isuzu', 'UD Trucks'],
    'Torton':              ['International', 'Kenworth', 'Freightliner', 'Volvo', 'Scania', 'Hino', 'Mercedes-Benz'],
    'Trailer':             ['Kenworth', 'Freightliner', 'International', 'Peterbilt', 'Scania', 'Volvo', 'Mack'],
    'Trailer Refrigerado': ['Kenworth', 'Freightliner', 'Volvo', 'Scania', 'International', 'Peterbilt', 'Mack'],
  };

  // ========== CATÁLOGO DE MODELOS POR MARCA ==========
  const MODELOS_POR_MARCA = {
    'Kenworth':       ['T800', 'T680', 'W900', 'T370', 'T440', 'T270', 'C500'],
    'Freightliner':   ['Cascadia', 'Columbia', 'M2 106', 'M2 112', '114SD', 'Argosy', 'Business Class M2'],
    'International':  ['LT Series', 'RH Series', 'MV Series', 'HV Series', 'LoneStar', 'ProStar', '4300'],
    'Peterbilt':      ['389', '579', '567', '386', '348', '337', '330'],
    'Scania':         ['R450', 'R500', 'R580', 'G410', 'G450', 'P360', 'S500'],
    'Volvo':          ['FH 460', 'FH 500', 'FM 370', 'FMX 460', 'VNL 760', 'VNL 860', 'VHD'],
    'Mack':           ['Anthem', 'Pinnacle', 'Granite', 'TerraPro', 'LR Series'],
    'Mercedes-Benz':  ['Actros', 'Atego', 'Axor', 'Accelo', 'Arocs'],
    'Hino':           ['300 Series', '500 Series', '700 Series', '258ALP', '268', '338'],
    'Isuzu':          ['NPR', 'NQR', 'NRR', 'FRR', 'FTR', 'FVR'],
    'UD Trucks':      ['Quon', 'Condor', 'Croner', 'Kuzer'],
    'Ford':           ['F-350', 'F-450', 'F-550', 'F-650', 'Transit 350', 'Ranger'],
    'Chevrolet':      ['Silverado 2500', 'Silverado 3500', 'Colorado', 'Express 3500', 'Low Cab Forward'],
    'Toyota':         ['Hilux', 'Dyna', 'Land Cruiser 79'],
    'Ram':            ['1500', '2500', '3500', 'ProMaster 3500'],
    'Nissan':         ['NP300', 'Frontier', 'NV350 Urvan', 'Cabstar'],
    'Volkswagen':     ['Delivery Express', 'Delivery 9.170', 'Worker 17.220', 'Constellation 24.280'],
    'Honda':          ['Ridgeline'],
  };

  // ========== CAPACIDAD DE CARGA POR MODELO (toneladas) ==========
  const CAPACIDAD_POR_MODELO = {
    // Kenworth
    'T800': '25 tons', 'T680': '22 tons', 'W900': '25 tons', 'T370': '14 tons',
    'T440': '18 tons', 'T270': '10 tons', 'C500': '30 tons',
    // Freightliner
    'Cascadia': '22 tons', 'Columbia': '22 tons', 'M2 106': '8 tons', 'M2 112': '12 tons',
    '114SD': '18 tons', 'Argosy': '22 tons', 'Business Class M2': '8 tons',
    // International
    'LT Series': '22 tons', 'RH Series': '18 tons', 'MV Series': '10 tons', 'HV Series': '14 tons',
    'LoneStar': '22 tons', 'ProStar': '22 tons', '4300': '8 tons',
    // Peterbilt
    '389': '25 tons', '579': '22 tons', '567': '22 tons', '386': '22 tons',
    '348': '16 tons', '337': '10 tons', '330': '8 tons',
    // Scania
    'R450': '22 tons', 'R500': '25 tons', 'R580': '25 tons', 'G410': '20 tons',
    'G450': '22 tons', 'P360': '16 tons', 'S500': '25 tons',
    // Volvo
    'FH 460': '22 tons', 'FH 500': '25 tons', 'FM 370': '18 tons', 'FMX 460': '22 tons',
    'VNL 760': '22 tons', 'VNL 860': '25 tons', 'VHD': '18 tons',
    // Mack
    'Anthem': '22 tons', 'Pinnacle': '22 tons', 'Granite': '18 tons',
    'TerraPro': '14 tons', 'LR Series': '12 tons',
    // Mercedes-Benz
    'Actros': '25 tons', 'Atego': '10 tons', 'Axor': '18 tons', 'Accelo': '5 tons', 'Arocs': '25 tons',
    // Hino
    '300 Series': '3.5 tons', '500 Series': '8 tons', '700 Series': '20 tons',
    '258ALP': '8 tons', '268': '10 tons', '338': '14 tons',
    // Isuzu
    'NPR': '3 tons', 'NQR': '5 tons', 'NRR': '7 tons', 'FRR': '7 tons', 'FTR': '9 tons', 'FVR': '12 tons',
    // UD Trucks
    'Quon': '20 tons', 'Condor': '14 tons', 'Croner': '10 tons', 'Kuzer': '3.5 tons',
    // Ford
    'F-350': '2 tons', 'F-450': '3 tons', 'F-550': '4 tons', 'F-650': '6 tons',
    'Transit 350': '1.5 tons', 'Ranger': '1 ton',
    // Chevrolet
    'Silverado 2500': '1.5 tons', 'Silverado 3500': '2 tons', 'Colorado': '0.8 tons',
    'Express 3500': '1.5 tons', 'Low Cab Forward': '5 tons',
    // Toyota
    'Hilux': '1 ton', 'Dyna': '3.5 tons', 'Land Cruiser 79': '1.5 tons',
    // Ram
    '1500': '1 ton', '2500': '1.5 tons', '3500': '2 tons', 'ProMaster 3500': '1.5 tons',
    // Nissan
    'NP300': '1 ton', 'Frontier': '1 ton', 'NV350 Urvan': '1.2 tons', 'Cabstar': '3.5 tons',
    // Volkswagen
    'Delivery Express': '3 tons', 'Delivery 9.170': '6 tons',
    'Worker 17.220': '12 tons', 'Constellation 24.280': '18 tons',
    // Honda
    'Ridgeline': '0.8 tons',
  };

  // ========== DATOS DE LA EMPRESA DESDE STORE ==========
  const empresaActiva = store.miEmpresa
    || [...(store.empresasActivas || []), ...(store.empresasPendientes || [])]
        .find(e => e.id === usuario?.empresaId || e.email === usuario?.email);
  const empresaInfo = empresaActiva ? {
    nombre: empresaActiva.nombre,
    rfc: empresaActiva.rfc,
    telefono: empresaActiva.telefono,
    email: empresaActiva.email,
    direccion: 'Ver perfil',
    calificacion: usuario?.calificacion ?? null,
    viajesCompletados: empresaActiva.viajesCompletados || 0,
    fechaRegistro: empresaActiva.fechaAprobacion || '2024-03-15'
  } : {
    nombre: 'Transportes Veloz SA de CV',
    rfc: 'TVE123456ABC',
    telefono: '664-123-4567',
    email: usuario?.email || 'contacto@transportesveloz.com',
    direccion: 'Blvd. Agua Caliente #456, Tijuana, BC',
    calificacion: 4.8,
    viajesCompletados: 1250,
    fechaRegistro: '2024-03-15'
  };
  const empresaId = empresaActiva?.id || usuario?.empresaId || 'E-001';
  const planEmpresa = empresaActiva?.plan || 'basico';
  const esPro = planEmpresa === 'pro';
  const comisionPct = empresaActiva?.comisionPersonalizada ?? store.configPlataforma?.comisionBasico ?? 20;
  const gananciaPct = (100 - comisionPct) / 100;
  const comisionRetornosPct = empresaActiva?.comisionRetornos ?? comisionPct;
  const gananciaPctRetornos = (100 - comisionRetornosPct) / 100;

  // ── FASE DE VISIBILIDAD POR ZONA ──────────────────────────────────────────
  // Extrae la ciudad del string de dirección o ciudad (primer segmento antes de la coma)
  // Normaliza ciudad para comparación (ambos lados vienen de combobox, solo minúsculas+acentos)
  const _norm = (str) => (str || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const _ciudadEmpresa = _norm(empresaActiva?.ciudad || '');
  const _tiempoEsperaMin = store.configPlataforma?.tiempoEsperaLocalMinutos || 30;

  /**
   * REGLAS DE VISIBILIDAD DE SOLICITUDES:
   *
   * difusionGlobal ON  → todos los transportistas ven todas las solicitudes (sin restricciones)
   * difusionGlobal OFF → sistema de fases por zona geográfica:
   *
   *   Fase 1 — ORIGEN:   PRO inmediato · Básico espera ventana PRO
   *   Fase 2 — DESTINO:  PRO después de tiempoEspera · Básico después de tiempoEspera + ventana PRO
   *   Fase 3 — INTERMEDIAS: Solo ciudades entre O y D en la ruta peninsular
   *                         PRO después de tiempoEspera×2 · Básico después de tiempoEspera×2 + ventana PRO
   *                         Ciudades fuera de la ruta → nunca ven la solicitud
   *
   * Retorna: 'local' | 'destino' | 'abierta' | null (null = no visible aún)
   */
  const getSolicitudFase = (sol) => {
    // Cupo lleno → nadie más puede ver
    if ((sol.cotizacionesRecibidas || 0) >= (sol.maxCotizaciones || 10)) return null;

    // ── DIFUSIÓN GLOBAL: bypass total de todas las reglas ──
    if (store.configPlataforma?.difusionGlobal) return 'abierta';

    // Tiempo transcurrido desde que se creó la solicitud
    const minutos = sol.fechaCreacion
      ? (Date.now() - new Date(sol.fechaCreacion).getTime()) / 60000
      : Infinity;

    const ciudadOrigen  = _norm(sol.origen);
    const ciudadDestino = _norm(sol.destino);
    const matchOrigen  = !!_ciudadEmpresa && (ciudadOrigen.includes(_ciudadEmpresa) || _ciudadEmpresa.includes(ciudadOrigen));
    const matchDestino = !!_ciudadEmpresa && (ciudadDestino.includes(_ciudadEmpresa) || _ciudadEmpresa.includes(ciudadDestino));

    // Ventana PRO: calculada una vez y reutilizada en las 3 fases
    const hayPro = (store.empresasActivas || []).some(e => e.plan === 'pro' && e.status === 'activa');
    const minVentanaPro = (hayPro && !esPro)
      ? (store.configPlataforma?.horasExclusivaPro ?? 6) * 60
      : 0;

    // ── FASE 1: Transportistas en ORIGEN ──
    if (matchOrigen) {
      if (minVentanaPro > 0 && minutos < minVentanaPro) return null;
      return 'local';
    }

    // ── FASE 2: Transportistas en DESTINO ──
    // PRO: visible tras tiempoEspera · Básico: visible tras tiempoEspera + ventana PRO
    if (matchDestino) {
      if (minutos < _tiempoEsperaMin) return null;
      if (minVentanaPro > 0 && minutos < _tiempoEsperaMin + minVentanaPro) return null;
      return 'destino';
    }

    // ── FASE 3: Transportistas en ciudades ENTRE origen y destino ──
    // Solo ciudades de la ruta peninsular entre O y D; fuera de la ruta → null
    if (_ciudadEmpresa) {
      const ciudadesRuta = calcCiudadesEnRuta(sol.origen, sol.destino);
      const matchIntermedia = ciudadesRuta.some(c => {
        const cn = _norm(c);
        return cn.includes(_ciudadEmpresa) || _ciudadEmpresa.includes(cn);
      });
      if (!matchIntermedia) return null;
      if (minutos < _tiempoEsperaMin * 2) return null;
      if (minVentanaPro > 0 && minutos < _tiempoEsperaMin * 2 + minVentanaPro) return null;
      return 'abierta';
    }

    // Sin ciudad configurada → fase 3 cuando vence el tiempo (sin restricción geográfica)
    if (minutos < _tiempoEsperaMin * 2) return null;
    if (minVentanaPro > 0 && minutos < _tiempoEsperaMin * 2 + minVentanaPro) return null;
    return 'abierta';
  };

  // ========== UNIDADES ==========
  // Unidades desde el store (persistidas), filtradas por empresa
  const unidades = (store.flota || []).filter(u => !u.empresaId || u.empresaId === (usuario?.empresaId || 'E-001'));
  const setUnidades = () => {}; // no-op: el store maneja el estado

  // ========== CHOFERES ==========
  const choferes = (store.plantillaChoferes || []).filter(c => c.empresaId === empresaId);
  const [activoOverride, setActivoOverride] = useState({}); // optimistic toggle: { [chofer.id]: boolean }
  const [statusOverride, setStatusOverride] = useState({}); // optimistic status: { [chofer.id]: string }
  const [menuChofer, setMenuChofer] = useState(null); // { id, top, right } — fixed position

  // ========== SOLICITUDES RECHAZADAS (localStorage por usuario) ==========
  const _lsKey = `choyero_rechazadas_${usuario?.id || 'guest'}`;
  const [solicitudesRechazadas, setSolicitudesRechazadas] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(_lsKey) || '[]');
      // Excluir IDs que ya existen como solicitudes reales en el store
      // para evitar que demos rechazados oculten solicitudes reales con el mismo ID
      const storeIds = new Set((getStore().solicitudes || []).map(s => s.id));
      return new Set(saved.filter(id => !storeIds.has(id)));
    } catch { return new Set(); }
  });

  // ========== SOLICITUDES DISPONIBLES DESDE STORE (+ datos demo) ==========
  // Merge store solicitudes con las demo; las del store tienen prioridad
  const solicitudesStore = (store.solicitudes || [])
    // Aceptar tanto el formato local ('cotizando') como el de la API ('abierta', 'en_cotizacion')
    .filter(s => ['cotizando', 'abierta', 'en_cotizacion'].includes(s.status))
    .map(s => {
      const fechaRecogida = s.fecha || s.fechaRecogida || '';
      const hoy = new Date().toISOString().slice(0, 10);
      if (fechaRecogida && fechaRecogida < hoy) return null; // solicitud pasada
      return {
        id: s.id,
        folio: s.folio || null,
        // Soporta formato local (clienteNombre) y API (cliente.nombre o clienteId)
        cliente: s.clienteNombre || s.cliente?.nombre || s.clienteId || 'Cliente',
        clienteAvatar: s.cliente?.avatar || null,
        clienteTipo: s.cliente?.tipoPersona || null,
        clienteDireccion: s.cliente?.direccion || null,
        clienteInsignias: s.cliente?.insigniasCliente || [],
        clienteCalificacion: s.cliente?.calificacion ?? null,
        clienteCancelaciones: s.cliente?.cancelacionesComoCliente ?? 0,
        clienteUltimaCancelacion: s.cliente?.ultimaCancelacionCliente ?? null,
        clienteId: s.clienteId,
        origen: s.origen,
        destino: s.destino,
        origenDir: s.origenDir || s.origen,
        destinoDir: s.destinoDir || s.destino,
        // Soporta formato local (carga) y API (descripcion)
        carga: s.carga || s.descripcion || '',
        peso: s.peso ? `${s.peso} tons` : '',
        // Soporta formato local (tipoUnidad) y API (tipoVehiculo)
        tipoUnidad: s.tipoUnidad || s.tipoVehiculo || '',
        fecha: fechaRecogida,
        horaRecogida: s.horaRecogida || '',
        // Soporta formato local (fechaCreacion) y API (creadoEn)
        fechaCreacion: s.fechaCreacion || s.creadoEn,
        hora: '08:00',
        distancia: '-- km',
        notas: s.notas || '',
        prioridad: s.prioridad || 'normal',
        fotos: s.fotos || [],
        origenCoords: s.origenCoords || null,
        destinoCoords: s.destinoCoords || null,
        cotizado: (store.cotizaciones || []).some(c => c.solicitudId === s.id && c.transportistaId === usuario?.id),
        rechazado: solicitudesRechazadas.has(s.id),
        miCotizacion: (store.cotizaciones || []).find(c => c.solicitudId === s.id && c.transportistaId === usuario?.id) || null,
        cotizacionesRecibidas: s.cotizacionesRecibidas || 0,
        maxCotizaciones: s.maxCotizaciones || 10,
        aceptaCotizaciones: s.aceptaCotizaciones !== false,
        flujoPago: s.flujoPago || 'unico',
      };
    })
    .filter(Boolean);

  // Solicitudes que cotizamos pero ganó otro transportista — mostrar hoy, desaparecen mañana
  const hoyStr = new Date().toDateString();
  const solicitudesPerdidas = (store.solicitudes || [])
    .filter(s => {
      if (s.status === 'cotizando') return false; // ya está en solicitudesStore
      const miCot = store.cotizaciones.find(c => c.solicitudId === s.id && c.transportistaId === usuario?.id);
      if (!miCot) return false; // no cotizamos esta solicitud
      if (miCot.status === 'ganada') return false; // ganamos, vive en Mis Viajes
      const fechaSol = new Date(s.fechaCreacion || s.fecha || 0);
      return fechaSol.toDateString() === hoyStr; // solo mostrar el mismo día
    })
    .map(s => ({
      id: s.id,
      cliente: s.clienteNombre,
      clienteId: s.clienteId,
      origen: s.origen,
      destino: s.destino,
      origenDir: s.origenDir || s.origen,
      destinoDir: s.destinoDir || s.destino,
      carga: s.carga,
      peso: `${s.peso} tons`,
      tipoUnidad: s.tipoUnidad,
      fecha: s.fecha,
      horaRecogida: s.horaRecogida || '',
      fechaCreacion: s.fechaCreacion,
      hora: '08:00',
      distancia: '-- km',
      notas: s.notas || '',
      prioridad: s.prioridad || 'normal',
      fotos: s.fotos || [],
      origenCoords: s.origenCoords || null,
      destinoCoords: s.destinoCoords || null,
      cotizado: true,
      perdida: s.status !== 'cancelada' && s.status !== 'expirada',
      cancelada: s.status === 'cancelada',
      expirada: s.status === 'expirada',
      rechazado: false,
      miCotizacion: (store.cotizaciones || []).find(c => c.solicitudId === s.id && c.transportistaId === usuario?.id) || null,
      cotizacionesRecibidas: s.cotizacionesRecibidas || 0,
      maxCotizaciones: s.maxCotizaciones || 10,
      aceptaCotizaciones: false,
    }));

  // Solicitudes disponibles: del store + perdidas (para referencia histórica)
  const solicitudesDisponibles = [
    ...solicitudesStore,
    // Solicitudes donde cotizamos pero perdimos — siempre visibles para referencia
    ...solicitudesPerdidas.filter(p => !solicitudesStore.find(s => s.id === p.id))
  ]
    // Las ganadas solo viven en Mis Viajes, no en Solicitudes Disponibles
    .filter(sol => sol.miCotizacion?.status !== 'ganada')
    // Filtro de fase geográfica: perdidas, canceladas, expiradas y rechazadas siempre pasan, resto por fase
    .filter(sol => sol.perdida || sol.cancelada || sol.expirada || sol.rechazado || getSolicitudFase(sol) !== null)
    .sort((a, b) => {
      // Rechazadas al fondo; luego pendientes de cotizar primero; más recientes arriba
      if (a.rechazado !== b.rechazado) return a.rechazado ? 1 : -1;
      const aPendiente = !a.cotizado ? 0 : 1;
      const bPendiente = !b.cotizado ? 0 : 1;
      if (aPendiente !== bPendiente) return aPendiente - bPendiente;
      return new Date(b.fechaCreacion || b.fecha || 0) - new Date(a.fechaCreacion || a.fecha || 0);
    });
  const setSolicitudesDisponibles = () => {}; // No-op

  // Siempre mantener ref actualizado con el getSolicitudFase más reciente (evita stale closure)
  getSolicitudFaseRef.current = getSolicitudFase;

  // Polling cada 60s: detectar solicitudes que acaban de entrar en la fase de este transportista
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const checkFases = (notificar = true) => {
      const storeActual = getStore();
      const pool = storeActual.solicitudes
        .filter(s => s.status === 'cotizando')
        .filter(s => !solicitudesRechazadas.has(s.id));

      const ahoraVisibles = pool.filter(s => getSolicitudFaseRef.current(s) !== null);
      const ahoraIds = new Set(ahoraVisibles.map(s => s.id));

      if (notificar && prevFaseVisibleIds.current !== null) {
        ahoraVisibles
          .filter(s => !prevFaseVisibleIds.current.has(s.id) && !notifiedSolicitudIds.current.has(s.id))
          .forEach(sol => {
            notifiedSolicitudIds.current.add(sol.id);
            const fase = getSolicitudFaseRef.current(sol);
            const titulo = fase === 'local'   ? '🚚 ¡Nueva solicitud en tu zona!'
                         : fase === 'destino' ? '🚚 Solicitud con destino a tu ciudad'
                                              : '🚚 Nueva solicitud disponible';
            setToastNotif(q => [...q, {
              tipo: 'nueva_solicitud',
              titulo,
              mensaje: `Flete de ${sol.origen} a ${sol.destino}`,
              datos: { solicitudId: sol.id }
            }]);
          });
      }

      prevFaseVisibleIds.current = ahoraIds;
    };

    expirarSolicitudesVencidas(); // expirar al montar
    checkFases(false); // primera llamada: solo inicializar sin mostrar toast
    // Pre-poblar notifiedSolicitudIds con las solicitudes ya visibles al montar
    if (prevFaseVisibleIds.current) {
      prevFaseVisibleIds.current.forEach(id => notifiedSolicitudIds.current.add(id));
    }
    const interval = setInterval(() => { expirarSolicitudesVencidas(); checkFases(true); setTickMinuto(t => t + 1); }, 60000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Detectar nuevas solicitudes visibles en tiempo real (cuando cambia store o difusión)
  useEffect(() => {
    if (prevFaseVisibleIds.current === null) return; // aún no inicializado
    const pool = (store.solicitudes || [])
      .filter(s => ['cotizando', 'en_cotizacion', 'abierta'].includes(s.status))
      .filter(s => !solicitudesRechazadas.has(s.id));

    const ahoraVisibles = pool.filter(s => getSolicitudFase(s) !== null);
    const ahoraIds = new Set(ahoraVisibles.map(s => s.id));

    const UMBRAL_MS = 10 * 60 * 1000; // solo toastear solicitudes de los últimos 10 min
    const ahora = Date.now();
    const nuevasSolicitudes = ahoraVisibles.filter(s =>
      !prevFaseVisibleIds.current.has(s.id) &&
      !notifiedSolicitudIds.current.has(s.id) &&
      (ahora - new Date(s.creadoEn || s.fechaCreacion || s.fecha || 0).getTime()) <= UMBRAL_MS
    );
    // Solo actualizar el registro interno — el toast lo muestra el sistema de notificaciones de BD
    nuevasSolicitudes.forEach(sol => {
      notifiedSolicitudIds.current.add(sol.id);
    });

    prevFaseVisibleIds.current = ahoraIds;
  }, [store.solicitudes?.length, store.configPlataforma?.difusionGlobal]); // eslint-disable-line react-hooks/exhaustive-deps

  // ========== MIS VIAJES (desde store + demo) ==========
  const viajesStore = (store.viajes || []).filter(v => v.empresaId === empresaId || v.transportistaId === usuario?.id);
  // 'completada' = chofer notificó entrega, aún esperando confirmación del cliente → sigue en Mis Viajes
  // 'confirmado' / 'entrega_confirmada' = cliente confirmó → ya va al historial
  const STATUSES_CERRADOS = ['confirmado', 'entrega_confirmada', 'cancelado', 'cancelado_admin'];
  const misViajes = viajesStore
    .filter(v => !STATUSES_CERRADOS.includes(v.status))
    .map(v => ({ ...v, cliente: v.cliente?.nombre || v.clienteNombre || (store.usuarios || []).find(u => u.id === v.clienteId)?.nombre || v.clienteId, ganancia: Math.round((v.costoFinal || v.precio || v.costo || 0) * gananciaPct) }))
    .sort((a, b) => new Date(b.creadoEn || b.fechaCreacion || b.fecha || 0) - new Date(a.creadoEn || a.fechaCreacion || a.fecha || 0));
  const setMisViajes = () => {}; // No-op

  // ========== RETORNOS VACÍOS ==========
  const defaultExpiresAt = () => {
    const d = new Date(Date.now() + 24 * 60 * 60 * 1000);
    const pad = n => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };
  const [formRetorno, setFormRetorno] = useState({
    origenActual: '', destino: _ciudadEmpresa || '', tipoUnidad: '', capacidadDisponible: '',
    precioBase: '', precioMinimo: '', expiresAt: defaultExpiresAt(), descripcion: ''
  });
  const [viajeRetornoOrigen, setViajeRetornoOrigen] = useState(null); // { id, destino } del viaje historial desde el que se publica
  const [retornoContraId, setRetornoContraId] = useState(null); // { retornoId, ofertaId }
  const [retornosExpandidos, setRetornosExpandidos] = useState(new Set());
  const [formContra, setFormContra] = useState({ monto: '', mensaje: '' });
  const [notificarChoferRetornoId, setNotificarChoferRetornoId] = useState(null); // retornoId para modal de selección de chofer
  const [mapaGpsOferta, setMapaGpsOferta] = useState(null); // { origenCoords, destinoCoords, clienteNombre }
  const [fotoLightbox, setFotoLightbox] = useState(null); // src de la foto a mostrar en grande
  const [evidenciasModal, setEvidenciasModal] = useState(null); // array de evidencias del historial
  const [infoRutaGps, setInfoRutaGps] = useState(null); // { km, tiempo }
  const [archivosFacturaCliente, setArchivosFacturaCliente] = useState({}); // { [solId]: { pdf, xml } }
  const [facturasExpandidas, setFacturasExpandidas] = useState(new Set()); // IDs de cards expandidas
  const [facturasVistasPendientes, setFacturasVistasPendientes] = useState(() => {
    try { return new Set(JSON.parse(localStorage.getItem('choyero_facturas_vistas') || '[]')); } catch { return new Set(); }
  });

  const misRetornos = (store.retornosVacios || []).filter(
    r => r.empresaId === empresaId && !['cancelado', 'expirado', 'entrega_confirmada'].includes(r.status)
  ).sort((a, b) => new Date(b.fechaPublicacion || 0) - new Date(a.fechaPublicacion || 0));
  const todosRetornosEmpresa = (store.retornosVacios || []).filter(r => r.empresaId === empresaId);
  const fletesRetorno = misRetornos;

  const eliminarRetorno = async (id) => {
    try {
      await apiCancelarRetorno(id);
      cancelarRetornoVacio(id);
    } catch (e) {
      mostrarNotificacion(e.message || 'No se pudo eliminar el retorno', 'error');
    }
  };

  const publicarRetorno = (e) => {
    e.preventDefault();
    if (formRetorno.origenActual === formRetorno.destino) {
      mostrarNotificacion('El origen y destino no pueden ser la misma ciudad', 'error');
      return;
    }
    if (!formRetorno.expiresAt) {
      mostrarNotificacion('Debes indicar la fecha y hora de expiración', 'error');
      return;
    }
    const base = Number(formRetorno.precioBase);
    const minimo = Number(formRetorno.precioMinimo);
    if (minimo > base) {
      mostrarNotificacion('El precio mínimo no puede ser mayor al precio base', 'error');
      return;
    }
    const retornoPayload = {
      origen: formRetorno.origenActual,
      destino: formRetorno.destino,
      ciudadesEnRuta: calcCiudadesEnRuta(formRetorno.origenActual, formRetorno.destino),
      tipoVehiculo: formRetorno.tipoUnidad,
      capacidad: formRetorno.capacidadDisponible,
      precioBase: formRetorno.precioBase,
      precioMinimo: formRetorno.precioMinimo,
      expiresAt: formRetorno.expiresAt,
    };
    const retornoLocalData = { ...formRetorno, viajeOrigenId: viajeRetornoOrigen?.id || null };
    // Cerrar form e feedback inmediato
    setFormRetorno({ origenActual: '', destino: _ciudadEmpresa || '', tipoUnidad: '', capacidadDisponible: '', precioBase: '', precioMinimo: '', expiresAt: defaultExpiresAt(), descripcion: '' });
    setViajeRetornoOrigen(null);
    setMostrarFormRetorno(false);
    mostrarNotificacion('Retorno publicado. Se notificará a clientes en ruta.');
    // Actualizar store y enviar API en segundo plano
    setTimeout(() => {
      publicarRetornoVacio(usuario?.id, empresaId, retornoLocalData);
      apiPublicarRetorno(retornoPayload)
        .then(() => recargar())
        .catch(() => { mostrarNotificacion('Error al publicar el retorno en el servidor. Intenta de nuevo.', 'error'); });
    }, 0);
  };

  // Descuento progresivo: calcula precio actual según tiempo transcurrido
  const precioActualRetorno = (ret) => {
    const base = ret.precioBase || 0;
    if (!ret.descuentoProgresivo || ret.status !== 'disponible') return base;
    const total = new Date(ret.expiresAt || ret.fechaExpiracion) - new Date(ret.creadoEn || ret.fechaPublicacion);
    const transcurrido = Date.now() - new Date(ret.creadoEn || ret.fechaPublicacion);
    const pct = transcurrido / total;
    if (pct > 0.66) return Math.round(base * 0.80);
    if (pct > 0.33) return Math.round(base * 0.90);
    return base;
  };

  // ========== HISTORIAL ==========
  const historialReal = [
    ...(store.viajes || [])
      .filter(v =>
        (v.empresaId === empresaId || v.transportistaId === usuario?.id) &&
        // 'completada' = chofer entregó pero cliente no confirmó → sigue en Mis Viajes
        // Solo pasa al historial cuando el cliente confirma o el viaje fue cancelado
        (['confirmado', 'entrega_confirmada', 'cancelado', 'cancelado_admin'].includes(v.status))
      )
      .map(v => ({
        id: v.id,
        fecha: (v.fechaCompletada || v.creadoEn || '').slice(0, 10),
        ruta: `${v.origen} → ${v.destino}`,
        origen: v.origen,
        destino: v.destino,
        cliente: v.clienteNombre || (store.usuarios || []).find(u => u.id === v.clienteId)?.nombre || v.clienteId,
        clienteId: v.clienteId,
        precio: v.costoFinal || v.precio || v.costo || 0,
        // Usar snapshot guardado al completar el viaje si existe; si no (viajes viejos), % actual —
        // mismo criterio que _gananciaViaje() más abajo, para no divergir del total del Dashboard.
        ganancia: v.gananciaTransportista ?? Math.round((v.costoFinal || v.precio || v.costo || 0) * gananciaPct),
        status: v.status,
        esCancelado: ['cancelado', 'cancelado_admin'].includes(v.status),
        tipo: 'flete',
        evidencias: v.evidenciasEntrega || [],
        firma: v.firmaEntrega || null,
        unidad: v.unidad,
        unidadAsignada: v.unidadAsignada,
        tipoUnidad: v.tipoUnidad,
        calificaciones: v.calificaciones || [],
      })),
    ...(store.retornosVacios || [])
      .filter(r =>
        r.empresaId === empresaId && (r.status === 'completado' || r.status === 'entrega_confirmada')
      )
      .map(r => {
        const ofertaAceptada = (r.ofertas || []).find(o => o.status === 'aceptada');
        const precio = ofertaAceptada ? (ofertaAceptada.contrapropuesta || ofertaAceptada.precio || ofertaAceptada.monto || 0) : 0;
        return {
          id: r.id,
          fecha: r.fechaPublicacion ? r.fechaPublicacion.slice(0, 10) : '',
          ruta: `${r.origenActual} → ${r.destino}`,
          cliente: ofertaAceptada?.clienteNombre || '—',
          clienteId: ofertaAceptada?.clienteId || '',
          precio,
          // Los retornos pueden tener una comisión distinta a la de fletes (comisionRetornos) —
          // mismo cálculo que retornosCompletadosReal más abajo, para no divergir del Dashboard.
          ganancia: Math.round(precio * gananciaPctRetornos),
          status: 'entrega_confirmada',
          tipo: 'retorno'
        };
      })
  ];
  const historial = historialReal
    .sort((a, b) => new Date(b.fecha || 0) - new Date(a.fecha || 0));


  // ========== FORMULARIOS ==========
  const emptyFormUnidad = { placas: '', numeroEconomico: '', tipo: '', marca: '', modelo: '', anio: '', capacidad: '', status: 'activa', foto: null, gpsInstalado: false, largoM: '', anchoM: '', altoM: '', seguroCarga: false, vigenciaSeguro: '', tempMinima: '', tarjetaCirculacionUrl: null };
  const [formUnidad, setFormUnidad] = useState(emptyFormUnidad);
  const emptyFormChofer = { nombre: '', licencia: '', telefono: '', password: '', status: 'disponible', foto: null, tipoLicencia: '', vigenciaLicencia: '', curp: '', contactoEmergenciaNombre: '', contactoEmergenciaTelefono: '', aniosExperiencia: '', licenciaFederalUrl: null };
  const [formChofer, setFormChofer] = useState(emptyFormChofer);
  const [nuevoAcceso, setNuevoAcceso] = useState(null); // { email, password } — pantalla de éxito tras crear chofer
  const [formAsignacion, setFormAsignacion] = useState({ choferId: '', unidadId: '', contactoCliente: '', telefonoCliente: '' });
  const [modalReasignar, setModalReasignar] = useState(null); // { viajeId, choferActualNombre }
  const [reasignarChoferId, setReasignarChoferId] = useState('');
  const [reasignarLoading, setReasignarLoading] = useState(false);

  // ========== FUNCIONES AUXILIARES ==========
  const getStatusColor = (status) => {
    const colors = { 
      'activa': 'bg-green-100 text-green-800',
      'mantenimiento': 'bg-yellow-100 text-yellow-800',
      'inactiva': 'bg-red-100 text-red-800',
      'disponible': 'bg-green-100 text-green-800',
      'en_viaje': 'bg-blue-100 text-blue-800',
      'vacaciones': 'bg-yellow-100 text-yellow-800',
      'inactivo': 'bg-gray-100 text-gray-600',
      'descanso': 'bg-gray-100 text-gray-800',
      'pendiente': 'bg-yellow-100 text-yellow-800',
      'ganada': 'bg-green-100 text-green-800',
      'perdida': 'bg-red-100 text-red-800',
      'rechazado': 'bg-red-100 text-red-800',
      'cerrada': 'bg-gray-100 text-gray-800',
      'pendiente_pago': 'bg-yellow-100 text-yellow-800',
      'activo': 'bg-orange-100 text-orange-800',
      'en_curso': 'bg-blue-100 text-blue-800',
      'completado': 'bg-green-100 text-green-800',
      'completada': 'bg-amber-100 text-amber-800',
      'entrega_confirmada': 'bg-green-100 text-green-800',
      'confirmado': 'bg-green-100 text-green-800',
      'cancelado': 'bg-red-100 text-red-800',
      'cancelada': 'bg-red-100 text-red-800',
      'descargando': 'bg-cyan-100 text-cyan-800',
      'en_camino_recogida': 'bg-indigo-100 text-indigo-800',
      'cargando': 'bg-yellow-100 text-yellow-800',
      'en_ruta': 'bg-orange-100 text-orange-800',
      'llegada_destino': 'bg-teal-100 text-teal-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const getStatusText = (status) => {
    const texts = {
      'activa': 'Activa',
      'mantenimiento': 'En Mantenimiento',
      'inactiva': 'Inactiva',
      'disponible': 'Disponible',
      'en_viaje': 'En Viaje',
      'descanso': 'Descanso',
      'pendiente': 'Pendiente',
      'ganada': 'Ganada',
      'perdida': 'No Seleccionada',
      'rechazado': 'Rechazada',
      'cerrada': 'Cerrada',
      'pendiente_pago': 'Esperando pago',
      'activo': 'Por Asignar',
      'en_curso': 'En Curso',
      'completado': 'Completado',
      'completada': 'Esperando confirmación',
      'entrega_confirmada': 'Entrega Confirmada',
      'confirmado': 'Entrega Confirmada',
      'cancelado': 'Cancelado',
      'cancelada': 'Cancelada',
      'descargando': 'Descargando',
      'en_camino_recogida': 'Chofer en Camino',
      'cargando': 'Cargando',
      'en_ruta': 'En Ruta',
      'llegada_destino': 'En Destino'
    };
    return texts[status] || status;
  };

  const getChoferById = (id) => choferes.find(c => c.id === id);
  const getUnidadById = (id) => unidades.find(u => u.id === id);

  const mostrarNotificacion = (mensaje, tipo = 'success', persistente = false, opciones = {}) => {
    const titulos = { success: '✓ Listo', warning: '⚠ Atención', error: '✗ Error' };
    setToastNotif(q => [...q, { tipo: `alerta_${tipo}`, titulo: titulos[tipo] || 'Aviso', mensaje, persistente, ...opciones }]);
  };


  // Auto-cerrar solo alertas simples (success/warning/error) en 3.5s
  // Las notificaciones del sistema permanecen hasta que el usuario las cierra manualmente
  useEffect(() => {
    if (toastNotif.length === 0 || toastPausado) return;
    const notif = toastNotif[0];
    if (!notif?.tipo?.startsWith('alerta_') || notif?.persistente) return;
    const timer = setTimeout(() => setToastNotif(q => q.slice(1)), 3500);
    return () => clearTimeout(timer);
  }, [toastNotif.length, toastPausado]); // eslint-disable-line

  // Cerrar modales con ESC — prioridad: más reciente primero
  // Excluidos: modalPagarPro, modalBienvenida (flujos críticos)
  useEffect(() => {
    const handle = (e) => {
      if (e.key !== 'Escape') return;
      if (chatModal)                { setChatModal(null); return; }
      if (fotoAmpliada)             { setFotoAmpliada(null); return; }
      if (fotoLightbox)             { setFotoLightbox(null); return; }
      if (evidenciasModal)          { setEvidenciasModal(null); return; }
      if (mostrarCalificarCliente)  { setMostrarCalificarCliente(null); return; }
      if (cancelarViajeModal)       { setCancelarViajeModal(null); setCancelarMotivo(''); return; }
      if (accesoCreado)             { setAccesoCreado(null); return; }
      if (mostrarAccesoChofer)      { setMostrarAccesoChofer(null); return; }
      if (mostrarCredenciales)      { setMostrarCredenciales(null); return; }
      if (notificarChoferRetornoId) { setNotificarChoferRetornoId(null); return; }
      if (mostrarAsignarViaje)      { setMostrarAsignarViaje(null); return; }
      if (mostrarDetalleViaje)      { setMostrarDetalleViaje(null); return; }
      if (mostrarCotizacion)        { setMostrarCotizacion(null); return; }
      if (abrirDFModal)             { setAbrirDFModal(false); return; }
      if (mostrarFormChofer)        { setMostrarFormChofer(false); return; }
      if (mostrarFormUnidad)        { setMostrarFormUnidad(false); return; }
      if (mostrarFormRetorno)       { setMostrarFormRetorno(false); return; }
      // Notificaciones — menor prioridad que modales
      if (toastNotif.length > 0 && !toastPausado) { cerrarToast(); return; }
      if (panelNotifAbierto)        { setPanelNotifAbierto(false); return; }
      if (mostrarNotificaciones)    { setMostrarNotificaciones(false); return; }
    };
    document.addEventListener('keydown', handle);
    return () => document.removeEventListener('keydown', handle);
  }, [chatModal, fotoAmpliada, fotoLightbox, evidenciasModal, mostrarCalificarCliente, cancelarViajeModal, accesoCreado, mostrarAccesoChofer, mostrarCredenciales, notificarChoferRetornoId, mostrarAsignarViaje, mostrarDetalleViaje, mostrarCotizacion, abrirDFModal, mostrarFormChofer, mostrarFormUnidad, mostrarFormRetorno, toastNotif.length, toastPausado, panelNotifAbierto, mostrarNotificaciones]); // eslint-disable-line

  // Recordatorios automáticos con delay
  // Cargar calificaciones del cliente cuando se expande una solicitud
  useEffect(() => {
    if (!expandedSolicitud) return;
    const sol = solicitudesDisponibles.find(s => s.id === expandedSolicitud);
    const clienteId = sol?.clienteId;
    if (!clienteId || califClienteCache[clienteId] !== undefined) return;
    setCalifClienteCache(prev => ({ ...prev, [clienteId]: null }));
    apiGetCalificacionesUsuario(clienteId)
      .then(cals => setCalifClienteCache(prev => ({ ...prev, [clienteId]: cals || [] })))
      .catch(() => setCalifClienteCache(prev => ({ ...prev, [clienteId]: [] })));
  }, [expandedSolicitud]); // eslint-disable-line

  useEffect(() => {
    const _lsKey = `choyero_rec_trans_${usuario?.id}`;
    const COOLDOWN = 4 * 60 * 60 * 1000; // 4 horas — persiste entre sesiones
    const HORAS_ANTICIPACION = 24; // solo avisar si el pickup es dentro de 24h

    const checkRecordatorios = () => {
      const s = getStore();
      const ahora = Date.now();
      const last = JSON.parse(localStorage.getItem(_lsKey) || '{}');

      // 1. Viajes pagados sin chofer asignado — solo si la recogida es en menos de 24h (o sin fecha)
      const sinChofer = (s.viajes || []).filter(v => {
        if (!(v.empresaId === empresaId || v.transportistaId === usuario?.id)) return false;
        if (v.status !== 'activo') return false;
        const fecha = v.solicitud?.fechaRecogida;
        if (fecha) {
          const horasRestantes = (new Date(fecha.split('T')[0] + 'T12:00:00').getTime() - ahora) / 3600000;
          if (horasRestantes > HORAS_ANTICIPACION) return false;
        }
        return true;
      });
      if (sinChofer.length > 0 && (!last.sinChofer || ahora - last.sinChofer > COOLDOWN)) {
        last.sinChofer = ahora;
        localStorage.setItem(_lsKey, JSON.stringify(last));
        mostrarNotificacion(
          `🚛 Tienes ${sinChofer.length} flete(s) pagado(s) sin chofer asignado. ¡Asigna uno para iniciar el servicio!`,
          'warning', true, { navegar: 'viajes' }
        );
        return;
      }
      // 2. Retornos confirmados (pagados) sin chofer
      const retSinChofer = (s.retornosVacios || []).filter(r => {
        if (r.empresaId !== empresaId) return false;
        if (!['confirmado'].includes(r.status)) return false;
        const oferta = (r.ofertas || []).find(o => o.status === 'aceptada' && o.pagado);
        const ordenChofer = (s.ordenesChofer || []).find(o => o.retornoId === r.id);
        return !!oferta && !ordenChofer;
      });
      if (retSinChofer.length > 0 && (!last.retSinChofer || ahora - last.retSinChofer > COOLDOWN)) {
        last.retSinChofer = ahora;
        localStorage.setItem(_lsKey, JSON.stringify(last));
        mostrarNotificacion(
          `📦 Tienes ${retSinChofer.length} retorno(s) con pago recibido sin chofer asignado. ¡Notifica a un chofer!`,
          'warning', true, { navegar: 'retornos' }
        );
      }
    };
    let interval;
    const timer = setTimeout(() => {
      checkRecordatorios();
      interval = setInterval(checkRecordatorios, 5 * 60 * 1000);
    }, 3 * 60 * 1000);
    return () => { clearTimeout(timer); if (interval) clearInterval(interval); };
  }, [empresaId, usuario?.id]); // eslint-disable-line

  // ========== FUNCIÓN PARA VERIFICAR SI SE PUEDE COTIZAR ==========
  const puedeCotizar = (solicitud) => {
    // No puede cotizar si ya cotizó
    if (solicitud.cotizado) return { puede: false, razon: 'Ya enviaste una cotización' };
    // No puede cotizar si rechazó
    if (solicitud.rechazado) return { puede: false, razon: 'Rechazaste esta solicitud' };
    // No puede cotizar si llegó al máximo
    if (!solicitud.aceptaCotizaciones || solicitud.cotizacionesRecibidas >= solicitud.maxCotizaciones) {
      return { puede: false, razon: 'Máximo de cotizaciones alcanzado (10/10)' };
    }
    return { puede: true, razon: '' };
  };

  // ========== FUNCIONES CRUD ==========
  const agregarUnidad = async (e) => {
    e.preventDefault();
    try {
      await apiAgregarUnidad(formUnidad);
      await recargar();
      mostrarNotificacion('Unidad agregada correctamente');
      setMostrarFormUnidad(false);
      setFormUnidad(emptyFormUnidad);
    } catch (err) {
      mostrarNotificacion(err?.message || 'Error al agregar la unidad en el servidor', 'error');
    }
  };

  const editarUnidad = (unidad) => {
    setEditando(unidad);
    setFormUnidad({ ...emptyFormUnidad, ...unidad });
    setMostrarFormUnidad(true);
  };

  const actualizarUnidad = async (e) => {
    e.preventDefault();
    try {
      await apiActualizarUnidad(editando.id, formUnidad);
      await recargar();
      mostrarNotificacion('Unidad actualizada');
      setMostrarFormUnidad(false);
      setEditando(null);
      setFormUnidad(emptyFormUnidad);
    } catch (err) {
      mostrarNotificacion(err?.message || 'Error al actualizar la unidad en el servidor', 'error');
    }
  };

  const eliminarUnidad = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta unidad?')) {
      try {
        await apiEliminarUnidad(id);
        await recargar();
        mostrarNotificacion('Unidad eliminada', 'error');
      } catch (err) {
        mostrarNotificacion(err?.message || 'Error al eliminar la unidad en el servidor', 'error');
      }
    }
  };

  const agregarChofer = async (e) => {
    e.preventDefault();
    const tel = formChofer.telefono.replace(/\D/g, '').slice(-10);
    const emailChofer = `tel_${tel}@chofer.choyero`;
    const datos = { ...formChofer, email: emailChofer, viajes: 0, calificacion: null, fechaAlta: new Date().toISOString().split('T')[0] };
    try {
      const payload = {
        nombre: formChofer.nombre, email: emailChofer, telefono: formChofer.telefono, licencia: formChofer.licencia,
        foto: formChofer.foto || undefined,
        tipoLicencia: formChofer.tipoLicencia || undefined,
        vigenciaLicencia: formChofer.vigenciaLicencia || undefined,
        curp: formChofer.curp || undefined,
        contactoEmergenciaNombre: formChofer.contactoEmergenciaNombre || undefined,
        contactoEmergenciaTelefono: formChofer.contactoEmergenciaTelefono || undefined,
        licenciaFederalUrl: formChofer.licenciaFederalUrl || undefined,
        aniosExperiencia: formChofer.aniosExperiencia ? parseInt(formChofer.aniosExperiencia) : undefined,
      };
      const nuevoChofer = await apiAgregarChofer(payload);
      if (nuevoChofer?.id && formChofer.password) {
        await apiCrearAccesoChofer(nuevoChofer.id, { email: emailChofer, password: formChofer.password });
        setNuevoAcceso({ telefono: formChofer.telefono, password: formChofer.password });
      } else {
        mostrarNotificacion('Chofer agregado correctamente');
        setMostrarFormChofer(false);
        setFormChofer({ nombre: '', licencia: '', telefono: '', password: '', status: 'disponible' });
      }
      recargar();
    } catch (err) {
      agregarChoferPlantilla(empresaId, datos);
      mostrarNotificacion(err.message || 'Chofer agregado (sin acceso al sistema)', 'warning');
      setMostrarFormChofer(false);
      setFormChofer({ nombre: '', licencia: '', telefono: '', password: '', status: 'disponible' });
    }
  };

  const editarChofer = (chofer) => {
    setEditando(chofer);
    setFormChofer({ ...emptyFormChofer, ...chofer, aniosExperiencia: chofer.aniosExperiencia ?? '' });
    setMostrarFormChofer(true);
  };

  const actualizarChofer = async (e) => {
    e.preventDefault();
    const payload = {
      nombre: formChofer.nombre, licencia: formChofer.licencia, telefono: formChofer.telefono,
      foto: formChofer.foto !== undefined ? formChofer.foto : undefined,
      tipoLicencia: formChofer.tipoLicencia || null,
      vigenciaLicencia: formChofer.vigenciaLicencia || null,
      curp: formChofer.curp || null,
      contactoEmergenciaNombre: formChofer.contactoEmergenciaNombre || null,
      contactoEmergenciaTelefono: formChofer.contactoEmergenciaTelefono || null,
      licenciaFederalUrl: formChofer.licenciaFederalUrl !== undefined ? formChofer.licenciaFederalUrl : undefined,
      aniosExperiencia: formChofer.aniosExperiencia ? parseInt(formChofer.aniosExperiencia) : null,
    };
    try {
      const actualizado = await apiActualizarChofer(editando.id, payload);
      actualizarChoferPlantilla(editando.id, actualizado || formChofer);
      mostrarNotificacion('Chofer actualizado');
      setMostrarFormChofer(false);
      setEditando(null);
      setFormChofer({ nombre: '', licencia: '', telefono: '', email: '', password: '', status: 'disponible' });
    } catch (err) {
      mostrarNotificacion(err?.message || 'Error al actualizar el chofer en el servidor', 'error');
    }
  };

  const eliminarChofer = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este chofer?')) {
      try {
        await apiEliminarChofer(id);
        await recargar();
        mostrarNotificacion('Chofer eliminado', 'error');
      } catch (err) {
        mostrarNotificacion(err?.message || 'Error al eliminar el chofer en el servidor', 'error');
      }
    }
  };

  // ========== FUNCIONES DE ASIGNACIÓN ==========
  const asignarViaje = (e) => {
    e.preventDefault();
    const choferSeleccionado = todosChoferes.find(c => String(c.id) === String(formAsignacion.choferId));
    const unidadSeleccionada = unidades.find(u => String(u.id) === String(formAsignacion.unidadId));

    const unidadLabelStr = unidadSeleccionada
      ? [unidadSeleccionada.marca, unidadSeleccionada.modelo, unidadSeleccionada.anio].filter(Boolean).join(' ') || unidadSeleccionada.placas
      : null;

    const viajeId = mostrarAsignarViaje.id;
    const apiPayload = {
      choferId: null,
      choferEmail: choferSeleccionado?.email || null,
      choferNombre: choferSeleccionado?.nombre || null,
      instrucciones: formAsignacion.instrucciones || null,
      unidadId: formAsignacion.unidadId || null,
      unidadLabel: unidadLabelStr,
      contactoCliente: formAsignacion.contactoCliente || null,
      telefonoCliente: formAsignacion.telefonoCliente || null
    };

    // Actualizar store local INMEDIATAMENTE
    dispatch(s => ({
      ...s,
      viajes: (s.viajes || []).map(v =>
        v.id === viajeId
          ? {
              ...v,
              status: 'en_curso',
              choferNombre: choferSeleccionado?.nombre,
              chofer: choferSeleccionado?.nombre,
              ordenesChofer: [{
                choferNombre: choferSeleccionado?.nombre,
                choferEmail: choferSeleccionado?.email,
                unidadId: formAsignacion.unidadId || null,
                unidadLabel: unidadLabelStr
              }]
            }
          : v
      )
    }));

    // Capturar viaje y form antes de cerrar para poder reabrir si falla
    const viajeCapturado = mostrarAsignarViaje;
    const formCapturado = { ...formAsignacion };

    // Cerrar modal inmediatamente — feedback instantáneo
    actualizarChoferPlantilla(formAsignacion.choferId, { status: 'en_viaje' });
    mostrarNotificacion('Viaje asignado correctamente');
    setMostrarAsignarViaje(null);
    setFormAsignacion({ choferId: '', unidadId: '', contactoCliente: '', telefonoCliente: '' });

    // API en segundo plano
    apiAsignarChofer(viajeId, apiPayload)
      .then(() => { recargar(); })
      .catch((err) => {
        console.error('[asignarViaje] Error API:', err?.message || err);
        // Reabrir modal con datos intactos para que pueda reintentar
        setMostrarAsignarViaje(viajeCapturado);
        setFormAsignacion(formCapturado);
        mostrarNotificacion('No se pudo asignar. Revisa tu conexión e intenta de nuevo.', 'error');
      });
  };

  // ========== FUNCIÓN DE RECHAZAR SOLICITUD ==========
  const rechazarSolicitud = (solicitudId) => {
    if (window.confirm('¿Estás seguro de rechazar esta solicitud?')) {
      setSolicitudesRechazadas(prev => {
        const next = new Set([...prev, solicitudId]);
        localStorage.setItem(_lsKey, JSON.stringify([...next]));
        return next;
      });
      mostrarNotificacion('Solicitud rechazada', 'warning');
    }
  };


  // ========== CÁLCULOS ==========
  // Solo contar ganancias cuando el cliente confirmó la entrega (escrow liberado)
  const viajesCompletadosReal = (store.viajes || []).filter(v =>
    (v.empresaId === empresaId || v.transportistaId === usuario?.id) &&
    ['confirmado', 'entrega_confirmada'].includes(v.status)
  );
  // Retornos completados y confirmados por el cliente
  const retornosCompletadosReal = (store.retornosVacios || []).filter(r =>
    r.empresaId === empresaId && ['completado', 'entrega_confirmada'].includes(r.status)
  ).map(r => {
    const oferta = (r.ofertas || []).find(o => o.status === 'aceptada');
    return { ganancia: Math.round((oferta?.monto || 0) * gananciaPctRetornos), fecha: r.fechaEntregaConfirmada || oferta?.fechaEntregaConfirmada || oferta?.fechaPago || r.fechaPublicacion || '' };
  });
  // Usar snapshot guardado al completar el viaje; si no existe (viajes viejos), calcular con % actual
  const _gananciaViaje = (v) => v.gananciaTransportista ?? Math.round((v.costoFinal || v.precio || v.costo || 0) * gananciaPct);
  const totalGananciasReal = viajesCompletadosReal.reduce((sum, v) => sum + _gananciaViaje(v), 0)
    + retornosCompletadosReal.reduce((sum, r) => sum + r.ganancia, 0);
  const totalGanancias = totalGananciasReal > 0 ? totalGananciasReal : historial.reduce((sum, v) => sum + v.ganancia, 0);
  const hoy = new Date().toISOString().slice(0, 10);
  const mesActual = new Date().toISOString().slice(0, 7);
  const gananciasHoy = viajesCompletadosReal
    .filter(v => (v.fechaCompletada || v.creadoEn || '').startsWith(hoy))
    .reduce((sum, v) => sum + _gananciaViaje(v), 0)
    + retornosCompletadosReal.filter(r => r.fecha.startsWith(hoy)).reduce((sum, r) => sum + r.ganancia, 0);
  const gananciasMes = viajesCompletadosReal
    .filter(v => (v.fechaCompletada || v.creadoEn || '').startsWith(mesActual))
    .reduce((sum, v) => sum + _gananciaViaje(v), 0)
    + retornosCompletadosReal.filter(r => r.fecha.startsWith(mesActual)).reduce((sum, r) => sum + r.ganancia, 0);
  const viajesPendientes = misViajes.filter(v => ['activo', 'en_curso', 'pendiente_pago'].includes(v.status)).length;
  // Choferes registrados en el store que pertenecen a esta empresa (creados via "Dar Acceso")
  const choferesStore = (store.usuarios || [])
    .filter(u => u.rol === 'chofer' && u.empresaId === usuario?.empresaId)
    .map(u => ({
      id: u.id,
      nombre: u.nombre,
      email: u.email,
      licencia: u.licencia || '',
      telefono: u.telefono || '',
      status: 'disponible',
      viajes: u.viajesCompletados || 0,
      calificacion: u.calificacion || null,
      fechaAlta: u.fechaAlta || ''
    }));

  // Lista unificada: estado local + store, sin duplicar por email
  const todosChoferes = [
    ...choferes,
    ...choferesStore.filter(sc => !choferes.some(c => c.email === sc.email))
  ];

  const choferesDisponibles = choferes.filter(c => c.status === 'disponible');
  const unidadesActivas = unidades; // Mostrar todas, con status indicado en el dropdown
  const solicitudesSinRechazar = solicitudesDisponibles.filter(s => !s.rechazado);
  const solicitudesAbiertas = solicitudesSinRechazar.filter(s => s.aceptaCotizaciones && !s.cotizado);

  // ========== VISTA LIMITADA: EMPRESA PENDIENTE O RECHAZADA ==========
  // Rechazada → pantalla completa de documentos (sin acceso al panel)
  const empresaPendiente = store.miEmpresa?.status === 'rechazada' ? store.miEmpresa : null;
  // En registro o pendiente → acceso al panel con restricciones según config
  const empresaEnRevision = ['en_registro', 'pendiente'].includes(store.miEmpresa?.status) ? store.miEmpresa : null;
  const fletesPruebaActivo = store.configPlataforma?.fletesPruebaHabilitado === true;
  // Bloquear cotizar y mapa: si está en revisión Y (no hay flete de prueba O ya completó 1 flete)
  const bloqueadoPorAprobacion = !!empresaEnRevision && (!fletesPruebaActivo || viajesCompletadosReal.length >= 1);

  // Mostrar spinner mientras carga la primera vez para evitar flash del dashboard
  if (!store.miEmpresa) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500 text-sm">Cargando...</p>
        </div>
      </div>
    );
  }

  if (empresaPendiente) {
    const docsRequeridos = getDocumentosRequeridos(usuario?.tipoPersona);
    const docsGuardados = empresaPendiente.documentosEmpresa || [];
    const docs = docsRequeridos.map(d => docsGuardados.find(x => x.id === d.id) || { id: d.id, nombre: d.nombre, status: 'pendiente' });
    const docsSubidos = docs.filter(d => d.status === 'subido' || d.status === 'verificado').length;

    return (
      <>
      <div className="flex h-screen bg-gray-100">
        {/* Sidebar mínimo */}
        <div className="w-64 bg-green-800 text-white p-4 flex flex-col overflow-y-auto">
          <div className="mb-8">
            <h1 className="text-2xl font-black text-orange-400 leading-none">Choyero!</h1>
            <p className="text-xs font-semibold text-green-200 tracking-widest uppercase mt-0.5">Marketplace Logístico</p>
          </div>
          <div className="flex-1" />
          <div className="p-3 bg-green-900 rounded-xl">
            <p className="text-sm font-semibold text-white truncate">{empresaPendiente.nombre}</p>
            <p className="text-xs text-green-300 truncate">{usuario?.email}</p>
            <button
              onClick={onLogout}
              className="mt-2 w-full flex items-center space-x-2 px-3 py-1.5 text-green-300 hover:text-white hover:bg-green-800 rounded-lg transition text-sm"
            >
              <LogOut size={14} />
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </div>

        {/* Contenido: subir documentos */}
        <div className="flex-1 p-8 overflow-auto">
          {/* Banner de rechazo (si aplica) */}
          {empresaPendiente.status === 'rechazada' && (() => {
            const motivoNotif = (store.notificaciones || []).find(n => n.tipo === 'empresa_rechazada');
            const motivo = motivoNotif?.datos?.motivo || null;
            return (
              <div className="bg-red-50 border border-red-300 rounded-xl p-5 mb-6 flex items-start gap-4">
                <AlertCircle size={28} className="text-red-500 shrink-0 mt-0.5" />
                <div>
                  <p className="font-bold text-red-800 text-lg">Tu solicitud fue rechazada</p>
                  {motivo && <p className="text-red-700 text-sm mt-1"><span className="font-semibold">Motivo:</span> {motivo}</p>}
                  <p className="text-red-600 text-sm mt-1">Puedes volver a subir tus documentos corregidos para una nueva revisión.</p>
                </div>
              </div>
            );
          })()}
          {/* Banner de aviso */}
          <div className="bg-amber-50 border border-amber-300 rounded-xl p-5 mb-8 flex items-start gap-4">
            <AlertCircle size={28} className="text-amber-500 shrink-0 mt-0.5" />
            <div>
              <p className="font-bold text-amber-800 text-lg">
                {empresaPendiente.status === 'rechazada' ? 'Vuelve a enviar tu documentación' : empresaPendiente.status === 'pendiente' ? 'Cuenta en revisión' : 'Sube tu documentación'}
              </p>
              <p className="text-amber-700 text-sm mt-1">
                {empresaPendiente.status === 'rechazada'
                  ? 'Corrige o reemplaza los documentos indicados y envíalos nuevamente para revisión.'
                  : empresaPendiente.status === 'pendiente'
                  ? 'Tu solicitud fue enviada y está siendo revisada por el administrador de Choyero.'
                  : 'Tu cuenta fue creada correctamente. Sube los documentos requeridos y envía tu solicitud para activar tu acceso.'
                }
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-2">Sube tu documentación</h2>
          <p className="text-gray-500 text-sm mb-6">
            Documentos subidos: <span className="font-semibold text-green-700">{docsSubidos} / {docs.length}</span>
          </p>

          {/* Barra de progreso */}
          <div className="w-full bg-gray-200 rounded-full h-2 mb-8">
            <div
              className="h-2 rounded-full bg-green-500 transition-all"
              style={{ width: `${docs.length > 0 ? (docsSubidos / docs.length) * 100 : 0}%` }}
            />
          </div>

          <div className="space-y-4 max-w-2xl">
            {docs.map(doc => {
              const info = docsRequeridos.find(d => d.id === doc.id);
              const esVerificado = doc.status === 'verificado';
              const esSubido = doc.status === 'subido';
              const esPendiente = doc.status === 'pendiente';

              return (
                <div key={doc.id} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex items-center justify-between gap-4">
                  <div className="flex items-center gap-4">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
                      esVerificado ? 'bg-green-100' : esSubido ? 'bg-blue-100' : 'bg-gray-100'
                    }`}>
                      {esVerificado
                        ? <CheckCircle size={20} className="text-green-600" />
                        : esSubido
                          ? <Clock size={20} className="text-blue-600" />
                          : <FileText size={20} className="text-gray-400" />
                      }
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">{doc.nombre}</p>
                      <p className="text-xs text-gray-500">{info?.descripcion}</p>
                      {esSubido && (
                        <p className="text-xs text-blue-600 mt-0.5">Subido — en revisión por el administrador</p>
                      )}
                      {esVerificado && (
                        <p className="text-xs text-green-600 mt-0.5">Verificado</p>
                      )}
                    </div>
                  </div>
                  {(esPendiente || (esSubido && empresaPendiente.status === 'rechazada')) && (
                    <label className="cursor-pointer flex items-center space-x-2 px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700 transition shrink-0">
                      <Upload size={15} />
                      <span>{esSubido ? 'Cambiar PDF' : 'Subir PDF'}</span>
                      <input
                        type="file"
                        accept=".pdf,application/pdf"
                        className="hidden"
                        onChange={e => {
                          const archivo = e.target.files?.[0];
                          if (!archivo) return;
                          const reader = new FileReader();
                          reader.onload = async (ev) => {
                            storeSubirDocumento(empresaPendiente.id, doc.id, ev.target.result, archivo.name);
                            try {
                              const res = await apiTransportistaSubirDocumento(doc.id, ev.target.result, archivo.name);
                              if (res?.filePath) storeActualizarFileUrl(empresaPendiente.id, doc.id, res.filePath);
                              mostrarNotificacion('Documento subido correctamente', 'success');
                            } catch (err) {
                              // Revertir estado local
                              dispatch(s => ({
                                ...s,
                                miEmpresa: s.miEmpresa ? {
                                  ...s.miEmpresa,
                                  documentosEmpresa: (s.miEmpresa.documentosEmpresa || []).map(d =>
                                    d.id === doc.id ? { ...d, status: 'pendiente', fileDataUrl: undefined } : d
                                  )
                                } : s.miEmpresa
                              }));
                              mostrarNotificacion(err?.message || 'Error al subir documento', 'error');
                            }
                          };
                          reader.readAsDataURL(archivo);
                        }}
                      />
                    </label>
                  )}
                  {esSubido && empresaPendiente.status !== 'rechazada' && (
                    <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full shrink-0">
                      En revisión
                    </span>
                  )}
                  {esVerificado && (
                    <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full shrink-0">
                      Aprobado
                    </span>
                  )}
                </div>
              );
            })}
          </div>

          {docs.length > 0 && (
            <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-xl max-w-2xl">
              {docsSubidos < docs.length ? (
                <>
                  <p className="text-blue-800 font-semibold">Sube todos los documentos antes de enviar tu solicitud.</p>
                  <p className="text-blue-600 text-sm mt-1">Faltan {docs.length - docsSubidos} documento(s).</p>
                </>
              ) : empresaPendiente.status === 'pendiente' ? (
                <>
                  <p className="text-blue-800 font-semibold">Solicitud enviada — en revisión.</p>
                  <p className="text-blue-600 text-sm mt-1">El administrador revisará tu documentación. Recibirás una notificación cuando tu empresa sea aprobada.</p>
                </>
              ) : (
                <>
                  <p className="text-blue-800 font-semibold">
                    {empresaPendiente.status === 'rechazada' ? 'Documentos actualizados.' : 'Todos los documentos fueron subidos.'}
                  </p>
                  <p className="text-blue-600 text-sm mt-1">
                    {empresaPendiente.status === 'rechazada'
                      ? 'Cuando estés listo, envía tu solicitud para una nueva revisión.'
                      : 'Cuando estés listo, envía tu solicitud para que el administrador revise tu empresa.'
                    }
                  </p>
                  <button
                    onClick={async () => {
                      try {
                        await apiReenviarSolicitud();
                        dispatch(s => ({ ...s, miEmpresa: s.miEmpresa ? { ...s.miEmpresa, status: 'pendiente' } : s.miEmpresa }));
                        mostrarNotificacion('Solicitud enviada. El admin la revisará pronto.', 'success');
                      } catch {
                        mostrarNotificacion('Error al enviar la solicitud', 'error');
                      }
                    }}
                    className="mt-4 px-6 py-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-xl transition"
                  >
                    {empresaPendiente.status === 'rechazada' ? 'Reenviar solicitud a revisión' : 'Enviar para revisión'}
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      {toastNotif.length > 0 && !toastPausado && (() => {
        const notif = toastNotif[0];
        const bgColor = notif.tipo === 'empresa_aprobada' ? 'bg-green-500' : notif.tipo === 'empresa_rechazada' ? 'bg-red-500' : 'bg-orange-500';
        return (
          <div className={`fixed top-6 right-6 ${bgColor} text-white px-6 py-4 rounded-2xl shadow-2xl z-[99999] flex items-center space-x-3 max-w-sm animate-slide-in-right`}>
            <Bell size={22} className="flex-shrink-0" />
            <div className="flex-1">
              <p className="font-bold text-sm">{notif.titulo}</p>
              <p className="text-xs opacity-90 mt-0.5">{notif.mensaje}</p>
            </div>
            <button onClick={() => setToastNotif(q => q.slice(1))} className="text-white hover:opacity-70 flex-shrink-0"><X size={18} /></button>
          </div>
        );
      })()}
    </>
  );
  }

  // ========== MENÚ DE NAVEGACIÓN ==========
  const menu = [
    ...(empresaEnRevision ? [{ id: 'documentos', label: 'Documentación', icon: Upload, badge: empresaEnRevision.status === 'en_registro' ? 1 : 0 }] : []),
    { id: 'dashboard', label: 'Dashboard', icon: TrendingUp },
    { id: 'solicitudes', label: 'Solicitudes', icon: FileText, badge: solicitudesDisponibles.length },
    { id: 'viajes', label: 'Mis Viajes', icon: Truck, badge: viajesPendientes },
    { id: 'retornos', label: 'Fletes Retorno', icon: RotateCcw, badge: misRetornos.filter(r => {
      const tieneOfertaPendiente = (r.ofertas || []).some(o => o.status === 'pendiente');
      const pagadoSinChofer = (r.ofertas || []).some(o => o.status === 'aceptada' && o.pagado) && !r.choferAsignado;
      return tieneOfertaPendiente || pagadoSinChofer;
    }).length },
    { id: 'mapa', label: 'Mapa Unidades', icon: Map },
    { id: 'unidades', label: 'Unidades', icon: Truck },
    { id: 'choferes', label: 'Choferes', icon: Users },
    { id: 'historial', label: 'Historial', icon: Clock },
    { id: 'costos', label: '🔧 Costos', icon: Wrench },
    { id: 'estadisticas', label: '📊 Estadísticas', icon: DollarSign },
    { id: 'cobros', label: 'Mis Cobros', icon: DollarSign },
    { id: 'facturas', label: 'Mis Facturas', icon: FileText },
    { id: 'facturas_clientes', label: 'Facturas Clientes', icon: FileCheck, badge: (store.viajes || []).filter(v => v.solicitudFactura?.status === 'pendiente' && !facturasVistasPendientes.has(v.solicitudFactura.id)).length },
    { id: 'bancario', label: 'Datos Bancarios', icon: CreditCard },
    { id: 'perfil', label: 'Mi Perfil', icon: User },
  ];

  // ========== MODALES ==========

  // Modal: Agregar/Editar Unidad
  // (ModalFormUnidad y ModalFormChofer ahora se renderizan inline en el return para evitar pérdida de foco)

  // Modal: Enviar Cotización (CON VALIDACIÓN DE LÍMITE)
  const ModalCotizacion = () => {
    // Usa estado del padre para evitar reset en re-renders del padre
    const localPrecio = cotizLocalPrecio;
    const setLocalPrecio = setCotizLocalPrecio;
    const localTiempoEntrega = cotizLocalTiempoEntrega;
    const setLocalTiempoEntrega = setCotizLocalTiempoEntrega;
    const localUnidadId = cotizLocalUnidadId;
    const setLocalUnidadId = setCotizLocalUnidadId;
    const localComentario = cotizLocalComentario;
    const setLocalComentario = setCotizLocalComentario;
    const localUnidadObj = unidadesActivas.find(u => String(u.id) === String(localUnidadId)) || null;
    const localSeguro = cotizLocalSeguro;
    const setLocalSeguro = setCotizLocalSeguro;
    const localRastreoGPS = cotizLocalRastreoGPS;
    const setLocalRastreoGPS = setCotizLocalRastreoGPS;
    const localCargaDescarga = cotizLocalCargaDescarga;
    const setLocalCargaDescarga = setCotizLocalCargaDescarga;
    const localAniosExp = cotizLocalAniosExp;
    const setLocalAniosExp = setCotizLocalAniosExp;

    const verificacion = puedeCotizar(mostrarCotizacion);

    const handleSubmit = (e) => {
      e.preventDefault();
      if (cotizEnviando) return;

      // Validar precio
      const precioNum = parseFloat(localPrecio.replace(/,/g, ''));
      if (!localPrecio || isNaN(precioNum) || precioNum <= 0) {
        mostrarNotificacion('Ingresa un precio válido mayor a $0', 'error');
        return;
      }
      // Validar unidad
      if (!localUnidadId) {
        mostrarNotificacion('Selecciona una unidad para esta cotización', 'error');
        return;
      }
      // Doble verificación antes de enviar
      if (!verificacion.puede) {
        mostrarNotificacion(verificacion.razon, 'error');
        return;
      }

      // Capturar datos necesarios antes de cerrar el modal
      const payload = {
        solicitudId: mostrarCotizacion.id,
        precio: precioNum,
        tiempoEntrega: localTiempoEntrega || null,
        notas: localComentario || null,
        unidadOfrecida: localUnidadObj
          ? `${localUnidadObj.tipo} ${localUnidadObj.marca || ''} ${localUnidadObj.modelo || ''} ${localUnidadObj.anio || ''}`.trim()
          : null,
        seguro: localSeguro,
        rastreoGPS: localRastreoGPS,
        cargaDescarga: localCargaDescarga,
        // Datos específicos de la unidad seleccionada
        tipoUnidad:  localUnidadObj?.tipo  || null,
        marcaUnidad: localUnidadObj?.marca  || null,
        modeloUnidad: localUnidadObj?.modelo || null,
        anioUnidad:  localUnidadObj?.anio   || null,
        fotoUnidad:  localUnidadObj?.foto   || null,
        largoM:      localUnidadObj?.largoM  ?? null,
        anchoM:      localUnidadObj?.anchoM  ?? null,
        altoM:       localUnidadObj?.altoM   ?? null,
        tempMinima:  localUnidadObj?.tempMinima ?? null,
        aniosExperienciaChofer: localAniosExp ? parseInt(localAniosExp) : null,
      };
      const solicitudCapturada = mostrarCotizacion;

      // Actualizar store optimistamente — feedback instantáneo sin esperar la API
      storeEnviarCotizacion(usuario.id, empresaId, empresaActiva?.nombre || '', payload.solicitudId, {
        precio: precioNum,
        tiempoEntrega: payload.tiempoEntrega,
        notas: payload.notas,
        unidadOfrecida: payload.unidadOfrecida,
        seguro: payload.seguro,
        rastreoGPS: payload.rastreoGPS,
        cargaDescarga: payload.cargaDescarga
      });

      // Cerrar modal inmediatamente — feedback instantáneo
      setCotizEnviando(true);
      setMostrarCotizacion(null);
      mostrarNotificacion(`Cotización enviada por $${precioNum.toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN`);
      phCapture('cotizacion_enviada', { precio: precioNum, origen: payload.origen, destino: payload.destino });
      // Auto-expandir la fila para que el transportista vea su cotización de inmediato
      setExpandedSolicitud(solicitudCapturada.id);

      // Enviar en segundo plano — sin recargar() para evitar flash visual
      apiEnviarCotizacion(payload)
        .then(() => {
          // El polling periódico sincronizará el store con el servidor
          // No llamar recargar() aquí para evitar que borre el estado optimista
        })
        .catch(() => {
          // Error real: revertir el store y reabrir modal con los datos intactos
          recargar(); // Recargar solo en error para restaurar estado real
          setMostrarCotizacion(solicitudCapturada);
          mostrarNotificacion('No se pudo enviar la cotización. Revisa tu conexión e intenta de nuevo.', 'error');
        })
        .finally(() => { setCotizEnviando(false); });
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
        <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6 border-b flex justify-between items-center">
            <h3 className="text-xl font-bold">Enviar Cotización</h3>
            <button onClick={() => setMostrarCotizacion(null)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
          </div>
          
          {/* Indicador de cotizaciones */}
          <div className={`mx-6 mt-4 p-3 rounded-lg ${
            mostrarCotizacion?.cotizacionesRecibidas >= 8 
              ? 'bg-red-50 border border-red-200' 
              : mostrarCotizacion?.cotizacionesRecibidas >= 5 
                ? 'bg-yellow-50 border border-yellow-200' 
                : 'bg-green-50 border border-green-200'
          }`}>
            <div className="flex justify-between items-center">
              <span className="text-sm font-semibold">Cotizaciones recibidas:</span>
              <span className={`text-lg font-bold ${
                mostrarCotizacion?.cotizacionesRecibidas >= 8 ? 'text-red-600' : 
                mostrarCotizacion?.cotizacionesRecibidas >= 5 ? 'text-yellow-600' : 'text-green-600'
              }`}>
                {mostrarCotizacion?.cotizacionesRecibidas}/{mostrarCotizacion?.maxCotizaciones}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
              <div 
                className={`h-2 rounded-full transition-all ${
                  mostrarCotizacion?.cotizacionesRecibidas >= 8 ? 'bg-red-500' : 
                  mostrarCotizacion?.cotizacionesRecibidas >= 5 ? 'bg-yellow-500' : 'bg-green-500'
                }`}
                style={{ width: `${Math.min((mostrarCotizacion?.cotizacionesRecibidas / Math.max(mostrarCotizacion?.maxCotizaciones || 1, 1)) * 100, 100)}%` }}
              ></div>
            </div>
            {mostrarCotizacion?.cotizacionesRecibidas >= 8 && (
              <p className="text-xs text-red-600 mt-1">⚠️ Quedan pocas plazas disponibles</p>
            )}
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            {/* Aviso flujo dos pagos */}
            {mostrarCotizacion?.flujoPago === 'dos_pagos' && (
              <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 flex items-start gap-2">
                <span className="text-lg flex-shrink-0">💳</span>
                <div>
                  <p className="text-sm font-bold text-amber-800">Esta solicitud usa anticipo + contra entrega</p>
                  <p className="text-xs text-amber-700 mt-0.5">Recibirás el <strong>100% de tu pago</strong> cuando el cliente confirme la recepción de la mercancía.</p>
                </div>
              </div>
            )}

            {/* Resumen de la solicitud */}
            <div className="bg-blue-50 rounded-xl p-4">
              <p className="text-xs text-blue-600 font-semibold mb-2">SOLICITUD {mostrarCotizacion?.id}</p>
              <div className="flex items-center gap-2 flex-wrap">
                {mostrarCotizacion?.clienteAvatar
                  ? <img src={mostrarCotizacion.clienteAvatar} alt="cliente" className="w-8 h-8 rounded-full object-cover flex-shrink-0 border-2 border-white shadow-sm" />
                  : <div className="w-8 h-8 rounded-full bg-blue-200 flex items-center justify-center flex-shrink-0 text-blue-700 font-bold text-xs">{(mostrarCotizacion?.cliente || '').toString().slice(0,2).toUpperCase() || 'CL'}</div>
                }
                <p className="font-semibold text-gray-800">{mostrarCotizacion?.cliente}</p>
                {(mostrarCotizacion?.clienteInsignias || []).map(id => {
                  const ins = CATALOGO_INSIGNIAS_CLIENTE.find(b => b.id === id);
                  if (!ins) return null;
                  return (
                    <span key={ins.id} title={ins.desc} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${ins.color}`}>
                      {ins.emoji} {ins.label}
                    </span>
                  );
                })}
              </div>
              <div className="grid grid-cols-2 gap-2 mt-2 text-sm">
                <div><span className="text-gray-500">Origen:</span> {mostrarCotizacion?.origen}</div>
                <div><span className="text-gray-500">Destino:</span> {mostrarCotizacion?.destino}</div>
                <div><span className="text-gray-500">Carga:</span> {mostrarCotizacion?.carga}</div>
                <div><span className="text-gray-500">Peso:</span> {mostrarCotizacion?.peso}</div>
                {mostrarCotizacion?.creadoEn && (
                  <div className="col-span-2">
                    <span className="text-gray-500">Solicitud creada:</span>{' '}
                    <span className="font-semibold text-gray-700">
                      {new Date(mostrarCotizacion.creadoEn).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}
                      {' · '}
                      {new Date(mostrarCotizacion.creadoEn).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </div>
                )}
                {mostrarCotizacion?.fechaRecogida && (
                  <div className="col-span-2">
                    <span className="text-gray-500">Fecha de recogida:</span>{' '}
                    <span className="font-semibold text-blue-700">
                      {new Date((mostrarCotizacion.fechaRecogida || '').split('T')[0] + 'T12:00:00').toLocaleDateString('es-MX', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })}
                    </span>
                    {(() => {
                      const t = (mostrarCotizacion.fechaRecogida || '').includes('T') ? mostrarCotizacion.fechaRecogida.split('T')[1]?.slice(0,5) : null;
                      if (!t || t === '00:00') return null;
                      const fmtHora = (h) => new Date(`1970-01-01T${h}`).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: true });
                      const horaFin = mostrarCotizacion.horaFinCarga ? fmtHora(mostrarCotizacion.horaFinCarga) : null;
                      return (
                        <div className="mt-1 flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-lg px-3 py-1.5">
                          <span className="text-blue-500 text-base">🕐</span>
                          <div>
                            <span className="text-xs text-blue-600 font-semibold">El cliente estará disponible:</span>
                            <span className="ml-1.5 text-sm font-bold text-blue-800">{fmtHora(t)}{horaFin ? ` – ${horaFin}` : ''}</span>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
                <div className="col-span-2 flex items-center gap-2 mt-1">
                  <span className="text-gray-500">Prioridad:</span>
                  <span className={`px-2 py-0.5 text-xs font-semibold rounded-full ${
                    mostrarCotizacion?.prioridad === 'urgente' ? 'bg-red-100 text-red-700' :
                    mostrarCotizacion?.prioridad === 'alta'    ? 'bg-amber-100 text-amber-700' :
                    'bg-gray-100 text-gray-600'
                  }`}>
                    {mostrarCotizacion?.prioridad === 'urgente' ? 'Urgente' :
                     mostrarCotizacion?.prioridad === 'alta'    ? 'Alta' : 'Normal'}
                  </span>
                </div>
              </div>
            </div>

            {/* Notas del cliente */}
            {mostrarCotizacion?.notas && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-3">
                <p className="text-xs font-semibold text-yellow-700 mb-1">💬 Comentarios del cliente</p>
                <p className="text-sm text-gray-700">{mostrarCotizacion.notas}</p>
              </div>
            )}

            {/* Fotos del flete */}
            {(mostrarCotizacion?.fotos || []).length > 0 && (
              <div>
                <p className="text-sm font-semibold text-gray-700 mb-2">📷 Fotografías del flete</p>
                <div className="flex gap-2 flex-wrap">
                  {(mostrarCotizacion.fotos || []).map((foto, idx) => (
                    <img
                      key={idx}
                      src={foto}
                      alt={`Foto ${idx + 1}`}
                      onClick={() => setFotoAmpliada(foto)}
                      className="w-20 h-20 object-cover rounded-lg border border-gray-200 hover:opacity-80 transition-opacity cursor-pointer"
                    />
                  ))}
                </div>
              </div>
            )}

            {/* Tarifa sugerida dinámica */}
            {(() => {
              const sol = mostrarCotizacion;
              if (!sol) return null;
              let distKm = 200;
              if (sol.origenCoords && sol.destinoCoords) {
                const dlat = sol.origenCoords.lat - sol.destinoCoords.lat;
                const dlng = sol.origenCoords.lng - sol.destinoCoords.lng;
                distKm = Math.round(Math.sqrt(dlat*dlat + dlng*dlng) * 111 * 1.35);
              }
              const pesoNum = parseFloat((sol.peso || '5').replace(/[^0-9.]/g, '')) || 5;
              const pesoMult = 1 + Math.max(0, pesoNum - 5) * 0.04;
              const cots = sol.cotizacionesRecibidas || 0;
              const demandaMult = cots >= 7 ? 0.88 : cots <= 2 ? 1.12 : 1.0;
              const base = distKm * 18 * pesoMult;
              const sugerido = Math.round(base * demandaMult / 500) * 500;
              const minPrecio = Math.round(sugerido * 0.82 / 500) * 500;
              const maxPrecio = Math.round(sugerido * 1.22 / 500) * 500;
              // Comisión de la plataforma — el sugerido ya la incluye
              const cfg = store.configPlataforma || {};
              const miEmp = store.miEmpresa;
              const tasaComision = miEmp?.comisionPersonalizada ?? (cfg.comisionBasico ?? 20);
              const sugeridoConComision = Math.round((sugerido / (1 - tasaComision / 100)) / 500) * 500;
              const minConComision = Math.round((minPrecio / (1 - tasaComision / 100)) / 500) * 500;
              const maxConComision = Math.round((maxPrecio / (1 - tasaComision / 100)) / 500) * 500;
              const comisionMonto = Math.round(sugeridoConComision * tasaComision / 100);
              const neto = sugeridoConComision - comisionMonto;
              const demandaLabel = cots >= 7 ? { txt: 'Alta demanda — baja precio para ganar', color: 'text-red-600' }
                : cots <= 2 ? { txt: 'Poca competencia — puedes cotizar más alto', color: 'text-green-600' }
                : { txt: 'Demanda normal', color: 'text-gray-500' };
              return (
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-4">
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-xs font-bold text-blue-700 uppercase tracking-wide">Tarifa sugerida</p>
                    <span className={`text-xs font-semibold ${demandaLabel.color}`}>{demandaLabel.txt}</span>
                  </div>
                  <div className="flex items-center gap-4 mb-3">
                    <div className="text-center">
                      <p className="text-xs text-gray-400">Mínimo</p>
                      <p className="text-base font-bold text-gray-600">${minConComision.toLocaleString()}</p>
                    </div>
                    <div className="flex-1 text-center">
                      <p className="text-xs text-blue-500 font-semibold">Precio óptimo</p>
                      <p className="text-2xl font-black text-blue-700">${sugeridoConComision.toLocaleString()}</p>
                      <p className="text-xs text-gray-400">IVA incluido · incl. comisión Choyero</p>
                    </div>
                    <div className="text-center">
                      <p className="text-xs text-gray-400">Máximo</p>
                      <p className="text-base font-bold text-gray-600">${maxConComision.toLocaleString()}</p>
                    </div>
                  </div>
                  {/* Desglose comisión */}
                  <div className="bg-white/70 border border-blue-100 rounded-lg px-3 py-2 mb-3 space-y-1 text-xs">
                    <div className="flex justify-between text-gray-500">
                      <span>Comisión Choyero ({tasaComision}%, IVA incluido)</span>
                      <span className="font-semibold text-orange-600">− ${comisionMonto.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between font-bold border-t border-blue-100 pt-1">
                      <span className="text-gray-700">Lo que recibes tú</span>
                      <span className="text-green-700">${neto.toLocaleString()}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <p className="text-xs text-gray-400">~{distKm} km · {pesoNum} tons · {cots} cotizaciones recibidas</p>
                    <button
                      type="button"
                      onClick={() => setLocalPrecio(String(sugeridoConComision))}
                      className="text-xs font-semibold text-blue-600 hover:text-blue-800 bg-white border border-blue-200 px-3 py-1 rounded-lg hover:bg-blue-50 transition"
                    >
                      Usar sugerido
                    </button>
                  </div>
                </div>
              );
            })()}

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Precio Total (IVA incluido) *</label>
              <p className="text-xs text-blue-600 mb-2">El precio que cotizas ya debe incluir IVA. Choyero cobra su comisión sobre este monto total.</p>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-semibold text-lg select-none">$</span>
                <input
                  type="text" inputMode="decimal" required
                  value={localPrecio}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/[^0-9.]/g, '');
                    const parts = raw.split('.');
                    const clean = parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : raw;
                    setLocalPrecio(clean);
                  }}
                  onBlur={() => {
                    const n = parseFloat(localPrecio.replace(/,/g, ''));
                    if (!isNaN(n)) setLocalPrecio(n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                  }}
                  placeholder="0.00"
                  className="w-full pl-8 pr-4 py-3 border border-gray-300 rounded-lg text-lg font-semibold"
                />
              </div>
              {localPrecio && parseFloat(localPrecio.replace(/,/g, '')) > 0 && (() => {
                const p = parseFloat(localPrecio.replace(/,/g, ''));
                const comPct = comisionPct / 100;
                return (
                  <div className="mt-2 p-3 bg-gray-50 rounded-lg text-sm text-gray-600 space-y-1">
                    <p>El cliente paga: <span className="font-semibold text-gray-800">${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN (IVA incluido)</span></p>
                    <p>Comisión Choyero ({comisionPct}% con IVA): <span className="text-red-600 font-semibold">-${(p * comPct).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></p>
                    <p className="border-t pt-1 mt-1">Tu pago neto: <span className="text-green-600 font-bold">${(p * (1 - comPct)).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN</span></p>
                  </div>
                );
              })()}
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Tiempo Estimado de Entrega</label>
              <input
                type="text"
                value={localTiempoEntrega}
                onChange={(e) => setLocalTiempoEntrega(e.target.value)}
                placeholder="Ej: 6-8 horas, 2 días..."
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Unidad a Utilizar *</label>
              <select required value={localUnidadId} onChange={(e) => {
                setLocalUnidadId(e.target.value);
                const u = unidadesActivas.find(u => String(u.id) === e.target.value);
                if (u) {
                  setCotizLocalRastreoGPS(!!u.gpsInstalado);
                  setCotizLocalSeguro(!!u.seguroCarga);
                }
              }} className="w-full px-4 py-3 border border-gray-300 rounded-lg">
                <option value="">Seleccionar unidad... ({unidadesActivas.length} registradas)</option>
                {unidadesActivas.map(u => (
                  <option key={u.id} value={String(u.id)}>
                    {u.tipo} {u.marca} {u.modelo} {u.anio || ''} – {u.capacidad} ({u.placas})
                  </option>
                ))}
              </select>
              {/* Badge mantenimiento al día */}
              {localUnidadId && (() => {
                const hace90d = new Date(Date.now() - 90 * 24 * 3600 * 1000);
                const tieneMantenimiento = (store.mantenimientos || []).some(
                  m => m.unidadId === localUnidadId && new Date(m.fecha) >= hace90d
                );
                return tieneMantenimiento ? (
                  <p className="text-xs text-green-600 font-semibold mt-1">✅ Mantenimiento al día (últimos 90 días)</p>
                ) : null;
              })()}
            </div>

            {/* Beneficios incluidos */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Beneficios incluidos</label>
              <div className="flex gap-4">
                <label className="flex items-center gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={localSeguro}
                    onChange={(e) => setLocalSeguro(e.target.checked)}
                    className="w-4 h-4 accent-green-600"
                  />
                  <span className="text-sm text-gray-700">🛡️ Seguro incluido</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={localRastreoGPS}
                    onChange={(e) => setLocalRastreoGPS(e.target.checked)}
                    className="w-4 h-4 accent-green-600"
                  />
                  <span className="text-sm text-gray-700">📍 Rastreo GPS</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={localCargaDescarga}
                    onChange={(e) => setLocalCargaDescarga(e.target.checked)}
                    className="w-4 h-4 accent-green-600"
                  />
                  <span className="text-sm text-gray-700">📦 Carga/Descarga incluida</span>
                </label>
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                👨‍✈️ Años de experiencia del chofer <span className="text-gray-400 font-normal">(opcional — visible para el cliente)</span>
              </label>
              <input
                type="number" min="0" max="60"
                value={localAniosExp}
                onChange={(e) => setLocalAniosExp(e.target.value)}
                placeholder="Ej: 8"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Comentario (Opcional)</label>
              <textarea rows="2" value={localComentario} onChange={(e) => setLocalComentario(e.target.value)} placeholder="Información adicional..." className="w-full px-4 py-2 border border-gray-300 rounded-lg"></textarea>
            </div>

            {!tieneCLABE && (
              <div className="flex items-center gap-2 bg-orange-50 border border-orange-200 rounded-lg p-3 text-sm text-orange-700">
                <AlertCircle size={16} className="flex-shrink-0" />
                <span>Registra tu <strong>CLABE bancaria</strong> en Datos Bancarios antes de cotizar.</span>
              </div>
            )}
            <button type="submit" disabled={cotizEnviando || !tieneCLABE} className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold flex items-center justify-center space-x-2 disabled:opacity-60">
              {cotizEnviando ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <Send size={20} />}
              <span>{cotizEnviando ? 'Enviando...' : 'Enviar Cotización'}</span>
            </button>
          </form>
        </div>
      </div>
    );
  };

  // Modal: Asignar Viaje
  const ModalAsignarViaje = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
      <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full">
        <div className="p-6 border-b flex justify-between items-center">
          <h3 className="text-xl font-bold">Asignar Chofer y Unidad</h3>
          <button onClick={() => setMostrarAsignarViaje(null)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <form onSubmit={asignarViaje} className="p-6 space-y-4">
          <div className="bg-green-50 rounded-xl p-4">
            <p className="text-xs text-green-600 font-semibold mb-2">VIAJE {mostrarAsignarViaje?.id}</p>
            <p className="font-semibold">{mostrarAsignarViaje?.cliente}</p>
            <p className="text-sm text-gray-600">{mostrarAsignarViaje?.origen} → {mostrarAsignarViaje?.destino}</p>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Chofer *</label>
            <select required value={formAsignacion.choferId} onChange={(e) => {
              const choferId = e.target.value;
              const chofer = todosChoferes.find(c => String(c.id) === String(choferId));
              setFormAsignacion({ choferId, unidadId: chofer?.unidadAsignada ? String(chofer.unidadAsignada) : '' });
            }} className="w-full px-4 py-3 border border-gray-300 rounded-lg">
              <option value="">Seleccionar chofer... ({todosChoferes.length} registrados)</option>
              {todosChoferes.map(c => {
                const ordenesActivas = store.ordenesChofer.filter(o =>
                  (o.choferId === c.id || o.choferEmail === c.email) &&
                  !['completada', 'cancelada'].includes(o.status)
                ).length;
                const statusLabel = c.status === 'disponible' ? '✅' : c.status === 'en_viaje' ? '🚛' : c.status === 'descanso' ? '😴' : '';
                const cal = c.calificacion ? ` ⭐${c.calificacion}` : '';
                const asignLabel = ordenesActivas > 0 ? ` · ${ordenesActivas} orden${ordenesActivas > 1 ? 'es' : ''} activa${ordenesActivas > 1 ? 's' : ''}` : '';
                return (
                  <option key={c.id} value={c.id}>
                    {statusLabel} {c.nombre}{cal}{asignLabel}
                  </option>
                );
              })}
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Unidad *</label>
            <select required value={formAsignacion.unidadId} onChange={(e) => setFormAsignacion({...formAsignacion, unidadId: e.target.value})} className="w-full px-4 py-3 border border-gray-300 rounded-lg">
              <option value="">Seleccionar unidad... ({unidadesActivas.length} registradas)</option>
              {unidadesActivas.map(u => {
                const st = u.status === 'activa' ? '✅' : u.status === 'mantenimiento' ? '🔧 Mant.' : u.status === 'inactiva' ? '⛔' : '';
                return <option key={u.id} value={u.id}>{st} {u.placas} - {u.tipo} ({u.capacidad})</option>;
              })}
            </select>
            {formAsignacion.unidadId && (() => {
              const cotizGanadora = (store.cotizaciones || []).find(c =>
                c.solicitudId === mostrarAsignarViaje?.solicitudId &&
                (c.transportistaId === usuario?.id || c.empresaId === empresaId)
              );
              const esPropuesta = cotizGanadora?.unidadId && String(cotizGanadora.unidadId) === String(formAsignacion.unidadId);
              if (esPropuesta) return <p className="text-xs text-indigo-600 mt-1 font-medium">🎯 Unidad propuesta en la cotización — cargada automáticamente</p>;
              const chofer = todosChoferes.find(c => String(c.id) === String(formAsignacion.choferId));
              return chofer?.unidadAsignada && String(chofer.unidadAsignada) === String(formAsignacion.unidadId)
                ? <p className="text-xs text-green-600 mt-1">✅ Unidad asignada a este chofer</p>
                : null;
            })()}
          </div>
          {/* Datos de contacto para entrega */}
          <div className="border-t pt-4 mt-2">
            <p className="text-xs font-semibold text-gray-500 uppercase mb-3">Contacto en destino (para el chofer)</p>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Nombre de quien recibe</label>
                <input
                  type="text"
                  placeholder="Ej: Juan García / Almacén Central"
                  value={formAsignacion.contactoCliente}
                  onChange={e => setFormAsignacion({ ...formAsignacion, contactoCliente: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Teléfono de contacto</label>
                <input
                  type="tel"
                  placeholder="Ej: 664-123-4567"
                  value={formAsignacion.telefonoCliente}
                  onChange={e => setFormAsignacion({ ...formAsignacion, telefonoCliente: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                  maxLength={10} inputMode="numeric"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>
            </div>
          </div>

          <button type="submit" className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold">
            Asignar y Notificar
          </button>
        </form>
      </div>
    </div>
  );

  // Modal: Publicar Flete de Retorno

  // Componente: Mapa de Unidades
  // COORDS_CIUDADES y MapaUnidades se definen fuera del componente (ver abajo)
  // para evitar violación de reglas de hooks al llamarse condicionalmente





  // ========== PANEL DE NOTIFICACIONES ==========
  const PanelNotificaciones = () => {
    const todas = (store.notificaciones || [])
      .filter(n => n.destinatarioId === usuario?.id || n.destinatarioRol === 'transportista')
      .slice().sort((a, b) => new Date(b.creadoEn) - new Date(a.creadoEn));
    return (
      <div className="fixed inset-0 z-[1000] flex items-start justify-center md:justify-end pt-2 px-2 md:pt-4 md:pr-4 md:px-0" onClick={cerrarNotificaciones}>
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm md:w-96 max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
          <div className="p-4 border-b flex justify-between items-center">
            <h3 className="font-bold text-gray-800 text-lg">Notificaciones</h3>
            <div className="flex items-center gap-2">
              {todas.length > 0 && (
                <button onClick={() => { apiEliminarTodasNotificaciones().catch(() => {}); limpiarNotificaciones(usuario?.id, 'transportista'); cerrarNotificaciones(); }} className="text-xs text-red-500 hover:text-red-700 font-medium">Limpiar todo</button>
              )}
              <button onClick={cerrarNotificaciones} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
            </div>
          </div>
          {todas.length === 0 ? (
            <div className="p-8 text-center text-gray-500">
              <Bell size={40} className="mx-auto mb-3 text-gray-300" />
              <p>Sin notificaciones</p>
            </div>
          ) : (
            <div className="divide-y">
              {todas.map(n => {
                const esCalifPendiente = n.tipo === 'calificacion_pendiente';
                const seccionDestino =
                  ['nueva_solicitud', 'cotizacion_rechazada', 'solicitud_cancelada', 'solicitud_expirada_trans', 'solicitud_modificada'].includes(n.tipo) ? 'solicitudes' :
                  ['cotizacion_ganadora', 'cotizacion_aceptada', 'entrega_confirmada', 'orden_completada_chofer', 'entrega_completada'].includes(n.tipo) ? 'viajes' :
                  esCalifPendiente ? '__modal_calificar__' :
                  ['empresa_aprobada', 'empresa_rechazada', 'docs_validados', 'empresa_suspendida', 'empresa_reactivada', 'documento_verificado', 'documento_rechazado'].includes(n.tipo) ? 'dashboard' :
                  ['retiro_aprobado', 'retiro_pagado', 'retiro_rechazado', 'comision_disponible'].includes(n.tipo) ? 'cobros' :
                  null;
                const linkLabel =
                  n.tipo === 'nueva_solicitud' ? 'Ver solicitud →' :
                  n.tipo === 'cotizacion_rechazada' ? 'Ver solicitudes →' :
                  n.tipo === 'solicitud_modificada' ? 'Ver solicitud →' :
                  n.tipo === 'solicitud_cancelada' ? 'Ver solicitudes →' :
                  n.tipo === 'cotizacion_ganadora' ? 'Ver viaje asignado →' :
                  n.tipo === 'cotizacion_aceptada' ? 'Ver viaje →' :
                  n.tipo === 'entrega_confirmada' ? 'Ver viaje completado →' :
                  n.tipo === 'orden_completada_chofer' ? 'Ver viaje →' :
                  n.tipo === 'calificacion_pendiente' ? 'Calificar cliente →' :
                  n.tipo === 'entrega_completada' ? 'Ver viaje →' :
                  n.tipo === 'empresa_aprobada' ? 'Ir al dashboard →' :
                  n.tipo === 'empresa_rechazada' ? 'Ir al dashboard →' :
                  n.tipo === 'docs_validados' ? 'Ir al dashboard →' :
                  n.tipo === 'empresa_suspendida' ? 'Ver estado →' :
                  n.tipo === 'empresa_reactivada' ? 'Ir al dashboard →' :
                  n.tipo === 'documento_verificado' ? 'Ver documentos →' :
                  n.tipo === 'documento_rechazado' ? 'Ver documentos →' :
                  n.tipo === 'retiro_aprobado' ? 'Ver cobros →' :
                  n.tipo === 'retiro_pagado' ? 'Ver cobros →' :
                  n.tipo === 'retiro_rechazado' ? 'Ver cobros →' :
                  n.tipo === 'comision_disponible' ? 'Ver comisiones →' :
                  null;
                return (
                  <div
                    key={n.id}
                    className={`p-4 relative ${seccionDestino ? 'cursor-pointer hover:bg-gray-50' : ''} ${n.leida ? 'bg-white' : 'bg-green-50'}`}
                    onClick={() => {
                      if (!seccionDestino) return;
                      if (seccionDestino === '__modal_calificar__') {
                        const d = n.datos || {};
                        const viajeObj = (store.viajes || []).find(v => v.id === d.viajeId)
                          || { id: d.viajeId, clienteId: d.clienteId, origen: '', destino: '' };
                        setMostrarCalificarCliente({ ...viajeObj, clienteNombre: d.clienteNombre });
                        cerrarNotificaciones();
                      } else {
                        setSeccion(seccionDestino);
                        cerrarNotificaciones();
                      }
                    }}
                  >
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        apiEliminarNotificacion(n.id).catch(() => {});
                        dispatch(s => ({ ...s, notificaciones: (s.notificaciones || []).filter(x => x.id !== n.id) }));
                      }}
                      className="absolute top-3 right-3 text-gray-300 hover:text-gray-500 transition"
                      title="Descartar"
                    >
                      <X size={14} />
                    </button>
                    <div className="flex items-start space-x-3 pr-5">
                      <div className={`mt-1 w-2 h-2 rounded-full flex-shrink-0 ${n.leida ? 'bg-gray-300' : 'bg-green-500'}`} />
                      <div className="flex-1">
                        <p className="font-semibold text-gray-800 text-sm">{n.titulo}</p>
                        <p className="text-gray-600 text-sm mt-0.5">{n.mensaje}</p>
                        <p className="text-xs text-gray-400 mt-1">{new Date(n.creadoEn || n.fecha).toLocaleString('es-MX')}</p>
                        {linkLabel && <span className="mt-2 inline-block text-xs text-green-700 font-semibold">{linkLabel}</span>}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  };

  // ========== RENDER PRINCIPAL ==========
  return (
    <div className="flex h-screen bg-gray-100">
      {toastNotif.length > 0 && !toastPausado && (() => {
        const notif = toastNotif[0];
        const esAlerta = notif.tipo?.startsWith('alerta_');
        const alertaTipo = esAlerta ? notif.tipo.replace('alerta_', '') : null;
        // Alertas simples no persistentes → píldora clásica
        if (esAlerta && !notif.persistente) {
          const bgColor = { success: 'bg-green-500', warning: 'bg-yellow-500', error: 'bg-red-500' }[alertaTipo] || 'bg-gray-700';
          return (
            <div className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${bgColor} text-white px-8 py-5 rounded-2xl shadow-2xl z-[99999] flex items-center space-x-3 text-center max-w-sm w-full mx-4 pointer-events-none`}>
              {alertaTipo === 'success' && <CheckCircle size={24} className="flex-shrink-0" />}
              {alertaTipo === 'warning' && <AlertCircle size={24} className="flex-shrink-0" />}
              {alertaTipo === 'error' && <XCircle size={24} className="flex-shrink-0" />}
              <span className="font-medium">{notif.mensaje}</span>
            </div>
          );
        }
        const headerColor = esAlerta
          ? { success: 'bg-green-600', warning: 'bg-yellow-500', error: 'bg-red-600' }[alertaTipo] || 'bg-gray-700'
          : (notif.tipo === 'solicitud_cancelada' || notif.tipo === 'solicitud_expirada_trans' || notif.tipo === 'documento_rechazado' || notif.tipo === 'retiro_rechazado') ? 'bg-red-600'
          : notif.tipo === 'incidencia_reportada' ? 'bg-red-700'
          : (notif.tipo === 'incidencia_resuelta' || notif.tipo === 'documento_verificado' || notif.tipo === 'retiro_pagado' || notif.tipo === 'comision_disponible') ? 'bg-green-600'
          : notif.tipo === 'retiro_aprobado' ? 'bg-blue-600' : 'bg-orange-500';
        const borderColor = esAlerta
          ? { success: 'border-green-200', warning: 'border-yellow-300', error: 'border-red-200' }[alertaTipo] || 'border-gray-200'
          : (notif.tipo === 'solicitud_cancelada' || notif.tipo === 'solicitud_expirada_trans' || notif.tipo === 'incidencia_reportada' || notif.tipo === 'documento_rechazado' || notif.tipo === 'retiro_rechazado') ? 'border-red-200'
          : (notif.tipo === 'documento_verificado' || notif.tipo === 'retiro_pagado' || notif.tipo === 'comision_disponible') ? 'border-green-200'
          : 'border-orange-200';
        const hoverColor = esAlerta
          ? { success: 'hover:bg-green-50', warning: 'hover:bg-yellow-50', error: 'hover:bg-red-50' }[alertaTipo] || 'hover:bg-gray-50'
          : 'hover:bg-orange-50';
        const toca = esAlerta
          ? { success: null, warning: 'text-yellow-600', error: 'text-red-600' }[alertaTipo]
          : 'text-orange-600';
        const seccionDestino = esAlerta ? (notif.navegar || null) : ({
          cotizacion_aceptada: 'viajes',
          cotizacion_ganadora: 'viajes',
          nueva_orden: 'viajes',
          cotizacion_rechazada: 'solicitudes',
          nueva_solicitud: 'solicitudes',
          solicitud_cancelada: 'solicitudes',
          solicitud_expirada_trans: 'solicitudes',
          solicitud_modificada: 'solicitudes',
          retorno_oferta: 'retornos',
          incidencia_reportada: 'viajes',
          incidencia_resuelta: 'viajes',
          orden_completada_chofer: 'historial',
          entrega_completada: 'historial',
          entrega_confirmada: 'historial',
          empresa_aprobada: 'dashboard',
          empresa_suspendida: 'dashboard',
          empresa_rechazada: 'dashboard',
          empresa_reactivada: 'dashboard',
          docs_validados: 'dashboard',
          documento_verificado: 'dashboard',
          documento_rechazado: 'dashboard',
          pago_recibido: 'cobros',
          escrow_liberado: 'cobros',
          retiro_aprobado: 'cobros',
          retiro_pagado: 'cobros',
          retiro_rechazado: 'cobros',
          comision_disponible: 'cobros',
          calificacion_pendiente: '__modal_calificar__',
        }[notif.tipo] || null);
        const esNavegable = !!seccionDestino || notif.tipo === 'chat_mensaje';
        return (
          <div className="fixed inset-0 flex items-center justify-center z-[2000] pointer-events-none">
            <div className={`bg-white border ${borderColor} rounded-2xl shadow-2xl w-96 pointer-events-auto animate-slide-in-right`}>
              <div className={`${headerColor} px-5 py-3 rounded-t-2xl flex items-center justify-between`}>
                <div className="flex items-center gap-2 text-white text-sm font-semibold">
                  {esAlerta ? (
                    alertaTipo === 'success' ? <CheckCircle size={16} /> : alertaTipo === 'error' ? <XCircle size={16} /> : <AlertCircle size={16} />
                  ) : <Bell size={16} />}
                  <span>{notif.titulo || 'Nueva notificación'}{toastNotif.length > 1 ? ` (1 de ${toastNotif.length})` : ''}</span>
                </div>
                <button onClick={() => cerrarToast()} className="text-white hover:opacity-70">
                  <X size={18} />
                </button>
              </div>
              {(() => {
                // Tiempo relativo
                const tiempoRelativo = (iso) => {
                  if (!iso) return null;
                  const diff = Date.now() - new Date(iso).getTime();
                  const min = Math.floor(diff / 60000);
                  if (min < 1) return 'Ahora';
                  if (min < 60) return `hace ${min} min`;
                  const hrs = Math.floor(min / 60);
                  if (hrs < 24) return `hace ${hrs}h`;
                  return `hace ${Math.floor(hrs / 24)} día${Math.floor(hrs / 24) > 1 ? 's' : ''}`;
                };
                // Para nueva_solicitud: enriquecer con datos del store
                const sol = (notif.tipo === 'nueva_solicitud' && notif.datos?.solicitudId)
                  ? solicitudesDisponibles.find(s => s.id === notif.datos.solicitudId)
                  : null;
                // Detectar si la solicitud está en ventana exclusiva PRO (visible para PRO, no para básico aún)
                const enVentanaPro = notif.tipo === 'nueva_solicitud' && !sol && !esPro
                  && !store.configPlataforma?.difusionGlobal
                  && (() => {
                    const horas = store.configPlataforma?.horasExclusivaPro ?? 6;
                    if (!horas || !notif.creadoEn) return false;
                    const minTranscurridos = (Date.now() - new Date(notif.creadoEn).getTime()) / 60000;
                    return minTranscurridos < horas * 60;
                  })();
                const minRestantesPro = enVentanaPro ? (() => {
                  const horas = store.configPlataforma?.horasExclusivaPro ?? 6;
                  const minTranscurridos = (Date.now() - new Date(notif.creadoEn).getTime()) / 60000;
                  return Math.ceil(horas * 60 - minTranscurridos);
                })() : 0;
                const navegar = () => {
                  if (!esNavegable) return;
                  cerrarNotificaciones();
                  if (esAlerta && notif.navegar) {
                    setSeccion(notif.navegar);
                    if (notif.expandId) { setExpandedViaje(notif.expandId); setTimeout(() => document.getElementById(`viaje-t-${notif.expandId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150); }
                    cerrarToast(); return;
                  }
                  if (notif.tipo === 'nueva_solicitud' && notif.datos?.solicitudId) {
                    if (sol) { setSeccion('solicitudes'); abrirModalCotizacion(sol); cerrarToast(); return; }
                    setSeccion('solicitudes'); cerrarToast(); return;
                  }
                  if ((notif.tipo === 'cotizacion_ganadora' || notif.tipo === 'cotizacion_aceptada') && notif.datos?.viajeId) {
                    setSeccion('viajes'); setExpandedViaje(notif.datos.viajeId);
                    setTimeout(() => document.getElementById(`viaje-t-${notif.datos.viajeId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
                    cerrarToast(); return;
                  }
                  if (notif.tipo === 'chat_mensaje' && notif.datos?.viajeId) {
                    if (notif.contraparte) {
                      setChatModal({ viajeId: notif.datos.viajeId, contraparte: notif.contraparte });
                    } else {
                      const vid = notif.datos.viajeId;
                      setSeccion('viajes'); setExpandedViaje(vid);
                      setTimeout(() => document.getElementById(`viaje-t-${vid}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
                    }
                    cerrarToast(); return;
                  }
                  if (notif.datos?.retornoId) {
                    setSeccion('retornos');
                    setTimeout(() => document.getElementById(`ret-t-${notif.datos.retornoId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
                    cerrarToast(); return;
                  }
                  if (seccionDestino === '__modal_calificar__') {
                    const d = notif.datos || {};
                    const viajeObj = (store.viajes || []).find(v => v.id === d.viajeId)
                      || { id: d.viajeId, clienteId: d.clienteId, origen: '', destino: '' };
                    setMostrarCalificarCliente({ ...viajeObj, clienteNombre: d.clienteNombre });
                    cerrarToast(); return;
                  }
                  if (seccionDestino) setSeccion(seccionDestino);
                  cerrarToast();
                };
                return (
                  <div className="p-5">
                    {/* Título + tiempo */}
                    <div className="flex items-start justify-between gap-2 mb-1">
                      <p className="font-bold text-gray-800 leading-snug">{notif.titulo}</p>
                      {(notif.creadoEn || notif.fecha) && (
                        <span className="text-gray-400 text-xs whitespace-nowrap flex-shrink-0 mt-0.5">
                          {tiempoRelativo(notif.creadoEn || notif.fecha)}
                        </span>
                      )}
                    </div>
                    {/* Cuerpo según caso */}
                    {sol ? (
                      /* Solicitud visible: mostrar folio + ruta */
                      <div className="mt-1 mb-2">
                        {sol.folio && (
                          <span className="inline-block text-xs font-mono font-semibold text-orange-600 bg-orange-50 rounded px-1.5 py-0.5 mb-1">
                            {sol.folio}
                          </span>
                        )}
                        <p className="text-gray-700 text-sm font-medium">
                          {sol.origen} → {sol.destino}
                        </p>
                        {sol.carga && (
                          <p className="text-gray-400 text-xs mt-0.5">{sol.carga}</p>
                        )}
                      </div>
                    ) : enVentanaPro ? (
                      /* Solicitud en ventana exclusiva PRO */
                      <div className="mt-1 mb-2">
                        <p className="text-gray-600 text-sm">{notif.mensaje}</p>
                        <div className="mt-2 flex items-start gap-2 bg-purple-50 border border-purple-200 rounded-lg px-3 py-2">
                          <Lock size={14} className="text-purple-500 flex-shrink-0 mt-0.5" />
                          <div>
                            <p className="text-purple-700 text-xs font-semibold">
                              Disponible en {minRestantesPro >= 60
                                ? minRestantesPro % 60 === 0
                                  ? `${Math.floor(minRestantesPro / 60)}h`
                                  : `${Math.floor(minRestantesPro / 60)}h ${minRestantesPro % 60}min`
                                : `${minRestantesPro} min`}
                            </p>
                            <p className="text-purple-500 text-xs">Los usuarios PRO la ven ahora</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      /* Mensaje genérico */
                      <p className="text-gray-600 text-sm mt-1">{notif.mensaje}</p>
                    )}
                    {/* Botón de acción */}
                    {enVentanaPro ? (
                      <button
                        onClick={() => { setModalPagarPro(true); cerrarToast(); }}
                        className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold px-4 py-2 rounded-lg transition text-purple-700 bg-purple-50 hover:bg-purple-100"
                      >
                        ⚡ Mejorar a PRO →
                      </button>
                    ) : esNavegable && (
                      <button
                        onClick={navegar}
                        className={`mt-3 inline-flex items-center gap-1.5 text-sm font-semibold px-4 py-2 rounded-lg transition ${toca ? `${toca} bg-orange-50 hover:bg-orange-100` : 'text-gray-600 bg-gray-100 hover:bg-gray-200'}`}
                      >
                        Ver →
                      </button>
                    )}
                  </div>
                );
              })()}
            </div>
          </div>
        );
      })()}
      {mostrarNotificaciones && PanelNotificaciones()}

      {/* Overlay móvil */}
      {sidebarAbierto && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarAbierto(false)} />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-30 w-72 bg-green-800 text-white p-4 pb-20 md:pb-4 flex flex-col overflow-y-auto
        transform transition-transform duration-300 ease-in-out
        ${sidebarAbierto ? 'translate-x-0' : '-translate-x-full'}
        md:relative md:translate-x-0 md:w-64 md:z-auto
      `}>
        <div className="mb-8 flex items-start justify-between">
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-black text-orange-400 leading-none">Choyero!</h1>
              {esPro && (
                <span className="px-2 py-0.5 text-xs font-black rounded-full bg-purple-500 text-white tracking-wide">PRO</span>
              )}
            </div>
            <p className="text-xs font-semibold text-green-200 tracking-widest uppercase mt-0.5">Marketplace Logístico</p>
          </div>
          <button onClick={abrirNotificaciones} className="relative mt-1 p-2 rounded-lg hover:bg-green-700 transition">
            <Bell size={20} className="text-white" />
            {notifsPendientes.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
                {notifsPendientes.length}
              </span>
            )}
          </button>
        </div>
        
        {!esPro && (store.configPlataforma?.pagoProHabilitado || store.configPlataforma?.modoPreLanzamientoPro) && (
          <button
            onClick={() => { setModalPagarPro(true); setPagoExitoso(false); setPeriodoPro('mensual'); setFormPago({ numero: '', nombre: '', expira: '', cvv: '' }); }}
            className="w-full mb-4 flex items-center justify-between gap-2 px-3 py-2.5 rounded-xl bg-gradient-to-r from-yellow-400 to-orange-400 hover:from-yellow-300 hover:to-orange-300 text-gray-900 shadow-lg font-bold text-sm"
          >
            <div className="flex items-center gap-2">
              <span className="text-lg">⚡</span>
              <div className="text-left">
                <p className="font-black leading-none">Hazte PRO</p>
                <p className="text-xs font-medium opacity-75">${(store.configPlataforma?.precioProMensual ?? 599).toLocaleString()} MXN/mes</p>
              </div>
            </div>
            <span className="bg-gray-900 text-yellow-400 text-xs font-black px-2 py-0.5 rounded-full">★ PRO</span>
          </button>
        )}

        <nav className="space-y-2 flex-1">
          {menu.map(item => (
            <button
              key={item.id}

              onClick={() => { setSeccion(item.id); setSidebarAbierto(false); }}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition ${seccion === item.id ? 'bg-green-600' : 'hover:bg-green-700'}`}
            >
              <item.icon size={20} />
              <span className="text-sm">{item.label}</span>
              {item.badge > 0 && (
                <span className="ml-auto bg-red-500 text-xs px-2 py-1 rounded-full">{item.badge}</span>
              )}
            </button>
          ))}
        </nav>

        <div className="p-4 bg-green-900 rounded-xl">
          <p className="text-xs text-green-300 mb-2 font-semibold uppercase tracking-wide">Ganancias</p>
          <div className="flex justify-between items-baseline mb-1">
            <p className="text-xs text-green-400">Hoy</p>
            <p className="text-base font-bold text-green-300">${gananciasHoy.toLocaleString()}</p>
          </div>
          <div className="flex justify-between items-baseline">
            <p className="text-xs text-green-400">Este mes</p>
            <p className="text-xl font-bold text-green-400">${gananciasMes.toLocaleString()}</p>
          </div>
        </div>

        {/* Info usuario + logout */}
        <div className="mt-3 p-3 bg-green-900 rounded-xl">
          {/* Logo de empresa */}
          <div className="flex items-center space-x-3 mb-2">
            <label className="cursor-pointer group relative flex-shrink-0" title="Cambiar logo">
              <div className="w-12 h-12 rounded-xl bg-green-700 flex items-center justify-center overflow-hidden border-2 border-green-600 group-hover:border-yellow-400 transition">
                {empresaActiva?.logo
                  ? <img src={empresaActiva.logo} alt="logo" className="w-full h-full object-cover" />
                  : <Truck size={22} className="text-green-300" />}
              </div>
              <div className="absolute inset-0 rounded-xl bg-black bg-opacity-0 group-hover:bg-opacity-40 flex items-center justify-center transition">
                <span className="text-white text-xs opacity-0 group-hover:opacity-100 font-bold">📷</span>
              </div>
              <input type="file" accept="image/*" className="hidden" onChange={handleLogoChange} />
            </label>
            <div className="min-w-0">
              <div className="flex items-center gap-1.5">
                <p className="text-sm font-semibold text-white truncate">{empresaInfo.nombre}</p>
                {esPro && <span className="flex-shrink-0 px-1.5 py-0.5 text-xs font-black rounded bg-purple-500 text-white">PRO</span>}
              </div>
              <p className="text-xs text-green-300 truncate">{usuario?.email}</p>
            </div>
          </div>
          {(empresaActiva?.insigniasManuales || []).length > 0 && (
            <div className="flex flex-wrap gap-1 mt-2">
              {(empresaActiva.insigniasManuales).map(id => {
                const ins = CATALOGO_INSIGNIAS.find(b => b.id === id);
                return ins ? (
                  <span key={id} title={ins.desc} className="text-base cursor-default">{ins.emoji}</span>
                ) : null;
              })}
            </div>
          )}
          {!esPro && (store.configPlataforma?.pagoProHabilitado || store.configPlataforma?.modoPreLanzamientoPro) && (
            <button
              onClick={() => { setModalPagarPro(true); setPagoExitoso(false); setPeriodoPro('mensual'); setFormPago({ numero: '', nombre: '', expira: '', cvv: '' }); }}
              className="mt-2 w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg transition text-sm font-bold bg-gradient-to-r from-yellow-400 to-orange-400 hover:from-yellow-300 hover:to-orange-300 text-gray-900 shadow"
            >
              <span>⚡ Mejorar a PRO</span>
            </button>
          )}
          {esPro && (
            <button
              onClick={() => setChatModal({ viajeId: `soporte-pro-${usuario.id}`, contraparte: { id: 'admin', nombre: 'Soporte Choyero', rol: 'admin' } })}
              className="mt-2 w-full flex items-center space-x-2 px-3 py-1.5 bg-purple-700 hover:bg-purple-600 text-white rounded-lg transition text-sm font-semibold"
            >
              <MessageCircle size={14} />
              <span>Soporte Prioritario ★</span>
            </button>
          )}
          {(() => {
            const canalAdmin = `admin-empresa-${empresaId}`;
            // Si el admin cerró la conversación, no mostrar el botón
            if ((store.canalesAdminCerrados || []).includes(canalAdmin)) return null;
            const msgsAdmin = (store.mensajes || []).filter(m => m.viajeId === canalAdmin && m.emisorRol === 'admin');
            if (msgsAdmin.length === 0) return null;
            const ultimoVistoAdmin = lastSeenMessages[`${canalAdmin}_admin`] || null;
            const noLeidosAdmin = ultimoVistoAdmin
              ? msgsAdmin.filter(m => new Date(m.fecha) > new Date(ultimoVistoAdmin)).length
              : msgsAdmin.length;
            return (
              <button
                onClick={() => setChatModal({ viajeId: canalAdmin, contraparte: { id: 'admin', nombre: 'Administración Choyero', rol: 'admin' } })}
                className="mt-2 w-full flex items-center justify-between px-3 py-2 bg-orange-600 hover:bg-orange-500 text-white rounded-lg transition text-sm font-semibold"
              >
                <span className="flex items-center gap-2"><Mail size={14} /> Mensaje de Admin</span>
                {noLeidosAdmin > 0 && (
                  <span className="bg-white text-orange-600 text-xs font-bold px-1.5 py-0.5 rounded-full">{noLeidosAdmin}</span>
                )}
              </button>
            );
          })()}
          <button
            onClick={onLogout}
            className="mt-2 w-full flex items-center space-x-2 px-3 py-1.5 text-green-300 hover:text-white hover:bg-green-800 rounded-lg transition text-sm"
          >
            <LogOut size={14} />
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </div>

      {/* Contenido Principal */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header móvil */}
        <div className="md:hidden flex items-center justify-between px-4 py-3 bg-green-800 text-white flex-shrink-0">
          <button onClick={() => setSidebarAbierto(true)} className="p-2 rounded-lg hover:bg-green-700">
            <Menu size={22} />
          </button>
          <span className="font-black text-orange-400 text-lg">Choyero!</span>
          <button onClick={abrirNotificaciones} className="relative p-2 rounded-lg hover:bg-green-700">
            <Bell size={22} className="text-white" />
            {notifsPendientes.length > 0 && (
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold">
                {notifsPendientes.length}
              </span>
            )}
          </button>
        </div>
        {usuario?.emailVerificado === false && (
          <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-3 flex flex-wrap items-center justify-between gap-2 flex-shrink-0">
            <div className="flex items-center gap-2 text-sm text-yellow-800">
              <AlertCircle size={16} className="flex-shrink-0 text-yellow-600" />
              <span>Confirma tu dirección de email para asegurar tu cuenta. Si no te llegó, revisa tu carpeta de <strong>spam o correo no deseado</strong>.</span>
            </div>
            <button disabled={reenvioVerifLoading || reenvioVerifOk}
              onClick={async () => {
                setReenvioVerifLoading(true);
                try { await apiResendVerification(); setReenvioVerifOk(true); }
                catch { } finally { setReenvioVerifLoading(false); }
              }}
              className="text-xs font-semibold px-3 py-1.5 rounded-lg border border-yellow-400 text-yellow-800 hover:bg-yellow-100 disabled:opacity-60 whitespace-nowrap">
              {reenvioVerifOk ? '✓ Email enviado' : reenvioVerifLoading ? 'Enviando…' : 'Reenviar email'}
            </button>
          </div>
        )}
        {/* Banner: empresa en revisión (no aprobada) */}
        {empresaEnRevision && (() => {
          // Caso A: flete de prueba activo y aún no completó ninguno → acceso completo con aviso
          if (fletesPruebaActivo && viajesCompletadosReal.length === 0) return (
            <div className="border-b border-green-200 bg-green-50 px-4 py-3 flex flex-wrap items-center justify-between gap-2 flex-shrink-0">
              <div className="flex items-center gap-2 text-sm">
                <CheckCircle size={16} className="flex-shrink-0 text-green-500" />
                <span className="text-green-800">
                  <strong>Tienes 1 flete de prueba gratuito</strong> para que experimentes la plataforma y conozcas cómo funciona.
                  Una vez completado, <strong>cotizar y el Mapa de Unidades quedarán bloqueados</strong> hasta que verifiquemos tu empresa transportista.
                </span>
              </div>
              <button onClick={() => setSeccion('documentos')} className="text-xs font-semibold px-3 py-1.5 rounded-lg border border-green-400 text-green-800 hover:bg-green-100 whitespace-nowrap">
                Subir documentos →
              </button>
            </div>
          );
          // Caso B: bloqueado — ya usó el flete de prueba o toggle OFF
          return (
            <div className={`border-b px-4 py-3 flex flex-wrap items-center justify-between gap-2 flex-shrink-0 ${empresaEnRevision.status === 'pendiente' ? 'bg-blue-50 border-blue-200' : 'bg-amber-50 border-amber-200'}`}>
              <div className="flex items-center gap-2 text-sm">
                <AlertCircle size={16} className={`flex-shrink-0 ${empresaEnRevision.status === 'pendiente' ? 'text-blue-500' : 'text-amber-500'}`} />
                {empresaEnRevision.status === 'pendiente' ? (
                  <span className="text-blue-800">Tu empresa está <strong>en revisión</strong> por el administrador. Cotizar y el Mapa quedarán disponibles una vez aprobada.</span>
                ) : (
                  <span className="text-amber-800"><strong>Sube tu documentación</strong> y espera aprobación para desbloquear cotizar y el Mapa de Unidades.</span>
                )}
              </div>
              {empresaEnRevision.status === 'en_registro' && (
                <button onClick={() => setSeccion('documentos')} className="text-xs font-semibold px-3 py-1.5 rounded-lg border border-amber-400 text-amber-800 hover:bg-amber-100 whitespace-nowrap">
                  Subir documentos →
                </button>
              )}
            </div>
          );
        })()}

        <div className="flex-1 p-4 pb-24 md:p-8 overflow-auto">

        {/* ========== DOCUMENTACIÓN (solo para empresas en revisión) ========== */}
        {seccion === 'documentos' && empresaEnRevision && (() => {
          const docsRequeridos = getDocumentosRequeridos(usuario?.tipoPersona);
          const docsGuardados = empresaEnRevision.documentosEmpresa || [];
          const docs = docsRequeridos.map(d => docsGuardados.find(x => x.id === d.id) || { id: d.id, nombre: d.nombre, status: 'pendiente' });
          const docsSubidos = docs.filter(d => d.status === 'subido' || d.status === 'verificado').length;
          return (
            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Documentación de empresa</h2>
              <p className="text-gray-500 text-sm mb-6">
                Documentos subidos: <span className="font-semibold text-green-700">{docsSubidos} / {docs.length}</span>
              </p>
              <div className="w-full bg-gray-200 rounded-full h-2 mb-8 max-w-2xl">
                <div className="h-2 rounded-full bg-green-500 transition-all" style={{ width: `${docs.length > 0 ? (docsSubidos / docs.length) * 100 : 0}%` }} />
              </div>
              {empresaEnRevision.status === 'pendiente' && (
                <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6 max-w-2xl flex items-start gap-3">
                  <AlertCircle size={20} className="text-blue-500 shrink-0 mt-0.5" />
                  <div>
                    <p className="font-semibold text-blue-800">Solicitud enviada — en revisión</p>
                    <p className="text-blue-600 text-sm mt-1">El administrador revisará tu documentación. Recibirás una notificación cuando tu empresa sea aprobada.</p>
                  </div>
                </div>
              )}
              <div className="space-y-4 max-w-2xl">
                {docs.map(doc => {
                  const info = docsRequeridos.find(d => d.id === doc.id);
                  const esVerificado = doc.status === 'verificado';
                  const esSubido = doc.status === 'subido';
                  const esPendiente = doc.status === 'pendiente';
                  return (
                    <div key={doc.id} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex items-center justify-between gap-4">
                      <div className="flex items-center gap-4">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${esVerificado ? 'bg-green-100' : esSubido ? 'bg-blue-100' : 'bg-gray-100'}`}>
                          {esVerificado
                            ? <CheckCircle size={20} className="text-green-600" />
                            : esSubido
                              ? <Clock size={20} className="text-blue-600" />
                              : <FileText size={20} className="text-gray-400" />}
                        </div>
                        <div>
                          <p className="font-semibold text-gray-800">{doc.nombre || info?.nombre}</p>
                          <p className="text-xs text-gray-500">{info?.descripcion}</p>
                          {esSubido && <p className="text-xs text-blue-600 mt-0.5">Subido — en revisión por el administrador</p>}
                          {esVerificado && <p className="text-xs text-green-600 mt-0.5">Verificado</p>}
                        </div>
                      </div>
                      {(esPendiente || (esSubido && empresaEnRevision.status !== 'pendiente')) && (
                        <label className="cursor-pointer flex items-center space-x-2 px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700 transition shrink-0">
                          <Upload size={15} />
                          <span>{esSubido ? 'Cambiar PDF' : 'Subir PDF'}</span>
                          <input
                            type="file"
                            accept=".pdf,application/pdf"
                            className="hidden"
                            onChange={e => {
                              const archivo = e.target.files?.[0];
                              if (!archivo) return;
                              const reader = new FileReader();
                              reader.onload = async (ev) => {
                                storeSubirDocumento(empresaEnRevision.id, doc.id, ev.target.result, archivo.name);
                                try {
                                  const res = await apiTransportistaSubirDocumento(doc.id, ev.target.result, archivo.name);
                                  if (res?.filePath) storeActualizarFileUrl(empresaEnRevision.id, doc.id, res.filePath);
                                  mostrarNotificacion('Documento subido correctamente', 'success');
                                } catch (err) {
                                  dispatch(s => ({ ...s, miEmpresa: s.miEmpresa ? { ...s.miEmpresa, documentosEmpresa: (s.miEmpresa.documentosEmpresa || []).map(d => d.id === doc.id ? { ...d, status: 'pendiente', fileDataUrl: undefined } : d) } : s.miEmpresa }));
                                  mostrarNotificacion(err?.message || 'Error al subir documento', 'error');
                                }
                              };
                              reader.readAsDataURL(archivo);
                            }}
                          />
                        </label>
                      )}
                      {esSubido && empresaEnRevision.status !== 'rechazada' && empresaEnRevision.status !== 'en_registro' && (
                        <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full shrink-0">En revisión</span>
                      )}
                    </div>
                  );
                })}
              </div>
              {docsSubidos === docs.length && docsSubidos > 0 && empresaEnRevision.status === 'en_registro' && (
                <div className="mt-8 max-w-2xl bg-green-50 border border-green-200 rounded-xl p-5">
                  <p className="font-semibold text-green-800 mb-1">Todos los documentos subidos</p>
                  <p className="text-green-600 text-sm mb-4">Cuando estés listo, envía tu solicitud para que el administrador revise tu empresa.</p>
                  <button onClick={async () => {
                    try {
                      await apiReenviarSolicitud();
                      dispatch(s => ({ ...s, miEmpresa: s.miEmpresa ? { ...s.miEmpresa, status: 'pendiente' } : s.miEmpresa }));
                      mostrarNotificacion('Solicitud enviada. El admin la revisará pronto.', 'success');
                    } catch {
                      mostrarNotificacion('Error al enviar la solicitud', 'error');
                    }
                  }} className="px-6 py-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-xl transition">
                    Enviar para revisión
                  </button>
                </div>
              )}
            </div>
          );
        })()}

        {/* ========== DASHBOARD ========== */}
        {seccion === 'dashboard' && (
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Dashboard</h2>

            {/* Banner promo activa */}
            {empresaActiva?.promoActiva && (() => {
              const promoConf = (store.configPlataforma?.promos || []).find(p => p.id === empresaActiva.promoId);
              const usados = empresaActiva.promoFletesUsados || 0;
              const total = promoConf?.fletesGratis || 0;
              const restantes = Math.max(0, total - usados);
              if (restantes === 0) return null;
              return (
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-2xl p-5 mb-6 flex items-center gap-4">
                  <span className="text-3xl">🎁</span>
                  <div className="flex-1">
                    <p className="font-bold text-green-800 text-lg">¡Tienes {restantes} flete{restantes !== 1 ? 's' : ''} con {promoConf?.comisionPromo ?? 0}% de comisión!</p>
                    <p className="text-sm text-green-600 mt-0.5">
                      {promoConf?.nombre ? `Promo "${promoConf.nombre}" · ` : ''}{usados} de {total} usados
                    </p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <p className="text-xs text-green-500 font-semibold uppercase">Tu ganancia</p>
                    <p className="text-2xl font-black text-green-700">{100 - (promoConf?.comisionPromo ?? 0)}%</p>
                  </div>
                </div>
              );
            })()}

            {/* Card flota: solo cuando no hay banner de revisión compitiendo */}
            {!empresaEnRevision && !bannerFlotaCerrado && (unidades.length === 0 || choferes.length === 0) && (() => {
              const sinUnidad = unidades.length === 0;
              const sinChofer = choferes.length === 0;
              const ambos = sinUnidad && sinChofer;
              return (
                <div className="mb-6 flex items-start gap-3 bg-amber-50 border border-amber-300 rounded-xl px-4 py-4 shadow-sm">
                  <span className="text-2xl mt-0.5">⚠️</span>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-amber-900 text-sm">
                      {ambos ? 'Registra tu flota para empezar a cotizar' : sinUnidad ? 'Aún no tienes unidades registradas' : 'Aún no tienes choferes registrados'}
                    </p>
                    <p className="text-amber-700 text-xs mt-0.5">
                      {ambos
                        ? 'Sin unidades ni choferes no apareces en las solicitudes de carga de los clientes.'
                        : sinUnidad
                          ? 'Sin unidades no puedes cotizar solicitudes de flete.'
                          : 'Sin choferes no puedes asignar viajes cuando ganes una cotización.'}
                    </p>
                    <div className="flex gap-2 mt-3 flex-wrap">
                      {sinUnidad && (
                        <button onClick={() => setSeccion('unidades')} className="px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white text-xs font-semibold rounded-lg transition">
                          + Agregar unidad
                        </button>
                      )}
                      {sinChofer && (
                        <button onClick={() => setSeccion('choferes')} className="px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white text-xs font-semibold rounded-lg transition">
                          + Agregar chofer
                        </button>
                      )}
                    </div>
                  </div>
                  <button
                    onClick={() => { sessionStorage.setItem(`choyero_banner_flota_${usuario?.id}`, '1'); setBannerFlotaCerrado(true); }}
                    className="text-amber-400 hover:text-amber-600 flex-shrink-0 mt-0.5"
                    title="Cerrar"
                  >✕</button>
                </div>
              );
            })()}

            {/* Onboarding checklist — solo aparece si no está completo y los datos ya cargaron */}
            {store.miEmpresa && (() => {
              const tieneUnidad = unidades.length > 0;
              const tieneChofer = choferes.length > 0;
              const tienePerfil = !!(empresaActiva?.telefono && empresaActiva?.direccion);
              const tieneLogo = !!(empresaActiva?.logo && empresaActiva.logo !== '🚛');
              const tieneRfc = !!(empresaActiva?.rfc && empresaActiva?.razonSocial && empresaActiva?.regimenFiscal && empresaActiva?.cpFiscal);
              const haCotizado = (store.cotizaciones || []).some(c => c.transportistaId === usuario?.id)
                || (store.viajes || []).length > 0;
              const abrirDatosFiscales = () => { setSeccion('facturas'); setAbrirDFModal(true); setTimeout(() => setAbrirDFModal(false), 500); };
              const pasos = [
                { label: 'Completa el perfil de tu empresa', sub: 'Teléfono y dirección visibles para clientes', ok: tienePerfil, accion: () => setSeccion('perfil') },
                { label: 'Agrega tu logo', sub: 'Genera más confianza con clientes', ok: tieneLogo, accion: () => { setSeccion('perfil'); setTimeout(() => logoInputRef.current?.click(), 150); } },
                { label: 'Registra tu CLABE bancaria', sub: 'Necesaria para recibir pagos de tus clientes', ok: tieneCLABE, accion: () => setSeccion('bancario') },
                { label: 'Completa tus datos fiscales', sub: 'RFC y régimen fiscal para emitir facturas', ok: tieneRfc, accion: abrirDatosFiscales },
                { label: 'Registra tu primera unidad', sub: 'Sin unidades no puedes cotizar', ok: tieneUnidad, accion: () => setSeccion('unidades') },
                { label: 'Registra un chofer', sub: 'Necesario para asignar viajes', ok: tieneChofer, accion: () => setSeccion('choferes') },
                { label: 'Envía tu primera cotización', sub: 'Revisa las solicitudes disponibles', ok: haCotizado, accion: () => setSeccion('solicitudes') },
              ];
              const completados = pasos.filter(p => p.ok).length;
              if (completados === pasos.length) return null; // ocultar cuando todo está completo
              const pct = Math.round((completados / pasos.length) * 100);
              return (
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl p-6 mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h3 className="text-lg font-bold text-gray-800">¡Completa tu perfil para empezar!</h3>
                      <p className="text-sm text-gray-500">{completados} de {pasos.length} pasos completados</p>
                    </div>
                    <div className="text-right">
                      <p className="text-3xl font-black text-blue-600">{pct}%</p>
                    </div>
                  </div>
                  <div className="w-full bg-white rounded-full h-3 mb-5 border border-blue-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-500 h-3 rounded-full transition-all" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="space-y-3">
                    {pasos.map((paso, i) => (
                      <div key={i} className={`flex items-center gap-4 p-3 rounded-xl transition ${paso.ok ? 'bg-green-50 border border-green-200' : 'bg-white border border-gray-200 cursor-pointer hover:border-blue-300 hover:bg-blue-50'}`}
                        onClick={() => !paso.ok && paso.accion()}>
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${paso.ok ? 'bg-green-500' : 'bg-gray-200'}`}>
                          {paso.ok
                            ? <CheckCircle size={18} className="text-white" />
                            : <span className="text-gray-500 text-sm font-bold">{i + 1}</span>}
                        </div>
                        <div className="flex-1">
                          <p className={`text-sm font-semibold ${paso.ok ? 'text-green-700 line-through opacity-60' : 'text-gray-800'}`}>{paso.label}</p>
                          {!paso.ok && <p className="text-xs text-gray-400">{paso.sub}</p>}
                        </div>
                        {!paso.ok && <ChevronRight size={16} className="text-gray-400 flex-shrink-0" />}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })()}

            {/* Insignias de la empresa */}
            {(() => {
              const ids = empresaActiva?.insigniasManuales || [];
              const insignias = ids.map(id => CATALOGO_INSIGNIAS.find(b => b.id === id)).filter(Boolean);
              if (insignias.length === 0) return null;
              return (
                <div className="bg-gradient-to-r from-yellow-50 to-amber-50 border border-yellow-200 rounded-xl p-5 mb-6">
                  <p className="text-xs font-semibold text-yellow-700 uppercase tracking-wide mb-3">Tus insignias</p>
                  <div className="flex flex-wrap gap-3">
                    {insignias.map(ins => (
                      <div key={ins.id} title={ins.desc} className={`flex items-center gap-2 px-4 py-2 rounded-xl border font-semibold text-sm ${ins.color} shadow-sm`}>
                        <span className="text-xl">{ins.emoji}</span>
                        <div>
                          <p className="font-bold leading-tight">{ins.label}</p>
                          <p className="text-xs font-normal opacity-75 leading-tight">{ins.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })()}


            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-4">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-sm text-gray-500 font-semibold">Ganancias</p>
                  <DollarSign className="text-green-500" size={24} />
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between items-baseline">
                    <span className="text-xs text-gray-400">Hoy</span>
                    <span className="text-lg font-bold text-green-600">${gananciasHoy.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-baseline">
                    <span className="text-xs text-gray-400">Este mes</span>
                    <span className="text-2xl font-bold text-green-700">${gananciasMes.toLocaleString()}</span>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-500">Viajes Activos</p>
                    <p className="text-2xl font-bold text-blue-600">{misViajes.length}</p>
                  </div>
                  <Truck className="text-blue-500" size={32} />
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-500">Unidades</p>
                    <p className="text-2xl font-bold text-purple-600">{unidades.length}</p>
                  </div>
                  <Package className="text-purple-500" size={32} />
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-500">Choferes</p>
                    <p className="text-2xl font-bold text-orange-600">{choferes.length}</p>
                  </div>
                  <Users className="text-orange-500" size={32} />
                </div>
              </div>
            </div>

            {/* Widget calificación empresa */}
            {(() => {
              const cal = usuario?.calificacion ?? null;
              const viajesComp = (store.viajes || []).filter(v => v.status === 'confirmado' || v.status === 'completada').length;
              const calificacionesPendientes = (store.notificaciones || []).filter(n => n.tipo === 'calificacion_pendiente' && !n.leida);
              return (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div className="bg-white rounded-xl shadow-lg p-5 flex items-center gap-4">
                    <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Star size={24} className="text-yellow-400" fill="currentColor" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">Calificación de tu empresa</p>
                      <div className="flex items-baseline gap-2">
                        <span className="text-3xl font-black text-gray-800">{(viajesComp > 0 && cal) ? cal.toFixed(1) : '—'}</span>
                        <span className="text-sm text-gray-400">/ 5</span>
                      </div>
                      <div className="flex items-center gap-1 mt-0.5">
                        {[1,2,3,4,5].map(i => (
                          <Star key={i} size={12}
                            className={viajesComp > 0 && i <= Math.round(cal || 0) ? 'text-yellow-400' : 'text-gray-200'}
                            fill={viajesComp > 0 && i <= Math.round(cal || 0) ? 'currentColor' : 'none'} />
                        ))}
                        <span className="text-xs text-gray-400 ml-1">· {viajesComp} viaje{viajesComp !== 1 ? 's' : ''}</span>
                      </div>
                    </div>
                  </div>
                  {calificacionesPendientes.length > 0 && (
                    <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 flex items-center gap-4">
                      <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                        <Star size={24} className="text-amber-500" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-xs text-amber-600 font-medium uppercase tracking-wide">Calificaciones pendientes</p>
                        <p className="text-2xl font-black text-amber-700">{calificacionesPendientes.length}</p>
                        <p className="text-xs text-amber-600">cliente{calificacionesPendientes.length !== 1 ? 's' : ''} por calificar</p>
                      </div>
                      <button
                        onClick={() => {
                          const notif = calificacionesPendientes[0];
                          const viajeData = notif.datos || {};
                          const viajeObj = (store.viajes || []).find(v => v.id === viajeData.viajeId)
                            || { id: viajeData.viajeId, clienteId: viajeData.clienteId, origen: '', destino: '' };
                          setMostrarCalificarCliente({ ...viajeObj, clienteNombre: viajeData.clienteNombre });
                        }}
                        className="px-3 py-2 bg-amber-500 text-white text-sm font-semibold rounded-lg hover:bg-amber-600 flex-shrink-0"
                      >
                        Calificar
                      </button>
                    </div>
                  )}
                </div>
              );
            })()}

            {/* Solicitudes disponibles resumen */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold text-gray-800">Solicitudes Disponibles</h3>
                <button
                  onClick={() => setSeccion('solicitudes')}
                  className="text-sm text-green-600 hover:underline font-medium"
                >
                  Ver todas →
                </button>
              </div>
              <div className="space-y-3">
                {solicitudesAbiertas.slice(0, 3).map(sol => (
                  <div key={sol.id} className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 p-4 bg-gray-50 rounded-lg">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 truncate">
                        <p className="font-semibold truncate">{sol.cliente}</p>
                        {sol.clienteCalificacion != null && (
                          <span className="flex items-center gap-0.5 text-xs text-yellow-600 flex-shrink-0">
                            <Star size={10} className="text-yellow-400" fill="currentColor" />
                            {sol.clienteCalificacion.toFixed(1)}
                          </span>
                        )}
                        {(() => {
                          const SEIS_MESES_MS = 6 * 30 * 24 * 60 * 60 * 1000;
                          const exp = sol.clienteUltimaCancelacion && (Date.now() - new Date(sol.clienteUltimaCancelacion).getTime()) > SEIS_MESES_MS;
                          const n = exp ? 0 : (sol.clienteCancelaciones || 0);
                          if (n === 0) return null;
                          return (
                            <span title={`${n} cancelación(es) en los últimos 6 meses`} className="flex-shrink-0 text-xs px-1.5 py-0.5 bg-red-100 text-red-600 rounded-full font-semibold">
                              ❌ {n}
                            </span>
                          );
                        })()}
                      </div>
                      <p className="text-sm text-gray-500">{sol.origen} → {sol.destino}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className={`text-sm font-semibold ${sol.cotizacionesRecibidas >= 8 ? 'text-red-600' : 'text-gray-600'}`}>
                        {sol.cotizacionesRecibidas}/{sol.maxCotizaciones} cot.
                      </span>
                      {(() => {
                        if (bloqueadoPorAprobacion) return (
                          <span title="Aprobación pendiente" className="px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap bg-gray-100 text-gray-400 cursor-not-allowed flex items-center gap-1.5">
                            <Lock size={14} /> Pendiente aprobación
                          </span>
                        );
                        const sinFlota = unidades.length === 0 || choferes.length === 0;
                        if (sinFlota) return (
                          <button
                            onClick={() => setModalSinFlota({ sinUnidad: unidades.length === 0, sinChofer: choferes.length === 0 })}
                            title="Registra unidad y chofer antes de cotizar"
                            className="px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap bg-red-100 text-red-700 hover:bg-red-200"
                          >
                            ⚠ Completar perfil
                          </button>
                        );
                        if (!tieneCLABE) return (
                          <button
                            onClick={() => setSeccion('bancario')}
                            title="Registra tu CLABE para cotizar"
                            className="px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap bg-orange-100 text-orange-700 hover:bg-orange-200"
                          >
                            ⚠ Registrar CLABE
                          </button>
                        );
                        return (
                          <button
                            onClick={() => abrirModalCotizacion(sol)}
                            className="px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap bg-green-600 text-white hover:bg-green-700"
                          >
                            Cotizar
                          </button>
                        );
                      })()}
                    </div>
                  </div>
                ))}
                {solicitudesAbiertas.length === 0 && (
                  <p className="text-gray-400 text-sm text-center py-4">No hay solicitudes disponibles en este momento</p>
                )}
              </div>
            </div>
          {/* ── Métricas Avanzadas (solo PRO) ── */}
          {esPro && (() => {
            const totalCotizadas = solicitudesDisponibles.filter(s => s.cotizado).length;
            const totalEnviadas = solicitudesDisponibles.filter(s => s.miCotizacion).length;
            const ganadas = misViajes.length;
            const perdidas = solicitudesPerdidas.length;
            const tasaConversion = (ganadas + perdidas) > 0 ? Math.round(ganadas / (ganadas + perdidas) * 100) : 0;
            const ticketPromedio = ganadas > 0
              ? Math.round(misViajes.reduce((s, v) => s + (v.costoFinal || v.precio || v.costo || 0), 0) / ganadas)
              : 0;
            const ahorroComision = store.configPlataforma?.comisionBasico ?? 20;
            return (
              <div className="mt-6 bg-gradient-to-r from-purple-50 to-indigo-50 border border-purple-200 rounded-xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <span className="px-2 py-0.5 text-xs font-black rounded-full bg-purple-500 text-white">PRO</span>
                  <h3 className="text-lg font-bold text-gray-800">Métricas Avanzadas</h3>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="bg-white rounded-xl p-4 shadow-sm">
                    <p className="text-xs text-gray-500 mb-1">Tasa de Conversión</p>
                    <p className="text-2xl font-bold text-purple-600">{tasaConversion}%</p>
                    <p className="text-xs text-gray-400">{ganadas} ganadas / {ganadas + perdidas} enviadas</p>
                  </div>
                  <div className="bg-white rounded-xl p-4 shadow-sm">
                    <p className="text-xs text-gray-500 mb-1">Ticket Promedio</p>
                    <p className="text-2xl font-bold text-purple-600">${ticketPromedio.toLocaleString()}</p>
                    <p className="text-xs text-gray-400">por viaje activo</p>
                  </div>
                  <div className="bg-white rounded-xl p-4 shadow-sm">
                    <p className="text-xs text-gray-500 mb-1">Tu Comisión</p>
                    <p className="text-2xl font-bold text-purple-600">{comisionPct}%</p>
                    <p className="text-xs text-green-600 font-semibold">-{Math.max(0, ahorroComision - comisionPct)}% vs Básico</p>
                  </div>
                  <div className="bg-white rounded-xl p-4 shadow-sm">
                    <p className="text-xs text-gray-500 mb-1">Acceso a Solicitudes</p>
                    <p className="text-2xl font-bold text-purple-600">Inmediato</p>
                    <p className="text-xs text-green-600 font-semibold">{store.configPlataforma?.horasExclusivaPro ?? 6}h antes que Básico</p>
                  </div>
                </div>
              </div>
            );
          })()}
          </div>
        )}

        {/* ========== SOLICITUDES ========== */}
        {seccion === 'solicitudes' && (
          <div>
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-3xl font-bold text-gray-800">Solicitudes Disponibles</h2>
            </div>
            {!tieneCLABE && (
              <div className="bg-orange-50 border border-orange-300 rounded-xl p-4 mb-4 flex items-start gap-3">
                <AlertCircle size={20} className="text-orange-500 flex-shrink-0 mt-0.5" />
                <div className="flex-1">
                  <p className="font-semibold text-orange-800">Necesitas registrar tu CLABE para cotizar</p>
                  <p className="text-sm text-orange-700 mt-0.5">Sin CLABE bancaria no puedes enviar cotizaciones. Regístrala en la sección <strong>Datos Bancarios</strong> para activar esta función.</p>
                </div>
                <button onClick={() => setSeccion('bancario')} className="px-3 py-1.5 bg-orange-500 text-white text-sm font-semibold rounded-lg hover:bg-orange-600 flex-shrink-0">
                  Registrar CLABE
                </button>
              </div>
            )}
            {(() => {
              const hintKey = `choyero_hint_sols_trans_${usuario?.id}`;
              const hintVisto = typeof window !== 'undefined' && localStorage.getItem(hintKey);
              if (hintVisto) return null;
              return (
                <div className="flex items-center gap-3 bg-green-50 border border-green-200 rounded-xl px-4 py-3 mb-4 text-sm text-green-800">
                  <span className="text-lg">👆</span>
                  <span className="flex-1">Toca cualquier fila para ver los detalles de la carga, ruta y enviar tu cotización al cliente.</span>
                  <button onClick={() => { localStorage.setItem(hintKey, '1'); window.dispatchEvent(new Event('choyero_sync')); }} className="text-green-500 hover:text-green-700 flex-shrink-0"><X size={16} /></button>
                </div>
              );
            })()}

            {/* Filtros — tabs de estado */}
            <div className="flex flex-wrap items-center gap-2 mb-3">
              {[
                { key: 'todas',      label: 'Todas',           color: 'green' },
                { key: 'abiertas',   label: 'Abiertas',        color: 'green' },
                { key: 'cotizadas',  label: 'Mis Cotizaciones', color: 'green' },
                { key: 'cerradas',   label: 'Cerradas',         color: 'gray'  },
                { key: 'rechazadas', label: 'Rechazadas',       color: 'red', badge: solicitudesDisponibles.filter(s => s.rechazado).length },
              ].map(f => (
                <button
                  key={f.key}
                  onClick={() => { setFiltroSolicitudes(f.key); setExpandedSolicitud(null); }}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ${
                    filtroSolicitudes === f.key
                      ? f.color === 'red' ? 'bg-red-600 text-white' : f.color === 'gray' ? 'bg-gray-600 text-white' : 'bg-green-600 text-white'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  {f.label}
                  {f.badge > 0 && (
                    <span className={`text-xs px-1.5 py-0.5 rounded-full font-bold ${filtroSolicitudes === f.key ? 'bg-white text-red-600' : 'bg-red-500 text-white'}`}>
                      {f.badge}
                    </span>
                  )}
                </button>
              ))}
            </div>

            {/* Filtros adicionales — búsqueda + tipo unidad + prioridad */}
            <div className="flex flex-wrap items-center gap-2 mb-5">
              <div className="relative flex-1 min-w-[200px]">
                <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
                <input
                  type="text"
                  placeholder="Buscar origen, destino o carga…"
                  value={busquedaSolicitudes}
                  onChange={e => { setBusquedaSolicitudes(e.target.value); setExpandedSolicitud(null); }}
                  className="w-full pl-8 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-400 outline-none"
                />
                {busquedaSolicitudes && (
                  <button onClick={() => setBusquedaSolicitudes('')} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                    <X size={14} />
                  </button>
                )}
              </div>
              <select
                value={filtroTipoUnidad}
                onChange={e => { setFiltroTipoUnidad(e.target.value); setExpandedSolicitud(null); }}
                className="px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-green-400 outline-none"
              >
                <option value="">Todos los vehículos</option>
                <option value="Camioneta">Camioneta</option>
                <option value="Rabon">Rabón</option>
                <option value="Torton">Tortón</option>
                <option value="Trailer">Trailer</option>
                <option value="Trailer Refrigerado">Trailer Refrigerado</option>
              </select>
              <select
                value={filtroPrioridad}
                onChange={e => { setFiltroPrioridad(e.target.value); setExpandedSolicitud(null); }}
                className="px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-green-400 outline-none"
              >
                <option value="">Cualquier prioridad</option>
                <option value="urgente">🔴 Urgente</option>
                <option value="alta">🟠 Alta</option>
                <option value="normal">⚪ Normal</option>
              </select>
              {(busquedaSolicitudes || filtroTipoUnidad || filtroPrioridad) && (
                <button
                  onClick={() => { setBusquedaSolicitudes(''); setFiltroTipoUnidad(''); setFiltroPrioridad(''); }}
                  className="px-3 py-2 text-sm text-gray-500 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center gap-1"
                >
                  <X size={13} /> Limpiar
                </button>
              )}
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase w-8"></th>
                    <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">ID / Cliente</th>
                    <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ruta</th>
                    <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Carga</th>
                    <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Fecha / Prioridad</th>
                    <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Cotizaciones</th>
                    <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Estado</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {solicitudesDisponibles
                    .filter(sol => {
                      if (filtroSolicitudes === 'abiertas') return sol.aceptaCotizaciones && !sol.cotizado && !sol.rechazado;
                      if (filtroSolicitudes === 'cotizadas') return sol.cotizado && !sol.perdida && !sol.cancelada && !sol.expirada;
                      if (filtroSolicitudes === 'cerradas') return (!sol.aceptaCotizaciones && !sol.cotizado) || sol.perdida || sol.cancelada || sol.expirada;
                      if (filtroSolicitudes === 'rechazadas') return sol.rechazado;
                      if (filtroSolicitudes === 'todas') return !sol.rechazado;
                      return true;
                    })
                    .filter(sol => {
                      if (busquedaSolicitudes) {
                        const q = busquedaSolicitudes.toLowerCase();
                        if (!(sol.origen?.toLowerCase().includes(q) || sol.destino?.toLowerCase().includes(q) || sol.carga?.toLowerCase().includes(q))) return false;
                      }
                      if (filtroTipoUnidad && sol.tipoUnidad !== filtroTipoUnidad) return false;
                      if (filtroPrioridad && (sol.prioridad || 'normal') !== filtroPrioridad) return false;
                      return true;
                    })
                    .map(sol => {
                      const verificacion = puedeCotizar(sol);
                      const isExpanded = expandedSolicitud === sol.id;
                      const esCerrada = !sol.aceptaCotizaciones && !sol.cotizado;

                      return (
                        <React.Fragment key={sol.id}>
                          {/* Fila compacta */}
                          <tr
                            onClick={() => {
                              setExpandedSolicitud(isExpanded ? null : sol.id);
                              if (!isExpanded) localStorage.setItem(`choyero_hint_sols_trans_${usuario?.id}`, '1');
                            }}
                            className={`cursor-pointer transition-colors ${isExpanded ? 'bg-green-50' : 'hover:bg-green-50'} ${sol.rechazado ? 'opacity-60' : ''}`}
                          >
                            <td className="px-4 py-4 text-center">
                              <ChevronDown size={16} className={`mx-auto transition-transform ${isExpanded ? 'rotate-180 text-green-600' : 'text-green-500'}`} />
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              <p className="font-mono font-bold text-gray-800 text-sm">{sol.folio || sol.id.slice(0, 8).toUpperCase()}</p>
                              <p className="text-xs text-gray-500">{sol.cliente}</p>
                            </td>
                            <td className="px-4 md:px-6 py-4">
                              <p className="text-sm font-medium text-gray-800">{sol.origen}</p>
                              <p className="text-xs text-gray-400">→ {sol.destino}</p>
                              {(() => {
                                const fase = getSolicitudFase(sol);
                                if (fase === 'local')   return <span className="mt-1 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700"><MapPin size={9} />Tu zona</span>;
                                if (fase === 'destino') return <span className="mt-1 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700"><MapPin size={9} />Ciudad destino</span>;
                                return <span className="mt-1 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-500"><MapPin size={9} />Abierta</span>;
                              })()}
                              {/* Info condensada solo en móvil */}
                              <div className="flex flex-wrap items-center gap-1.5 mt-1 md:hidden">
                                <span className="text-xs text-gray-400">{sol.carga} · {sol.peso}</span>
                                {sol.prioridad !== 'normal' && (
                                  <span className={`px-1.5 py-0.5 text-xs font-semibold rounded-full ${sol.prioridad === 'urgente' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
                                    {sol.prioridad === 'urgente' ? 'Urgente' : 'Alta'}
                                  </span>
                                )}
                              </div>
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              <p className="text-sm text-gray-700">{sol.carga}</p>
                              <p className="text-xs text-gray-400">{sol.peso} · {sol.distancia}</p>
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              <p className="text-sm text-gray-600">{(() => {
                                try {
                                  const f = sol.fecha || '';
                                  const fechaParte = f.split('T')[0];
                                  const horaParte = f.includes('T') ? f.split('T')[1]?.slice(0,5) : null;
                                  const fechaFmt = new Date(fechaParte + 'T12:00:00').toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
                                  return horaParte && horaParte !== '00:00' ? `${fechaFmt} · ${horaParte}` : fechaFmt;
                                } catch { return sol.fecha || '—'; }
                              })()}</p>
                              <span className={`mt-1 inline-block px-2 py-0.5 text-xs font-semibold rounded-full ${sol.prioridad === 'urgente' ? 'bg-red-100 text-red-700' : sol.prioridad === 'alta' ? 'bg-amber-100 text-amber-700' : 'bg-gray-100 text-gray-500'}`}>
                                {sol.prioridad === 'urgente' ? 'Urgente' : sol.prioridad === 'alta' ? 'Alta' : 'Normal'}
                              </span>
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                sol.cotizacionesRecibidas >= 10 ? 'bg-gray-100 text-gray-700' :
                                sol.cotizacionesRecibidas >= 8  ? 'bg-red-100 text-red-700' :
                                sol.cotizacionesRecibidas >= 5  ? 'bg-yellow-100 text-yellow-700' :
                                'bg-green-100 text-green-700'
                              }`}>
                                {sol.cotizacionesRecibidas >= 10
                                  ? <><Lock size={10} className="inline mr-0.5" />Cerrada</>
                                  : `${sol.cotizacionesRecibidas}/${sol.maxCotizaciones}`}
                              </span>
                            </td>
                            <td className="px-4 md:px-6 py-4">
                              {sol.rechazado ? (
                                <span className="px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-700">Rechazada</span>
                              ) : sol.cancelada ? (
                                <span className="px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-700">❌ Cancelada</span>
                              ) : sol.expirada ? (
                                <span className="px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-700">⏰ Expirada</span>
                              ) : sol.perdida ? (
                                <span className="px-2 py-1 text-xs font-semibold rounded-full bg-orange-100 text-orange-700">No ganada</span>
                              ) : sol.cotizado ? (
                                <span className={`px-2 py-1 text-xs font-semibold rounded-full ${sol.miCotizacion?.status === 'ganada' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
                                  {sol.miCotizacion?.status === 'ganada' ? '🎉 Ganaste' : 'Cotizada'}
                                </span>
                              ) : esCerrada ? (
                                <span className="px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-600">Cerrada</span>
                              ) : (
                                <span className="px-2 py-1 text-xs font-semibold rounded-full bg-amber-100 text-amber-700">Abierta</span>
                              )}
                            </td>
                          </tr>

                          {/* Panel expandible */}
                          {isExpanded && (
                            <tr>
                              <td colSpan={7} className="bg-green-50">
                                <div className="px-4 py-4 md:px-8 md:py-6">
                                  {/* Foto e info del cliente */}
                                  {sol.cliente && (
                                    <div className="flex items-center space-x-3 mb-5 bg-white rounded-lg p-3 border border-green-100">
                                      <div className="w-12 h-12 rounded-full overflow-hidden bg-blue-100 flex items-center justify-center flex-shrink-0 font-bold text-blue-700">
                                        {sol.clienteAvatar
                                          ? <img src={sol.clienteAvatar} alt="cliente" className="w-full h-full object-cover" />
                                          : (sol.cliente?.slice(0,2)?.toUpperCase() || 'CL')}
                                      </div>
                                      <div>
                                        <p className="font-semibold text-gray-800 text-sm">{sol.cliente}</p>
                                        {sol.clienteCalificacion != null && (
                                          <div className="flex items-center gap-1 mt-0.5">
                                            {[1,2,3,4,5].map(i => (
                                              <Star key={i} size={11}
                                                className={i <= Math.round(sol.clienteCalificacion) ? 'text-yellow-400' : 'text-gray-300'}
                                                fill={i <= Math.round(sol.clienteCalificacion) ? 'currentColor' : 'none'} />
                                            ))}
                                            <span className="text-xs text-gray-500 ml-0.5">{sol.clienteCalificacion.toFixed(1)}</span>
                                          </div>
                                        )}
                                        {(() => {
                                          const SEIS_MESES_MS = 6 * 30 * 24 * 60 * 60 * 1000;
                                          const exp = sol.clienteUltimaCancelacion && (Date.now() - new Date(sol.clienteUltimaCancelacion).getTime()) > SEIS_MESES_MS;
                                          const n = exp ? 0 : (sol.clienteCancelaciones || 0);
                                          if (n === 0) return null;
                                          return (
                                            <span className="inline-flex items-center gap-1 mt-1 text-xs px-2 py-0.5 bg-red-50 text-red-600 border border-red-200 rounded-full font-semibold">
                                              ❌ {n} cancelación{n !== 1 ? 'es' : ''} (6 meses)
                                            </span>
                                          );
                                        })()}
                                        {sol.clienteDireccion && (
                                          <p className="text-xs text-gray-500 mt-0.5 flex items-center gap-1">
                                            <MapPin size={10} className="flex-shrink-0 text-gray-400" />
                                            {sol.clienteDireccion}
                                          </p>
                                        )}
                                        {sol.clienteTipo && (
                                          <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${sol.clienteTipo === 'moral' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}`}>
                                            {sol.clienteTipo === 'moral' ? 'Persona Moral' : 'Persona Física'}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {/* Calificaciones del cliente por otros transportistas */}
                                  {sol.clienteId && (() => {
                                    const cals = califClienteCache[sol.clienteId];
                                    if (!cals || cals.length === 0) return null;
                                    const expandido = !!opinionesExpandidas[sol.clienteId];
                                    return (
                                      <div className="mb-5 bg-yellow-50 border border-yellow-200 rounded-xl overflow-hidden">
                                        <button
                                          onClick={() => setOpinionesExpandidas(prev => ({ ...prev, [sol.clienteId]: !prev[sol.clienteId] }))}
                                          className="w-full flex items-center justify-between px-4 py-3 text-left"
                                        >
                                          <p className="text-xs font-semibold text-yellow-700 uppercase tracking-wide">💬 Opiniones de otros transportistas ({cals.length})</p>
                                          <ChevronDown size={16} className={`text-yellow-600 transition-transform ${expandido ? 'rotate-180' : ''}`} />
                                        </button>
                                        {expandido && (
                                          <div className="px-4 pb-4 space-y-3">
                                            {cals.map((c, i) => (
                                              <div key={i} className="bg-white rounded-lg p-3 border border-yellow-100">
                                                <div className="flex items-center justify-between mb-1">
                                                  <div className="flex items-center gap-1.5">
                                                    {[1,2,3,4,5].map(s => (
                                                      <Star key={s} size={12} className={s <= Math.round(c.puntuacion) ? 'text-yellow-400' : 'text-gray-300'} fill={s <= Math.round(c.puntuacion) ? 'currentColor' : 'none'} />
                                                    ))}
                                                    <span className="text-xs font-bold text-gray-700 ml-1">{c.autorNombre}</span>
                                                  </div>
                                                  <span className="text-xs text-gray-400">{new Date(c.creadoEn).toLocaleDateString('es-MX', { month: 'short', year: 'numeric' })}</span>
                                                </div>
                                                <p className="text-sm text-gray-700 italic">"{c.comentario}"</p>
                                              </div>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })()}

                                  {/* Ruta detallada */}
                                  <div className="grid grid-cols-2 gap-4 mb-5">
                                    <div className="bg-white rounded-lg p-4 border border-green-100">
                                      <p className="text-xs text-gray-500 mb-1">📍 Origen</p>
                                      <p className="font-semibold text-gray-800">{sol.origen}</p>
                                      {sol.origenDir && <p className="text-xs text-gray-400 mt-0.5">{sol.origenDir}</p>}
                                    </div>
                                    <div className="bg-white rounded-lg p-4 border border-green-100">
                                      <p className="text-xs text-gray-500 mb-1">🏁 Destino</p>
                                      <p className="font-semibold text-gray-800">{sol.destino}</p>
                                      {sol.destinoDir && <p className="text-xs text-gray-400 mt-0.5">{sol.destinoDir}</p>}
                                    </div>
                                  </div>

                                  {/* Prioridad + Notas */}
                                  {(sol.prioridad === 'alta' || sol.prioridad === 'urgente' || sol.notas) && (
                                    <div className={`border rounded-lg p-3 mb-5 ${sol.prioridad === 'urgente' ? 'bg-red-50 border-red-200' : sol.prioridad === 'alta' ? 'bg-amber-50 border-amber-200' : 'bg-blue-50 border-blue-200'}`}>
                                      {(sol.prioridad === 'alta' || sol.prioridad === 'urgente') && (
                                        <p className={`text-sm font-semibold mb-1 ${sol.prioridad === 'urgente' ? 'text-red-700' : 'text-amber-700'}`}>
                                          {sol.prioridad === 'urgente' ? '🔴 Servicio urgente — requiere atención inmediata' : '🟡 Servicio de alta prioridad'}
                                        </p>
                                      )}
                                      {sol.notas && <p className="text-sm text-blue-800"><AlertCircle size={14} className="inline mr-1" />{sol.notas}</p>}
                                    </div>
                                  )}

                                  {/* Fotos */}
                                  {sol.fotos && sol.fotos.length > 0 && (
                                    <div className="mb-5">
                                      <p className="text-xs font-semibold text-gray-500 uppercase mb-2">📷 Fotografías del flete</p>
                                      <div className="flex gap-2 flex-wrap">
                                        {sol.fotos.map((foto, idx) => (
                                          <img key={idx} src={foto} alt={`Foto ${idx + 1}`} onClick={() => setFotoAmpliada(foto)} className="w-20 h-20 object-cover rounded-lg border border-gray-200 hover:opacity-80 transition-opacity cursor-pointer" />
                                        ))}
                                      </div>
                                    </div>
                                  )}


                                  {/* Mi cotización */}
                                  {sol.cotizado && sol.miCotizacion && !sol.rechazado && (
                                    <div className="bg-green-100 rounded-lg p-4 mb-5 flex items-center justify-between">
                                      <div>
                                        <p className="text-xs text-green-700 font-semibold mb-0.5">Tu cotización</p>
                                        <span className="text-2xl font-bold text-green-800">${sol.miCotizacion.precio.toLocaleString()} MXN</span>
                                      </div>
                                      {sol.miCotizacion?.status === 'ganada' && (
                                        <span className="text-2xl">🎉</span>
                                      )}
                                    </div>
                                  )}

                                  {/* Botones de acción */}
                                  {!sol.cotizado && !sol.rechazado && (
                                    <div className="flex flex-wrap gap-2">
                                      {bloqueadoPorAprobacion ? (
                                        <div className="px-6 py-2.5 bg-gray-100 text-gray-400 rounded-lg font-semibold flex items-center space-x-2 text-sm cursor-not-allowed">
                                          <Lock size={16} />
                                          <span>Pendiente de aprobación para cotizar</span>
                                        </div>
                                      ) : !tieneCLABE ? (
                                        <button
                                          onClick={(e) => { e.stopPropagation(); setSeccion('bancario'); }}
                                          className="px-6 py-2.5 bg-orange-100 text-orange-700 rounded-lg hover:bg-orange-200 font-semibold flex items-center space-x-2 text-sm"
                                        >
                                          <AlertCircle size={16} />
                                          <span>Registra tu CLABE para cotizar</span>
                                        </button>
                                      ) : verificacion.puede ? (
                                        <button
                                          onClick={(e) => { e.stopPropagation(); abrirModalCotizacion(sol); }}
                                          className="px-6 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold flex items-center space-x-2 text-sm"
                                        >
                                          <Send size={16} />
                                          <span>Cotizar Flete</span>
                                        </button>
                                      ) : (
                                        <div className="px-6 py-2.5 bg-gray-200 text-gray-500 rounded-lg font-semibold flex items-center space-x-2 text-sm cursor-not-allowed">
                                          <Lock size={16} />
                                          <span>{verificacion.razon}</span>
                                        </div>
                                      )}
                                      {sol.aceptaCotizaciones && !sol.cotizado && !sol.perdida && !sol.rechazado && (
                                        <button
                                          onClick={(e) => { e.stopPropagation(); rechazarSolicitud(sol.id); }}
                                          className="px-6 py-2.5 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 font-semibold flex items-center space-x-2 text-sm"
                                        >
                                          <XCircle size={16} />
                                          <span>Rechazar</span>
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ========== MIS VIAJES ========== */}
        {seccion === 'viajes' && (
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Mis Viajes</h2>
            <p className="text-gray-500 text-sm mb-5">Gestiona tus viajes activos. Haz clic en una fila para ver los detalles.</p>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase w-8"></th>
                    <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">ID / Cliente</th>
                    <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ruta</th>
                    <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Chofer / Unidad</th>
                    <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Progreso</th>
                    <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ganancia</th>
                    <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Estado</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {misViajes.map(viaje => {
                    const isExpanded = expandedViaje === viaje.id;
                    const progreso = viaje.progreso ?? 0;
                    const PROGRESO_ORDEN_V = { en_camino_recogida: 10, cargando: 25, en_ruta: 50, llegada_destino: 75, descargando: 90, completada: 100 };
                    const isCompletedV = (s) => {
                      if (['confirmado','entrega_confirmada'].includes(viaje.status) || progreso >= 100) return true;
                      return progreso >= (PROGRESO_ORDEN_V[s] ?? 101);
                    };
                    const etapasViaje = [
                      { label: 'Pago realizado',   completado: true },
                      { label: 'Chofer en camino', completado: isCompletedV('en_camino_recogida') },
                      { label: 'Recogiendo carga', completado: isCompletedV('cargando') },
                      { label: 'En ruta',          completado: isCompletedV('en_ruta') },
                      { label: 'En destino',       completado: isCompletedV('llegada_destino') },
                      { label: 'Entregado',        completado: isCompletedV('completada') || viaje.status === 'entrega_confirmada' },
                    ];
                    const lastIdxV = etapasViaje.reduce((acc, e, i) => e.completado ? i : acc, 0);
                    const barWidthV = Math.round((lastIdxV / (etapasViaje.length - 1)) * 100);
                    const ordenActiva = (viaje.ordenesChofer || [])[0];
                    const ordenCompletada = ordenActiva?.status === 'completada';
                    const ciudadDestino = (viaje.destino || '').split(',')[0].trim();
                    const tieneRetornoActivo = ciudadDestino.length > 2 && (store.retornosVacios || []).some(r =>
                      ['disponible', 'en_negociacion', 'confirmado'].includes(r.status) &&
                      (r.origen || r.origenActual || '').includes(ciudadDestino)
                    );
                    const choferNombre = viaje.choferNombre || ordenActiva?.choferNombre || getChoferById(viaje.choferAsignado)?.nombre;
                    const unreadCliente = (unreadByChatKey[`${viaje.id}_cliente`] || 0) + (unreadByChatKey[`${viaje.id}_admin`] || 0);
                    const unreadChofer = unreadByChatKey[`${viaje.id}_chofer`] || 0;
                    const unidadObj = getUnidadById(viaje.unidadAsignada || ordenActiva?.unidadId);
                    const unidadLabel = unidadObj
                      ? [unidadObj.marca, unidadObj.modelo, unidadObj.anio].filter(Boolean).join(' ') || unidadObj.placas
                      : (ordenActiva?.unidadLabel || viaje.cotizacion?.unidadOfrecida || null);
                    const calificaciones = store.calificaciones || [];
                    const yaCalifique = calificaciones.find(c => c.viajeId === viaje.id && c.autorRol === 'transportista');
                    const ratingRecibido = calificaciones.find(c => c.viajeId === viaje.id && c.autorRol === 'cliente');
                    const necesitaAccion = viaje.status === 'activo' || viaje.status === 'entrega_confirmada';

                    return (
                      <React.Fragment key={viaje.id}>
                        {/* Fila compacta */}
                        <tr
                          id={`viaje-t-${viaje.id}`}
                          onClick={() => setExpandedViaje(isExpanded ? null : viaje.id)}
                          className={`cursor-pointer transition-colors ${isExpanded ? 'bg-green-50' : 'hover:bg-gray-50'}`}
                        >
                          <td className="px-4 py-4 text-center">
                            <ChevronDown size={16} className={`text-gray-400 transition-transform mx-auto ${isExpanded ? 'rotate-180' : ''}`} />
                          </td>
                          <td className="hidden md:table-cell px-6 py-4">
                            <p className="font-mono font-bold text-gray-800 text-sm">{viaje.folio || viaje.id.slice(0, 8).toUpperCase()}</p>
                            <p className="text-xs text-gray-500">{viaje.cliente}</p>
                            {necesitaAccion && <span className="inline-block w-2 h-2 rounded-full bg-amber-400 mt-0.5" />}
                          </td>
                          <td className="px-4 md:px-6 py-4">
                            <p className="text-sm font-medium text-gray-800">{viaje.origen}</p>
                            <p className="text-xs text-gray-400">→ {viaje.destino}</p>
                            {/* Info condensada solo en móvil */}
                            <div className="md:hidden mt-0.5">
                              {choferNombre
                                ? <p className="text-xs text-gray-500">{choferNombre}</p>
                                : <span className="text-xs text-orange-500 font-semibold">Sin asignar</span>
                              }
                            </div>
                          </td>
                          <td className="hidden md:table-cell px-6 py-4">
                            {choferNombre ? (
                              <>
                                <p className="text-sm font-medium text-gray-700">{choferNombre}</p>
                                <p className="text-xs text-gray-400 font-mono">{unidadLabel || '—'}</p>
                              </>
                            ) : (
                              <span className="text-xs text-orange-500 font-semibold">Sin asignar</span>
                            )}
                          </td>
                          <td className="px-4 md:px-6 py-4">
                            <div className="flex items-center gap-2">
                              <div className="w-16 md:w-20 bg-gray-200 rounded-full h-1.5">
                                <div className="bg-green-500 h-1.5 rounded-full transition-all" style={{ width: `${progreso}%` }} />
                              </div>
                              <span className="text-xs font-semibold text-green-600">{progreso}%</span>
                            </div>
                          </td>
                          <td className="hidden md:table-cell px-6 py-4 text-sm">
                            <span className="font-bold text-green-600">${_gananciaViaje(viaje).toLocaleString()}</span>
                            {viaje.flujoPago === 'dos_pagos' && (
                              <span className="block text-xs text-amber-600 font-semibold mt-0.5">
                                {viaje.contraEntregaStatus === 'pagado' ? '✅ Anticipo + contra entrega' : '💳 50% anticipo · 50% contra entrega'}
                              </span>
                            )}
                          </td>
                          <td className="px-4 md:px-6 py-4">
                            <span className={`px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(viaje.status)}`}>
                              {getStatusText(viaje.status)}
                            </span>
                          </td>
                        </tr>

                        {/* Panel expandible */}
                        {isExpanded && (
                          <tr>
                            <td colSpan={7} className="bg-green-50">
                              <div className="px-4 py-4 md:px-8 md:py-6">
                                {/* Chofer + Unidad */}
                                {(choferNombre || unidadLabel) && (
                                  <div className="grid grid-cols-2 gap-4 mb-5">
                                    <div className="bg-white rounded-lg p-4 border border-green-100">
                                      <p className="text-xs text-gray-500 mb-1">Chofer asignado</p>
                                      <p className="font-semibold text-gray-800">{choferNombre || '—'}</p>
                                    </div>
                                    <div className="bg-white rounded-lg p-4 border border-green-100">
                                      <p className="text-xs text-gray-500 mb-1">Unidad</p>
                                      <p className="font-semibold text-gray-800">{unidadLabel || '—'}</p>
                                      {unidadObj && <p className="text-xs text-gray-400 font-mono mt-0.5">{unidadObj.placas}</p>}
                                    </div>
                                  </div>
                                )}

                                {/* Fecha de recogida solicitada */}
                                {viaje.solicitud?.fechaRecogida && (
                                  <div className="bg-orange-50 border border-orange-200 rounded-lg px-4 py-3 mb-5 flex items-center gap-2">
                                    <span className="text-orange-500 text-sm">📅</span>
                                    <div>
                                      <p className="text-xs text-orange-600 font-semibold uppercase tracking-wide">Recogida solicitada para</p>
                                      <p className="text-sm font-bold text-orange-800">
                                        {(() => {
                                          try {
                                            const fechaParte = viaje.solicitud.fechaRecogida.split('T')[0];
                                            const horaParte = viaje.solicitud.fechaRecogida.includes('T') ? viaje.solicitud.fechaRecogida.split('T')[1]?.slice(0,5) : null;
                                            const fechaFmt = new Date(fechaParte + 'T12:00:00').toLocaleDateString('es-MX', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
                                            if (!horaParte || horaParte === '00:00') return fechaFmt;
                                            const fmtH = (h) => new Date(`1970-01-01T${h}`).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: true });
                                            const horaFin = viaje.solicitud.horaFinCarga ? ` – ${fmtH(viaje.solicitud.horaFinCarga)}` : '';
                                            return `${fechaFmt} · ${fmtH(horaParte)}${horaFin}`;
                                          } catch { return viaje.solicitud.fechaRecogida; }
                                        })()}
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {/* Barra de progreso + Checkpoints */}
                                <div className="mb-5">
                                  <div className="flex justify-between text-xs text-gray-500 mb-1">
                                    <span className="font-medium">Progreso del chofer</span>
                                    <span className="font-bold text-green-600">{progreso}%</span>
                                  </div>
                                  <div className="w-full bg-gray-200 rounded-full h-2 mb-3">
                                    <div className="bg-green-500 h-2 rounded-full transition-all" style={{ width: `${barWidthV}%` }} />
                                  </div>
                                  <div className="flex items-start justify-between">
                                    {etapasViaje.map((etapa, idx) => (
                                      <div key={idx} className="flex flex-col items-center flex-1">
                                        <div className={`w-7 h-7 rounded-full flex items-center justify-center mb-1 ${etapa.completado ? 'bg-green-600' : 'bg-gray-200'}`}>
                                          {etapa.completado
                                            ? <CheckCircle size={14} className="text-white" />
                                            : <span className="text-gray-400 text-xs">{idx + 1}</span>}
                                        </div>
                                        <p className={`text-center leading-tight ${etapa.completado ? 'text-green-700 font-semibold' : 'text-gray-400'}`} style={{ fontSize: '10px' }}>
                                          {etapa.label}
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                </div>

                                {/* Calificar cliente */}
                                {viaje.status === 'confirmado' && (
                                  <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                    <div>
                                      <p className="text-sm font-semibold text-yellow-800">Entrega confirmada por el cliente</p>
                                      {ratingRecibido ? (
                                        <div className="flex items-center space-x-1 mt-1">
                                          <span className="text-xs text-gray-500">Cliente te calificó:</span>
                                          {[1,2,3,4,5].map(i => (
                                            <Star key={i} size={13} className={i <= ratingRecibido.estrellas ? 'text-yellow-400' : 'text-gray-300'} fill={i <= ratingRecibido.estrellas ? 'currentColor' : 'none'} />
                                          ))}
                                        </div>
                                      ) : (
                                        <p className="text-xs text-yellow-600 mt-0.5">El cliente aún no te ha calificado</p>
                                      )}
                                    </div>
                                    {!yaCalifique ? (
                                      <button
                                        onClick={(e) => { e.stopPropagation(); setMostrarCalificarCliente({ id: viaje.id, cliente: viaje.cliente || viaje.clienteId, clienteId: viaje.clienteId }); }}
                                        className="w-full sm:w-auto px-4 py-2.5 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 font-semibold text-sm flex items-center justify-center space-x-1"
                                      >
                                        <Star size={14} />
                                        <span>Calificar Cliente</span>
                                      </button>
                                    ) : (
                                      <div className="flex items-center space-x-1">
                                        {[1,2,3,4,5].map(i => (
                                          <Star key={i} size={15} className={i <= yaCalifique.estrellas ? 'text-yellow-400' : 'text-gray-300'} fill={i <= yaCalifique.estrellas ? 'currentColor' : 'none'} />
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                )}

                                {/* Posición del chofer en tiempo real */}
                                {(() => {
                                  const orden = (viaje.ordenesChofer || [])[0];
                                  if (!orden) return null;
                                  const choferPlantilla = (store.plantillaChoferes || []).find(c =>
                                    c.email === orden.choferEmail || c.nombre === orden.choferNombre
                                  );
                                  if (!choferPlantilla?.lat || !choferPlantilla?.lng) return null;
                                  const mapsUrl = `https://www.google.com/maps?q=${choferPlantilla.lat},${choferPlantilla.lng}`;
                                  return (
                                    <div className="mb-4 bg-green-50 border border-green-200 rounded-xl p-3 flex items-center justify-between">
                                      <div className="flex items-center gap-2">
                                        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                                        <span className="text-sm font-semibold text-green-800">
                                          {orden.choferNombre || 'Chofer'} — GPS activo
                                        </span>
                                      </div>
                                      <a href={mapsUrl} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-xs text-green-700 hover:text-green-900 font-semibold border border-green-300 rounded-lg px-2 py-1">
                                        <Navigation size={12} /> Ver en mapa
                                      </a>
                                    </div>
                                  );
                                })()}

                                {/* Contacto en destino */}
                                {viaje.contactoDestino && (
                                  <div className="mb-4 bg-blue-50 border border-blue-200 rounded-xl p-3 flex items-center gap-3">
                                    <Phone size={16} className="text-blue-500 flex-shrink-0" />
                                    <div>
                                      <p className="text-xs text-blue-600 font-semibold uppercase tracking-wide mb-0.5">Contacto en destino</p>
                                      <p className="text-sm font-bold text-blue-900">{viaje.contactoDestino}</p>
                                      {viaje.telefonoDestino && <p className="text-sm text-blue-700">{viaje.telefonoDestino}</p>}
                                    </div>
                                  </div>
                                )}

                                {/* Carta Porte del cliente */}
                                {viaje.cartaPorte ? (
                                  <div className="mb-5 bg-indigo-50 border border-indigo-200 rounded-xl p-4">
                                    <div className="flex items-center justify-between mb-3">
                                      <p className="text-sm font-bold text-indigo-800 flex items-center gap-2">
                                        <FileText size={16} /> Datos de Carta Porte
                                      </p>
                                      <button onClick={(e) => { e.stopPropagation(); descargarCartaPortePDF(viaje); }} className="flex items-center gap-1.5 text-xs font-semibold text-indigo-600 hover:text-indigo-800 border border-indigo-300 hover:border-indigo-500 bg-white rounded-lg px-3 py-1.5 transition">
                                        <Download size={13} /> Descargar PDF
                                      </button>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs">
                                      {/* Mercancías */}
                                      <div className="bg-white rounded-lg p-3 border border-indigo-100">
                                        <p className="font-bold text-indigo-700 mb-2 uppercase tracking-wide">Mercancías</p>
                                        {(Array.isArray(viaje.cartaPorte.mercancias) ? viaje.cartaPorte.mercancias : [viaje.cartaPorte.mercancias]).map((m, idx) => (
                                          <div key={idx} className={`space-y-1 text-gray-700 ${idx > 0 ? 'mt-3 pt-3 border-t border-indigo-100' : ''}`}>
                                            {Array.isArray(viaje.cartaPorte.mercancias) && viaje.cartaPorte.mercancias.length > 1 && <p className="text-xs font-bold text-indigo-500">Producto {idx + 1}</p>}
                                            <p><span className="text-gray-400">Descripción:</span> {m?.descripcion || '—'}</p>
                                            <p><span className="text-gray-400">Clave SAT:</span> {m?.claveSAT || '—'}</p>
                                            <p><span className="text-gray-400">Cantidad:</span> {m?.cantidad || '—'} {m?.unidadMedida || ''}</p>
                                            <p><span className="text-gray-400">Peso bruto:</span> {m?.pesoKg || '—'} kg</p>
                                            <p><span className="text-gray-400">Embalaje:</span> {m?.tipoEmbalaje || '—'}</p>
                                            <p><span className="text-gray-400">Valor declarado:</span> ${Number(m?.valorDeclarado || 0).toLocaleString('es-MX')} MXN</p>
                                          </div>
                                        ))}
                                      </div>
                                      {/* Remitente */}
                                      <div className="bg-white rounded-lg p-3 border border-indigo-100">
                                        <p className="font-bold text-indigo-700 mb-2 uppercase tracking-wide">Remitente</p>
                                        <div className="space-y-1 text-gray-700">
                                          <p className="font-semibold">{viaje.cartaPorte.remitente?.nombre || '—'}</p>
                                          <p><span className="text-gray-400">RFC:</span> {viaje.cartaPorte.remitente?.rfc || '—'}</p>
                                          <p>{[viaje.cartaPorte.remitente?.calle, viaje.cartaPorte.remitente?.numero].filter(Boolean).join(' ')}</p>
                                          <p>{[viaje.cartaPorte.remitente?.colonia, viaje.cartaPorte.remitente?.municipio].filter(Boolean).join(', ')}</p>
                                          <p>{[viaje.cartaPorte.remitente?.estado, viaje.cartaPorte.remitente?.cp].filter(Boolean).join(' C.P. ')}</p>
                                        </div>
                                      </div>
                                      {/* Destinatario */}
                                      <div className="bg-white rounded-lg p-3 border border-indigo-100">
                                        <p className="font-bold text-indigo-700 mb-2 uppercase tracking-wide">Destinatario</p>
                                        <div className="space-y-1 text-gray-700">
                                          <p className="font-semibold">{viaje.cartaPorte.destinatario?.nombre || '—'}</p>
                                          <p><span className="text-gray-400">RFC:</span> {viaje.cartaPorte.destinatario?.rfc || '—'}</p>
                                          <p>{[viaje.cartaPorte.destinatario?.calle, viaje.cartaPorte.destinatario?.numero].filter(Boolean).join(' ')}</p>
                                          <p>{[viaje.cartaPorte.destinatario?.colonia, viaje.cartaPorte.destinatario?.municipio].filter(Boolean).join(', ')}</p>
                                          <p>{[viaje.cartaPorte.destinatario?.estado, viaje.cartaPorte.destinatario?.cp].filter(Boolean).join(' C.P. ')}</p>
                                        </div>
                                      </div>
                                    </div>
                                    {/* Vehículo y Operador */}
                                    {(viaje.cartaPorte.vehiculo || viaje.cartaPorte.operador) && (
                                      <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3 text-xs">
                                        {viaje.cartaPorte.operador?.nombre && (
                                          <div className="bg-white rounded-lg p-3 border border-indigo-100">
                                            <p className="font-bold text-indigo-700 mb-2 uppercase tracking-wide">Operador</p>
                                            <div className="space-y-1 text-gray-700">
                                              <p className="font-semibold">{viaje.cartaPorte.operador.nombre}</p>
                                              {viaje.cartaPorte.operador.licencia && <p><span className="text-gray-400">Licencia:</span> {viaje.cartaPorte.operador.licencia}</p>}
                                              {viaje.cartaPorte.operador.curp && <p><span className="text-gray-400">CURP:</span> {viaje.cartaPorte.operador.curp}</p>}
                                            </div>
                                          </div>
                                        )}
                                        {viaje.cartaPorte.vehiculo?.placas && (
                                          <div className="bg-white rounded-lg p-3 border border-indigo-100">
                                            <p className="font-bold text-indigo-700 mb-2 uppercase tracking-wide">Vehículo</p>
                                            <div className="space-y-1 text-gray-700">
                                              {viaje.cartaPorte.vehiculo.descripcion && <p className="font-semibold">{viaje.cartaPorte.vehiculo.descripcion}</p>}
                                              <p><span className="text-gray-400">Placas:</span> {viaje.cartaPorte.vehiculo.placas}</p>
                                              {viaje.cartaPorte.vehiculo.configuracion && <p><span className="text-gray-400">Config:</span> {viaje.cartaPorte.vehiculo.configuracion}</p>}
                                              {viaje.cartaPorte.vehiculo.numeroRemolque && <p><span className="text-gray-400">Remolque:</span> {viaje.cartaPorte.vehiculo.numeroRemolque}</p>}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div className="mb-5 bg-gray-50 border border-dashed border-gray-300 rounded-xl p-3 text-center text-xs text-gray-400">
                                    El cliente aún no ha registrado los datos de Carta Porte
                                  </div>
                                )}

                                {/* Banner: esperando pago del cliente */}
                                {viaje.status === 'pendiente_pago' && (
                                  <div className="mb-4 flex items-center gap-2 bg-yellow-50 border border-yellow-200 rounded-xl px-4 py-3 text-sm text-yellow-800">
                                    <span className="text-lg">⏳</span>
                                    <span>
                                      {viaje.flujoPago === 'dos_pagos'
                                        ? 'Esperando que el cliente pague el anticipo (50%). Podrás asignar chofer una vez procesado.'
                                        : 'Esperando que el cliente confirme el pago. Podrás asignar chofer una vez que el pago se procese.'}
                                    </span>
                                  </div>
                                )}

                                {/* Desglose financiero dos_pagos */}
                                {viaje.flujoPago === 'dos_pagos' && (() => {
                                  const ganancia = _gananciaViaje(viaje);
                                  const mitad = Math.round(ganancia / 2);
                                  return (
                                    <div className="mb-4 bg-amber-50 border border-amber-200 rounded-xl p-4">
                                      <p className="text-xs font-bold text-amber-800 uppercase mb-2">💳 Estructura de pago</p>
                                      <div className="space-y-1.5">
                                        <div className="flex justify-between text-sm">
                                          <span className="text-gray-600">Anticipo al iniciar</span>
                                          <span className="font-bold text-green-700">
                                            ${mitad.toLocaleString()} MXN
                                            {['activo','en_curso','completada','confirmado'].includes(viaje.status) && <span className="ml-1 text-xs">✅</span>}
                                          </span>
                                        </div>
                                        <div className="flex justify-between text-sm">
                                          <span className="text-gray-600">Contra entrega</span>
                                          <span className={`font-bold ${viaje.contraEntregaStatus === 'pagado' ? 'text-green-700' : 'text-amber-600'}`}>
                                            ${mitad.toLocaleString()} MXN
                                            <span className="ml-1 text-xs">
                                              {viaje.contraEntregaStatus === 'pagado' ? '✅' : viaje.contraEntregaStatus === 'pendiente' ? '⏳' : ''}
                                            </span>
                                          </span>
                                        </div>
                                        <div className="flex justify-between text-sm border-t border-amber-200 pt-1.5 mt-1.5">
                                          <span className="font-semibold text-gray-700">Total a recibir</span>
                                          <span className="font-black text-gray-800">${ganancia.toLocaleString()} MXN</span>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })()}

                                {/* Botones de acción */}
                                <div className="flex flex-wrap gap-3">
                                  {viaje.status === 'activo' && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        // Buscar la cotización ganadora para obtener la unidad propuesta
                                        const cotizGanadora = (store.cotizaciones || []).find(c =>
                                          c.solicitudId === viaje.solicitudId &&
                                          (c.transportistaId === usuario?.id || c.empresaId === empresaId)
                                        );
                                        const unidadCotizId = cotizGanadora?.unidadId ? String(cotizGanadora.unidadId) : null;
                                        // Auto-seleccionar el primer chofer disponible con su unidad
                                        const primerChofer = todosChoferes.find(c => c.status === 'disponible') || todosChoferes[0];
                                        const unidadAuto = unidadCotizId
                                          || (primerChofer?.unidadAsignada ? String(primerChofer.unidadAsignada) : '');
                                        setFormAsignacion({
                                          choferId: primerChofer ? String(primerChofer.id) : '',
                                          unidadId: unidadAuto,
                                          contactoCliente: viaje.contactoDestino || '',
                                          telefonoCliente: viaje.telefonoDestino || ''
                                        });
                                        setMostrarAsignarViaje(viaje);
                                      }}
                                      className="px-5 py-2.5 bg-orange-600 text-white rounded-lg hover:bg-orange-700 font-semibold text-sm flex items-center space-x-2"
                                    >
                                      <Users size={16} />
                                      <span>Asignar Chofer y Unidad</span>
                                    </button>
                                  )}
                                  {/* Publicar retorno vacío — disponible desde que el viaje inicia, oculto si ya hay uno activo */}
                                  {['en_curso', 'en_proceso', 'en_ruta', 'cargando', 'en_camino_recogida', 'llegada_destino', 'descargando'].includes(viaje.status) && !tieneRetornoActivo && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        // Buscar la unidad en la flota por ID, placas o unidadId de la orden
                                        const ordenReciente = viaje.ordenesChofer?.[0];
                                        const unidadFlota = (store.flota || []).find(u =>
                                          u.id === ordenReciente?.unidadId ||
                                          u.placas === viaje.unidad ||
                                          u.id === viaje.unidadAsignada
                                        );
                                        setFormRetorno(f => ({
                                          ...f,
                                          origenActual: viaje.destino || viaje.solicitud?.destino || '',
                                          destino: viaje.origen || viaje.solicitud?.origen || _ciudadEmpresa || f.destino,
                                          tipoUnidad: unidadFlota?.tipo || viaje.tipoUnidad || f.tipoUnidad,
                                          capacidadDisponible: unidadFlota?.capacidad || f.capacidadDisponible,
                                        }));
                                        setSeccion('retornos');
                                        setMostrarFormRetorno(true);
                                      }}
                                      className="px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium text-sm flex items-center space-x-2"
                                    >
                                      <RotateCcw size={16} />
                                      <span>Publicar retorno vacío</span>
                                    </button>
                                  )}
                                  {viaje.clienteId && viaje.status !== 'cancelado' && viaje.status !== 'pendiente_pago' && (() => {
                                    const clienteInfo = (store.usuarios || []).find(u => u.id === viaje.clienteId);
                                    const clienteNombreChat = clienteInfo?.nombre || viaje.cliente || 'Cliente';
                                    return (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        const _cm = { viajeId: viaje.id, contraparte: { id: viaje.clienteId, nombre: clienteNombreChat, rol: 'cliente' } };
                                        chatModalRef.current = _cm; setChatModal(_cm);
                                        setUnreadByChatKey(prev => { const n = {...prev}; delete n[`${viaje.id}_cliente`]; delete n[`${viaje.id}_admin`]; return n; });
                                        setLastSeenMessages(prev => { const next = {...prev, [`${viaje.id}_cliente`]: new Date().toISOString()}; sessionStorage.setItem(_chatSeenKey, JSON.stringify(next)); return next; });
                                      }}
                                      className="flex items-center space-x-2 px-4 py-2.5 rounded-lg border border-purple-300 text-purple-700 hover:bg-purple-50 font-medium text-sm"
                                    >
                                      <MessageCircle size={16} />
                                      <span>Chat con {clienteNombreChat}</span>
                                      {unreadCliente > 0 && <span className="ml-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">{unreadCliente > 9 ? '9+' : unreadCliente}</span>}
                                    </button>
                                    );
                                  })()}
                                  {choferNombre && viaje.status !== 'cancelado' && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        const _cm2 = { viajeId: viaje.id, contraparte: { id: viaje.choferAsignado || viaje.choferId, nombre: choferNombre, rol: 'chofer' } };
                                        chatModalRef.current = _cm2; setChatModal(_cm2);
                                        setUnreadByChatKey(prev => { const n = {...prev}; delete n[`${viaje.id}_chofer`]; return n; });
                                        setLastSeenMessages(prev => { const next = {...prev, [`${viaje.id}_chofer`]: new Date().toISOString()}; sessionStorage.setItem(_chatSeenKey, JSON.stringify(next)); return next; });
                                      }}
                                      className="flex items-center space-x-2 px-4 py-2.5 rounded-lg border border-green-300 text-green-700 hover:bg-green-50 font-medium text-sm"
                                    >
                                      <MessageCircle size={16} />
                                      <span>Chat con {choferNombre}</span>
                                      {unreadChofer > 0 && <span className="ml-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">{unreadChofer > 9 ? '9+' : unreadChofer}</span>}
                                    </button>
                                  )}
                                  {choferNombre && !['confirmado', 'cancelado', 'completado'].includes(viaje.status) && !ordenCompletada && (
                                    <button
                                      onClick={(e) => { e.stopPropagation(); setModalReasignar({ viajeId: viaje.id, choferActualNombre: choferNombre }); setReasignarChoferId(''); }}
                                      className="flex items-center space-x-2 px-4 py-2.5 rounded-lg border border-orange-300 text-orange-700 hover:bg-orange-50 font-medium text-sm"
                                    >
                                      <span>🔄</span>
                                      <span>Reasignar chofer</span>
                                    </button>
                                  )}
                                  {choferNombre && !ordenCompletada && (
                                    <button
                                      onClick={(e) => { e.stopPropagation(); setVerMapaViajeId(verMapaViajeId === viaje.id ? null : viaje.id); }}
                                      className={`flex items-center space-x-2 px-4 py-2.5 rounded-lg border font-medium text-sm transition-colors ${verMapaViajeId === viaje.id ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-300 hover:bg-blue-50'}`}
                                    >
                                      <Navigation size={16} />
                                      <span>{verMapaViajeId === viaje.id ? 'Ocultar GPS' : 'Ver GPS del chofer'}</span>
                                    </button>
                                  )}
                                  {choferNombre && !ordenCompletada && (() => {
                                    const org = viaje.origenCoords ? `${viaje.origenCoords.lat},${viaje.origenCoords.lng}` : encodeURIComponent(viaje.origen);
                                    const dst = viaje.destinoCoords ? `${viaje.destinoCoords.lat},${viaje.destinoCoords.lng}` : encodeURIComponent(viaje.destino);
                                    return (
                                      <a
                                        href={`https://maps.google.com/maps?saddr=${org}&daddr=${dst}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()}
                                        className="flex items-center space-x-2 px-4 py-2.5 rounded-lg border border-green-300 text-green-700 hover:bg-green-50 font-medium text-sm"
                                      >
                                        <MapPin size={16} />
                                        <span>Abrir en Maps</span>
                                      </a>
                                    );
                                  })()}
                                  {/* ── Contra entrega ── */}
                                  {viaje.contraEntregaStatus === 'pendiente' && (() => {
                                    const vence = viaje.contraEntregaVence ? new Date(viaje.contraEntregaVence) : null;
                                    const vencio = vence && vence < new Date();
                                    return (
                                      <div className="flex items-center gap-2 flex-wrap">
                                        <span className="text-xs px-2 py-1 bg-amber-100 text-amber-700 rounded-full font-semibold">
                                          ⏳ Contra entrega pendiente {vence ? `— vence ${vence.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}` : ''}
                                        </span>
                                        {vencio && (
                                          <button
                                            onClick={async (e) => {
                                              e.stopPropagation();
                                              try {
                                                await apiReclamarContraEntrega(viaje.id);
                                                mostrarNotificacion('Reclamación enviada al administrador', 'success');
                                                recargar();
                                              } catch (err) {
                                                mostrarNotificacion(err.message || 'Error al reclamar', 'error');
                                              }
                                            }}
                                            className="text-xs px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-lg font-semibold transition"
                                          >
                                            Abrir reclamación
                                          </button>
                                        )}
                                      </div>
                                    );
                                  })()}
                                  {viaje.contraEntregaStatus === 'reclamado' && (
                                    <span className="text-xs px-2 py-1 bg-red-100 text-red-700 rounded-full font-semibold">⚠️ Reclamación en revisión</span>
                                  )}
                                  {viaje.contraEntregaStatus === 'pagado' && (
                                    <span className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded-full font-semibold">✅ Contra entrega pagada</span>
                                  )}

                                  {/* Cancelar viaje — solo si aún no está en estado terminal */}
                                  {['pendiente_pago', 'activo'].includes(viaje.status) && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setCancelarMotivo('');
                                        setCancelarViajeModal({ id: viaje.id, origen: viaje.origen, destino: viaje.destino });
                                      }}
                                      className="flex items-center space-x-2 px-4 py-2.5 rounded-lg border border-red-300 text-red-600 hover:bg-red-50 font-medium text-sm"
                                    >
                                      <XCircle size={16} />
                                      <span>Cancelar viaje</span>
                                    </button>
                                  )}
                                </div>

                                {/* Mapa GPS */}
                                {choferNombre && verMapaViajeId === viaje.id && (() => {
                                  // Usar ordenesChofer anidado en el viaje (tiene ultimaLat/Lng del backend)
                                  // store.ordenesChofer está vacío para transportistas — los datos vienen de viaje.ordenesChofer
                                  const ordenViaje = (viaje.ordenesChofer || [])[0] || store.ordenesChofer.find(o => o.viajeId === viaje.id);
                                  const gpsVivo = choferGpsLive[viaje.id] || (ordenViaje ? choferGpsLive[ordenViaje.id] : null) || null;
                                  const ultimaPos = ordenViaje?.ultimaLat && ordenViaje?.ultimaLng
                                    ? { lat: ordenViaje.ultimaLat, lng: ordenViaje.ultimaLng, en: ordenViaje.ultimaPosicionEn }
                                    : null;
                                  const choferCoords = gpsVivo || ultimaPos || null;
                                  const tieneCoords = viaje.origenCoords || viaje.destinoCoords || choferCoords;
                                  const tiempoRelativo = (fecha) => {
                                    if (!fecha) return '';
                                    const mins = Math.floor((Date.now() - new Date(fecha)) / 60000);
                                    if (mins < 1) return 'hace un momento';
                                    if (mins < 60) return `hace ${mins} min`;
                                    const hrs = Math.floor(mins / 60);
                                    return hrs < 24 ? `hace ${hrs}h` : `hace ${Math.floor(hrs/24)}d`;
                                  };
                                  if (!tieneCoords) return (
                                    <div className="mt-4 rounded-xl border border-blue-200 bg-blue-50 p-4 text-sm text-blue-700">
                                      <p className="font-semibold mb-1">📡 Esperando señal GPS del chofer...</p>
                                      <p className="text-xs text-blue-500">El chofer debe iniciar la orden desde su app para activar el GPS.</p>
                                    </div>
                                  );
                                  return (
                                    <div className="rounded-xl overflow-hidden border border-gray-200 mt-4">
                                      <ViajeMapView
                                        origenCoords={viaje.origenCoords}
                                        destinoCoords={viaje.destinoCoords}
                                        progreso={viaje.progreso || 0}
                                        choferCoords={choferCoords}
                                      />
                                      <div className="bg-gray-50 px-4 py-2 flex gap-6 text-xs text-gray-600">
                                        {viaje.origenCoords && <span><span className="font-semibold text-green-700">📦</span> {viaje.origenCoords.direccion || viaje.origen}</span>}
                                        {viaje.destinoCoords && <span><span className="font-semibold text-red-600">🏁</span> {viaje.destinoCoords.direccion || viaje.destino}</span>}
                                      </div>
                                      <div className={`px-4 py-2 text-xs ${gpsVivo ? 'bg-blue-50 text-blue-600' : ultimaPos ? 'bg-amber-50 text-amber-700' : 'bg-gray-50 text-gray-500'}`}>
                                        {gpsVivo
                                          ? '📡 Posición GPS en tiempo real del chofer'
                                          : ultimaPos
                                            ? `🕐 Última posición conocida · ${tiempoRelativo(ultimaPos.en)}`
                                            : `🚛 Posición estimada según progreso (${progreso}%)`}
                                      </div>
                                    </div>
                                  );
                                })()}
                                {/* Incidencias reportadas por el chofer */}
                                {(() => {
                                  const ordenViaje = (viaje.ordenesChofer || [])[0] || store.ordenesChofer.find(o => o.viajeId === viaje.id);
                                  const incidencias = ordenViaje?.incidencias || [];
                                  if (incidencias.length === 0) return null;
                                  const tiposLabel = {
                                    mecanica: 'Falla mecánica', accidente: 'Accidente vial', clima: 'Condiciones climáticas',
                                    carga: 'Problema con la carga', direccion: 'Dirección incorrecta',
                                    cliente: 'Cliente no disponible', otro: 'Otro',
                                  };
                                  return (
                                    <div className="mt-4 rounded-xl border border-red-200 bg-red-50 p-4">
                                      <p className="text-sm font-bold text-red-700 mb-3 flex items-center gap-2">
                                        <AlertCircle size={16} /> Incidencias reportadas ({incidencias.length})
                                      </p>
                                      <div className="space-y-3">
                                        {incidencias.map(inc => (
                                          <div key={inc.id} className="bg-white rounded-lg border border-red-100 p-3 flex gap-3">
                                            {inc.foto && (
                                              <img
                                                src={inc.foto} alt="Evidencia"
                                                className="w-16 h-16 object-cover rounded-lg flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity ring-2 ring-transparent hover:ring-red-400"
                                                onClick={() => setFotoLightbox(inc.foto)}
                                                title="Ver foto en grande"
                                              />
                                            )}
                                            <div className="flex-1 min-w-0">
                                              <div className="flex items-center gap-2 mb-1 flex-wrap">
                                                <span className="text-xs font-bold text-red-700 bg-red-100 px-2 py-0.5 rounded-full">
                                                  {tiposLabel[inc.tipo] || inc.tipo}
                                                </span>
                                                <span className="text-xs text-gray-400">
                                                  {new Date(inc.fecha).toLocaleString('es-MX', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                                                </span>
                                              </div>
                                              <p className="text-sm text-gray-700 mb-2">{inc.descripcion}</p>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  );
                                })()}
                                {/* Evidencias de entrega */}
                                {(() => {
                                  const viajeReal = store.viajes.find(v => v.id === viaje.id) || viaje;
                                  const evs = viajeReal.evidenciasEntrega || viaje.evidencias || [];
                                  const firma = viajeReal.firmaEntrega || viaje.firma || null;
                                  if (evs.length === 0 && !firma) return null;
                                  return (
                                    <div className="mt-4 rounded-xl border border-green-200 bg-green-50 p-4">
                                      <p className="text-sm font-bold text-green-700 mb-3 flex items-center gap-2">
                                        <Camera size={16} /> Evidencias de entrega ({evs.length})
                                      </p>
                                      <div className="flex gap-3 flex-wrap">
                                        {evs.map((ev, i) => (
                                          <div key={i} className="text-center">
                                            <img
                                              src={ev.url || ev.base64} alt={ev.nombre}
                                              className="w-20 h-20 object-cover rounded-xl cursor-pointer hover:opacity-80 transition-opacity ring-2 ring-transparent hover:ring-green-400"
                                              onClick={() => setFotoLightbox(ev.url || ev.base64)}
                                              title="Ver en grande"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">{ev.nombre}</p>
                                          </div>
                                        ))}
                                      </div>
                                      {firma && (
                                        <div className="mt-3 pt-3 border-t border-green-200">
                                          <p className="text-xs font-semibold text-green-700 mb-2">✍️ Firma de recepción</p>
                                          <img src={firma} alt="Firma del cliente" className="w-full max-w-xs h-24 object-contain bg-white rounded-lg border border-green-200 px-2 cursor-pointer hover:opacity-80 transition-opacity" onClick={() => setFotoLightbox(firma)} title="Ver en grande" />
                                        </div>
                                      )}
                                    </div>
                                  );
                                })()}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ========== FLETES DE RETORNO ========== */}
        {seccion === 'retornos' && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <div>
                <h2 className="text-3xl font-bold text-gray-800">Retornos Vacíos</h2>
                <p className="text-gray-500 text-sm mt-1">Publica tu camión de regreso y negocia precio con clientes en ruta</p>
              </div>
              <button onClick={() => setMostrarFormRetorno(true)} className="px-6 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 flex items-center space-x-2 font-semibold">
                <Plus size={20} /><span>Publicar Retorno</span>
              </button>
            </div>

            {fletesRetorno.length === 0 ? (
              <div className="bg-white rounded-xl shadow p-12 text-center text-gray-400">
                <RotateCcw size={48} className="mx-auto mb-4 opacity-30" />
                <p className="text-lg font-medium">Sin retornos publicados</p>
                <p className="text-sm mt-1">Publica tu primer retorno vacío para recibir ofertas de clientes en ruta</p>
              </div>
            ) : (
              <div className="space-y-2">
                {fletesRetorno.map(ret => {
                  const precioActual = precioActualRetorno(ret);
                  const tieneDescuento = precioActual < ret.precioBase;
                  const ofertasPendientes = ret.ofertas.filter(o => o.status === 'pendiente');
                  const clientesAceptados = ret.ofertas.filter(o => o.status === 'aceptada');
                  const statusColor = { disponible: 'bg-green-100 text-green-800', negociando: 'bg-yellow-100 text-yellow-800', en_negociacion: 'bg-yellow-100 text-yellow-800', aceptado: 'bg-blue-100 text-blue-800', confirmado: 'bg-blue-100 text-blue-800', completado: 'bg-purple-100 text-purple-800', cancelado: 'bg-gray-100 text-gray-500' };
                  const expira = new Date(ret.expiresAt || ret.fechaExpiracion);
                  const _fmtExpira = (d) => { void tickMinuto; const mins = isNaN(d.getTime()) ? null : Math.max(0, Math.round((d - Date.now()) / 60000)); if (mins === null) return null; if (mins >= 1440) return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short' }); if (mins >= 60) { const h = Math.floor(mins/60); const m = mins%60; return m > 0 ? `${h}h ${m}m` : `${h}h`; } return `${mins}m`; };
                  const minutosRestantes = isNaN(expira.getTime()) ? null : Math.max(0, Math.round((expira - Date.now()) / 60000));
                  const expandido = retornosExpandidos.has(ret.id);
                  const toggleExpandido = () => setRetornosExpandidos(prev => {
                    const s = new Set(prev);
                    s.has(ret.id) ? s.delete(ret.id) : s.add(ret.id);
                    return s;
                  });
                  return (
                    <div key={ret.id} id={`ret-t-${ret.id}`} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                      {/* Fila compacta — siempre visible */}
                      <button
                        onClick={toggleExpandido}
                        className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 transition-colors"
                      >
                        {/* Chevron */}
                        <span className={`text-gray-400 transition-transform flex-shrink-0 ${expandido ? 'rotate-90' : ''}`} style={{ display: 'inline-block' }}>▶</span>
                        {/* ID + status */}
                        <span className="font-mono text-xs font-bold text-gray-500 flex-shrink-0">{ret.id}</span>
                        <span className={`px-2 py-0.5 text-xs font-semibold rounded-full flex-shrink-0 ${ret.status === 'disponible' && clientesAceptados.length > 0 ? 'bg-teal-100 text-teal-800' : statusColor[ret.status] || 'bg-gray-100 text-gray-600'}`}>
                          {ret.status === 'disponible' && clientesAceptados.length > 0 ? `✅ ${clientesAceptados.length} cliente${clientesAceptados.length > 1 ? 's' : ''} confirmado${clientesAceptados.length > 1 ? 's' : ''}` : ret.status === 'disponible' ? 'Disponible' : ['negociando','en_negociacion'].includes(ret.status) ? 'En negociación' : ['aceptado','confirmado'].includes(ret.status) ? 'Confirmado' : ret.status === 'completado' ? 'Completado' : 'Cancelado'}
                        </span>
                        {/* Ruta */}
                        <span className="font-semibold text-gray-800 text-sm truncate flex-1 min-w-0">
                          {ret.origenActual} <span className="text-green-600">→</span> {ret.destino}
                        </span>
                        {/* Info compacta */}
                        <span className="text-xs text-gray-500 flex-shrink-0 hidden sm:inline">🚛 {ret.tipoUnidad || ret.tipoVehiculo} · ⚖️ {ret.capacidadDisponible || ret.capacidad}</span>
                        {_fmtExpira(expira) !== null && <span className="text-xs text-gray-400 flex-shrink-0">⏱ {_fmtExpira(expira)}</span>}
                        {/* Precio */}
                        <span className={`font-bold text-sm flex-shrink-0 ${tieneDescuento ? 'text-orange-600' : 'text-green-600'}`}>${precioActual.toLocaleString()}</span>
                        {/* Badge ofertas pendientes */}
                        {ofertasPendientes.length > 0 && (
                          <span className="px-1.5 py-0.5 text-xs font-bold rounded-full bg-red-500 text-white flex-shrink-0">{ofertasPendientes.length}</span>
                        )}
                      </button>

                      {/* Detalle expandido */}
                      {expandido && (
                        <div className="border-t">
                          {/* Info adicional */}
                          <div className="px-4 py-3 bg-gray-50 border-b text-sm text-gray-600 space-y-1">
                            {(ret.ciudadesEnRuta?.length || 0) > 0 && (
                              <p className="text-xs text-gray-500">Ciudades en ruta: {ret.ciudadesEnRuta.join(' · ')}</p>
                            )}
                            <div className="flex items-center gap-4 text-xs">
                              {tieneDescuento && <span className="line-through text-gray-400">${(ret.precioBase || 0).toLocaleString()}</span>}
                              {tieneDescuento && <span className="text-orange-500 font-medium">Precio con descuento progresivo</span>}
                              <span className="text-gray-400">Mín. oculto: ${(ret.precioMinimo || 0).toLocaleString()}</span>
                            </div>
                            {ret.descripcion && <p className="text-xs italic text-gray-500">"{ret.descripcion}"</p>}
                          </div>

                          {/* Ofertas */}
                          {ret.ofertas.length > 0 && (
                            <div className="p-4 bg-gray-50 space-y-3">
                              <h4 className="font-semibold text-gray-700 text-sm">Ofertas recibidas</h4>
                              {(() => {
                                // Mostrar solo la oferta más reciente por cliente (evita duplicados cuando re-negocian)
                                const porCliente = {};
                                ret.ofertas.forEach(o => {
                                  if (!porCliente[o.clienteId] || new Date(o.creadoEn) > new Date(porCliente[o.clienteId].creadoEn)) {
                                    porCliente[o.clienteId] = o;
                                  }
                                });
                                return Object.values(porCliente);
                              })().map(oferta => (
                                <div key={oferta.id} className="bg-white rounded-lg p-3 border">
                                  <div className="flex justify-between items-start mb-2">
                                    <div>
                                      <span className="font-semibold text-gray-800 text-sm">{oferta.clienteNombre}</span>
                                      <span className="ml-2 text-xs text-gray-500">({oferta.origen || oferta.ciudadCliente || '—'})</span>
                                    </div>
                                    <div className="text-right">
                                      {oferta.contrapropuesta ? (
                                        <div>
                                          <span className="text-sm line-through text-gray-400">${(oferta.precio || oferta.monto || 0).toLocaleString()}</span>
                                          <span className="ml-2 font-bold text-blue-600">${(oferta.contrapropuesta).toLocaleString()}</span>
                                          <span className="ml-1 text-xs text-blue-500">tu contraoferta</span>
                                        </div>
                                      ) : (
                                        <span className="font-bold text-gray-800">${(oferta.precio || oferta.monto || 0).toLocaleString()}</span>
                                      )}
                                    </div>
                                  </div>
                                  {/* Ubicación y carga del cliente */}
                                  <div className="mb-2 rounded-lg border border-gray-100 bg-gray-50 p-2 space-y-1 text-xs">
                                    <p className="font-semibold text-gray-600">📦 {oferta.origen || oferta.ciudadCliente || '—'} → {oferta.destino || oferta.destinoEntrega || '—'}</p>
                                    {(oferta.peso) && (
                                      <p className="text-gray-500">⚖️ {oferta.peso} ton{oferta.volumen ? ` · ${oferta.volumen} m³` : ''}</p>
                                    )}
                                    {(oferta.fotos?.length > 0) && (
                                      <div className="flex flex-wrap gap-1 mt-1">
                                        {oferta.fotos.map((f, i) => (
                                          <img key={i} src={f} alt={`foto ${i+1}`} className="w-16 h-16 object-cover rounded border cursor-pointer" onClick={() => window.open(f, '_blank')} />
                                        ))}
                                      </div>
                                    )}
                                    {(oferta.origenCoords || oferta.destinoCoords) ? (
                                      <div className="mt-1 pt-1 border-t border-gray-200 space-y-1">
                                        {oferta.origenCoords && (
                                          <p className="text-green-700 truncate">
                                            <span className="font-semibold">📍 Recoge:</span>{' '}
                                            {oferta.origenCoords.direccion || `${oferta.origenCoords.lat?.toFixed(4)}, ${oferta.origenCoords.lng?.toFixed(4)}`}
                                          </p>
                                        )}
                                        {oferta.destinoCoords && (
                                          <p className="text-red-700 truncate">
                                            <span className="font-semibold">🏁 Entrega:</span>{' '}
                                            {oferta.destinoCoords.direccion || `${oferta.destinoCoords.lat?.toFixed(4)}, ${oferta.destinoCoords.lng?.toFixed(4)}`}
                                          </p>
                                        )}
                                        {oferta.status === 'aceptada' && oferta.pagado && (
                                          <button
                                            onClick={() => setMapaGpsOferta({ origenCoords: oferta.origenCoords, destinoCoords: oferta.destinoCoords, clienteNombre: oferta.clienteNombre })}
                                            className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm px-4 py-2 rounded-lg shadow-sm transition-colors">
                                            <MapPin size={15} />
                                            <span>Ver en mapa</span>
                                          </button>
                                        )}
                                      </div>
                                    ) : (
                                      <p className="text-gray-400 italic">Sin coordenadas GPS</p>
                                    )}
                                  </div>
                                  {(oferta.descripcion || oferta.mensaje) && <p className="text-xs text-gray-600 mb-2 italic">"{oferta.descripcion || oferta.mensaje}"</p>}
                                  {/* Fecha de entrega y contacto */}
                                  {(oferta.fechaEntrega || oferta.contactoDestino) && (
                                    <div className="mb-2 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 space-y-1 text-xs">
                                      {oferta.fechaEntrega && (
                                        <p className="text-amber-800">
                                          <span className="font-semibold">📅 Entrega deseada:</span>{' '}
                                          {new Date(oferta.fechaEntrega).toLocaleString('es-MX', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' })}
                                        </p>
                                      )}
                                      {oferta.contactoDestino && (
                                        <p className="text-amber-800">
                                          <span className="font-semibold">👤 Contacto en destino:</span>{' '}
                                          {oferta.contactoDestino}{oferta.telefonoDestino ? ` · ${oferta.telefonoDestino}` : ''}
                                        </p>
                                      )}
                                    </div>
                                  )}
                                  <div className="flex items-center gap-2 flex-wrap">
                                    <span className={`px-2 py-0.5 text-xs font-semibold rounded-full flex-shrink-0 ${oferta.status === 'pendiente' ? 'bg-yellow-100 text-yellow-700' : oferta.status === 'aceptada' ? 'bg-green-100 text-green-700' : oferta.status === 'rechazada' ? 'bg-red-100 text-red-700' : oferta.status === 'perdida' ? 'bg-gray-100 text-gray-500' : 'bg-blue-100 text-blue-700'}`}>
                                      {oferta.status === 'pendiente' ? 'Pendiente' : oferta.status === 'aceptada' ? '✅ Aceptada' : oferta.status === 'rechazada' ? 'Rechazada' : oferta.status === 'perdida' ? '⛔ Sin espacio' : '🔄 Contraoferta enviada'}
                                    </span>
                                    {oferta.status === 'pendiente' && (
                                      <div className="flex space-x-2 flex-shrink-0">
                                        <button onClick={async () => { try { await apiResponderOferta(oferta.id, { status: 'aceptada' }); responderOfertaRetorno(ret.id, oferta.id, 'aceptar'); recargar(); } catch (e) { mostrarNotificacion(e.message || 'Error al aceptar oferta', 'error'); } }}
                                          className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700">
                                          ✅ Aceptar
                                        </button>
                                        <button onClick={() => { setRetornoContraId({ retornoId: ret.id, ofertaId: oferta.id }); setFormContra({ monto: '', mensaje: '' }); }}
                                          className="px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium hover:bg-blue-200">
                                          🔄 Contraoferta
                                        </button>
                                        <button onClick={async () => { try { await apiResponderOferta(oferta.id, { status: 'rechazada' }); responderOfertaRetorno(ret.id, oferta.id, 'rechazar'); recargar(); } catch (e) { mostrarNotificacion(e.message || 'Error al rechazar oferta', 'error'); } }}
                                          className="px-3 py-1.5 bg-red-100 text-red-700 rounded-lg text-sm font-medium hover:bg-red-200">
                                          ❌ Rechazar
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}

                          {/* Acciones */}
                          <div className="px-4 py-3 border-t space-y-3">
                            {/* Retorno disponible con clientes aceptados → botón cerrar */}
                            {ret.status === 'disponible' && (
                              <div className="bg-teal-50 border border-teal-200 rounded-lg p-3 flex items-center justify-between gap-3 flex-wrap">
                                <div>
                                  <p className="text-sm font-semibold text-teal-800">
                                    {clientesAceptados.length > 0
                                      ? `${clientesAceptados.length} cliente${clientesAceptados.length > 1 ? 's' : ''} confirmado${clientesAceptados.length > 1 ? 's' : ''} — retorno aún abierto`
                                      : 'Retorno abierto — aceptando ofertas'}
                                  </p>
                                  <p className="text-xs text-teal-600 mt-0.5">Cuando ya no quieras más cargas, márcalo como lleno.</p>
                                </div>
                                <div className="flex gap-2 flex-shrink-0">
                                  <button
                                    onClick={() => {
                                      setFormRetorno(f => ({
                                        ...f,
                                        origenActual: ret.origenActual || ret.origen || '',
                                        destino: ret.destino || '',
                                        tipoUnidad: ret.tipoVehiculo || ret.tipoUnidad || '',
                                        capacidadDisponible: ret.capacidad || ret.capacidadDisponible || '',
                                        precioBase: ret.precioBase ? String(ret.precioBase) : '',
                                        precioMinimo: ret.precioMinimo ? String(ret.precioMinimo) : '',
                                        expiresAt: defaultExpiresAt(),
                                        descripcion: ret.descripcion || '',
                                      }));
                                      setMostrarFormRetorno(true);
                                    }}
                                    className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 flex-shrink-0"
                                    title="Publicar otro retorno igual"
                                  >
                                    📋 Duplicar
                                  </button>
                                  <button
                                    onClick={async () => {
                                      if (!window.confirm('¿Marcar el retorno como lleno? Las ofertas pendientes serán rechazadas y ya no aceptarás más cargas.')) return;
                                      try {
                                        await apiCerrarRetorno(ret.id);
                                        cerrarRetornoManual(ret.id);
                                        recargar();
                                      } catch (e) { mostrarNotificacion(e.message || 'Error al cerrar el retorno', 'error'); }
                                    }}
                                    className="px-3 py-2 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 flex-shrink-0"
                                  >
                                    🚫 Cupo lleno
                                  </button>
                                </div>
                              </div>
                            )}
                            {ret.status === 'confirmado' && (() => {
                              const ofAceptada = (ret.ofertas || []).find(o => o.status === 'aceptada' && o.pagado) || (ret.ofertas || []).find(o => o.status === 'aceptada');
                              const habilitado = !!ofAceptada?.pagado;
                              // Buscar viaje del retorno para detectar si ya tiene chofer asignado (ret.choferAsignado no persiste en BD)
                              const viajeRetorno = (store.viajes || []).find(v => v.retornoId === ret.id);
                              const tieneChofer = ret.choferAsignado || viajeRetorno?.choferAsignado || (viajeRetorno?.ordenesChofer?.length > 0);
                              if (tieneChofer) {
                                const ordenRetorno = viajeRetorno?.ordenesChofer?.[0] || (store.ordenesChofer || []).find(o => o.retornoId === ret.id);
                                const choferAsignadoId = ret.choferAsignado || viajeRetorno?.choferAsignado;
                                const choferUser = (store.usuarios || []).find(u => u.id === choferAsignadoId);
                                const choferNombreR = choferUser?.nombre || ordenRetorno?.choferNombre || ordenRetorno?.cliente || 'Chofer';
                                const org = ordenRetorno?.origenCoords ? `${ordenRetorno.origenCoords.lat},${ordenRetorno.origenCoords.lng}` : encodeURIComponent(ret.origenActual);
                                const dst = ordenRetorno?.destinoCoords ? `${ordenRetorno.destinoCoords.lat},${ordenRetorno.destinoCoords.lng}` : encodeURIComponent(ret.destino);
                                const progresoR = ordenRetorno?.progreso ?? 0;
                                const statusOrderR = ['asignada','en_camino_recogida','cargando','en_ruta','llegada_destino','descargando','completada'];
                                const currentIdxR = statusOrderR.indexOf(ordenRetorno?.status);
                                const isCompletedR = (s) => { const i = statusOrderR.indexOf(s); return i !== -1 && currentIdxR >= i; };
                                const entregaConfirmadaR = ret.status === 'entrega_confirmada';
                                const etapasR = [
                                  { label: 'Pago realizado',   completado: true },
                                  { label: 'Chofer en camino', completado: isCompletedR('en_camino_recogida') },
                                  { label: 'Recogiendo carga', completado: isCompletedR('cargando') },
                                  { label: 'En ruta',          completado: isCompletedR('en_ruta') },
                                  { label: 'En destino',       completado: isCompletedR('llegada_destino') },
                                  { label: 'Entregado',        completado: isCompletedR('completada') || entregaConfirmadaR },
                                ];
                                return (
                                  <div className="space-y-3">
                                    {/* Checkpoints retorno */}
                                    <div className="bg-white rounded-lg border border-green-100 p-3">
                                      <div className="flex justify-between text-xs text-gray-500 mb-1">
                                        <span className="font-medium">Progreso del servicio</span>
                                        <span className="font-bold text-green-600">{progresoR}%</span>
                                      </div>
                                      <div className="w-full bg-gray-200 rounded-full h-2 mb-3">
                                        <div className="bg-green-500 h-2 rounded-full transition-all" style={{ width: `${progresoR}%` }} />
                                      </div>
                                      <div className="flex items-start justify-between">
                                        {etapasR.map((etapa, idx) => (
                                          <div key={idx} className="flex flex-col items-center flex-1">
                                            <div className={`w-6 h-6 rounded-full flex items-center justify-center mb-1 ${etapa.completado ? 'bg-green-600' : 'bg-gray-200'}`}>
                                              {etapa.completado
                                                ? <CheckCircle size={12} className="text-white" />
                                                : <span className="text-gray-400" style={{ fontSize: '10px' }}>{idx + 1}</span>}
                                            </div>
                                            <p className={`text-center leading-tight ${etapa.completado ? 'text-green-700 font-semibold' : 'text-gray-400'}`} style={{ fontSize: '9px' }}>
                                              {etapa.label}
                                            </p>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                    <div className="flex flex-wrap gap-2">
                                      <span className="px-3 py-1.5 rounded-lg text-xs font-medium flex items-center space-x-1 bg-green-50 text-green-700 border border-green-200">
                                        <Users size={13} /><span>✅ Chofer notificado</span>
                                      </span>
                                      {ofAceptada?.clienteId && (
                                        <button
                                          onClick={() => setChatModal({ viajeId: ret.id, contraparte: { id: ofAceptada.clienteId, nombre: ofAceptada.clienteNombre || 'Cliente', rol: 'cliente' } })}
                                          className="flex items-center space-x-1.5 px-3 py-1.5 rounded-lg border border-purple-300 text-purple-700 hover:bg-purple-50 font-medium text-xs"
                                        >
                                          <MessageCircle size={13} /><span>Chat con {ofAceptada.clienteNombre || 'Cliente'}</span>
                                        </button>
                                      )}
                                      <button
                                        onClick={() => setChatModal({ viajeId: ret.id, contraparte: { id: ret.choferAsignado, nombre: choferNombreR, rol: 'chofer' } })}
                                        className="flex items-center space-x-1.5 px-3 py-1.5 rounded-lg border border-green-300 text-green-700 hover:bg-green-50 font-medium text-xs"
                                      >
                                        <MessageCircle size={13} /><span>Chat con {choferNombreR || 'Chofer'}</span>
                                      </button>
                                      <button
                                        onClick={() => setVerMapaRetornoId(verMapaRetornoId === ret.id ? null : ret.id)}
                                        className={`flex items-center space-x-1.5 px-3 py-1.5 rounded-lg border font-medium text-xs transition-colors ${verMapaRetornoId === ret.id ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-300 hover:bg-blue-50'}`}
                                      >
                                        <Navigation size={13} /><span>{verMapaRetornoId === ret.id ? 'Ocultar GPS' : 'Ver GPS del chofer'}</span>
                                      </button>
                                      <a href={`https://maps.google.com/maps?saddr=${org}&daddr=${dst}`} target="_blank" rel="noopener noreferrer"
                                        className="flex items-center space-x-1.5 px-3 py-1.5 rounded-lg border border-green-300 text-green-700 hover:bg-green-50 font-medium text-xs"
                                      >
                                        <MapPin size={13} /><span>Abrir en Maps</span>
                                      </a>
                                    </div>
                                    {verMapaRetornoId === ret.id && ordenRetorno && (
                                      ordenRetorno.origenCoords || ordenRetorno.destinoCoords ? (
                                        <div className="rounded-xl overflow-hidden border border-blue-200">
                                          <MapaGpsOfertaView
                                            key={`retorno-map-${ret.id}`}
                                            origenCoords={ordenRetorno.origenCoords}
                                            destinoCoords={ordenRetorno.destinoCoords}
                                            onInfoRuta={() => {}}
                                          />
                                        </div>
                                      ) : (
                                        <div className="rounded-xl border border-blue-200 bg-blue-50 p-4 text-sm text-blue-700">
                                          <Navigation size={16} className="inline mr-2" />
                                          Ruta: {ret.origenActual} → {ret.destino} · Chofer: {choferNombreR}
                                        </div>
                                      )
                                    )}
                                  </div>
                                );
                              }
                              return (
                                <button
                                  onClick={() => setNotificarChoferRetornoId(ret.id)}
                                  disabled={!habilitado}
                                  title={!habilitado ? 'Disponible cuando el cliente confirme el pago' : ''}
                                  className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center space-x-2 ${habilitado ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-100 text-gray-400 cursor-not-allowed'}`}
                                >
                                  <Users size={14} />
                                  <span>{habilitado ? 'Notificar chofer' : '⏳ Esperando pago del cliente'}</span>
                                </button>
                              );
                            })()}
                            {ret.status === 'disponible' && clientesAceptados.length === 0 && (
                              <button onClick={() => eliminarRetorno(ret.id)} className="px-3 py-1.5 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 text-sm font-medium flex items-center space-x-1">
                                <X size={13} /><span>Cancelar retorno</span>
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

{/* Modal movido al nivel superior del componente */}

            {/* Modal contraoferta */}
            {retornoContraId && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
                <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
                  <h3 className="text-xl font-bold mb-4">Enviar Contraoferta</h3>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Tu precio propuesto *</label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-semibold select-none">$</span>
                        <input type="text" inputMode="decimal" required value={formContra.monto}
                          onChange={e => {
                            const raw = e.target.value.replace(/[^0-9.]/g, '');
                            const parts = raw.split('.');
                            const clean = parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : raw;
                            setFormContra({...formContra, monto: clean});
                          }}
                          onBlur={() => {
                            const n = parseFloat(formContra.monto.replace(/,/g, ''));
                            if (!isNaN(n)) setFormContra({...formContra, monto: n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })});
                          }}
                          placeholder="0.00" className="w-full pl-8 pr-4 py-2 border border-gray-300 rounded-lg" />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Mensaje (opcional)</label>
                      <textarea rows={2} value={formContra.mensaje}
                        onChange={e => setFormContra({...formContra, mensaje: e.target.value})}
                        placeholder="Ej. Precio final, incluye maniobras de carga..."
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg resize-none" />
                    </div>
                    <div className="flex space-x-3">
                      <button onClick={() => { setRetornoContraId(null); setFormContra({ monto: '', mensaje: '' }); }} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">Cancelar</button>
                      <button onClick={async () => {
                        if (!formContra.monto) return;
                        const montoContra = parseFloat(formContra.monto.replace(/,/g, ''));
                        try {
                          await apiResponderOferta(retornoContraId.ofertaId, { status: 'contrapropuesta', contrapropuesta: montoContra });
                          responderOfertaRetorno(retornoContraId.retornoId, retornoContraId.ofertaId, 'contraoferta', { monto: montoContra, mensaje: formContra.mensaje });
                          setRetornoContraId(null);
                          setFormContra({ monto: '', mensaje: '' });
                          mostrarNotificacion('Contraoferta enviada al cliente');
                          recargar();
                        } catch (e) { mostrarNotificacion(e.message || 'Error al enviar contraoferta', 'error'); }
                      }} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold">
                        Enviar Contraoferta
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
        )}

        {/* Modal publicar retorno */}
        {mostrarFormRetorno && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
            <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6 border-b flex justify-between items-center">
                <h3 className="text-xl font-bold">Publicar Retorno Vacío</h3>
                <button onClick={() => setMostrarFormRetorno(false)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
              </div>
              <form onSubmit={publicarRetorno} className="p-6 space-y-4">
                <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-2 text-xs text-blue-700">
                  <strong>¿Cómo funciona?</strong> El camión ya entregó su carga y está vacío. Indica <strong>dónde está ahora</strong> el camión y <strong>a dónde regresa</strong>. Los clientes en esa ruta podrán contratar el espacio vacío.
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">📍 Ubicación actual del camión *</label>
                    <select required value={formRetorno.origenActual}
                      onChange={e => setFormRetorno({...formRetorno, origenActual: e.target.value})}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg">
                      <option value="">Seleccionar ciudad actual...</option>
                      {CIUDADES_BC.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                    <p className="text-xs text-gray-400 mt-1">Ciudad donde cargará el cliente</p>
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">🏁 Ciudad de destino / regreso *</label>
                    <select required value={formRetorno.destino}
                      onChange={e => setFormRetorno({...formRetorno, destino: e.target.value})}
                      className={`w-full px-4 py-2 border border-gray-300 rounded-lg ${formRetorno.destino === _ciudadEmpresa ? 'bg-green-50 text-green-800' : ''}`}>
                      <option value="">Seleccionar destino...</option>
                      {CIUDADES_BC.filter(c => c !== formRetorno.origenActual).map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                    <p className="text-xs text-gray-400 mt-1">
                      Ciudad donde descarga el cliente
                      {_ciudadEmpresa && formRetorno.destino === _ciudadEmpresa && <span className="ml-1 text-green-600 font-medium">· tu base ✓</span>}
                    </p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Tipo de unidad *</label>
                    <select required value={formRetorno.tipoUnidad}
                      onChange={e => setFormRetorno({...formRetorno, tipoUnidad: e.target.value})}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg">
                      <option value="">Seleccionar...</option>
                      {['Trailer', 'Torton', 'Rabon', 'Camioneta 3.5T', 'Pickup', 'Grua Plana'].map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Capacidad disponible *</label>
                    <input required type="text" value={formRetorno.capacidadDisponible}
                      onChange={e => setFormRetorno({...formRetorno, capacidadDisponible: e.target.value})}
                      placeholder="Ej. 20 tons"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Precio base (MXN) *</label>
                    <input required type="number" min="0" value={formRetorno.precioBase}
                      onChange={e => setFormRetorno({...formRetorno, precioBase: e.target.value})}
                      onWheel={e => e.target.blur()}
                      placeholder="Ej. 15000" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                    <p className="text-xs text-gray-400 mt-1">Precio sugerido que verá el cliente</p>
                    {formRetorno.precioBase > 0 && (
                      <div className="mt-2 bg-green-50 border border-green-200 rounded-lg px-3 py-2 flex justify-between text-xs">
                        <span className="text-gray-500">Comisión Choyero ({comisionRetornosPct}%): <span className="text-red-500 font-semibold">−${Math.round(Number(formRetorno.precioBase) * comisionRetornosPct / 100).toLocaleString()}</span></span>
                        <span className="text-green-700 font-bold">Tu ganancia: ${Math.round(Number(formRetorno.precioBase) * gananciaPctRetornos).toLocaleString()}</span>
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Precio mínimo (MXN) *</label>
                    <input required type="number" min="0" value={formRetorno.precioMinimo}
                      onChange={e => setFormRetorno({...formRetorno, precioMinimo: e.target.value})}
                      onWheel={e => e.target.blur()}
                      placeholder="Ej. 10000" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                    <p className="text-xs text-gray-400 mt-1">Oculto al cliente. Ofertas ≥ a este precio se aceptan automáticamente</p>
                    {formRetorno.precioMinimo > 0 && (
                      <div className="mt-2 bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2 flex justify-between text-xs">
                        <span className="text-gray-500">Comisión ({comisionRetornosPct}%): <span className="text-red-500 font-semibold">−${Math.round(Number(formRetorno.precioMinimo) * comisionRetornosPct / 100).toLocaleString()}</span></span>
                        <span className="text-yellow-700 font-bold">Ganancia mín.: ${Math.round(Number(formRetorno.precioMinimo) * gananciaPctRetornos).toLocaleString()}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Ajusta la fecha de retorno</label>
                  <input type="datetime-local" value={formRetorno.expiresAt}
                    onChange={e => setFormRetorno({...formRetorno, expiresAt: e.target.value})}
                    min={new Date(Date.now() + 60 * 60 * 1000).toISOString().slice(0, 16)}
                    max={new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                  <p className="text-xs text-gray-400 mt-1">Hora en tiempo de Baja California. Máximo 7 días. El precio baja 10% al 33% del plazo y 20% al 66%</p>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Nota adicional</label>
                  <textarea rows={2} value={formRetorno.descripcion}
                    onChange={e => setFormRetorno({...formRetorno, descripcion: e.target.value})}
                    placeholder="Ej. Disponible desde las 3pm, incluye lona..."
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg resize-none" />
                </div>
                <button type="submit" className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold">
                  Publicar y notificar clientes en ruta
                </button>
              </form>
            </div>
          </div>
        )}

        {/* ========== MAPA ========== */}
        {seccion === 'mapa' && (
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Mapa de Unidades</h2>
            {bloqueadoPorAprobacion ? (
              <div className="bg-amber-50 border border-amber-200 rounded-2xl p-10 flex flex-col items-center text-center max-w-lg mx-auto">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
                  <Lock size={28} className="text-amber-500" />
                </div>
                <h3 className="text-xl font-bold text-amber-800 mb-2">Mapa bloqueado</h3>
                <p className="text-amber-700 text-sm mb-6">
                  El Mapa de Unidades estará disponible una vez que tu empresa sea verificada y aprobada por el administrador de Choyero.
                </p>
                {empresaEnRevision?.status === 'en_registro' && (
                  <button onClick={() => setSeccion('documentos')} className="px-6 py-2.5 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-xl transition text-sm">
                    Subir documentación →
                  </button>
                )}
              </div>
            ) : (
              <MapaUnidades
                unidades={unidades}
                plantillaChoferes={store.plantillaChoferes || []}
                empresaActiva={empresaActiva}
              />
            )}
          </div>
        )}

        {/* ========== UNIDADES ========== */}
        {seccion === 'unidades' && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-3xl font-bold text-gray-800">Mis Unidades</h2>
              <button onClick={() => setMostrarFormUnidad(true)} className="px-6 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 flex items-center space-x-2 font-semibold">
                <Plus size={20} /><span>Agregar Unidad</span>
              </button>
            </div>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Unidad</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Marca / Modelo</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Capacidad</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ubicación</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Chofer asignado</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Status</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Acciones</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {unidades.map(unidad => {
                    const choferDeEstaUnidad = choferes.find(c => c.id === unidad.choferAsignado);
                    const conflictoMantenimiento = ['mantenimiento', 'inactiva'].includes(unidad.status) && choferDeEstaUnidad;
                    return (
                    <tr key={unidad.id} className={`hover:bg-gray-50 ${conflictoMantenimiento ? 'bg-yellow-50' : ''}`}>
                      <td className="px-6 py-4">
                        <p className="font-mono font-bold text-gray-800">{unidad.placas}</p>
                        <p className="text-xs text-gray-500">{unidad.tipo}</p>
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-gray-700">
                        <p>{unidad.marca || '—'} {unidad.modelo || ''}</p>
                        {unidad.anio && <p className="text-xs text-gray-400">{unidad.anio}</p>}
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-gray-700">{unidad.capacidad}</td>
                      <td className="px-6 py-4 text-sm text-gray-600">{unidad.ciudad || <span className="text-gray-400">—</span>}</td>
                      <td className="px-6 py-4">
                        <div>
                          <select
                            value={unidad.choferAsignado || ''}
                            onChange={async (e) => {
                              const newChoferId = e.target.value || null;
                              asignarChoferAUnidad(newChoferId, unidad.id); // actualización local inmediata
                              try { await apiActualizarUnidad(unidad.id, { choferAsignado: newChoferId }); } catch { /* ya guardó local */ }
                            }}
                            className="w-full text-sm border border-gray-200 rounded-lg px-2 py-1"
                          >
                            <option value="">Sin asignar</option>
                            {choferes
                              .map(c => (
                                <option key={c.id} value={c.id}>{c.nombre}</option>
                              ))}
                          </select>
                          {conflictoMantenimiento && (
                            <p className="text-xs text-yellow-700 mt-1 font-semibold">⚠️ Unidad no activa — reasignar chofer</p>
                          )}
                        </div>
                      </td>
                      {/* Status — dropdown directo, sin badge redundante */}
                      <td className="px-6 py-4">
                        <select
                          value={unidad.status}
                          onChange={async (e) => {
                            const newStatus = e.target.value;
                            actualizarUnidadFlota(unidad.id, { ...unidad, status: newStatus });
                            try { await apiActualizarUnidad(unidad.id, { status: newStatus }); } catch { /* ya guardó local */ }
                          }}
                          className={`text-xs font-semibold px-2 py-1 rounded-lg border-0 cursor-pointer ${getStatusColor(unidad.status)}`}
                        >
                          <option value="activa">Activa</option>
                          <option value="disponible">Disponible</option>
                          <option value="mantenimiento">En mantenimiento</option>
                          <option value="inactiva">Inactiva</option>
                        </select>
                      </td>
                      {/* Acciones — menú ··· igual que choferes */}
                      <td className="px-6 py-4">
                        <button
                          onClick={(e) => {
                            if (menuChofer?.id === `u-${unidad.id}`) { setMenuChofer(null); return; }
                            const rect = e.currentTarget.getBoundingClientRect();
                            setMenuChofer({ id: `u-${unidad.id}`, top: rect.bottom + 4, right: window.innerWidth - rect.right, unidad });
                          }}
                          className="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg font-bold text-lg leading-none"
                        >···</button>
                      </td>
                    </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ========== CHOFERES ========== */}
        {seccion === 'choferes' && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-3xl font-bold text-gray-800">Mis Choferes</h2>
              <button onClick={() => setMostrarFormChofer(true)} className="px-6 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 flex items-center space-x-2 font-semibold">
                <UserPlus size={20} /><span>Agregar Chofer</span>
              </button>
            </div>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Chofer</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Licencia</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Unidad asignada</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Viajes</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Calificación</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Acceso</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Acciones</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {choferes.map(chofer => {
                    const usuarioChofer = chofer.tieneAcceso != null ? null : (store.usuarios || []).find(u => u.email === chofer.email && u.rol === 'chofer');
                    const tieneAcceso = chofer.tieneAcceso ?? !!usuarioChofer;
                    const estaActivoReal = !tieneAcceso || (chofer.tieneAcceso != null ? chofer.usuarioActivo !== false : usuarioChofer?.activo !== false);
                    const estaActivo = chofer.id in activoOverride ? activoOverride[chofer.id] : estaActivoReal;
                    const viajesCompletados = chofer.viajesCompletados ?? chofer.viajes ?? 0;
                    const unidadDeEsteChofer = unidades.find(u => u.id === chofer.unidadAsignada) || unidades.find(u => u.choferAsignado === chofer.id);
                    return (
                    <tr key={chofer.id} className={`hover:bg-gray-50 ${!estaActivo ? 'opacity-60' : ''}`}>
                      <td className="px-6 py-4">
                        <p className="font-semibold">{chofer.nombre}</p>
                        <p className="text-xs text-gray-500">{chofer.telefono}</p>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-1.5">
                          <span className="font-mono text-sm">{chofer.licencia || '—'}</span>
                          {chofer.licencia && !/^[A-Z]{4}\d{6}[AHM]\d{2}$/.test(chofer.licencia) && (
                            <span title="Formato de licencia federal inválido — edita el chofer para corregirlo" className="cursor-help text-base leading-none">⚠️</span>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        {unidadDeEsteChofer ? (
                          <div className="flex items-center gap-2">
                            <span className="px-2 py-1 bg-blue-50 border border-blue-200 text-blue-800 text-xs font-semibold rounded-lg font-mono">
                              {unidadDeEsteChofer.placas}
                            </span>
                            <span className="text-xs text-gray-500">{unidadDeEsteChofer.tipo}</span>
                          </div>
                        ) : (
                          <span className="text-xs text-gray-400 italic">Sin unidad</span>
                        )}
                      </td>
                      <td className="px-6 py-4 font-semibold">{viajesCompletados}</td>
                      <td className="px-6 py-4">
                        {viajesCompletados > 0 && chofer.calificacion ? (
                          <div className="flex items-center space-x-1">
                            <Star size={16} className="text-yellow-400" fill="currentColor" />
                            <span className="font-semibold">{chofer.calificacion}</span>
                          </div>
                        ) : (
                          <span className="text-gray-400 text-sm">—</span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        {tieneAcceso ? (
                          <div className="flex flex-col items-start gap-1">
                            <button
                              onClick={async () => {
                                const nuevoValor = !estaActivo;
                                setActivoOverride(prev => ({ ...prev, [chofer.id]: nuevoValor }));
                                try {
                                  await apiToggleActivoChofer(chofer.id, nuevoValor);
                                  mostrarNotificacion(nuevoValor ? `${chofer.nombre} activado` : `${chofer.nombre} desactivado`);
                                  await recargar();
                                  setActivoOverride(prev => { const n = { ...prev }; delete n[chofer.id]; return n; });
                                } catch (e) {
                                  setActivoOverride(prev => { const n = { ...prev }; delete n[chofer.id]; return n; });
                                  mostrarNotificacion(e.message || 'Error al cambiar acceso', 'error');
                                }
                              }}
                              title={estaActivo ? 'Desactivar acceso' : 'Activar acceso'}
                              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${estaActivo ? 'bg-green-500' : 'bg-gray-300'}`}
                            >
                              <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${estaActivo ? 'translate-x-6' : 'translate-x-1'}`} />
                            </button>
                            <span className={`text-xs font-semibold ${estaActivo ? 'text-green-600' : 'text-gray-400'}`}>
                              {estaActivo ? 'Activo' : 'Inactivo'}
                            </span>
                          </div>
                        ) : (
                          <span className="text-xs font-semibold px-2 py-1 bg-orange-50 text-orange-600 border border-orange-200 rounded-lg">Sin acceso</span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2">
                          {/* Status — griseado si el chofer no está activo */}
                          <select
                            value={chofer.id in statusOverride ? statusOverride[chofer.id] : chofer.status}
                            disabled={!estaActivo}
                            onChange={async (e) => {
                              const nuevoStatus = e.target.value;
                              setStatusOverride(prev => ({ ...prev, [chofer.id]: nuevoStatus }));
                              try {
                                await apiActualizarChofer(chofer.id, { status: nuevoStatus });
                                actualizarChoferPlantilla(chofer.id, { status: nuevoStatus });
                                await recargar();
                                setStatusOverride(prev => { const n = { ...prev }; delete n[chofer.id]; return n; });
                              } catch (e) {
                                setStatusOverride(prev => { const n = { ...prev }; delete n[chofer.id]; return n; });
                                mostrarNotificacion(e.message || 'Error al cambiar el status del chofer', 'error');
                              }
                            }}
                            title={!estaActivo ? 'Activa el acceso para cambiar el status' : ''}
                            className={`text-xs font-semibold px-2 py-1 rounded-lg border-0 cursor-pointer transition ${
                              !estaActivo ? 'opacity-40 cursor-not-allowed' : getStatusColor(chofer.id in statusOverride ? statusOverride[chofer.id] : chofer.status)
                            }`}
                          >
                            <option value="disponible">Disponible</option>
                            <option value="vacaciones">Vacaciones</option>
                            <option value="inactivo">Inactivo</option>
                          </select>

                          {/* Menú ··· — renderizado en fixed para no ser recortado por overflow */}
                          <button
                            onClick={(e) => {
                              if (menuChofer?.id === chofer.id) { setMenuChofer(null); return; }
                              const rect = e.currentTarget.getBoundingClientRect();
                              setMenuChofer({ id: chofer.id, top: rect.bottom + 4, right: window.innerWidth - rect.right });
                            }}
                            className="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg font-bold text-lg leading-none"
                          >···</button>
                        </div>
                      </td>
                    </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Menú ··· de UNIDADES — fixed fuera de la tabla */}
        {menuChofer?.unidad && (() => {
          const u = menuChofer.unidad;
          return (
            <>
              <div className="fixed inset-0 z-40" onClick={() => setMenuChofer(null)} />
              <div
                className="fixed z-50 bg-white border border-gray-200 rounded-xl shadow-2xl py-1 w-40"
                style={{ top: menuChofer.top, right: menuChofer.right }}
              >
                <button
                  onClick={() => { editarUnidad(u); setMenuChofer(null); }}
                  className="w-full px-4 py-2 text-sm text-left hover:bg-gray-50 flex items-center gap-2"
                >
                  <Edit size={15} className="text-blue-600" />
                  <span>Editar</span>
                </button>
                <div className="border-t border-gray-100 my-1" />
                <button
                  onClick={() => { eliminarUnidad(u.id); setMenuChofer(null); }}
                  className="w-full px-4 py-2 text-sm text-left hover:bg-red-50 text-red-600 flex items-center gap-2"
                >
                  <Trash2 size={15} />
                  <span>Eliminar</span>
                </button>
              </div>
            </>
          );
        })()}

        {/* Menú ··· de choferes — fixed fuera de la tabla para no ser recortado por overflow */}
        {menuChofer && !menuChofer?.unidad && (() => {
          const c = choferes.find(x => x.id === menuChofer.id);
          if (!c) return null;
          const tAcceso = c.tieneAcceso ?? !!(store.usuarios || []).find(u => u.email === c.email && u.rol === 'chofer');
          return (
            <>
              <div className="fixed inset-0 z-40" onClick={() => setMenuChofer(null)} />
              <div
                className="fixed z-50 bg-white border border-gray-200 rounded-xl shadow-2xl py-1 w-44"
                style={{ top: menuChofer.top, right: menuChofer.right }}
              >
                <button
                  onClick={() => { setMostrarAccesoChofer(c); setMenuChofer(null); }}
                  className="w-full px-4 py-2 text-sm text-left hover:bg-gray-50 flex items-center gap-2"
                >
                  <Key size={15} className={tAcceso ? 'text-green-600' : 'text-orange-500'} />
                  <span>{tAcceso ? 'Gestionar acceso' : 'Dar acceso'}</span>
                </button>
                <button
                  onClick={() => { editarChofer(c); setMenuChofer(null); }}
                  className="w-full px-4 py-2 text-sm text-left hover:bg-gray-50 flex items-center gap-2"
                >
                  <Edit size={15} className="text-blue-600" />
                  <span>Editar chofer</span>
                </button>
                <div className="border-t border-gray-100 my-1" />
                <button
                  onClick={() => { eliminarChofer(c.id); setMenuChofer(null); }}
                  className="w-full px-4 py-2 text-sm text-left hover:bg-red-50 text-red-600 flex items-center gap-2"
                >
                  <Trash2 size={15} />
                  <span>Eliminar</span>
                </button>
              </div>
            </>
          );
        })()}

        {/* ========== HISTORIAL ========== */}
        {seccion === 'historial' && (
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Historial de Viajes</h2>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">ID</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Fecha</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ruta</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Cliente</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ganancia</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Mi calificación</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Retorno</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {historial.map(viaje => {
                    // miRating: buscar en API (viaje.calificaciones) y en store local (sesión actual)
                    const miRatingApi   = (viaje.calificaciones || []).find(c => c.calificadoRol === 'cliente');
                    const miRatingLocal = (store.calificaciones || []).find(c => c.viajeId === viaje.id && c.autorRol === 'transportista');
                    const miRating = miRatingApi
                      ? { estrellas: miRatingApi.puntuacion, comentario: miRatingApi.comentario }
                      : miRatingLocal;
                    const yaPublicoRetorno = viaje.tipo === 'retorno' || todosRetornosEmpresa.some(r => r.viajeOrigenId === viaje.id);
                    return (
                      <tr key={viaje.id} className={`hover:bg-gray-50 ${viaje.esCancelado ? 'bg-red-50/30 opacity-75' : ''}`}>
                        <td className="px-6 py-4 font-mono font-semibold">
                          {viaje.id}
                          {viaje.tipo === 'retorno' && <span className="ml-1 text-xs bg-indigo-100 text-indigo-700 px-1.5 py-0.5 rounded font-normal">Retorno</span>}
                          {viaje.esCancelado && <span className="ml-1 text-xs bg-red-100 text-red-700 px-1.5 py-0.5 rounded font-normal">❌ Cancelado</span>}
                        </td>
                        <td className="px-6 py-4 text-gray-600">{viaje.fecha}</td>
                        <td className="px-6 py-4 font-medium">{viaje.ruta}</td>
                        <td className="px-6 py-4">{viaje.cliente}</td>
                        <td className="px-6 py-4 font-bold text-green-600">{viaje.esCancelado ? <span className="text-gray-400 font-normal text-sm">—</span> : `$${(viaje.ganancia||0).toLocaleString()}`}</td>
                        <td className="px-6 py-4">
                          {viaje.esCancelado ? (
                            <span className="text-gray-400 text-sm">—</span>
                          ) : miRating ? (
                            <div className="flex items-center space-x-1">
                              {[1,2,3,4,5].map(i => (
                                <Star key={i} size={16} className={i <= miRating.estrellas ? 'text-yellow-400' : 'text-gray-300'} fill={i <= miRating.estrellas ? 'currentColor' : 'none'} />
                              ))}
                            </div>
                          ) : (
                            <button
                              onClick={() => setMostrarCalificarCliente(viaje)}
                              className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-lg hover:bg-yellow-200 font-medium text-sm flex items-center space-x-1"
                            >
                              <Star size={13} />
                              <span>Calificar cliente</span>
                            </button>
                          )}
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex flex-col gap-2">
                            {((viaje.evidencias || []).length > 0 || viaje.firma) && (
                              <button
                                onClick={() => setEvidenciasModal({ fotos: viaje.evidencias || [], firma: viaje.firma || null })}
                                className="px-3 py-1 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 font-medium text-sm flex items-center space-x-1 whitespace-nowrap"
                              >
                                <Camera size={13} />
                                <span>Ver evidencias {viaje.evidencias?.length > 0 ? `(${viaje.evidencias.length})` : ''}{viaje.firma ? ' + firma' : ''}</span>
                              </button>
                            )}
                            {!yaPublicoRetorno ? (
                              <button
                                onClick={() => {
                                  const unidadFlota = (store.flota || []).find(u =>
                                    u.placas === viaje.unidad || u.id === viaje.unidadAsignada
                                  );
                                  setFormRetorno(f => ({
                                    ...f,
                                    origenActual: viaje.destino || '',
                                    destino: viaje.origen || _ciudadEmpresa || f.destino,
                                    tipoUnidad: unidadFlota?.tipo || viaje.tipoUnidad || viaje.unidad || f.tipoUnidad,
                                    capacidadDisponible: unidadFlota?.capacidad || f.capacidadDisponible,
                                  }));
                                  setViajeRetornoOrigen({ id: viaje.id, destino: viaje.destino });
                                  setMostrarFormRetorno(true);
                                }}
                                className="px-3 py-1 bg-indigo-100 text-indigo-700 rounded-lg hover:bg-indigo-200 font-medium text-sm flex items-center space-x-1 whitespace-nowrap"
                              >
                                <span>📦</span>
                                <span>Publicar retorno</span>
                              </button>
                            ) : (
                              <span className="text-xs text-gray-400">—</span>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {seccion === 'costos' && <SeccionCostos unidades={unidades} />}
        {seccion === 'estadisticas' && <SeccionEstadisticasPro />}
        {seccion === 'cobros' && <SeccionMisCobros />}
        {seccion === 'facturas' && <SeccionMisFacturas empresaId={empresaId} autoAbrirModal={abrirDFModal} />}

        {seccion === 'facturas_clientes' && (() => {
          const solicitudes = (store.viajes || [])
            .filter(v => v.solicitudFactura)
            .map(v => ({ ...v.solicitudFactura, origen: v.origen, destino: v.destino, precio: v.costoFinal ?? v.precio, clienteNombre: v.clienteNombre }))
            .sort((a, b) => new Date(b.creadoEn) - new Date(a.creadoEn));
          // Marcar todas las pendientes como vistas al entrar a la sección
          const pendientesIds = solicitudes.filter(s => s.status === 'pendiente').map(s => s.id);
          if (pendientesIds.some(id => !facturasVistasPendientes.has(id))) {
            const nuevas = new Set([...facturasVistasPendientes, ...pendientesIds]);
            setFacturasVistasPendientes(nuevas);
            try { localStorage.setItem('choyero_facturas_vistas', JSON.stringify([...nuevas])); } catch {}
          }
          return (
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-2">Solicitudes de Factura</h2>
              <p className="text-gray-500 mb-6 text-sm">Clientes que solicitan factura por sus fletes. Emite la factura con los datos fiscales indicados y sube el PDF.</p>
              {solicitudes.length === 0 ? (
                <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                  <FileCheck size={48} className="mx-auto text-gray-300 mb-4" />
                  <p className="text-gray-500">No hay solicitudes de factura</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {solicitudes.map(sol => {
                    const expandida = facturasExpandidas.has(sol.id);
                    const toggleExpand = () => setFacturasExpandidas(prev => {
                      const next = new Set(prev);
                      expandida ? next.delete(sol.id) : next.add(sol.id);
                      return next;
                    });
                    return (
                    <div key={sol.id} className="bg-white rounded-xl shadow-lg overflow-hidden">
                      {/* Header — siempre visible, click para expandir */}
                      <button onClick={toggleExpand} className="w-full flex items-center justify-between gap-4 px-6 py-4 hover:bg-gray-50 transition text-left">
                        <div className="min-w-0">
                          <p className="font-bold text-gray-800 truncate">{sol.origen?.split(',')[0]} → {sol.destino?.split(',')[0]}</p>
                          <p className="text-sm text-gray-500">{sol.clienteNombre} · ${sol.precio?.toLocaleString('es-MX')} MXN</p>
                        </div>
                        <div className="flex items-center gap-3 flex-shrink-0">
                          <span className={`px-3 py-1 rounded-full text-xs font-semibold ${sol.status === 'subida' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                            {sol.status === 'subida' ? '✅ Factura subida' : '⏳ Pendiente'}
                          </span>
                          <ChevronDown size={18} className={`text-gray-400 transition-transform ${expandida ? 'rotate-180' : ''}`} />
                        </div>
                      </button>

                      {/* Contenido — solo visible cuando expandida */}
                      {expandida && <div className="px-6 pb-6 border-t border-gray-100">
                        <div className="bg-gray-50 rounded-lg p-4 mt-4 mb-4 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                        <div><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">RFC Receptor</p><p className="font-mono font-semibold text-gray-800">{sol.rfcReceptor}</p></div>
                        <div><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">Razón Social</p><p className="text-gray-800">{sol.nombreReceptor}</p></div>
                        {sol.regimenFiscal && <div><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">Régimen</p><p className="text-gray-800">{sol.regimenFiscal}</p></div>}
                        {sol.cpFiscal && <div><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">CP Fiscal</p><p className="font-mono text-gray-800">{sol.cpFiscal}</p></div>}
                        <div><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">Uso CFDI</p><p className="text-gray-800">{sol.usoCfdi || 'S01'}</p></div>
                        {sol.notas && <div className="sm:col-span-2"><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">Notas del cliente</p><p className="text-gray-600 italic">{sol.notas}</p></div>}
                        {sol.clienteCsfUrl && (
                          <div className="sm:col-span-2 pt-1 border-t border-gray-200 mt-1">
                            <p className="text-xs text-gray-400 font-semibold uppercase mb-1">Constancia de Situación Fiscal</p>
                            <button
                              onClick={async () => {
                                const val = sol.clienteCsfUrl;
                                const url = val.startsWith('https://') ? val : await apiGetDownloadUrl(val).catch(() => null);
                                if (url) window.open(url, '_blank');
                              }}
                              className="inline-flex items-center gap-2 px-3 py-1.5 bg-indigo-600 text-white text-xs font-semibold rounded-lg hover:bg-indigo-700">
                              <FileText size={13} />
                              Descargar CSF
                            </button>
                          </div>
                        )}
                      </div>

                      {sol.status === 'subida' ? (
                        <div className="flex flex-wrap items-center gap-3">
                          <span className="text-sm text-green-700 font-semibold">Factura disponible</span>
                          <a href={sol.pdfUrl} download={`factura-${sol.viajeId}.pdf`}
                            className="px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700">
                            Descargar PDF
                          </a>
                          {sol.xmlUrl && (
                            <a href={sol.xmlUrl} download={`factura-${sol.viajeId}.xml`}
                              className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700">
                              Descargar XML
                            </a>
                          )}
                        </div>
                      ) : (() => {
                        const archivos = archivosFacturaCliente[sol.id] || {};
                        const setArchivo = (tipo, val) => setArchivosFacturaCliente(prev => ({ ...prev, [sol.id]: { ...(prev[sol.id] || {}), [tipo]: val } }));
                        const leerArchivo = (file, tipo) => { const r = new FileReader(); r.onload = (ev) => setArchivo(tipo, ev.target.result); r.readAsDataURL(file); };
                        const subirAmbos = async () => {
                          if (!archivos.pdf || !archivos.xml) { mostrarNotificacion('Debes seleccionar el PDF y el XML', 'error'); return; }
                          try {
                            await apiSubirFacturaTransportista(sol.viajeId, { pdfUrl: archivos.pdf, xmlUrl: archivos.xml });
                            mostrarNotificacion('Factura subida correctamente', 'success');
                            setArchivosFacturaCliente(prev => { const n = { ...prev }; delete n[sol.id]; return n; });
                            recargar();
                          } catch (err) { mostrarNotificacion(err.message || 'Error al subir la factura', 'error'); }
                        };
                        return (
                          <div>
                            <p className="text-sm text-gray-600 mb-3">Emite la factura con los datos anteriores y sube ambos archivos:</p>
                            <div className="flex flex-wrap gap-3 mb-3">
                              <label className={`cursor-pointer inline-flex items-center gap-2 px-4 py-2 rounded-lg border-2 font-semibold text-sm ${archivos.pdf ? 'border-green-500 bg-green-50 text-green-700' : 'border-gray-300 bg-white text-gray-600 hover:border-gray-400'}`}>
                                <Upload size={15} />
                                <span>{archivos.pdf ? '✓ PDF seleccionado' : 'Seleccionar PDF'}</span>
                                <input type="file" accept="application/pdf" className="hidden"
                                  onChange={(e) => { const f = e.target.files?.[0]; if (!f) return; if (f.type !== 'application/pdf') { mostrarNotificacion('Solo archivos PDF', 'error'); return; } if (f.size > 5*1024*1024) { mostrarNotificacion('El PDF no puede superar 5MB', 'error'); return; } leerArchivo(f, 'pdf'); e.target.value = ''; }} />
                              </label>
                              <label className={`cursor-pointer inline-flex items-center gap-2 px-4 py-2 rounded-lg border-2 font-semibold text-sm ${archivos.xml ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-300 bg-white text-gray-600 hover:border-gray-400'}`}>
                                <Upload size={15} />
                                <span>{archivos.xml ? '✓ XML seleccionado' : 'Seleccionar XML'}</span>
                                <input type="file" accept=".xml,text/xml,application/xml" className="hidden"
                                  onChange={(e) => { const f = e.target.files?.[0]; if (!f) return; if (f.size > 2*1024*1024) { mostrarNotificacion('El XML no puede superar 2MB', 'error'); return; } leerArchivo(f, 'xml'); e.target.value = ''; }} />
                              </label>
                            </div>
                            <button onClick={subirAmbos} disabled={!archivos.pdf || !archivos.xml}
                              className="px-5 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold text-sm disabled:opacity-40 disabled:cursor-not-allowed">
                              Subir Factura (PDF + XML)
                            </button>
                          </div>
                        );
                      })()}
                      </div>}
                    </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })()}

        {seccion === 'bancario' && <SeccionDatosBancarios empresaId={empresaId} onCLABERegistrada={() => setTieneCLABE(true)} />}

        {seccion === 'perfil' && (() => {
          const emp = store.empresasActivas?.find(e => e.id === empresaId) || empresaActiva || {};
          // Separar dirección en calle y ciudad
          const partes = (emp.direccion || '').split(',');
          const calleInicial = partes.length > 1 ? partes.slice(0, -2).join(',').trim() : '';
          const ciudadInicial = partes.length > 1 ? partes.slice(-2).join(',').trim() : (emp.direccion || '');

          const iniciarEdicion = () => {
            setFormPerfil({
              nombre: emp.nombre || '',
              rfc: emp.rfc || '',
              telefono: emp.telefono || '',
              calle: calleInicial,
              ciudad: ciudadInicial,
            });
            setEditandoPerfil(true);
            setPerfilGuardado(false);
          };
          const guardar = async () => {
            const direccion = formPerfil.calle
              ? `${formPerfil.calle}, ${formPerfil.ciudad}`
              : formPerfil.ciudad;
            const datos = {
              nombre: formPerfil.nombre,
              telefono: formPerfil.telefono,
              ciudad: formPerfil.ciudad,
              direccion,
            };
            try {
              await apiActualizarEmpresa(datos);
              await recargar();
            } catch (e) {
              // fallback: al menos actualizar store local
              actualizarPerfilEmpresa(empresaId, datos);
            }
            setEditandoPerfil(false);
            setPerfilGuardado(true);
            setTimeout(() => setPerfilGuardado(false), 3000);
          };
          return (
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-2">Mi Perfil</h2>
              <p className="text-gray-600 mb-6">Información de tu empresa en la plataforma</p>

              <div className="max-w-2xl">
                {/* Logo / Avatar */}
                <div className="bg-white rounded-2xl shadow-lg p-6 mb-6 flex items-center space-x-5">
                  <label className="relative cursor-pointer group flex-shrink-0" title="Cambiar logo de empresa">
                    <div className="w-20 h-20 bg-green-700 rounded-full flex items-center justify-center text-white text-3xl overflow-hidden">
                      {emp.logo
                        ? (emp.logo.startsWith('data:') || emp.logo.startsWith('http')
                            ? <img src={emp.logo} alt="logo" className="w-full h-full object-cover" />
                            : <span>{emp.logo}</span>)
                        : <Truck size={36} />}
                    </div>
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 rounded-full flex items-center justify-center transition-all">
                      <span className="text-white text-xs font-semibold opacity-0 group-hover:opacity-100">Cambiar</span>
                    </div>
                    <input
                      ref={logoInputRef}
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleLogoChange}
                    />
                  </label>
                  <div>
                    <p className="text-xl font-bold text-gray-800">{emp.nombre}</p>
                    {usuario?.nombre && (
                      <p className="text-sm text-gray-600 mt-0.5">Titular: <span className="font-medium">{usuario.nombre}</span></p>
                    )}
                    <p className="text-gray-500 text-sm">{emp.email}</p>
                    <div className="flex items-center space-x-3 mt-1">
                      <span className="flex items-center space-x-1 text-yellow-500 text-sm">
                        <Star size={14} fill="currentColor" />
                        <span className="font-semibold">{emp.calificacion?.toFixed(1) || '—'}</span>
                      </span>
                      <span className="text-gray-400 text-xs">•</span>
                      <span className="text-gray-500 text-sm">{emp.viajesCompletados || 0} viajes completados</span>
                    </div>
                    <p className="text-xs text-gray-400 mt-1">Haz clic en el logo para cambiarlo</p>
                  </div>
                </div>

                {/* Datos de la empresa */}
                <div className="bg-white rounded-2xl shadow-lg p-6">
                  <div className="flex justify-between items-center mb-5">
                    <h3 className="text-lg font-bold text-gray-800">Datos de la empresa</h3>
                    {!editandoPerfil ? (
                      <button onClick={iniciarEdicion} className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm font-medium transition">
                        <Edit2 size={15} />
                        <span>Editar</span>
                      </button>
                    ) : (
                      <div className="flex space-x-2">
                        <button onClick={() => setEditandoPerfil(false)} className="px-4 py-2 border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50 text-sm transition">
                          Cancelar
                        </button>
                        <button onClick={guardar} className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm font-medium transition">
                          <Save size={15} />
                          <span>Guardar</span>
                        </button>
                      </div>
                    )}
                  </div>

                  {perfilGuardado && (
                    <div className="flex items-center space-x-2 bg-green-50 border border-green-200 rounded-lg px-4 py-3 mb-5 text-green-700 text-sm">
                      <CheckCircle size={16} />
                      <span>Perfil actualizado correctamente</span>
                    </div>
                  )}

                  <div className="space-y-4">
                    {/* Nombre empresa */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">Razón Social / Nombre empresa</label>
                      {editandoPerfil ? (
                        <input type="text" value={formPerfil.nombre} onChange={e => setFormPerfil(p => ({ ...p, nombre: e.target.value }))}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent" />
                      ) : (
                        <p className="text-gray-800">{emp.nombre || '—'}</p>
                      )}
                    </div>

                    {/* RFC — solo lectura, modificable solo por admin */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">
                        RFC
                        <span className="ml-2 text-xs font-normal text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">Solo el administrador puede modificarlo</span>
                      </label>
                      <p className="text-gray-800 font-mono">{emp.rfc || '—'}</p>
                    </div>

                    {/* Email (readonly) */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">Correo electrónico</label>
                      <p className="text-gray-800">{emp.email || usuario?.email || '—'}</p>
                    </div>

                    {/* Teléfono */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">Teléfono</label>
                      {editandoPerfil ? (
                        <input type="tel" value={formPerfil.telefono}
                          onChange={e => setFormPerfil(p => ({ ...p, telefono: e.target.value.replace(/\D/g, '').slice(0, 10) }))}
                          maxLength={10} inputMode="numeric" placeholder="6641234567"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent" />
                      ) : (
                        <p className="text-gray-800">{emp.telefono || '—'}</p>
                      )}
                    </div>

                    {/* Calle y número */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">Calle y número <span className="text-gray-400 font-normal">(opcional)</span></label>
                      {editandoPerfil ? (
                        <input type="text" value={formPerfil.calle} onChange={e => setFormPerfil(p => ({ ...p, calle: e.target.value }))}
                          placeholder="Ej. Blvd. Agua Caliente #456"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent" />
                      ) : (
                        <p className="text-gray-800">{calleInicial || '—'}</p>
                      )}
                    </div>

                    {/* Ciudad */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">Ciudad</label>
                      {editandoPerfil ? (
                        <CiudadComboboxT
                          value={formPerfil.ciudad}
                          placeholder="Selecciona tu ciudad"
                          onChange={val => setFormPerfil(p => ({ ...p, ciudad: val }))}
                        />
                      ) : (
                        <p className="text-gray-800">{ciudadInicial || '—'}</p>
                      )}
                    </div>
                  </div>
                </div>


                {/* Documentos de la empresa */}
                {(() => {
                  const docsReq = getDocumentosRequeridos(usuario?.tipoPersona);
                  const docsGuardados = emp.documentosEmpresa || [];
                  const docs = docsReq.map(d => docsGuardados.find(x => x.id === d.id) || { id: d.id, nombre: d.nombre, status: 'pendiente' });
                  const docsSubidos = docs.filter(d => d.status === 'subido' || d.status === 'verificado').length;
                  return (
                    <div className="bg-white rounded-2xl shadow-lg p-6 mt-6">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="text-lg font-bold text-gray-800">Documentos de la empresa</h3>
                        <span className="text-sm text-gray-500">{docsSubidos} / {docs.length} subidos</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2 mb-5">
                        <div
                          className="h-2 rounded-full bg-green-500 transition-all"
                          style={{ width: `${docs.length > 0 ? (docsSubidos / docs.length) * 100 : 0}%` }}
                        />
                      </div>
                      <div className="space-y-3">
                        {docs.map(doc => {
                          const info = docsReq.find(d => d.id === doc.id);
                          const esVerificado = doc.status === 'verificado';
                          const esSubido = doc.status === 'subido';
                          return (
                            <div key={doc.id} className="flex items-center justify-between gap-4 p-4 border border-gray-100 rounded-xl">
                              <div className="flex items-center gap-3">
                                <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${
                                  esVerificado ? 'bg-green-100' : esSubido ? 'bg-blue-100' : 'bg-gray-100'
                                }`}>
                                  {esVerificado
                                    ? <CheckCircle size={18} className="text-green-600" />
                                    : esSubido
                                      ? <Clock size={18} className="text-blue-600" />
                                      : <FileText size={18} className="text-gray-400" />}
                                </div>
                                <div>
                                  <p className="font-semibold text-gray-800 text-sm">{doc.nombre}</p>
                                  <p className="text-xs text-gray-400">{info?.descripcion}</p>
                                  {esSubido && <p className="text-xs text-blue-600 mt-0.5">En revisión por el administrador</p>}
                                  {esVerificado && <p className="text-xs text-green-600 mt-0.5">Verificado</p>}
                                  {doc.nombreArchivo && <p className="text-xs text-gray-500 mt-0.5">{doc.nombreArchivo}</p>}
                                </div>
                              </div>
                              {esVerificado ? (
                                <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full shrink-0">Aprobado</span>
                              ) : esSubido ? (
                                <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full shrink-0">En revisión</span>
                              ) : (
                                <label className="cursor-pointer flex items-center space-x-1 px-3 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700 transition shrink-0">
                                  <Upload size={14} />
                                  <span>Adjuntar</span>
                                  <input
                                    type="file"
                                    accept=".pdf,application/pdf"
                                    className="hidden"
                                    onChange={e => {
                                      const archivo = e.target.files?.[0];
                                      if (!archivo) return;
                                      const reader = new FileReader();
                                      reader.onload = async (ev) => {
                                        try {
                                          const d = await apiTransportistaSubirDocumento(doc.id, ev.target.result, archivo.name);
                                          storeSubirDocumento(empresaId, doc.id, ev.target.result, archivo.name);
                                          if (d?.filePath) storeActualizarFileUrl(empresaId, doc.id, d.filePath);
                                        } catch (e) {
                                          mostrarNotificacion(e.message || 'Error al subir documento', 'error');
                                        }
                                      };
                                      reader.readAsDataURL(archivo);
                                    }}
                                  />
                                </label>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          );
        })()}
      </div>
      </div>

      {/* MODAL: Calificar Cliente */}
      {mostrarCalificarCliente && (
        <ModalCalificarCliente
          viaje={mostrarCalificarCliente}
          onClose={() => setMostrarCalificarCliente(null)}
          onSubmit={(estrellas, comentario) => {
            calificarServicio(
              mostrarCalificarCliente.id,
              usuario?.id,
              'transportista',
              mostrarCalificarCliente.clienteId,
              'cliente',
              estrellas,
              comentario
            );
            apiCalificar(mostrarCalificarCliente.id, { calificadoId: mostrarCalificarCliente.clienteId, calificadoRol: 'cliente', puntuacion: estrellas, comentario })
              .catch(() => { mostrarNotificacion('No se pudo guardar la calificación. Intenta de nuevo más tarde.', 'error'); });
            setMostrarCalificarCliente(null);
            mostrarNotificacion('¡Calificación enviada! Gracias por tu retroalimentación.', 'success');
          }}
        />
      )}

      {/* MODAL: Cancelar Viaje */}
      {cancelarViajeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
            <div className="p-6 border-b flex justify-between items-center">
              <h3 className="text-xl font-bold text-red-700 flex items-center gap-2">
                <XCircle size={20} /> Cancelar Viaje
              </h3>
              <button onClick={() => setCancelarViajeModal(null)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-sm text-gray-600">
                ¿Estás seguro de cancelar el viaje <span className="font-semibold text-gray-800">{cancelarViajeModal.origen} → {cancelarViajeModal.destino}</span>?
              </p>
              <p className="text-xs text-amber-600 bg-amber-50 border border-amber-200 rounded-lg p-3">
                ⚠️ Esta acción notificará al cliente y no se puede deshacer. Si el pago ya fue procesado se marcará como reembolso.
              </p>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Motivo (opcional)</label>
                <textarea
                  value={cancelarMotivo}
                  onChange={(e) => setCancelarMotivo(e.target.value.slice(0, 300))}
                  placeholder="Describe el motivo de la cancelación..."
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-red-300"
                />
                <p className="text-xs text-gray-400 text-right mt-1">{cancelarMotivo.length}/300</p>
              </div>
              <div className="flex gap-3 pt-2">
                <button
                  onClick={() => setCancelarViajeModal(null)}
                  className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-semibold text-sm"
                >
                  Volver
                </button>
                <button
                  disabled={cancelandoViaje}
                  onClick={async () => {
                    setCancelandoViaje(true);
                    try {
                      await apiCancelarViaje(cancelarViajeModal.id, cancelarMotivo || undefined);
                      dispatch(s => ({
                        ...s,
                        viajes: (s.viajes || []).map(v =>
                          v.id === cancelarViajeModal.id ? { ...v, status: 'cancelado' } : v
                        )
                      }));
                      recargar();
                      setCancelarViajeModal(null);
                      setCancelarMotivo('');
                      mostrarNotificacion('Viaje cancelado correctamente.', 'success');
                    } catch (err) {
                      mostrarNotificacion(err.message || 'No se pudo cancelar el viaje.', 'error');
                    } finally {
                      setCancelandoViaje(false);
                    }
                  }}
                  className="flex-1 px-4 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 font-semibold text-sm disabled:opacity-60"
                >
                  {cancelandoViaje ? 'Cancelando...' : 'Confirmar cancelación'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODALES — JSX inline para evitar pérdida de foco al escribir */}
      {mostrarFormUnidad && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] flex flex-col">
            <div className="p-6 border-b flex justify-between items-center flex-shrink-0">
              <h3 className="text-xl font-bold">{editando ? 'Editar Unidad' : 'Agregar Unidad'}</h3>
              <button onClick={() => { setMostrarFormUnidad(false); setEditando(null); }} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
            </div>
            <form onSubmit={editando ? actualizarUnidad : agregarUnidad} className="p-6 space-y-4 overflow-y-auto">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Placas *</label>
                <input
                  type="text" required
                  value={formUnidad.placas}
                  onChange={(e) => setFormUnidad({...formUnidad, placas: e.target.value.replace(/[^A-Za-z0-9\-]/g, '').toUpperCase().slice(0, 10)})}
                  maxLength={10} placeholder="ABC-123-D"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg font-mono"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Número Económico</label>
                <input
                  type="text"
                  value={formUnidad.numeroEconomico}
                  onChange={(e) => setFormUnidad({...formUnidad, numeroEconomico: e.target.value.toUpperCase().slice(0, 20)})}
                  maxLength={20} placeholder="Ej. 001, T-12, ECO-05"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg font-mono"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Tipo *</label>
                <select
                  required
                  value={formUnidad.tipo}
                  onChange={(e) => setFormUnidad({...formUnidad, tipo: e.target.value, marca: ''})}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                >
                  <option value="">Seleccionar...</option>
                  <option value="Camioneta">Camioneta</option>
                  <option value="Rabon">Rabón</option>
                  <option value="Torton">Tortón</option>
                  <option value="Trailer">Trailer</option>
                  <option value="Trailer Refrigerado">Trailer Refrigerado</option>
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Marca *</label>
                  <select
                    required
                    value={formUnidad.marca}
                    onChange={(e) => setFormUnidad({...formUnidad, marca: e.target.value, modelo: ''})}
                    disabled={!formUnidad.tipo}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg disabled:bg-gray-100 disabled:text-gray-400"
                  >
                    <option value="">{formUnidad.tipo ? 'Seleccionar...' : 'Primero elige tipo'}</option>
                    {(MARCAS_POR_TIPO[formUnidad.tipo] || []).map(m => (
                      <option key={m} value={m}>{m}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Modelo *</label>
                  <select
                    required
                    value={formUnidad.modelo}
                    onChange={(e) => setFormUnidad({...formUnidad, modelo: e.target.value, capacidad: CAPACIDAD_POR_MODELO[e.target.value] || formUnidad.capacidad})}
                    disabled={!formUnidad.marca}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg disabled:bg-gray-100 disabled:text-gray-400"
                  >
                    <option value="">{formUnidad.marca ? 'Seleccionar...' : 'Primero elige marca'}</option>
                    {(MODELOS_POR_MARCA[formUnidad.marca] || []).map(m => (
                      <option key={m} value={m}>{m}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Año *</label>
                <input
                  required type="number" min="1990" max={new Date().getFullYear() + 1}
                  value={formUnidad.anio}
                  onChange={(e) => setFormUnidad({...formUnidad, anio: e.target.value})}
                  onWheel={e => e.target.blur()}
                  placeholder={String(new Date().getFullYear())}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Capacidad *
                  {CAPACIDAD_POR_MODELO[formUnidad.modelo] && (
                    <span className="ml-2 text-xs font-normal text-green-600">autocompletado</span>
                  )}
                </label>
                <input
                  type="text" required
                  value={formUnidad.capacidad}
                  onChange={(e) => setFormUnidad({...formUnidad, capacidad: e.target.value})}
                  placeholder="Ej. 20 tons"
                  readOnly={!!CAPACIDAD_POR_MODELO[formUnidad.modelo]}
                  className={`w-full px-4 py-2 border border-gray-300 rounded-lg ${CAPACIDAD_POR_MODELO[formUnidad.modelo] ? 'bg-green-50 text-green-800 cursor-default' : ''}`}
                />
              </div>
              {/* ── Foto de la unidad ── */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Foto de la unidad</label>
                <div className="flex items-center gap-3">
                  {formUnidad.foto && (
                    <img src={formUnidad.foto} alt="Unidad" className="w-16 h-16 object-cover rounded-lg border border-gray-200 flex-shrink-0" />
                  )}
                  <label className="flex-1 cursor-pointer">
                    <div className="flex items-center gap-2 px-4 py-2 border-2 border-dashed border-gray-300 rounded-lg hover:border-green-400 transition text-sm text-gray-500">
                      <Camera size={16} />
                      <span>{formUnidad.foto ? 'Cambiar foto' : 'Subir foto (opcional)'}</span>
                    </div>
                    <input
                      type="file" accept="image/*" className="hidden"
                      onChange={e => {
                        const file = e.target.files?.[0];
                        if (!file) return;
                        const reader = new FileReader();
                        reader.onload = ev => setFormUnidad({ ...formUnidad, foto: ev.target.result });
                        reader.readAsDataURL(file);
                      }}
                    />
                  </label>
                  {formUnidad.foto && (
                    <button type="button" onClick={() => setFormUnidad({ ...formUnidad, foto: null })} className="text-red-400 hover:text-red-600"><X size={18} /></button>
                  )}
                </div>
              </div>

              {/* ── GPS instalado ── */}
              <div className="flex items-center justify-between py-1">
                <div>
                  <p className="text-sm font-semibold text-gray-700">GPS instalado</p>
                  <p className="text-xs text-gray-400">Se mostrará como ventaja en tus cotizaciones</p>
                </div>
                <button
                  type="button"
                  onClick={() => setFormUnidad({ ...formUnidad, gpsInstalado: !formUnidad.gpsInstalado })}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${formUnidad.gpsInstalado ? 'bg-green-500' : 'bg-gray-300'}`}
                >
                  <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${formUnidad.gpsInstalado ? 'translate-x-6' : 'translate-x-1'}`} />
                </button>
              </div>

              {/* ── Dimensiones (no para camioneta) ── */}
              {formUnidad.tipo && formUnidad.tipo !== 'Camioneta' && (
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Dimensiones de la caja (metros)</label>
                  <div className="grid grid-cols-3 gap-2">
                    {[['largoM', 'Largo'], ['anchoM', 'Ancho'], ['altoM', 'Alto']].map(([field, label]) => (
                      <div key={field}>
                        <label className="block text-xs text-gray-500 mb-0.5">{label}</label>
                        <input
                          type="number" min="0" step="0.1"
                          value={formUnidad[field]}
                          onChange={e => setFormUnidad({ ...formUnidad, [field]: e.target.value })}
                          onWheel={e => e.target.blur()}
                          placeholder="0.0"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* ── Temperatura mínima (solo Trailer Refrigerado) ── */}
              {formUnidad.tipo === 'Trailer Refrigerado' && (
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Temperatura mínima de operación (°C)</label>
                  <input
                    type="number" min="-40" max="10"
                    value={formUnidad.tempMinima}
                    onChange={e => setFormUnidad({ ...formUnidad, tempMinima: e.target.value })}
                    onWheel={e => e.target.blur()}
                    placeholder="Ej. -18"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                  />
                </div>
              )}

              {/* ── Seguro de carga ── */}
              <div>
                <div className="flex items-center justify-between py-1">
                  <div>
                    <p className="text-sm font-semibold text-gray-700">Seguro de carga propio</p>
                    <p className="text-xs text-gray-400">La unidad ya tiene seguro de carga contratado</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => setFormUnidad({ ...formUnidad, seguroCarga: !formUnidad.seguroCarga })}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${formUnidad.seguroCarga ? 'bg-green-500' : 'bg-gray-300'}`}
                  >
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${formUnidad.seguroCarga ? 'translate-x-6' : 'translate-x-1'}`} />
                  </button>
                </div>
                {formUnidad.seguroCarga && (
                  <div className="mt-2">
                    <label className="block text-xs text-gray-500 mb-0.5">Vigencia del seguro</label>
                    <input
                      type="date"
                      value={formUnidad.vigenciaSeguro}
                      onChange={e => setFormUnidad({ ...formUnidad, vigenciaSeguro: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                    />
                  </div>
                )}
              </div>

              {/* ── Tarjeta de Circulación ── */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Tarjeta de Circulación <span className="text-gray-400 font-normal">(opcional)</span></label>
                <div className="flex items-center gap-3">
                  {formUnidad.tarjetaCirculacionUrl && (
                    <a href={formUnidad.tarjetaCirculacionUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 underline flex-shrink-0">Ver PDF</a>
                  )}
                  <label className="flex-1 cursor-pointer">
                    <div className="flex items-center gap-2 px-4 py-2 border-2 border-dashed border-gray-300 rounded-lg hover:border-green-400 transition text-sm text-gray-500">
                      <Upload size={16} />
                      <span>{formUnidad.tarjetaCirculacionUrl ? 'Cambiar PDF' : 'Subir PDF (opcional)'}</span>
                    </div>
                    <input
                      type="file" accept=".pdf,application/pdf" className="hidden"
                      onChange={e => {
                        const file = e.target.files?.[0];
                        if (!file) return;
                        const reader = new FileReader();
                        reader.onload = ev => setFormUnidad({ ...formUnidad, tarjetaCirculacionUrl: ev.target.result });
                        reader.readAsDataURL(file);
                      }}
                    />
                  </label>
                  {formUnidad.tarjetaCirculacionUrl && (
                    <button type="button" onClick={() => setFormUnidad({ ...formUnidad, tarjetaCirculacionUrl: null })} className="text-red-400 hover:text-red-600"><X size={18} /></button>
                  )}
                </div>
              </div>

              <button type="submit" className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold">
                {editando ? 'Actualizar' : 'Agregar'} Unidad
              </button>
            </form>
          </div>
        </div>
      )}

      {mostrarFormChofer && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] flex flex-col">
            <div className="p-6 border-b flex justify-between items-center flex-shrink-0">
              <h3 className="text-xl font-bold">{editando ? 'Editar Chofer' : 'Agregar Chofer'}</h3>
              <button onClick={() => { setMostrarFormChofer(false); setEditando(null); setNuevoAcceso(null); setFormChofer(emptyFormChofer); }} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
            </div>

            {nuevoAcceso ? (
              /* ── Pantalla de credenciales creadas ── */
              <div className="p-6">
                <div className="flex items-center space-x-3 mb-5">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <CheckCircle size={26} className="text-green-600" />
                  </div>
                  <div>
                    <p className="font-bold text-green-700">¡Chofer registrado con acceso!</p>
                    <p className="text-sm text-gray-500">Comparte estas credenciales con el chofer</p>
                  </div>
                </div>
                <div className="space-y-3 mb-6">
                  <div className="bg-gray-50 rounded-xl p-4 flex justify-between items-center">
                    <div>
                      <p className="text-xs text-gray-500 mb-0.5">Número de teléfono (usuario)</p>
                      <p className="font-mono font-semibold text-gray-800">{nuevoAcceso.telefono}</p>
                    </div>
                    <button onClick={() => { navigator.clipboard?.writeText(nuevoAcceso.telefono); }} className="p-2 hover:bg-gray-200 rounded-lg"><Copy size={18} className="text-gray-500" /></button>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-4 flex justify-between items-center">
                    <div>
                      <p className="text-xs text-gray-500 mb-0.5">Contraseña</p>
                      <p className="font-mono font-semibold text-gray-800 text-xl tracking-widest">{nuevoAcceso.password}</p>
                    </div>
                    <button onClick={() => { navigator.clipboard?.writeText(nuevoAcceso.password); }} className="p-2 hover:bg-gray-200 rounded-lg"><Copy size={18} className="text-gray-500" /></button>
                  </div>
                </div>
                <button onClick={() => { setMostrarFormChofer(false); setNuevoAcceso(null); setFormChofer(emptyFormChofer); }} className="w-full py-3 bg-green-600 text-white rounded-xl font-semibold hover:bg-green-700">
                  Listo
                </button>
              </div>
            ) : (
              <form onSubmit={editando ? actualizarChofer : agregarChofer} className="p-6 space-y-4 overflow-y-auto">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Nombre Completo *</label>
                  <input type="text" required value={formChofer.nombre}
                    onChange={(e) => setFormChofer({...formChofer, nombre: e.target.value.replace(/\b\w/g, c => c.toUpperCase()).replace(/(?<=\S)\B\w/g, c => c.toLowerCase())})}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Licencia Federal *</label>
                  <input type="text" required value={formChofer.licencia}
                    onChange={(e) => setFormChofer({...formChofer, licencia: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 13)})}
                    maxLength={13} placeholder="Ej: BACU870101H15"
                    className={`w-full px-4 py-2 border rounded-lg font-mono ${
                      formChofer.licencia.length === 0 ? 'border-gray-300'
                      : /^[A-Z]{4}\d{6}[AHM]\d{2}$/.test(formChofer.licencia) ? 'border-green-500 bg-green-50'
                      : 'border-red-400 bg-red-50'
                    }`} />
                  {formChofer.licencia.length > 0 && !/^[A-Z]{4}\d{6}[AHM]\d{2}$/.test(formChofer.licencia) && (
                    <p className="text-xs text-red-500 mt-1">
                      Formato: 4 letras + 6 dígitos (AAMMDD) + A, H o M + 2 dígitos · Ej: BACU870101H15
                    </p>
                  )}
                  {/^[A-Z]{4}\d{6}[AHM]\d{2}$/.test(formChofer.licencia) && (
                    <p className="text-xs text-green-600 mt-1">✓ Formato válido</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Teléfono *</label>
                  <input type="tel" required value={formChofer.telefono} onChange={(e) => setFormChofer({...formChofer, telefono: e.target.value.replace(/\D/g, '').slice(0, 10)})} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                </div>
                {!editando && (
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Contraseña *</label>
                    <div className="flex gap-2">
                      <input type="text" required value={formChofer.password}
                        onChange={(e) => setFormChofer({...formChofer, password: e.target.value})}
                        placeholder="Mínimo 8 caracteres"
                        minLength={6}
                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg font-mono" />
                      <button type="button"
                        onClick={() => {
                          const chars = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
                          let pwd = '';
                          for (let i = 0; i < 8; i++) pwd += chars[Math.floor(Math.random() * chars.length)];
                          setFormChofer(f => ({...f, password: pwd}));
                        }}
                        className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm font-medium">
                        Generar
                      </button>
                    </div>
                    <p className="text-xs text-gray-400 mt-1">El chofer entrará a la app con su número de teléfono y esta contraseña.</p>
                  </div>
                )}
                {/* ── Separador campos opcionales ── */}
                <div className="border-t border-gray-100 pt-4">
                  <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Perfil adicional (opcional)</p>

                  {/* Foto del chofer */}
                  <div className="mb-4">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">📷 Foto del chofer</label>
                    {formChofer.foto && (
                      <div className="relative inline-block mb-2">
                        <img src={formChofer.foto} alt="Chofer" className="w-20 h-20 rounded-full object-cover border-2 border-green-500" />
                        <button type="button" onClick={() => setFormChofer(f => ({...f, foto: null}))}
                          className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center text-xs">✕</button>
                      </div>
                    )}
                    <input type="file" accept="image/*" onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      const reader = new FileReader();
                      reader.onload = (ev) => setFormChofer(f => ({...f, foto: ev.target.result}));
                      reader.readAsDataURL(file);
                    }} className="w-full text-sm text-gray-500 file:mr-4 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
                  </div>

                  {/* Tipo y vigencia de licencia */}
                  <div className="grid grid-cols-2 gap-3 mb-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Tipo de licencia</label>
                      <select value={formChofer.tipoLicencia} onChange={(e) => setFormChofer(f => ({...f, tipoLicencia: e.target.value}))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm">
                        <option value="">Selecciona</option>
                        <option value="A">A — Motocicleta</option>
                        <option value="B">B — Automóvil</option>
                        <option value="C">C — Camión unitario</option>
                        <option value="D">D — Autobús</option>
                        <option value="E">E — Tractocamión</option>
                        <option value="F">F — Vehículo especial</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1">Vigencia</label>
                      <input type="date" value={formChofer.vigenciaLicencia}
                        onChange={(e) => setFormChofer(f => ({...f, vigenciaLicencia: e.target.value}))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                    </div>
                  </div>

                  {/* CURP */}
                  <div className="mb-4">
                    <label className="block text-sm font-semibold text-gray-700 mb-1">CURP</label>
                    <input type="text" value={formChofer.curp}
                      onChange={(e) => setFormChofer(f => ({...f, curp: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 18)}))}
                      maxLength={18} placeholder="18 caracteres"
                      className={`w-full px-4 py-2 border rounded-lg font-mono text-sm ${
                        !formChofer.curp ? 'border-gray-300'
                        : /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]{2}$/.test(formChofer.curp) ? 'border-green-500 bg-green-50'
                        : 'border-yellow-400 bg-yellow-50'
                      }`} />
                  </div>

                  {/* Contacto de emergencia */}
                  <div className="mb-4">
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Contacto de emergencia</label>
                    <div className="grid grid-cols-2 gap-3">
                      <input type="text" value={formChofer.contactoEmergenciaNombre}
                        onChange={(e) => setFormChofer(f => ({...f, contactoEmergenciaNombre: e.target.value}))}
                        placeholder="Nombre"
                        className="px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                      <input type="tel" value={formChofer.contactoEmergenciaTelefono}
                        onChange={(e) => setFormChofer(f => ({...f, contactoEmergenciaTelefono: e.target.value.replace(/\D/g, '').slice(0, 10)}))}
                        placeholder="10 dígitos"
                        className="px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                    </div>
                  </div>

                  {/* Años de experiencia */}
                  <div className="mb-4">
                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                      Años de experiencia <span className="text-gray-400 font-normal">(visible en cotizaciones si se registra)</span>
                    </label>
                    <input type="number" min="0" max="60" value={formChofer.aniosExperiencia}
                      onChange={(e) => setFormChofer(f => ({...f, aniosExperiencia: e.target.value}))}
                      placeholder="Ej: 8"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                  </div>

                  {/* Licencia federal PDF */}
                  <div className="mb-4">
                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                      Licencia Federal <span className="text-gray-400 font-normal">(opcional)</span>
                    </label>
                    <div className="flex items-center gap-3">
                      {formChofer.licenciaFederalUrl && (
                        <a href={formChofer.licenciaFederalUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 underline flex-shrink-0">Ver PDF</a>
                      )}
                      <label className="flex-1 cursor-pointer">
                        <div className="flex items-center gap-2 px-4 py-2 border-2 border-dashed border-gray-300 rounded-lg hover:border-green-400 transition text-sm text-gray-500">
                          <Upload size={16} />
                          <span>{formChofer.licenciaFederalUrl ? 'Cambiar PDF' : 'Subir licencia federal (opcional)'}</span>
                        </div>
                        <input
                          type="file" accept=".pdf,application/pdf" className="hidden"
                          onChange={e => {
                            const file = e.target.files?.[0];
                            if (!file) return;
                            const reader = new FileReader();
                            reader.onload = ev => setFormChofer(f => ({...f, licenciaFederalUrl: ev.target.result}));
                            reader.readAsDataURL(file);
                          }}
                        />
                      </label>
                      {formChofer.licenciaFederalUrl && (
                        <button type="button" onClick={() => setFormChofer(f => ({...f, licenciaFederalUrl: null}))} className="text-red-400 hover:text-red-600"><X size={18} /></button>
                      )}
                    </div>
                  </div>
                </div>

                <button type="submit"
                  disabled={!formChofer.licencia || formChofer.licencia.length < 6}
                  className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold disabled:opacity-50 disabled:cursor-not-allowed">
                  {editando ? 'Actualizar Chofer' : 'Agregar Chofer'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
      {mostrarCotizacion && ModalCotizacion()}
      {mostrarAsignarViaje && ModalAsignarViaje()}

      {/* ===== MODAL: SIN FLOTA — bloquea cotizar sin unidad/chofer ===== */}
      {modalSinFlota && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] p-4">
          <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full">
            <div className="text-center mb-5">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🚛</span>
              </div>
              <h2 className="text-xl font-bold text-gray-800 mb-1">Completa tu perfil primero</h2>
              <p className="text-sm text-gray-500">Necesitas tener al menos una unidad y un chofer registrados para poder cotizar.</p>
            </div>
            <div className="space-y-3 mb-6">
              <div className={`flex items-center gap-3 p-3 rounded-xl border ${!modalSinFlota.sinUnidad ? 'border-green-200 bg-green-50' : 'border-red-200 bg-red-50'}`}>
                <span className="text-lg">{!modalSinFlota.sinUnidad ? '✅' : '❌'}</span>
                <div className="flex-1">
                  <p className={`text-sm font-semibold ${!modalSinFlota.sinUnidad ? 'text-green-800' : 'text-red-700'}`}>
                    {!modalSinFlota.sinUnidad ? 'Unidad registrada' : 'Sin unidad registrada'}
                  </p>
                  {modalSinFlota.sinUnidad && <p className="text-xs text-red-500">Agrega el camión o vehículo con el que trabajas</p>}
                </div>
              </div>
              <div className={`flex items-center gap-3 p-3 rounded-xl border ${!modalSinFlota.sinChofer ? 'border-green-200 bg-green-50' : 'border-red-200 bg-red-50'}`}>
                <span className="text-lg">{!modalSinFlota.sinChofer ? '✅' : '❌'}</span>
                <div className="flex-1">
                  <p className={`text-sm font-semibold ${!modalSinFlota.sinChofer ? 'text-green-800' : 'text-red-700'}`}>
                    {!modalSinFlota.sinChofer ? 'Chofer registrado' : 'Sin chofer registrado'}
                  </p>
                  {modalSinFlota.sinChofer && <p className="text-xs text-red-500">Registra al operador que realizará los fletes</p>}
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              {modalSinFlota.sinUnidad && (
                <button
                  onClick={() => { setModalSinFlota(null); setSeccion('unidades'); setMostrarFormUnidad(true); }}
                  className="w-full px-4 py-2.5 bg-blue-600 text-white rounded-xl font-semibold text-sm hover:bg-blue-700 transition"
                >
                  + Agregar unidad
                </button>
              )}
              {modalSinFlota.sinChofer && (
                <button
                  onClick={() => { setModalSinFlota(null); setSeccion('choferes'); setMostrarFormChofer(true); }}
                  className="w-full px-4 py-2.5 bg-indigo-600 text-white rounded-xl font-semibold text-sm hover:bg-indigo-700 transition"
                >
                  + Agregar chofer
                </button>
              )}
              <button
                onClick={() => setModalSinFlota(null)}
                className="w-full px-4 py-2 border border-gray-300 text-gray-600 rounded-xl text-sm hover:bg-gray-50 transition"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL: REASIGNAR CHOFER ===== */}
      {modalReasignar && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[1100]">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-1">Reasignar chofer</h3>
            <p className="text-sm text-gray-500 mb-4">Chofer actual: <span className="font-semibold text-gray-700">{modalReasignar.choferActualNombre}</span></p>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nuevo chofer</label>
            <select
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm mb-5 focus:outline-none focus:ring-2 focus:ring-orange-400"
              value={reasignarChoferId}
              onChange={(e) => setReasignarChoferId(e.target.value)}
            >
              <option value="">— Selecciona un chofer —</option>
              {(choferes || []).filter(c => c.tieneAcceso && c.usuarioActivo && String(c.usuarioId) !== String(viajesStore.find(v => v.id === modalReasignar.viajeId)?.choferAsignado)).map(c => (
                <option key={c.id} value={c.usuarioId}>{c.nombre}</option>
              ))}
            </select>
            <div className="flex gap-3">
              <button
                onClick={() => setModalReasignar(null)}
                className="flex-1 px-4 py-2.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium text-sm"
                disabled={reasignarLoading}
              >Cancelar</button>
              <button
                disabled={!reasignarChoferId || reasignarLoading}
                onClick={async () => {
                  setReasignarLoading(true);
                  try {
                    const chofer = (choferes || []).find(c => String(c.usuarioId) === String(reasignarChoferId));
                    await apiReasignarChofer(modalReasignar.viajeId, { choferId: reasignarChoferId, choferNombre: chofer?.nombre });
                    setModalReasignar(null);
                    setReasignarChoferId('');
                    alert(`Chofer reasignado a ${chofer?.nombre || 'nuevo chofer'}`);
                  } catch (err) {
                    alert(err?.message || 'Error al reasignar chofer');
                  } finally {
                    setReasignarLoading(false);
                  }
                }}
                className="flex-1 px-4 py-2.5 rounded-lg bg-orange-600 text-white hover:bg-orange-700 font-medium text-sm disabled:opacity-50"
              >{reasignarLoading ? 'Reasignando…' : 'Confirmar reasignación'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL: DAR ACCESO A CHOFER ===== */}
      {/* Modal: Chat */}
      {chatModal && (
        <ChatModal
          viajeId={chatModal.viajeId}
          usuarioId={usuario?.id}
          usuarioNombre={usuario?.nombre || empresaActiva?.nombre || 'Transportista'}
          usuarioRol="transportista"
          contraparte={chatModal.contraparte}
          onClose={() => { chatModalRef.current = null; setLastSeenMessages(prev => { const next = {...prev, [`${chatModal.viajeId}_${chatModal.contraparte.rol}`]: new Date().toISOString()}; sessionStorage.setItem(_chatSeenKey, JSON.stringify(next)); return next; }); setChatModal(null); }}
        />
      )}

      {/* ===== MODAL: PAGAR SUSCRIPCIÓN PRO ===== */}
      {modalPagarPro && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[1100]">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">

            {/* Header degradado */}
            <div className="bg-gradient-to-r from-yellow-400 to-orange-400 px-6 py-5">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-xl font-black text-gray-900">Plan PRO</h2>
                  <p className="text-gray-800 text-sm">Choyero Marketplace Logístico</p>
                </div>
                <button onClick={() => setModalPagarPro(false)} className="text-gray-800 hover:text-gray-900 p-1">
                  <X size={22} />
                </button>
              </div>
            </div>

            <div className="p-6">
              {pagoExitoso ? (
                /* ── Estado: pago exitoso ── */
                <div className="text-center py-6">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <CheckCircle size={32} className="text-green-500" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">¡Bienvenido a PRO!</h3>
                  <p className="text-gray-500 text-sm mb-6">Tu cuenta ha sido actualizada. Ya tienes acceso a todos los beneficios PRO.</p>
                  <button
                    onClick={() => setModalPagarPro(false)}
                    className="w-full py-3 bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 font-bold rounded-xl hover:from-yellow-300 hover:to-orange-300 transition"
                  >
                    Comenzar
                  </button>
                </div>
              ) : !store.configPlataforma?.pagoProHabilitado ? (
                /* ── Estado: pre-lanzamiento o deshabilitado ── */
                (() => {
                  const cfg = store.configPlataforma || {};
                  const modoPreLanz = cfg.modoPreLanzamientoPro;
                  const enLista = store.miEmpresa?.enListaEspera;
                  const esFounder = store.miEmpresa?.esMiembroFundador;
                  const fechaObj = cfg.fechaLanzamientoPro ? new Date(cfg.fechaLanzamientoPro) : null;
                  const haFechaPasado = fechaObj && fechaObj <= new Date();
                  return (
                    <div className="py-4">
                      {/* Badge founding member (si ya lo tienen) */}
                      {esFounder && (
                        <div className="flex items-center justify-center gap-2 bg-yellow-50 border border-yellow-300 rounded-xl px-3 py-2 mb-4">
                          <span className="text-lg">🏅</span>
                          <span className="text-sm font-bold text-yellow-700">Miembro Fundador</span>
                        </div>
                      )}

                      <div className="text-center mb-4">
                        <span className="text-4xl">⚡</span>
                        <h3 className="text-lg font-black text-gray-800 mt-2">
                          {modoPreLanz ? (haFechaPasado ? '¡El lanzamiento está próximo!' : 'Plan PRO — Próximamente') : 'Próximamente disponible'}
                        </h3>
                        {modoPreLanz && fechaObj && !haFechaPasado && (
                          <ProCountdown fecha={fechaObj} />
                        )}
                        <p className="text-gray-500 text-xs mt-2">
                          {cfg.mensajePagoProDeshabilitado || 'La suscripción PRO estará disponible próximamente.'}
                        </p>
                      </div>

                      {/* Beneficios */}
                      <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl p-3 text-left space-y-2 mb-4 border border-yellow-200">
                        {[
                          `⚡ Acceso anticipado — ves solicitudes ${cfg.horasExclusivaPro ?? 6}h antes que los demás`,
                          '🥇 Primero en cotizaciones — tu cotización aparece arriba cuando el cliente elige',
                          '🏅 Badge PRO — visible en tu perfil y en cada cotización que envías',
                          '📊 Estadísticas avanzadas — ingresos por período, rutas más rentables, tasa de cierre',
                          '🛡️ Soporte prioritario — respuesta preferente por chat',
                          '💼 Perfil destacado — más datos visibles para generar confianza al cliente',
                        ].map((b, i) => (
                          <p key={i} className="text-xs text-gray-700">{b}</p>
                        ))}
                      </div>

                      <div className="text-center mb-4">
                        {cfg.precioFundador && (
                          <p className="text-xs text-green-600 font-semibold mb-1">🏅 Precio fundador: ${Number(cfg.precioFundador).toLocaleString()} MXN/mes (primeros {cfg.limiteFoundingMembers ?? 50})</p>
                        )}
                        <p className="text-xl font-black text-gray-800">${(cfg.precioProMensual ?? 599).toLocaleString()} <span className="text-sm font-normal text-gray-500">MXN/mes</span></p>
                      </div>

                      {/* Botón lista de espera o confirmación */}
                      {modoPreLanz && !enLista && !esFounder ? (
                        <button
                          onClick={async () => {
                            try {
                              await apiUnirseListaEsperaPro();
                              dispatch(s => ({ ...s, miEmpresa: s.miEmpresa ? { ...s.miEmpresa, enListaEspera: true } : s.miEmpresa }));
                              mostrarNotificacion('¡Listo! Te avisaremos cuando PRO esté disponible.', 'success');
                            } catch { mostrarNotificacion('Error al unirse. Intenta de nuevo.', 'error'); }
                          }}
                          className="w-full py-2.5 bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 font-bold rounded-xl hover:from-yellow-300 hover:to-orange-300 transition text-sm"
                        >
                          🔔 Avisarme cuando esté disponible
                        </button>
                      ) : modoPreLanz && enLista ? (
                        <div className="w-full py-2.5 bg-green-50 border border-green-200 rounded-xl text-center text-sm font-semibold text-green-700">
                          ✅ Estás en la lista — te avisamos al lanzar
                        </div>
                      ) : (
                        <button onClick={() => setModalPagarPro(false)} className="w-full py-2 border border-gray-300 text-gray-600 rounded-xl hover:bg-gray-50 text-sm">Cerrar</button>
                      )}
                    </div>
                  );
                })()
              ) : (
                /* ── Estado: pago con MercadoPago ── */
                (() => {
                  const cfg = store.configPlataforma || {};
                  const precioMensual = cfg.precioProMensual ?? 5000;
                  const precioAnual = cfg.precioProAnual ?? 36000;
                  const precioMensualEquiv = Math.round(precioAnual / 12);
                  const ahorroPct = Math.round((1 - precioMensualEquiv / precioMensual) * 100);
                  const horasExclusiva = cfg.horasExclusivaPro ?? 6;
                  const BENEFICIOS = [
                    { icon: '⚡', txt: `Acceso anticipado — ves las solicitudes ${horasExclusiva}h antes que los demás` },
                    { icon: '🥇', txt: 'Primero en resultados — tu cotización aparece arriba cuando el cliente elige' },
                    { icon: '🏅', txt: 'Badge PRO visible en tu perfil y en cada cotización que envías' },
                    { icon: '📊', txt: 'Estadísticas avanzadas — ingresos, rutas rentables y tasa de cierre' },
                    { icon: '🛡️', txt: 'Soporte prioritario — atención preferente por chat' },
                    { icon: '💼', txt: 'Perfil destacado — más información visible para generar confianza' },
                  ];
                  return (
                    <>
                      {/* Beneficios */}
                      <div className="space-y-1.5 mb-4">
                        {BENEFICIOS.map((b, i) => (
                          <div key={i} className="flex items-start gap-2 text-xs text-gray-700">
                            <span className="shrink-0 mt-0.5">{b.icon}</span>
                            <span>{b.txt}</span>
                          </div>
                        ))}
                      </div>

                      {/* Toggle mensual / anual */}
                      <div className="flex rounded-xl border border-gray-200 overflow-hidden mb-4 text-sm font-semibold">
                        {['mensual', 'anual'].map(p => (
                          <button key={p} onClick={() => setPeriodoPro(p)}
                            className={`flex-1 py-2 transition ${periodoPro === p ? 'bg-gray-900 text-white' : 'bg-white text-gray-500 hover:bg-gray-50'}`}>
                            {p === 'mensual' ? 'Mensual' : `Anual — ${ahorroPct}% descuento`}
                          </button>
                        ))}
                      </div>

                      {/* Precio */}
                      <div className="text-center mb-4">
                        {periodoPro === 'anual' ? (
                          <>
                            <p className="text-2xl font-black text-gray-900">${precioAnual.toLocaleString()} <span className="text-sm font-normal text-gray-500">MXN/año</span></p>
                            <p className="text-xs text-green-600 font-semibold mt-0.5">${precioMensualEquiv.toLocaleString()}/mes · ahorras ${(precioMensual * 12 - precioAnual).toLocaleString()} MXN al año</p>
                          </>
                        ) : (
                          <p className="text-2xl font-black text-gray-900">${precioMensual.toLocaleString()} <span className="text-sm font-normal text-gray-500">MXN/mes</span></p>
                        )}
                      </div>

                      <p className="text-xs text-gray-500 text-center mb-3">Serás redirigido a MercadoPago para completar tu pago de forma segura.</p>

                      <button
                        disabled={pagoProcesando}
                        onClick={async () => {
                          setPagoProcesando(true);
                          try {
                            const data = await apiCrearPreferenciaPro(periodoPro);
                            if (data?.paymentUrl) window.location.href = data.paymentUrl;
                          } catch (e) {
                            mostrarNotificacion('Error al iniciar el pago. Intenta de nuevo.', 'error');
                            setPagoProcesando(false);
                          }
                        }}
                        className="w-full py-3 bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 font-bold rounded-xl hover:from-yellow-300 hover:to-orange-300 disabled:opacity-50 disabled:cursor-not-allowed transition flex items-center justify-center gap-2"
                      >
                        {pagoProcesando ? (
                          <><div className="w-4 h-4 border-2 border-gray-700 border-t-transparent rounded-full animate-spin" /> Redirigiendo...</>
                        ) : (
                          <>💳 Pagar ${(periodoPro === 'anual' ? precioAnual : precioMensual).toLocaleString()} MXN con MercadoPago</>
                        )}
                      </button>
                      <p className="text-xs text-gray-400 flex items-center justify-center gap-1 mt-3">
                        <Lock size={11} /> Pago procesado por MercadoPago
                      </p>
                    </>
                  );
                })()
              )}
            </div>
          </div>
        </div>
      )}

      {mostrarAccesoChofer && (
        <ModalAccesoChofer
          chofer={mostrarAccesoChofer}
          onClose={() => { setMostrarAccesoChofer(null); setAccesoCreado(null); }}
          accesoCreado={accesoCreado}
          onCrear={async (email, password) => {
            try {
              await apiCrearAccesoChofer(mostrarAccesoChofer.id, { email, password });
            } catch {
              // fallback local
              crearAccesoChofer({
                nombre: mostrarAccesoChofer.nombre,
                email,
                password,
                telefono: mostrarAccesoChofer.telefono,
                licencia: mostrarAccesoChofer.licencia,
                empresaId: empresaId,
                empresaNombre: empresaInfo?.nombre || usuario?.nombre
              });
            }
            setAccesoCreado({ telefono: mostrarAccesoChofer.telefono, password });
            mostrarNotificacion('Acceso creado correctamente');
          }}
          yaExiste={false}
        />
      )}

      {/* ===== MODAL: NOTIFICAR CHOFER DE RETORNO ===== */}
      {notificarChoferRetornoId && (() => {
        const ret = misRetornos.find(r => r.id === notificarChoferRetornoId);
        const ofertasAceptadas = (ret?.ofertas || []).filter(o => o.status === 'aceptada');
        const ofertaAceptada = ofertasAceptadas.find(o => o.pagado) || ofertasAceptadas[0];
        // Choferes de esta empresa: usar todosChoferes (plantillaChoferes + store.usuarios combinados)
        const choferesDisp = todosChoferes;
        return (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[9999]">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold">Asignar chofer al retorno</h3>
                <button onClick={() => setNotificarChoferRetornoId(null)} className="text-gray-400 hover:text-gray-600"><X size={22} /></button>
              </div>

              {/* Resumen del servicio */}
              <div className="bg-blue-50 rounded-lg p-3 mb-5 text-sm space-y-1">
                <p className="font-semibold text-blue-800">{ret?.origenActual} → {ret?.destino}</p>
                {ofertasAceptadas.length > 1 ? (
                  <div className="mt-1 space-y-1.5">
                    <p className="text-blue-700 font-medium">{ofertasAceptadas.length} clientes confirmados:</p>
                    {ofertasAceptadas.map((o, i) => (
                      <div key={o.id} className="flex justify-between text-blue-700">
                        <span>• {o.clienteNombre}{o.peso ? ` (${o.peso} ton)` : ''}</span>
                        <span className="font-semibold">${Number(o.contrapropuesta || o.precio || o.monto || 0).toLocaleString()}</span>
                      </div>
                    ))}
                    <p className="font-bold text-blue-800 pt-1 border-t border-blue-200">
                      Total: ${ofertasAceptadas.reduce((s, o) => s + Number(o.contrapropuesta || o.precio || o.monto || 0), 0).toLocaleString()}
                    </p>
                  </div>
                ) : ofertaAceptada ? (
                  <>
                    <p className="text-blue-700">Cliente: {ofertaAceptada.clienteNombre}</p>
                    {ofertaAceptada.origenDir && <p className="text-blue-700">📦 Recoge en: {ofertaAceptada.origenDir}</p>}
                    {ofertaAceptada.destinoDir && <p className="text-blue-700">📍 Entrega en: {ofertaAceptada.destinoDir}</p>}
                    {ofertaAceptada.peso && <p className="text-blue-600">Carga: {ofertaAceptada.peso} ton{ofertaAceptada.volumen ? ` · ${ofertaAceptada.volumen} m³` : ''}</p>}
                    <p className="font-bold text-blue-800">Precio pactado: ${Number(ofertaAceptada.contrapropuesta || ofertaAceptada.precio || ofertaAceptada.monto || 0).toLocaleString()}</p>
                  </>
                ) : null}
              </div>

              <p className="text-sm font-semibold text-gray-700 mb-3">Selecciona el chofer:</p>
              {choferesDisp.length === 0 ? (
                <p className="text-sm text-gray-400 text-center py-4">No hay choferes disponibles</p>
              ) : (
                <div className="space-y-2 max-h-60 overflow-y-auto">
                  {choferesDisp.map(chofer => {
                    return (
                      <button key={chofer.id} onClick={() => {
                        const choferId = chofer.usuarioId || chofer._usuarioId || chofer.id;
                        notificarChoferRetorno(notificarChoferRetornoId, choferId);
                        setNotificarChoferRetornoId(null);
                        mostrarNotificacion(`✅ ${chofer.nombre} ha sido notificado del nuevo servicio`);
                        // Persistir en BD: el viaje de este retorno ya existe, asignar el chofer
                        const viajeRetorno = (store.viajes || []).find(v => v.retornoId === notificarChoferRetornoId);
                        if (viajeRetorno) {
                          apiAsignarChofer(viajeRetorno.id, { choferId, choferNombre: chofer.nombre })
                            .catch(() => { mostrarNotificacion('Error al registrar el chofer en el servidor. La asignación local fue guardada.', 'error'); });
                        }
                      }}
                        className="w-full flex items-center space-x-3 p-3 border border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 text-left transition">
                        <div className="w-9 h-9 bg-orange-100 rounded-full flex items-center justify-center text-orange-600 font-bold text-sm flex-shrink-0">
                          {chofer.nombre.charAt(0)}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-medium text-gray-800 truncate">{chofer.nombre}</p>
                          <p className="text-xs text-gray-500">{chofer.licencia || 'Sin licencia registrada'}</p>
                        </div>
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${chofer.status === 'disponible' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                          {chofer.status === 'disponible' ? 'Disponible' : chofer.status}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        );
      })()}


      {/* ===== MODAL: MAPA GPS DE OFERTA ===== */}
      {mapaGpsOferta && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-end justify-center z-[9999] sm:items-center sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full sm:max-w-2xl flex flex-col" style={{ maxHeight: '92vh' }}>
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-3 border-b flex-shrink-0">
              <div>
                <h3 className="text-lg font-bold text-gray-900">Ruta del servicio</h3>
                <p className="text-xs text-gray-500">Cliente: {mapaGpsOferta.clienteNombre}</p>
              </div>
              <div className="flex items-center space-x-3">
                {infoRutaGps && (
                  <div className="text-right">
                    <p className="text-sm font-bold text-indigo-700">🚛 {infoRutaGps.km} km</p>
                    <p className="text-xs text-gray-500">⏱ {infoRutaGps.tiempo}</p>
                  </div>
                )}
                <button onClick={() => { setMapaGpsOferta(null); setInfoRutaGps(null); }} className="text-gray-400 hover:text-gray-600 p-1"><X size={22} /></button>
              </div>
            </div>
            {/* Direcciones compactas */}
            <div className="px-4 py-2 flex gap-3 flex-shrink-0 bg-gray-50 border-b">
              {mapaGpsOferta.origenCoords && (
                <div className="flex-1 flex items-center space-x-2 text-xs">
                  <span className="text-green-600 text-base flex-shrink-0">📦</span>
                  <div className="min-w-0">
                    <p className="font-semibold text-green-700">Recogida</p>
                    <p className="text-gray-600 truncate">{mapaGpsOferta.origenCoords.direccion || `${mapaGpsOferta.origenCoords.lat?.toFixed(5)}, ${mapaGpsOferta.origenCoords.lng?.toFixed(5)}`}</p>
                  </div>
                </div>
              )}
              {mapaGpsOferta.origenCoords && mapaGpsOferta.destinoCoords && <div className="flex items-center text-gray-400 font-bold">→</div>}
              {mapaGpsOferta.destinoCoords && (
                <div className="flex-1 flex items-center space-x-2 text-xs">
                  <span className="text-red-600 text-base flex-shrink-0">🏁</span>
                  <div className="min-w-0">
                    <p className="font-semibold text-red-700">Entrega</p>
                    <p className="text-gray-600 truncate">{mapaGpsOferta.destinoCoords.direccion || `${mapaGpsOferta.destinoCoords.lat?.toFixed(5)}, ${mapaGpsOferta.destinoCoords.lng?.toFixed(5)}`}</p>
                  </div>
                </div>
              )}
            </div>
            {/* Mapa */}
            <div className="flex-1" style={{ minHeight: '340px' }}>
              <MapaGpsOfertaView
                key={`${mapaGpsOferta.origenCoords?.lat}-${mapaGpsOferta.destinoCoords?.lat}`}
                origenCoords={mapaGpsOferta.origenCoords}
                destinoCoords={mapaGpsOferta.destinoCoords}
                onInfoRuta={setInfoRutaGps}
              />
            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL EVIDENCIAS DE ENTREGA ===== */}
      {evidenciasModal && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[2000] p-4" onClick={() => setEvidenciasModal(null)}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold text-gray-800">📸 Evidencias de entrega</h3>
              <button onClick={() => setEvidenciasModal(null)} className="text-gray-400 hover:text-gray-600"><X size={22} /></button>
            </div>
            {(evidenciasModal.fotos || []).length > 0 && (
              <div className="grid grid-cols-2 gap-3 mb-4">
                {(evidenciasModal.fotos || []).map((ev, i) => (
                  <div key={i} className="space-y-1">
                    <img
                      src={ev.url || ev.base64} alt={ev.nombre}
                      className="w-full h-36 object-cover rounded-xl cursor-pointer hover:opacity-80 transition-opacity"
                      onClick={() => { setEvidenciasModal(null); setFotoLightbox(ev.url || ev.base64); }}
                      title="Ver en grande"
                    />
                    <p className="text-xs text-center text-gray-500 font-medium">{ev.nombre}</p>
                  </div>
                ))}
              </div>
            )}
            {evidenciasModal.firma && (
              <div className="border-t border-gray-200 pt-4">
                <p className="text-sm font-semibold text-gray-700 mb-2">✍️ Firma de recepción del cliente</p>
                <img src={evidenciasModal.firma} alt="Firma del cliente" className="w-full h-24 object-contain bg-gray-50 rounded-xl border border-gray-200 cursor-pointer hover:opacity-80 transition-opacity" onClick={() => { setEvidenciasModal(null); setFotoLightbox(evidenciasModal.firma); }} title="Ver en grande" />
              </div>
            )}
          </div>
        </div>
      )}

      {/* ===== LIGHTBOX FOTO INCIDENCIA ===== */}
      {fotoLightbox && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[2000] p-4"
          onClick={() => setFotoLightbox(null)}
        >
          <button
            className="absolute top-4 right-4 text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-80"
            onClick={() => setFotoLightbox(null)}
          >
            <X size={24} />
          </button>
          <img
            src={fotoLightbox}
            alt="Evidencia incidencia"
            className="max-w-full max-h-full rounded-xl shadow-2xl object-contain"
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}

      {/* Lightbox de fotos */}
      {fotoAmpliada && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[9999] p-4"
          onClick={() => setFotoAmpliada(null)}
        >
          <img
            src={fotoAmpliada}
            alt="Vista ampliada"
            className="max-w-full max-h-full rounded-xl shadow-2xl"
            onClick={e => e.stopPropagation()}
          />
          <button
            onClick={() => setFotoAmpliada(null)}
            className="absolute top-4 right-4 text-white bg-black bg-opacity-50 rounded-full w-10 h-10 flex items-center justify-center text-xl hover:bg-opacity-80"
          >✕</button>
        </div>
      )}



      {modalBienvenida && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[2000]">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
            <div className="bg-gradient-to-br from-blue-600 to-indigo-700 p-8 text-center text-white">
              <div className="text-6xl mb-4">🚛</div>
              <h2 className="text-2xl font-black mb-2">¡Bienvenido a Choyero!</h2>
              <p className="text-blue-100 text-sm">Tu empresa fue aprobada. Sigue los pasos del dashboard para comenzar a recibir solicitudes de flete.</p>
            </div>
            <div className="p-6 space-y-3">
              {[
                { icon: '🏢', label: 'Completa tu perfil', sub: 'Agrega teléfono, dirección y logo' },
                { icon: '🏦', label: 'Registra tu CLABE', sub: 'Para recibir pagos directamente' },
                { icon: '🧾', label: 'Datos fiscales', sub: 'RFC para emitir facturas automáticas' },
                { icon: '🚚', label: 'Agrega tu flota', sub: 'Unidad y chofer para cotizar' },
                { icon: '💼', label: 'Primera cotización', sub: '¡Empieza a ganar dinero!' },
              ].map((paso, i) => (
                <div key={i} className="flex items-center gap-3">
                  <span className="text-2xl">{paso.icon}</span>
                  <div>
                    <p className="text-sm font-semibold text-gray-800">{paso.label}</p>
                    <p className="text-xs text-gray-400">{paso.sub}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="px-6 pb-6">
              <button
                onClick={() => { setModalBienvenida(false); setSeccion('dashboard'); }}
                className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl transition text-sm"
              >
                Empezar ahora →
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Barra de navegación inferior — solo móvil ── */}
      <div
        className="fixed bottom-0 left-0 right-0 z-[100] md:hidden bg-white border-t border-gray-200"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        <div className="flex items-center h-14">
          {/* Dashboard */}
          <button
            onClick={() => setSeccion('dashboard')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors ${seccion === 'dashboard' ? 'text-green-700' : 'text-gray-500'}`}
          >
            <TrendingUp size={20} />
            <span>Dashboard</span>
          </button>

          {/* Solicitudes */}
          <button
            onClick={() => setSeccion('solicitudes')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors relative ${seccion === 'solicitudes' ? 'text-green-700' : 'text-gray-500'}`}
          >
            <FileText size={20} />
            <span>Solicitudes</span>
            {solicitudesDisponibles.length > 0 && (
              <span className="absolute top-2 right-4 w-4 h-4 bg-orange-500 text-white text-[9px] rounded-full flex items-center justify-center font-bold">
                {solicitudesDisponibles.length > 9 ? '9+' : solicitudesDisponibles.length}
              </span>
            )}
          </button>

          {/* Mis Viajes */}
          <button
            onClick={() => setSeccion('viajes')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors relative ${seccion === 'viajes' ? 'text-green-700' : 'text-gray-500'}`}
          >
            <Truck size={20} />
            <span>Mis Viajes</span>
            {viajesPendientes > 0 && (
              <span className="absolute top-2 right-4 w-4 h-4 bg-green-600 text-white text-[9px] rounded-full flex items-center justify-center font-bold">
                {viajesPendientes > 9 ? '9+' : viajesPendientes}
              </span>
            )}
          </button>

          {/* Mapas */}
          <button
            onClick={() => setSeccion('mapa')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors ${seccion === 'mapa' ? 'text-green-700' : 'text-gray-500'}`}
          >
            <Map size={20} />
            <span>Mapas</span>
          </button>

          {/* Cobros */}
          <button
            onClick={() => setSeccion('cobros')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors ${seccion === 'cobros' ? 'text-green-700' : 'text-gray-500'}`}
          >
            <Banknote size={20} />
            <span>Cobros</span>
          </button>
        </div>
      </div>

      <FeedbackButton pantalla={seccion} />
    </div>
  );
}

export default AppTransportista;